var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromotionApp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 231,
    viewBox: "0 0 286 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65613 154.145H0.000366211V161.507H8.65613V154.145Z",
    fill: "#2B2B2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285.136 126.365H278.913V134.004H285.136V126.365Z",
    fill: "#2B2B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.239 129.812C286.102 132.041 286.102 135.656 282.239 137.887L125.506 228.38C121.645 230.609 115.382 230.609 111.521 228.38L2.89608 165.664C-0.966143 163.434 -0.964578 159.819 2.89608 157.589L159.63 67.0967C163.491 64.8662 169.753 64.8662 173.615 67.0967L282.239 129.812Z",
    fill: "#2B2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M282.239 122.328C286.102 124.558 286.102 128.174 282.239 130.403L125.506 220.896C121.645 223.126 115.382 223.126 111.521 220.896L2.89608 158.181C-0.966143 155.951 -0.964578 152.337 2.89608 150.107L159.63 59.6136C163.491 57.3839 169.753 57.3839 173.615 59.6144L282.239 122.328Z",
    fill: "#262C33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M125.506 220.896C121.645 223.126 115.382 223.126 111.521 220.896L2.89608 158.181C-0.966143 155.951 -0.964578 152.336 2.89608 150.107L159.63 59.6133L125.506 220.896Z",
    fill: "#3A414C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.513 209.97L21.8229 154.145L166.622 70.541L263.313 126.367L118.513 209.97Z",
    fill: "url(#paint0_linear_3744_1590)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M261.789 126.421L122.987 206.552L118.601 209.087L63.6805 177.385L55.4701 172.641L54.484 172.072L23.3444 154.093L85.4232 118.254L87.217 117.217L133.2 90.6653L134.748 89.7684L166.533 71.4199L261.789 126.421Z",
    fill: "url(#paint1_linear_3744_1590)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2747 180.115C58.1105 180.598 58.1113 181.381 57.2747 181.864C56.4396 182.347 55.0834 182.347 54.2468 181.863C53.4109 181.382 53.4109 180.598 54.2468 180.115C55.0834 179.633 56.4396 179.633 57.2747 180.115Z",
    fill: "#49505B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.618 180.496C57.0907 180.769 57.0907 181.212 56.618 181.486C56.1446 181.759 55.3776 181.759 54.9049 181.486C54.4314 181.212 54.4314 180.769 54.9041 180.496C55.3776 180.223 56.1446 180.223 56.618 180.496Z",
    fill: "#6D7889"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0506 186.337C68.8857 186.818 68.8857 187.602 68.0506 188.084C67.2148 188.567 65.8577 188.567 65.0227 188.084L58.9777 184.593C58.1419 184.112 58.1419 183.329 58.9777 182.847C59.8135 182.364 61.169 182.364 62.0057 182.846L68.0506 186.337Z",
    fill: "#49505B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1858 187.585C66.8274 187.793 66.2451 187.793 65.8867 187.585L59.8417 184.095C59.4833 183.888 59.4833 183.552 59.8417 183.344C60.1994 183.138 60.7824 183.138 61.1416 183.344L67.1866 186.835C67.5442 187.042 67.5442 187.378 67.1858 187.585Z",
    fill: "#6D7889"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2286 119.289L81.3292 157.471L98.6423 162.433L107.239 172.431L185.839 127.048L186.253 119.289H79.2286Z",
    fill: "url(#paint2_linear_3744_1590)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M150.971 162.557V190.474L205.496 158.299L205.549 153.049L150.971 162.557Z",
    fill: "url(#paint3_linear_3744_1590)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M134.85 167.578V174.342L144.097 180.265L144.292 171.07L134.85 167.578Z",
    fill: "url(#paint4_linear_3744_1590)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M156.221 174.389V181.152L146.975 187.076L146.78 177.881L156.221 174.389Z",
    fill: "url(#paint5_linear_3744_1590)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M144.022 189.558V194.408L118.601 209.087L95.2168 195.386L95.1088 186.338L126.573 182.986L144.022 189.558Z",
    fill: "url(#paint6_linear_3744_1590)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3953 146.256H46.4587V157.571H54.3953V146.256Z",
    fill: "url(#paint7_linear_3744_1590)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1515 154.76H39.2157V163.71H47.1515V154.76Z",
    fill: "url(#paint8_linear_3744_1590)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M249.482 129.954L216.63 148.902L187.498 148.894L171.795 138.694L167.331 138.895L163.358 136.722L208.3 108.199L249.482 129.954Z",
    fill: "url(#paint9_linear_3744_1590)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2125 153.644C46.9198 153.141 46.3876 152.65 45.6723 152.244C44.3042 151.451 42.4627 151.023 40.4835 151.023C38.5097 151.023 36.6706 151.455 35.3026 152.244C34.1435 152.916 33.4986 153.734 33.4971 154.554C33.4971 154.859 33.5879 155.158 33.7592 155.463C34.0519 155.966 34.5818 156.449 35.3026 156.87C36.6635 157.651 38.5097 158.088 40.4835 158.088C42.4635 158.088 44.3058 157.657 45.6676 156.87C46.8329 156.197 47.4746 155.374 47.4746 154.554C47.4739 154.249 47.3854 153.947 47.2125 153.644Z",
    fill: "url(#paint10_linear_3744_1590)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1192 146.355C54.8265 145.852 54.2951 145.36 53.5798 144.953C52.2094 144.161 50.3687 143.732 48.3902 143.732C46.4165 143.732 44.5765 144.164 43.2101 144.953C42.0495 145.626 41.4054 146.444 41.4038 147.264C41.4038 147.569 41.4938 147.869 41.6652 148.173C41.9587 148.677 42.4885 149.159 43.2093 149.58C44.5687 150.361 46.4157 150.799 48.3895 150.799C50.3687 150.799 52.2126 150.367 53.5727 149.58C54.7381 148.908 55.3806 148.084 55.3806 147.264C55.3814 146.96 55.2922 146.656 55.1192 146.355Z",
    fill: "url(#paint11_linear_3744_1590)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7292 176.995C90.3762 176.389 89.736 175.798 88.8744 175.306C87.2238 174.352 85.0059 173.836 82.622 173.836C80.2436 173.836 78.028 174.355 76.3806 175.306C74.9829 176.117 74.2065 177.103 74.205 178.091C74.205 178.458 74.313 178.82 74.5204 179.186C74.8733 179.792 75.5127 180.374 76.3806 180.881C78.0179 181.822 80.2436 182.349 82.622 182.349C85.0059 182.349 87.2277 181.83 88.8665 180.881C90.2705 180.07 91.0446 179.078 91.0446 178.091C91.0446 177.723 90.9373 177.358 90.7292 176.995Z",
    fill: "url(#paint12_linear_3744_1590)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.531 158.333C88.9323 157.304 87.846 156.301 86.3841 155.466C83.5815 153.847 79.8163 152.971 75.7694 152.971C71.7319 152.971 67.9706 153.852 65.1743 155.466C62.8006 156.844 61.4835 158.516 61.4803 160.193C61.4803 160.815 61.665 161.431 62.0164 162.052C62.6159 163.082 63.6999 164.068 65.1751 164.929C67.9542 166.529 71.7319 167.422 75.7702 167.422C79.8171 167.422 83.5885 166.541 86.3715 164.929C88.7538 163.555 90.0678 161.871 90.0678 160.193C90.0671 159.569 89.8855 158.95 89.531 158.333Z",
    fill: "url(#paint13_linear_3744_1590)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9399 163.948C66.6472 163.445 66.1158 162.954 65.4012 162.546C64.0309 161.754 62.1902 161.326 60.2109 161.326C58.2372 161.326 56.398 161.757 55.0308 162.546C53.8709 163.219 53.2261 164.038 53.2245 164.857C53.2245 165.163 53.3145 165.462 53.4867 165.767C53.7794 166.271 54.31 166.753 55.0308 167.173C56.3902 167.955 58.2372 168.392 60.2109 168.392C62.1902 168.392 64.034 167.961 65.3942 167.173C66.5595 166.501 67.2021 165.678 67.2021 164.857C67.2021 164.553 67.1128 164.25 66.9399 163.948Z",
    fill: "url(#paint14_linear_3744_1590)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1768 152.223L40.1775 153.13C40.212 153.109 40.2495 153.084 40.2887 153.063C41.0541 152.622 42.0816 152.377 43.1836 152.377C44.2871 152.375 45.3115 152.622 46.0793 153.065C46.1153 153.086 46.1528 153.109 46.1873 153.13V152.254L47.1522 152.252V154.581L47.1515 154.578C47.1076 155.064 46.7327 155.534 46.0793 155.908C45.3154 156.353 44.2871 156.594 43.1812 156.594C42.0832 156.594 41.0533 156.353 40.2887 155.908C39.5953 155.51 39.2157 155.006 39.2157 154.486V152.223H40.1768V152.223Z",
    fill: "url(#paint15_linear_3744_1590)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1812 154.334C44.2832 154.334 45.3154 154.09 46.0793 153.646C46.7734 153.248 47.1522 152.743 47.1522 152.224C47.1522 151.707 46.7734 151.2 46.0793 150.8C45.3115 150.359 44.2871 150.114 43.1867 150.115C42.084 150.115 41.0541 150.36 40.2887 150.8C39.5953 151.203 39.2157 151.707 39.2157 152.224C39.2157 152.743 39.5953 153.248 40.2855 153.646C41.0533 154.089 42.0832 154.334 43.1812 154.334Z",
    fill: "url(#paint16_linear_3744_1590)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1813 153.963C44.093 153.963 44.9398 153.763 45.5722 153.398C46.1435 153.067 46.4589 152.651 46.4589 152.223C46.4589 151.797 46.1443 151.378 45.5745 151.053C44.9398 150.687 44.093 150.484 43.186 150.484C42.275 150.484 41.4259 150.682 40.7943 151.046C40.223 151.378 39.9076 151.799 39.9076 152.223C39.9099 152.649 40.223 153.067 40.7943 153.396C41.4259 153.763 42.275 153.966 43.1813 153.963Z",
    fill: "url(#paint17_linear_3744_1590)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4859 152.331L45.9494 152.329C45.9947 152.329 46.03 152.293 46.03 152.25C46.03 152.202 45.9947 152.168 45.9494 152.168L40.4859 152.166C40.4436 152.168 40.4045 152.202 40.4053 152.247C40.41 152.293 40.4436 152.331 40.4859 152.331Z",
    fill: "url(#paint18_linear_3744_1590)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4191 144.707L47.4207 145.615C47.4551 145.593 47.4927 145.568 47.5326 145.546C48.2964 145.105 49.3232 144.86 50.4267 144.86C51.5294 144.858 52.5539 145.105 53.3216 145.548C53.3584 145.569 53.3968 145.593 53.4304 145.615V144.738L54.3946 144.735V147.064L54.3938 147.062C54.3492 147.549 53.9743 148.019 53.3208 148.392C52.557 148.837 51.5294 149.08 50.4244 149.08C49.3256 149.08 48.2956 148.837 47.5318 148.392C46.8368 147.995 46.4573 147.49 46.4573 146.97V144.707H47.4191Z",
    fill: "url(#paint19_linear_3744_1590)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4261 146.815C51.5272 146.815 52.5579 146.573 53.3226 146.128C54.0183 145.731 54.3963 145.226 54.3963 144.707C54.3963 144.189 54.0183 143.682 53.3226 143.282C52.5556 142.842 51.5311 142.596 50.43 142.598C49.3281 142.598 48.2974 142.843 47.5335 143.282C46.8386 143.685 46.459 144.189 46.459 144.707C46.459 145.226 46.8386 145.732 47.5288 146.128C48.2966 146.573 49.3273 146.815 50.4261 146.815Z",
    fill: "url(#paint20_linear_3744_1590)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M50.426 146.446C51.3369 146.446 52.1829 146.245 52.8161 145.88C53.3874 145.55 53.7028 145.134 53.7028 144.707C53.7028 144.279 53.3874 143.861 52.8184 143.536C52.1829 143.169 51.3369 142.967 50.4291 142.967C49.5189 142.967 48.669 143.165 48.0382 143.529C47.4677 143.861 47.1515 144.281 47.1515 144.707C47.1546 145.132 47.4669 145.55 48.0382 145.879C48.669 146.245 49.5189 146.448 50.426 146.446Z",
    fill: "url(#paint21_linear_3744_1590)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.729 144.814L53.1925 144.81C53.2395 144.81 53.2731 144.776 53.2739 144.732C53.2731 144.685 53.2395 144.651 53.1925 144.651L47.729 144.648C47.6876 144.651 47.6476 144.685 47.6492 144.731C47.6531 144.776 47.6876 144.814 47.729 144.814Z",
    fill: "url(#paint22_linear_3744_1590)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7541 144.249C52.5976 143.982 52.3151 143.72 51.9355 143.504C51.2077 143.084 50.2302 142.855 49.1784 142.855C48.1297 142.855 47.1514 143.085 46.4243 143.504C45.8092 143.862 45.4664 144.296 45.4648 144.731C45.4648 144.894 45.5134 145.053 45.6049 145.215C45.7607 145.482 46.0424 145.739 46.4243 145.962C47.1475 146.376 48.1297 146.61 49.1784 146.61C50.2302 146.61 51.2085 146.381 51.9324 145.962C52.5515 145.604 52.8927 145.167 52.8927 144.731C52.8927 144.57 52.8457 144.409 52.7541 144.249Z",
    fill: "url(#paint23_linear_3744_1590)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9498 141.836L48.9506 142.744C48.9858 142.722 49.0234 142.697 49.0633 142.676C49.8279 142.234 50.8555 141.989 51.9574 141.989C53.0601 141.987 54.0846 142.234 54.8523 142.677C54.8891 142.698 54.9267 142.722 54.9603 142.744V141.866L55.9253 141.865V144.194L55.9237 144.19C55.8791 144.678 55.5043 145.147 54.8515 145.522C54.0877 145.966 53.0586 146.206 51.9543 146.206C50.8555 146.206 49.8264 145.966 49.0625 145.522C48.3668 145.123 47.9888 144.618 47.9888 144.098V141.836H48.9498Z",
    fill: "url(#paint24_linear_3744_1590)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9553 143.946C53.0572 143.946 54.0887 143.701 54.8525 143.259C55.5475 142.86 55.9263 142.355 55.9263 141.837C55.9263 141.318 55.5475 140.811 54.8525 140.412C54.0848 139.972 53.0595 139.726 51.96 139.727C50.8573 139.727 49.8281 139.972 49.0635 140.412C48.3678 140.814 47.9897 141.318 47.9897 141.837C47.9897 142.355 48.3685 142.861 49.0596 143.259C49.8273 143.701 50.8565 143.946 51.9553 143.946Z",
    fill: "url(#paint25_linear_3744_1590)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9551 143.576C52.8661 143.576 53.7129 143.376 54.3453 143.011C54.9174 142.68 55.232 142.264 55.232 141.837C55.232 141.409 54.9181 140.991 54.3476 140.666C53.7129 140.299 52.8661 140.098 51.959 140.098C51.0489 140.098 50.1982 140.295 49.5681 140.66C48.9976 140.991 48.6807 141.412 48.6807 141.837C48.6838 142.262 48.9976 142.68 49.5681 143.009C50.1982 143.376 51.0496 143.579 51.9551 143.576Z",
    fill: "url(#paint26_linear_3744_1590)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2606 141.943L54.7233 141.94C54.7694 141.94 54.8031 141.906 54.8039 141.863C54.8031 141.815 54.7687 141.781 54.7233 141.781L49.2606 141.777C49.2175 141.781 49.1784 141.815 49.18 141.86C49.1831 141.906 49.2183 141.943 49.2606 141.943Z",
    fill: "url(#paint27_linear_3744_1590)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M131.307 145.082L119.591 158.154L134.624 174.793L169.196 173.177L169.313 169.036L174.051 145.423L131.307 145.082Z",
    fill: "url(#paint28_linear_3744_1590)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M205.574 153.012C205.579 153.145 205.528 153.272 205.423 153.391C205.387 153.442 205.337 153.487 205.273 153.529C205.24 153.56 205.199 153.588 205.153 153.614L185.615 164.896L171.262 173.18C170.7 173.506 169.791 173.506 169.222 173.175L151.395 162.884C151.22 162.783 151.097 162.659 151.033 162.536C151.011 162.495 150.993 162.445 150.984 162.394C150.955 162.275 150.974 162.153 151.042 162.038C151.07 161.987 151.107 161.937 151.153 161.89C151.193 161.84 151.254 161.799 151.316 161.753C151.34 161.735 151.363 161.722 151.389 161.703L151.532 161.621L151.77 161.483L152.644 160.98L152.887 160.839L153.76 160.335L154.005 160.193L154.875 159.69L155.112 159.553L155.986 159.049L156.229 158.908L157.101 158.404L157.34 158.267L158.217 157.759L158.456 157.623L159.327 157.119L159.571 156.976L160.446 156.474L160.682 156.336L161.56 155.829L161.799 155.692L162.671 155.19L162.915 155.046L163.786 154.543L164.026 154.406L164.894 153.902L165.141 153.761L166.013 153.258L166.257 153.116L167.129 152.612L167.366 152.475L168.246 151.968L168.483 151.83L169.357 151.327L169.599 151.186L170.472 150.682L170.71 150.545L171.588 150.038L171.825 149.9L172.7 149.397L172.942 149.255L173.814 148.751L174.053 148.615L174.93 148.108L175.169 147.97L176.042 147.467L176.284 147.325L177.158 146.823L177.397 146.686L178.273 146.179L178.338 146.142L178.512 146.042L179.384 145.538L179.628 145.396L180.501 144.892L180.738 144.755L181.608 144.252L181.853 144.111L182.726 143.608L182.969 143.465L183.843 142.962L184.081 142.824L184.949 142.321L185.197 142.179L185.283 142.129C185.428 142.047 185.597 141.988 185.777 141.947C186.111 141.865 186.494 141.869 186.834 141.947C187.011 141.983 187.179 142.047 187.326 142.129L187.415 142.179L187.66 142.321L188.528 142.824L188.767 142.962L189.645 143.469L189.882 143.607L190.756 144.11L190.998 144.251L191.871 144.754L192.11 144.891L192.979 145.395L193.226 145.538L194.104 146.045L194.332 146.177L195.21 146.684L195.456 146.827L196.321 147.324L196.563 147.466L197.435 147.969L197.674 148.107L198.552 148.614L198.791 148.75L199.659 149.254L199.904 149.397L200.777 149.899L201.02 150.042L201.893 150.545L202.136 150.687L203.009 151.19L203.248 151.327L204.116 151.83L204.353 151.968L205.153 152.429C205.181 152.444 205.203 152.457 205.227 152.475C205.29 152.516 205.35 152.562 205.396 152.613C205.438 152.655 205.469 152.699 205.497 152.745C205.524 152.787 205.546 152.832 205.556 152.878C205.569 152.925 205.574 152.97 205.574 153.012Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M205.574 153.012C205.556 153.054 205.528 153.09 205.496 153.128C205.46 153.174 205.405 153.219 205.345 153.265C205.308 153.292 205.268 153.319 205.227 153.342L204.49 153.768L204.243 153.909L203.375 154.413L203.137 154.55L202.264 155.054L202.218 155.082L202.021 155.197L201.148 155.699L200.909 155.836L200.036 156.343H200.031L199.794 156.481L198.921 156.983L198.683 157.126H198.678L197.81 157.63H197.805L197.567 157.766L196.694 158.274H196.689L196.45 158.411L195.577 158.918H195.573L195.34 159.056H195.335L194.466 159.559L194.224 159.697L193.352 160.205H193.347L193.11 160.341L192.24 160.844L191.996 160.986H191.991L191.123 161.489L190.882 161.627L190.009 162.134L189.77 162.272L188.891 162.778H188.887L188.654 162.915H188.65L187.781 163.418L187.537 163.556L186.669 164.063H186.665L186.426 164.201L186.112 164.378L185.553 164.704L185.312 164.846L184.439 165.347L184.2 165.486L183.322 165.993L183.084 166.13L182.211 166.638H182.206L181.969 166.776L181.096 167.279L180.858 167.416L179.985 167.919L179.742 168.061L178.869 168.564L178.63 168.706H178.626L177.753 169.21L177.514 169.347L176.636 169.854L176.4 169.992L175.525 170.495L174.411 171.14L174.172 171.277L173.299 171.784H173.295L173.056 171.922L172.182 172.425L171.941 172.567L171.333 172.919C170.77 173.244 169.856 173.244 169.293 172.919L168.686 172.567L168.447 172.429H168.442L167.565 171.923L167.331 171.785H167.328L166.453 171.278L166.214 171.141L165.342 170.637L165.1 170.495L164.227 169.992L163.988 169.854H163.984L163.116 169.352H163.111L162.872 169.21L161.999 168.706L161.761 168.569H161.757L160.883 168.061H160.878L160.646 167.924H160.641L159.772 167.42L159.571 167.307L159.53 167.28L158.657 166.777H158.652L158.419 166.639H158.413L157.54 166.132L157.302 165.995L156.424 165.487L156.187 165.349L155.315 164.847L155.076 164.71L154.198 164.202L153.959 164.065H153.954L153.087 163.557L152.843 163.42L151.975 162.917H151.972L151.729 162.776L151.459 162.619C151.284 162.524 151.164 162.401 151.102 162.273C151.074 162.227 151.06 162.186 151.052 162.135C151.042 162.103 151.037 162.076 151.037 162.044C151.032 161.901 151.092 161.761 151.215 161.628C151.261 161.582 151.317 161.537 151.381 161.491C151.408 161.477 151.431 161.459 151.459 161.441L152.491 160.846L153.366 160.342L153.603 160.2L154.476 159.698L154.714 159.56L155.587 159.057L155.834 158.915L156.708 158.411L156.946 158.274L157.819 157.766L158.056 157.63L159.154 156.998L159.171 156.984L160.046 156.482L160.287 156.344L161.161 155.837L161.4 155.7L162.496 155.065L162.514 155.054L163.388 154.551L164.746 153.769L165.614 153.267L165.857 153.124L166.73 152.621L166.967 152.483L167.841 151.976H167.846L168.088 151.839L168.958 151.335L169.2 151.194L170.068 150.691H170.072L170.311 150.553L171.184 150.046H171.189L171.427 149.909L172.3 149.406L172.542 149.264L173.412 148.76H173.415L173.654 148.624L174.526 148.116H174.531L174.77 147.979L175.642 147.475L175.886 147.334L176.754 146.831H176.759L176.996 146.694L177.874 146.187L178.112 146.05L178.167 146.017L178.985 145.547L179.227 145.405L180.096 144.901H180.101L180.166 144.865L181.212 144.26L181.455 144.12L182.328 143.616L182.566 143.474H182.571L183.444 142.971L183.682 142.833L184.555 142.33L184.797 142.187L185.352 141.868C185.493 141.785 185.661 141.722 185.841 141.686C186.179 141.607 186.562 141.607 186.901 141.686C187.08 141.727 187.248 141.786 187.39 141.868L187.944 142.187L188.185 142.33L189.06 142.833L189.298 142.971L190.413 143.616L191.285 144.119L191.529 144.26L192.403 144.763L192.64 144.9L193.508 145.404H193.513L193.757 145.546L194.63 146.053L194.862 146.186H194.868L195.744 146.693L195.987 146.835L196.851 147.333H196.855L197.099 147.475L197.967 147.978H197.971L198.205 148.116L199.083 148.623H199.087L199.32 148.759H199.324L200.194 149.263L200.436 149.405H200.44L201.308 149.908H201.314L201.552 150.05H201.557L202.425 150.553L202.672 150.696L203.54 151.198L203.778 151.335L204.647 151.839H204.652L204.884 151.976L205.219 152.168C205.383 152.26 205.496 152.369 205.566 152.483C205.592 152.524 205.612 152.575 205.625 152.621C205.665 152.746 205.646 152.884 205.574 153.012Z",
    fill: "url(#paint29_linear_3744_1590)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.943 172.56L172.185 172.42L168.444 172.421L168.685 172.56H171.943Z",
    fill: "#B6BCC1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.058 171.915L173.3 171.777H167.331L167.569 171.916L173.058 171.915Z",
    fill: "#B6BCC1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M174.173 171.271L174.414 171.133H166.216L166.454 171.271H174.173Z",
    fill: "#B6BCC1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M175.286 170.628L175.525 170.49H165.101L165.345 170.631L175.286 170.628Z",
    fill: "#B6BCC1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M176.4 169.985L176.642 169.848H163.987L164.227 169.986L176.4 169.985Z",
    fill: "#B6BCC1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M177.518 169.34L177.753 169.205H162.874L163.114 169.344L177.518 169.34Z",
    fill: "#B6BCC1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M178.63 168.698L178.872 168.561H161.759L162.001 168.698H178.63Z",
    fill: "#B6BCC1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M179.742 168.056L179.984 167.916L160.647 167.918L160.883 168.056H179.742Z",
    fill: "#B6BCC1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M180.859 167.411L181.098 167.275L159.532 167.271L159.772 167.413L180.859 167.411Z",
    fill: "#B6BCC1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M181.971 166.768L182.212 166.631H158.415L158.657 166.768H181.971Z",
    fill: "#B6BCC1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M183.084 166.125L183.327 165.986L157.304 165.988L157.543 166.126L183.084 166.125Z",
    fill: "#B6BCC1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M184.2 165.482L184.441 165.342L156.19 165.347L156.432 165.482H184.2Z",
    fill: "#B6BCC1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M185.313 164.84L185.557 164.701L155.075 164.704L155.319 164.843L185.313 164.84Z",
    fill: "#B6BCC1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M186.428 164.197L186.67 164.057H153.959L154.202 164.197H186.428Z",
    fill: "#B6BCC1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M187.539 163.553L187.782 163.414L152.846 163.416L153.089 163.553H187.539Z",
    fill: "#B6BCC1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M188.656 162.909L188.894 162.773L151.733 162.771L151.974 162.909H188.656Z",
    fill: "#B6BCC1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M189.77 162.267L190.009 162.129L151.057 162.131C151.065 162.181 151.079 162.224 151.107 162.268L189.77 162.267Z",
    fill: "#B6BCC1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M191.124 161.485L190.882 161.622H181.645C181.645 161.622 181.645 161.622 181.64 161.622H164.563C164.563 161.622 164.558 161.618 164.558 161.622H151.219C151.265 161.576 151.321 161.531 151.385 161.485H181.476C181.476 161.485 181.482 161.48 181.482 161.485H191.124Z",
    fill: "#B6BCC1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M191.997 160.979L192.239 160.84H152.496L152.252 160.979H191.997Z",
    fill: "#B6BCC1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M193.348 160.202L193.111 160.338H153.371L153.607 160.195H165.202L175.153 160.202H193.348Z",
    fill: "#B6BCC1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M194.466 159.555L194.224 159.692H181.226C181.226 159.692 181.226 159.692 181.221 159.692H154.48L154.718 159.555H158.907C158.907 159.555 158.907 159.555 158.912 159.555H194.466Z",
    fill: "#B6BCC1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M195.573 158.914L195.341 159.052H155.592L155.839 158.91H173.287L182.871 158.914H195.573Z",
    fill: "#B6BCC1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M196.689 158.27L196.451 158.407H156.713L156.951 158.27H196.689Z",
    fill: "#B6BCC1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M197.805 157.627L197.567 157.763H157.824L158.061 157.627H197.805Z",
    fill: "#B6BCC1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M198.921 156.981L198.683 157.124H158.938L159.159 156.996L159.176 156.982H189.683C189.683 156.982 189.689 156.978 189.689 156.982H198.921V156.981Z",
    fill: "#B6BCC1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M200.031 156.34L199.794 156.478H160.051L160.293 156.34H184.344C184.344 156.34 184.344 156.335 184.349 156.34H200.031Z",
    fill: "#B6BCC1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M201.148 155.695L200.909 155.832H161.166L161.405 155.695H194.335C194.459 155.7 194.582 155.7 194.705 155.695H201.148Z",
    fill: "#B6BCC1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M202.263 155.051L202.217 155.079L202.025 155.194H162.28L162.501 155.061L162.519 155.051H183.69C183.69 155.051 183.69 155.047 183.696 155.051H202.263Z",
    fill: "#B6BCC1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M203.138 154.548L203.375 154.41H163.633L163.393 154.548H203.138Z",
    fill: "#B6BCC1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M204.251 153.906L204.49 153.766H164.75L164.51 153.906H204.251Z",
    fill: "#B6BCC1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M205.496 153.128C205.46 153.174 205.405 153.219 205.345 153.265H165.619L165.863 153.123H181.757L187.001 153.128H193.2C193.2 153.128 193.206 153.128 193.211 153.128H205.496Z",
    fill: "#B6BCC1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M205.628 152.618H166.735L166.973 152.48H205.569C205.596 152.521 205.615 152.573 205.628 152.618Z",
    fill: "#B6BCC1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M204.897 151.974H167.851L168.092 151.836H204.655L204.897 151.974Z",
    fill: "#B6BCC1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M203.781 151.334H168.964L169.205 151.193H178.999C179.005 151.193 179.005 151.193 179.005 151.193H184.605L191.108 151.197H203.545L203.781 151.334Z",
    fill: "#B6BCC1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M202.676 150.694H186.726L185.135 150.69H170.077L170.316 150.553H202.428L202.676 150.694Z",
    fill: "#B6BCC1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M201.554 150.049H192.377C192.373 150.044 192.368 150.044 192.368 150.049H187.036L185.435 150.044H171.193L171.431 149.906H201.316L201.554 150.049Z",
    fill: "#B6BCC1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M200.438 149.404H172.305L172.546 149.262H200.202L200.438 149.404Z",
    fill: "#B6BCC1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M199.323 148.759H173.42L173.658 148.623H199.09L199.323 148.759Z",
    fill: "#B6BCC1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M198.215 148.115H174.536L174.774 147.979H197.974L198.215 148.115Z",
    fill: "#B6BCC1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M197.102 147.474H175.647L175.89 147.332H196.858L197.102 147.474Z",
    fill: "#B6BCC1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M195.99 146.836H187.595L183.8 146.83H176.763L177 146.693H195.746L195.99 146.836Z",
    fill: "#B6BCC1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M194.864 146.186H177.878L178.116 146.049H183.881L187.302 146.054H194.632L194.864 146.186Z",
    fill: "#B6BCC1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M193.758 145.544L193.517 145.404H179.231L178.989 145.544H193.758Z",
    fill: "#B6BCC1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M192.643 144.901L192.403 144.761L180.346 144.76L180.102 144.901L192.643 144.901Z",
    fill: "#B6BCC1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M191.53 144.259L191.29 144.119H181.457L181.215 144.258L191.53 144.259Z",
    fill: "#B6BCC1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M190.416 143.615L190.176 143.477L182.571 143.477L182.332 143.615H190.416Z",
    fill: "#B6BCC1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M189.303 142.971L189.063 142.832H183.685L183.445 142.971H189.303Z",
    fill: "#B6BCC1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M188.188 142.328L187.946 142.188H184.8L184.558 142.328H188.188Z",
    fill: "#B6BCC1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M186.904 141.684C186.564 141.609 186.184 141.607 185.845 141.684H186.904Z",
    fill: "#B6BCC1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M159.067 160.945C157.555 161.818 157.555 163.235 159.067 164.108C160.58 164.98 163.031 164.98 164.546 164.108C166.058 163.235 166.06 161.817 164.549 160.945C163.034 160.069 160.58 160.072 159.067 160.945Z",
    fill: "#F0F7FA"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M161.808 164.667C162.827 164.666 163.781 164.441 164.498 164.026C165.2 163.62 165.587 163.088 165.587 162.525C165.587 161.963 165.201 161.433 164.498 161.027C163.78 160.613 162.825 160.385 161.808 160.385C160.788 160.383 159.832 160.613 159.115 161.027C158.414 161.431 158.027 161.963 158.029 162.525C158.029 163.088 158.414 163.62 159.115 164.026C159.832 164.439 160.788 164.667 161.808 164.667Z",
    fill: "url(#paint30_linear_3744_1590)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M164.999 162.094C164.86 161.854 164.608 161.623 164.268 161.429C163.619 161.053 162.744 160.85 161.806 160.85C160.868 160.85 159.997 161.055 159.348 161.429C158.797 161.748 158.492 162.136 158.491 162.524C158.491 162.67 158.533 162.812 158.613 162.956C158.754 163.195 159.005 163.425 159.348 163.625C159.992 163.996 160.867 164.203 161.806 164.203C162.743 164.203 163.62 163.998 164.266 163.625C164.818 163.306 165.123 162.914 165.123 162.525C165.123 162.38 165.081 162.237 164.999 162.094Z",
    fill: "#9FA1A3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M159.499 160.736L159.5 161.433C159.527 161.416 159.556 161.397 159.585 161.382C160.172 161.042 160.96 160.855 161.808 160.855C162.654 160.853 163.441 161.042 164.03 161.383C164.058 161.398 164.086 161.416 164.113 161.433V160.76L164.853 160.759V162.546L164.852 162.543C164.818 162.917 164.529 163.278 164.029 163.566C163.441 163.907 162.653 164.091 161.806 164.091C160.961 164.091 160.172 163.907 159.585 163.566C159.052 163.259 158.762 162.873 158.762 162.474V160.737L159.499 160.736Z",
    fill: "url(#paint31_linear_3744_1590)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M161.807 162.354C162.651 162.354 163.442 162.167 164.03 161.826C164.564 161.522 164.854 161.133 164.854 160.735C164.854 160.338 164.564 159.949 164.03 159.642C163.441 159.304 162.654 159.114 161.81 159.115C160.962 159.115 160.172 159.304 159.585 159.642C159.053 159.95 158.763 160.338 158.763 160.735C158.763 161.133 159.053 161.522 159.584 161.826C160.172 162.167 160.962 162.354 161.807 162.354Z",
    fill: "url(#paint32_linear_3744_1590)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M161.807 162.071C162.505 162.071 163.155 161.918 163.641 161.637C164.081 161.384 164.322 161.065 164.322 160.737C164.322 160.408 164.08 160.088 163.643 159.838C163.155 159.557 162.505 159.402 161.81 159.402C161.11 159.402 160.458 159.553 159.974 159.834C159.535 160.088 159.295 160.41 159.295 160.737C159.295 161.064 159.535 161.384 159.974 161.636C160.458 161.917 161.11 162.072 161.807 162.071Z",
    fill: "url(#paint33_linear_3744_1590)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M159.736 160.818L163.929 160.817C163.964 160.817 163.991 160.789 163.992 160.756C163.991 160.72 163.964 160.694 163.929 160.694L159.736 160.691C159.704 160.694 159.675 160.72 159.675 160.756C159.677 160.789 159.704 160.818 159.736 160.818Z",
    fill: "#A8BAC1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.328 163.739C164.62 163.572 164.848 163.379 165.005 163.177C165.162 162.972 165.25 162.754 165.259 162.536C165.259 162.524 165.259 162.515 165.259 162.5L165.258 162.059C165.258 162.011 165.259 161.962 165.258 161.915L165.259 161.497V161.122C165.263 161.047 165.259 160.975 165.263 160.913C165.259 160.726 165.263 160.593 165.259 160.548C165.259 160.543 165.259 160.543 165.263 160.543C165.259 160.54 165.259 160.536 165.263 160.533C165.259 160.08 164.929 159.64 164.325 159.292C163.658 158.91 162.765 158.697 161.81 158.697C160.85 158.698 159.953 158.909 159.289 159.294C158.729 159.618 158.403 160.021 158.36 160.436C158.36 160.436 158.36 160.436 158.358 160.439C158.357 160.471 158.357 160.5 158.354 160.533C158.357 160.54 158.357 160.548 158.357 160.559V162.58H158.36C158.361 162.592 158.361 162.603 158.366 162.613C158.387 162.811 158.473 163.003 158.619 163.186C158.772 163.385 158.999 163.571 159.29 163.739C159.304 163.749 159.319 163.756 159.339 163.766C159.878 164.063 160.559 164.253 161.303 164.316C161.465 164.326 161.634 164.331 161.806 164.331C162.762 164.334 163.658 164.126 164.328 163.739Z",
    fill: "#F0F7FA"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.81 162.369C160.85 162.369 159.954 162.157 159.289 161.771C158.686 161.422 158.355 160.982 158.355 160.534C158.355 160.082 158.686 159.642 159.287 159.296C159.954 158.911 160.85 158.699 161.81 158.699C162.765 158.699 163.658 158.912 164.325 159.294C164.928 159.642 165.26 160.084 165.26 160.534C165.26 160.982 164.928 161.422 164.327 161.771C163.658 162.158 162.765 162.369 161.81 162.369Z",
    fill: "#F0F7FA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.029 161.912C160.343 161.912 159.705 161.762 159.229 161.484C158.799 161.238 158.564 160.924 158.562 160.603C158.562 160.281 158.799 159.965 159.231 159.719C159.704 159.442 160.346 159.29 161.028 159.291C161.711 159.291 162.35 159.442 162.828 159.719C163.257 159.964 163.494 160.278 163.494 160.603C163.498 160.924 163.257 161.237 162.828 161.486C162.35 161.762 161.713 161.912 161.029 161.912Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.62 163.188C158.62 163.188 158.574 161.301 158.577 161.152C158.441 160.945 158.341 160.729 158.361 160.438C158.353 160.891 158.364 161.568 158.367 162.615C158.387 162.813 158.473 163.005 158.62 163.188Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.303 164.317C161.326 163.549 161.353 162.7 161.357 162.336C160.903 162.318 159.929 162.06 159.415 161.838L159.339 163.767C159.879 164.064 160.559 164.255 161.303 164.317Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.005 163.177C165.162 162.972 165.25 162.753 165.259 162.536C165.258 162.38 165.258 162.221 165.258 162.06C165.258 162.012 165.259 161.962 165.258 161.916C165.258 161.775 165.258 161.634 165.259 161.498C165.259 161.364 165.258 161.238 165.259 161.122C165.263 161.048 165.259 160.975 165.263 160.914C165.259 160.726 165.263 160.593 165.259 160.549C165.256 160.701 165.216 160.869 165.138 160.999C165.106 161.068 165.057 161.132 165.015 161.194L165.005 163.177Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M167.656 165.811C166.142 166.685 166.143 168.101 167.656 168.974C169.17 169.847 171.623 169.846 173.136 168.974C174.648 168.101 174.648 166.684 173.136 165.811C171.623 164.938 169.169 164.938 167.656 165.811Z",
    fill: "#F0F7FA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 169.534C171.413 169.534 172.37 169.305 173.086 168.892C173.79 168.487 174.175 167.956 174.175 167.391C174.175 166.83 173.79 166.297 173.087 165.893C172.37 165.479 171.413 165.25 170.395 165.25C169.377 165.25 168.419 165.48 167.704 165.893C167.002 166.298 166.617 166.83 166.616 167.392C166.614 167.956 167.002 168.487 167.704 168.891C168.421 169.309 169.377 169.536 170.395 169.534Z",
    fill: "url(#paint34_linear_3744_1590)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M173.587 166.963C173.448 166.722 173.197 166.49 172.855 166.294C172.209 165.921 171.335 165.714 170.395 165.713C169.457 165.713 168.585 165.921 167.936 166.294C167.385 166.612 167.081 167.003 167.081 167.391C167.081 167.538 167.121 167.68 167.205 167.82C167.342 168.062 167.596 168.292 167.936 168.489C168.583 168.863 169.457 169.07 170.395 169.071C171.332 169.07 172.206 168.863 172.855 168.489C173.406 168.171 173.711 167.78 173.711 167.392C173.71 167.248 173.669 167.105 173.587 166.963Z",
    fill: "#9FA1A3"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M168.089 165.604V166.297C168.114 166.279 168.146 166.265 168.171 166.249C168.762 165.909 169.55 165.721 170.394 165.721C171.24 165.723 172.031 165.909 172.617 166.247C172.646 166.265 172.674 166.279 172.704 166.299L172.7 165.624L173.441 165.623V167.409L173.439 167.411C173.404 167.783 173.118 168.145 172.619 168.434C172.031 168.773 171.239 168.958 170.393 168.96C169.549 168.96 168.758 168.771 168.171 168.432C167.642 168.124 167.346 167.737 167.346 167.338V165.602L168.089 165.604Z",
    fill: "url(#paint35_linear_3744_1590)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 167.222C171.241 167.222 172.029 167.036 172.618 166.696C173.148 166.389 173.442 166 173.442 165.602C173.442 165.206 173.148 164.816 172.618 164.51C172.032 164.17 171.241 163.984 170.395 163.984C169.55 163.986 168.762 164.169 168.172 164.51C167.643 164.817 167.347 165.206 167.347 165.602C167.347 166.001 167.643 166.389 168.172 166.696C168.761 167.035 169.55 167.221 170.395 167.222Z",
    fill: "url(#paint36_linear_3744_1590)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 166.937C171.091 166.937 171.743 166.783 172.228 166.504C172.668 166.249 172.906 165.932 172.909 165.603C172.906 165.273 172.668 164.954 172.229 164.701C171.743 164.421 171.091 164.266 170.395 164.266C169.697 164.266 169.046 164.421 168.56 164.701C168.123 164.953 167.885 165.274 167.882 165.602C167.882 165.929 168.125 166.249 168.56 166.504C169.05 166.783 169.697 166.937 170.395 166.937Z",
    fill: "url(#paint37_linear_3744_1590)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M168.326 165.685L172.516 165.683C172.553 165.682 172.581 165.655 172.581 165.621C172.581 165.587 172.554 165.558 172.516 165.557L168.326 165.558C168.294 165.558 168.265 165.587 168.265 165.621C168.267 165.657 168.295 165.685 168.326 165.685Z",
    fill: "#A8BAC1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.914 168.606C173.206 168.438 173.436 168.245 173.591 168.041C173.75 167.839 173.837 167.622 173.843 167.405C173.845 167.391 173.843 167.38 173.845 167.368V166.926C173.843 166.877 173.845 166.83 173.845 166.785V166.365V165.991C173.849 165.914 173.845 165.842 173.849 165.779C173.845 165.592 173.852 165.46 173.849 165.414C173.849 165.412 173.849 165.412 173.852 165.41C173.849 165.407 173.849 165.402 173.849 165.398C173.849 164.949 173.515 164.507 172.914 164.16C172.247 163.777 171.353 163.563 170.394 163.564C169.435 163.566 168.544 163.777 167.874 164.163C167.315 164.484 166.991 164.888 166.949 165.303C166.949 165.303 166.949 165.303 166.949 165.307C166.943 165.338 166.94 165.368 166.943 165.397C166.943 165.407 166.943 165.415 166.944 165.426L166.94 167.445L166.946 167.449C166.949 167.46 166.949 167.47 166.954 167.482C166.973 167.678 167.062 167.87 167.205 168.052C167.359 168.253 167.588 168.441 167.873 168.605C167.891 168.615 167.907 168.623 167.927 168.633C168.466 168.932 169.149 169.123 169.888 169.182C170.055 169.194 170.221 169.202 170.393 169.202C171.353 169.204 172.248 168.99 172.914 168.606Z",
    fill: "#F0F7FA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.395 167.232C169.436 167.232 168.545 167.022 167.877 166.636C167.273 166.29 166.944 165.848 166.944 165.398C166.944 164.949 167.277 164.509 167.877 164.163C168.544 163.775 169.436 163.562 170.395 163.562C171.354 163.562 172.248 163.775 172.915 164.16C173.516 164.509 173.849 164.949 173.846 165.4C173.849 165.848 173.516 166.29 172.915 166.637C172.248 167.022 171.355 167.233 170.395 167.232Z",
    fill: "#F0F7FA"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.618 166.78C168.932 166.778 168.295 166.63 167.819 166.355C167.387 166.103 167.151 165.789 167.151 165.468C167.151 165.148 167.387 164.834 167.819 164.586C168.294 164.309 168.932 164.158 169.616 164.158C170.301 164.158 170.942 164.308 171.418 164.582C171.845 164.834 172.083 165.146 172.083 165.468C172.08 165.789 171.844 166.105 171.418 166.353C170.941 166.629 170.302 166.778 169.618 166.78Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.206 168.051C167.206 168.051 167.163 166.164 167.163 166.017C167.028 165.809 166.929 165.594 166.95 165.303C166.94 165.754 166.951 166.434 166.955 167.482C166.973 167.677 167.063 167.87 167.206 168.051Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.889 169.182C169.913 168.415 169.941 167.569 169.944 167.204C169.493 167.182 168.516 166.927 168.002 166.705L167.929 168.633C168.467 168.932 169.151 169.123 169.889 169.182Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.592 168.039C173.751 167.837 173.838 167.621 173.844 167.403C173.844 167.25 173.845 167.087 173.845 166.924C173.844 166.876 173.845 166.829 173.845 166.783C173.844 166.641 173.844 166.499 173.845 166.364C173.845 166.229 173.845 166.103 173.845 165.989C173.849 165.912 173.845 165.84 173.849 165.778C173.845 165.591 173.853 165.458 173.849 165.412C173.844 165.566 173.803 165.735 173.724 165.864C173.694 165.931 173.647 165.994 173.604 166.059L173.592 168.039Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M167.11 156.302C165.595 157.174 165.595 158.59 167.108 159.465C168.62 160.337 171.073 160.337 172.587 159.463C174.102 158.591 174.098 157.174 172.589 156.302C171.074 155.428 168.623 155.428 167.11 156.302Z",
    fill: "#F0F7FA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M169.846 160.025C170.867 160.025 171.822 159.798 172.539 159.385C173.241 158.978 173.629 158.448 173.629 157.883C173.629 157.322 173.242 156.789 172.541 156.383C171.822 155.971 170.866 155.742 169.848 155.742C168.828 155.742 167.874 155.971 167.157 156.383C166.454 156.789 166.066 157.322 166.068 157.884C166.066 158.448 166.453 158.978 167.157 159.385C167.875 159.798 168.829 160.025 169.846 160.025Z",
    fill: "url(#paint38_linear_3744_1590)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M173.039 157.452C172.901 157.214 172.646 156.981 172.309 156.787C171.66 156.411 170.789 156.205 169.848 156.207C168.912 156.207 168.036 156.412 167.387 156.789C166.837 157.105 166.533 157.494 166.533 157.883C166.533 158.027 166.575 158.171 166.656 158.313C166.794 158.553 167.045 158.783 167.387 158.981C168.034 159.355 168.908 159.562 169.846 159.562C170.783 159.562 171.661 159.355 172.308 158.981C172.858 158.664 173.162 158.273 173.163 157.884C173.164 157.739 173.121 157.595 173.039 157.452Z",
    fill: "#9FA1A3"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M167.542 156.094L167.54 156.79C167.569 156.773 167.596 156.757 167.624 156.74C168.214 156.399 169.002 156.213 169.846 156.213C170.691 156.213 171.481 156.401 172.071 156.74C172.1 156.757 172.128 156.773 172.155 156.79V156.119H172.894V157.902L172.892 157.901C172.859 158.276 172.57 158.636 172.07 158.924C171.482 159.265 170.691 159.452 169.848 159.452C169.002 159.45 168.214 159.265 167.624 158.924C167.095 158.615 166.8 158.23 166.8 157.831V156.095H167.542V156.094Z",
    fill: "url(#paint39_linear_3744_1590)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M169.848 157.713C170.691 157.713 171.484 157.528 172.07 157.186C172.602 156.88 172.897 156.494 172.894 156.093C172.894 155.697 172.602 155.307 172.07 155.001C171.484 154.661 170.691 154.472 169.848 154.475C169.002 154.475 168.214 154.663 167.624 155.003C167.095 155.31 166.8 155.697 166.8 156.094C166.8 156.493 167.095 156.881 167.624 157.186C168.212 157.528 169.002 157.713 169.848 157.713Z",
    fill: "url(#paint40_linear_3744_1590)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M169.846 157.429C170.544 157.429 171.196 157.273 171.682 156.994C172.12 156.74 172.36 156.423 172.36 156.093C172.36 155.765 172.12 155.445 171.683 155.194C171.196 154.912 170.544 154.759 169.848 154.76C169.151 154.759 168.499 154.91 168.012 155.193C167.574 155.445 167.335 155.769 167.335 156.093C167.335 156.42 167.575 156.74 168.015 156.994C168.502 157.277 169.152 157.43 169.846 157.429Z",
    fill: "url(#paint41_linear_3744_1590)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M167.779 156.176H171.97C172.006 156.174 172.033 156.147 172.035 156.115C172.033 156.079 172.005 156.052 171.972 156.052L167.777 156.049C167.746 156.052 167.718 156.078 167.719 156.113C167.718 156.147 167.746 156.176 167.779 156.176Z",
    fill: "#A8BAC1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.368 159.098C172.66 158.928 172.888 158.737 173.045 158.534C173.203 158.329 173.29 158.113 173.298 157.893C173.299 157.883 173.299 157.871 173.299 157.859L173.298 157.418C173.298 157.37 173.299 157.321 173.299 157.273V156.856V156.482C173.302 156.406 173.299 156.334 173.302 156.272C173.301 156.085 173.302 155.951 173.301 155.906C173.299 155.903 173.299 155.903 173.302 155.902C173.299 155.899 173.301 155.893 173.302 155.891C173.301 155.439 172.967 155 172.366 154.652C171.7 154.268 170.807 154.055 169.851 154.055C168.892 154.058 167.995 154.268 167.33 154.653C166.769 154.975 166.446 155.378 166.401 155.794C166.401 155.794 166.401 155.794 166.4 155.798C166.397 155.829 166.395 155.859 166.397 155.89C166.395 155.899 166.395 155.907 166.395 155.918V157.94H166.401C166.401 157.951 166.401 157.962 166.406 157.972C166.426 158.17 166.516 158.361 166.657 158.544C166.813 158.743 167.041 158.93 167.329 159.099C167.345 159.105 167.359 159.114 167.379 159.124C167.918 159.422 168.599 159.614 169.342 159.672C169.505 159.685 169.674 159.693 169.846 159.691C170.804 159.693 171.702 159.483 172.368 159.098Z",
    fill: "#F0F7FA"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.848 157.728C168.892 157.726 167.995 157.514 167.33 157.129C166.727 156.781 166.396 156.34 166.396 155.891C166.396 155.44 166.728 155 167.33 154.653C167.997 154.268 168.892 154.057 169.848 154.059C170.805 154.057 171.701 154.269 172.366 154.653C172.967 155.001 173.301 155.44 173.301 155.891C173.299 156.34 172.967 156.782 172.368 157.129C171.7 157.513 170.807 157.725 169.848 157.728Z",
    fill: "#F0F7FA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.072 157.271C168.387 157.271 167.746 157.123 167.27 156.845C166.842 156.598 166.602 156.283 166.602 155.963C166.602 155.639 166.842 155.323 167.27 155.076C167.745 154.8 168.387 154.65 169.072 154.65C169.755 154.65 170.393 154.801 170.869 155.078C171.298 155.324 171.536 155.637 171.538 155.961C171.538 156.283 171.297 156.596 170.869 156.845C170.393 157.12 169.755 157.271 169.072 157.271Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.658 158.545C166.658 158.545 166.617 156.659 166.617 156.508C166.483 156.302 166.379 156.088 166.402 155.795C166.396 156.246 166.407 156.923 166.407 157.972C166.427 158.171 166.516 158.361 166.658 158.545Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.343 159.673C169.367 158.907 169.393 158.06 169.397 157.693C168.946 157.677 167.968 157.419 167.454 157.197L167.38 159.126C167.92 159.423 168.6 159.616 169.343 159.673Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.045 158.534C173.203 158.329 173.29 158.112 173.298 157.893C173.298 157.739 173.299 157.579 173.298 157.417C173.298 157.37 173.299 157.32 173.299 157.273C173.299 157.133 173.299 156.991 173.299 156.856C173.299 156.723 173.299 156.597 173.299 156.482C173.302 156.406 173.299 156.334 173.302 156.272C173.301 156.085 173.302 155.951 173.301 155.906C173.298 156.06 173.256 156.226 173.181 156.357C173.146 156.426 173.097 156.491 173.057 156.553L173.045 158.534Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M175.697 161.169C174.185 162.042 174.185 163.457 175.697 164.331C177.21 165.205 179.663 165.205 181.177 164.331C182.688 163.457 182.69 162.042 181.177 161.165C179.663 160.296 177.21 160.296 175.697 161.169Z",
    fill: "#F0F7FA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 164.892C179.455 164.892 180.409 164.661 181.128 164.247C181.829 163.842 182.214 163.309 182.214 162.749C182.214 162.188 181.829 161.654 181.128 161.25C180.409 160.836 179.454 160.609 178.435 160.609C177.418 160.609 176.463 160.836 175.743 161.25C175.042 161.654 174.656 162.186 174.656 162.749C174.656 163.309 175.042 163.842 175.743 164.245C176.463 164.663 177.418 164.892 178.435 164.892Z",
    fill: "url(#paint42_linear_3744_1590)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M181.627 162.32C181.489 162.08 181.235 161.849 180.897 161.652C180.247 161.279 179.374 161.074 178.434 161.074C177.496 161.074 176.625 161.28 175.974 161.653C175.423 161.971 175.12 162.361 175.12 162.751C175.12 162.896 175.16 163.039 175.241 163.18C175.379 163.421 175.635 163.653 175.973 163.848C176.622 164.223 177.495 164.427 178.433 164.429C179.371 164.427 180.245 164.223 180.895 163.848C181.446 163.529 181.749 163.139 181.751 162.751C181.752 162.606 181.708 162.463 181.627 162.32Z",
    fill: "#9FA1A3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M176.128 160.958V161.654C176.155 161.639 176.186 161.623 176.214 161.604C176.802 161.265 177.592 161.078 178.436 161.078C179.282 161.078 180.071 161.265 180.659 161.604C180.688 161.621 180.716 161.639 180.743 161.656V160.981H181.482L181.483 162.766L181.478 162.769C181.446 163.141 181.161 163.501 180.661 163.789C180.071 164.131 179.28 164.316 178.434 164.316C177.591 164.316 176.8 164.128 176.213 163.788C175.681 163.482 175.389 163.095 175.389 162.696V160.957H176.128V160.958Z",
    fill: "url(#paint43_linear_3744_1590)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 162.579C179.281 162.579 180.071 162.392 180.657 162.052C181.19 161.745 181.484 161.357 181.482 160.958C181.482 160.563 181.19 160.175 180.657 159.867C180.071 159.528 179.282 159.34 178.435 159.34C177.592 159.34 176.801 159.528 176.212 159.867C175.682 160.175 175.39 160.563 175.39 160.958C175.39 161.357 175.682 161.746 176.214 162.053C176.802 162.392 177.59 162.577 178.435 162.579Z",
    fill: "url(#paint44_linear_3744_1590)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 162.296C179.133 162.297 179.783 162.141 180.269 161.861C180.707 161.607 180.95 161.288 180.95 160.961C180.95 160.632 180.707 160.313 180.271 160.057C179.785 159.778 179.133 159.625 178.435 159.623C177.738 159.623 177.088 159.777 176.603 160.058C176.164 160.313 175.925 160.633 175.923 160.958C175.922 161.288 176.165 161.607 176.603 161.86C177.088 162.14 177.738 162.296 178.435 162.296Z",
    fill: "url(#paint45_linear_3744_1590)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M176.368 161.04H180.558C180.593 161.04 180.621 161.012 180.621 160.98C180.621 160.945 180.595 160.916 180.558 160.916H176.368C176.333 160.916 176.305 160.945 176.305 160.977C176.305 161.013 176.334 161.042 176.368 161.04Z",
    fill: "#A8BAC1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.955 163.963C181.248 163.794 181.477 163.603 181.632 163.4C181.789 163.196 181.879 162.98 181.885 162.761C181.885 162.75 181.885 162.738 181.885 162.727V162.284C181.885 162.236 181.885 162.188 181.885 162.141V161.725L181.887 161.348C181.887 161.272 181.887 161.2 181.887 161.138C181.885 160.953 181.892 160.819 181.887 160.776C181.887 160.772 181.887 160.772 181.892 160.77C181.887 160.765 181.887 160.761 181.887 160.758C181.891 160.308 181.559 159.866 180.955 159.519C180.29 159.137 179.394 158.924 178.436 158.924C177.478 158.925 176.583 159.135 175.916 159.52C175.358 159.845 175.034 160.245 174.988 160.663C174.988 160.663 174.988 160.663 174.988 160.666C174.987 160.698 174.984 160.725 174.984 160.754C174.984 160.767 174.984 160.775 174.985 160.785L174.984 162.806H174.988C174.99 162.82 174.99 162.828 174.994 162.84C175.015 163.039 175.099 163.229 175.249 163.411C175.401 163.612 175.627 163.799 175.916 163.963C175.934 163.973 175.95 163.984 175.967 163.991C176.506 164.293 177.189 164.481 177.931 164.54C178.095 164.553 178.264 164.56 178.435 164.56C179.394 164.56 180.29 164.347 180.955 163.963Z",
    fill: "#F0F7FA"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M178.437 162.592C177.479 162.588 176.583 162.379 175.917 161.993C175.317 161.646 174.986 161.206 174.984 160.756C174.986 160.306 175.318 159.866 175.917 159.517C176.583 159.133 177.478 158.922 178.435 158.922C179.394 158.922 180.29 159.133 180.955 159.517C181.559 159.864 181.887 160.306 181.887 160.756C181.887 161.208 181.558 161.649 180.955 161.994C180.29 162.379 179.395 162.592 178.437 162.592Z",
    fill: "#F0F7FA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.658 162.137C176.974 162.137 176.337 161.987 175.86 161.711C175.429 161.462 175.191 161.146 175.192 160.827C175.192 160.506 175.429 160.189 175.858 159.942C176.337 159.665 176.976 159.514 177.658 159.516C178.343 159.514 178.981 159.665 179.458 159.941C179.889 160.191 180.125 160.505 180.125 160.827C180.123 161.146 179.889 161.461 179.458 161.711C178.981 161.987 178.342 162.137 177.658 162.137Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M175.25 163.409C175.25 163.409 175.205 161.523 175.203 161.373C175.067 161.163 174.969 160.953 174.989 160.66C174.984 161.111 174.994 161.789 174.995 162.837C175.016 163.037 175.099 163.227 175.25 163.409Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.931 164.54C177.956 163.773 177.983 162.926 177.986 162.56C177.532 162.544 176.557 162.287 176.042 162.062L175.967 163.992C176.507 164.292 177.189 164.482 177.931 164.54Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.632 163.4C181.789 163.196 181.879 162.98 181.885 162.761C181.885 162.608 181.885 162.446 181.885 162.283C181.885 162.236 181.885 162.188 181.885 162.141C181.885 161.997 181.885 161.855 181.885 161.725C181.885 161.588 181.885 161.463 181.887 161.347C181.887 161.272 181.887 161.2 181.887 161.138C181.885 160.953 181.892 160.819 181.887 160.775C181.885 160.927 181.846 161.094 181.766 161.224C181.734 161.292 181.685 161.358 181.646 161.418L181.632 163.4Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M175.15 151.661C173.636 152.535 173.637 153.95 175.152 154.824C176.664 155.696 179.116 155.697 180.629 154.822C182.142 153.95 182.142 152.533 180.629 151.661C179.116 150.787 176.663 150.787 175.15 151.661Z",
    fill: "#F0F7FA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 155.383C178.907 155.381 179.862 155.154 180.581 154.74C181.281 154.335 181.668 153.803 181.668 153.24C181.668 152.677 181.283 152.146 180.58 151.741C179.861 151.326 178.907 151.1 177.889 151.1C176.87 151.097 175.913 151.328 175.197 151.741C174.494 152.147 174.108 152.676 174.11 153.24C174.11 153.803 174.493 154.334 175.197 154.74C175.913 155.153 176.87 155.383 177.89 155.383Z",
    fill: "url(#paint46_linear_3744_1590)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M181.079 152.81C180.942 152.57 180.688 152.338 180.35 152.142C179.701 151.766 178.826 151.564 177.889 151.564C176.953 151.564 176.078 151.771 175.429 152.142C174.876 152.462 174.575 152.851 174.575 153.239C174.575 153.383 174.614 153.529 174.696 153.672C174.836 153.909 175.086 154.138 175.429 154.338C176.078 154.71 176.949 154.916 177.889 154.916C178.826 154.918 179.701 154.711 180.35 154.338C180.9 154.02 181.204 153.629 181.205 153.24C181.204 153.094 181.162 152.95 181.079 152.81Z",
    fill: "#9FA1A3"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M175.582 151.449V152.146C175.609 152.13 175.637 152.112 175.667 152.096C176.254 151.756 177.042 151.567 177.889 151.569C178.732 151.567 179.522 151.756 180.111 152.096C180.141 152.113 180.167 152.13 180.193 152.148V151.473H180.934L180.936 153.259L180.931 153.257C180.899 153.631 180.609 153.991 180.11 154.279C179.521 154.62 178.735 154.807 177.889 154.807C177.042 154.807 176.253 154.62 175.664 154.279C175.132 153.973 174.84 153.587 174.84 153.186V151.451L175.582 151.449Z",
    fill: "url(#paint47_linear_3744_1590)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 153.071C178.733 153.069 179.523 152.886 180.114 152.545C180.643 152.239 180.938 151.85 180.936 151.451C180.938 151.056 180.643 150.667 180.112 150.36C179.523 150.019 178.733 149.832 177.89 149.832C177.044 149.832 176.254 150.021 175.667 150.36C175.134 150.669 174.842 151.056 174.842 151.452C174.842 151.85 175.134 152.239 175.666 152.545C176.253 152.882 177.044 153.071 177.89 153.071Z",
    fill: "url(#paint48_linear_3744_1590)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M177.889 152.786C178.587 152.786 179.237 152.632 179.722 152.351C180.16 152.099 180.404 151.778 180.402 151.452C180.402 151.124 180.159 150.804 179.724 150.552C179.237 150.272 178.585 150.115 177.89 150.115C177.192 150.115 176.54 150.268 176.054 150.549C175.615 150.802 175.377 151.126 175.377 151.45C175.374 151.778 175.616 152.099 176.054 152.351C176.542 152.634 177.192 152.788 177.889 152.786Z",
    fill: "url(#paint49_linear_3744_1590)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M175.82 151.535L180.012 151.533C180.046 151.533 180.074 151.505 180.074 151.471C180.073 151.438 180.046 151.41 180.013 151.41H175.818C175.786 151.41 175.757 151.438 175.757 151.47C175.757 151.505 175.786 151.535 175.82 151.535Z",
    fill: "#A8BAC1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.409 154.454C180.701 154.287 180.929 154.093 181.085 153.893C181.246 153.685 181.33 153.47 181.341 153.251C181.341 153.24 181.341 153.229 181.341 153.214V152.773C181.338 152.724 181.341 152.676 181.341 152.628V152.213V151.838C181.342 151.764 181.341 151.691 181.342 151.628C181.342 151.441 181.342 151.308 181.341 151.262C181.341 151.259 181.341 151.259 181.342 151.258C181.341 151.254 181.342 151.251 181.342 151.248C181.342 150.797 181.009 150.357 180.408 150.007C179.741 149.624 178.845 149.412 177.889 149.412C176.93 149.414 176.036 149.624 175.368 150.01C174.807 150.332 174.486 150.736 174.441 151.151C174.441 151.151 174.441 151.151 174.44 151.153C174.436 151.186 174.435 151.217 174.438 151.246C174.435 151.255 174.435 151.262 174.436 151.275L174.435 153.295H174.44C174.441 153.307 174.441 153.317 174.447 153.328C174.468 153.526 174.554 153.719 174.699 153.901C174.853 154.1 175.08 154.288 175.368 154.454C175.385 154.463 175.401 154.471 175.419 154.48C175.958 154.779 176.641 154.97 177.385 155.03C177.547 155.04 177.715 155.049 177.885 155.048C178.845 155.053 179.742 154.84 180.409 154.454Z",
    fill: "#F0F7FA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M177.89 153.083C176.931 153.083 176.035 152.87 175.369 152.485C174.768 152.136 174.437 151.697 174.437 151.247C174.437 150.797 174.77 150.357 175.369 150.008C176.037 149.624 176.934 149.412 177.89 149.412C178.846 149.412 179.742 149.624 180.407 150.007C181.011 150.357 181.342 150.797 181.343 151.247C181.342 151.697 181.01 152.136 180.409 152.485C179.742 152.868 178.845 153.083 177.89 153.083Z",
    fill: "#F0F7FA"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.111 152.627C176.427 152.627 175.788 152.479 175.311 152.2C174.881 151.952 174.646 151.637 174.646 151.316C174.646 150.995 174.881 150.68 175.311 150.431C175.79 150.157 176.428 150.003 177.11 150.004C177.795 150.004 178.432 150.157 178.91 150.431C179.343 150.679 179.574 150.994 179.574 151.316C179.578 151.637 179.338 151.951 178.91 152.2C178.433 152.476 177.796 152.627 177.111 152.627Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.7 153.903C174.7 153.903 174.656 152.016 174.656 151.865C174.521 151.66 174.423 151.443 174.442 151.152C174.436 151.606 174.445 152.281 174.448 153.329C174.469 153.528 174.555 153.721 174.7 153.903Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.386 155.031C177.406 154.265 177.434 153.417 177.438 153.05C176.987 153.033 176.009 152.776 175.494 152.553L175.421 154.481C175.959 154.78 176.643 154.972 177.386 155.031Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.086 153.893C181.247 153.686 181.331 153.471 181.341 153.252C181.338 153.096 181.341 152.938 181.341 152.775C181.338 152.726 181.341 152.677 181.341 152.629C181.341 152.491 181.338 152.348 181.341 152.215C181.341 152.079 181.338 151.956 181.341 151.84C181.343 151.765 181.341 151.693 181.343 151.629C181.343 151.443 181.343 151.31 181.341 151.264C181.338 151.417 181.297 151.585 181.222 151.714C181.188 151.783 181.14 151.848 181.099 151.91L181.086 153.893Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M183.74 156.526C182.227 157.399 182.223 158.817 183.737 159.688C185.25 160.563 187.703 160.563 189.217 159.689C190.73 158.817 190.73 157.401 189.217 156.526C187.703 155.653 185.251 155.652 183.74 156.526Z",
    fill: "#F0F7FA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M186.478 160.248C187.493 160.25 188.45 160.021 189.168 159.607C189.87 159.201 190.256 158.669 190.256 158.109C190.256 157.545 189.871 157.012 189.168 156.609C188.45 156.195 187.496 155.967 186.477 155.967C185.457 155.967 184.502 156.192 183.786 156.607C183.084 157.012 182.697 157.545 182.697 158.109C182.697 158.669 183.082 159.204 183.783 159.605C184.502 160.023 185.459 160.25 186.478 160.248Z",
    fill: "url(#paint50_linear_3744_1590)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M189.669 157.678C189.53 157.437 189.277 157.205 188.936 157.011C188.287 156.636 187.416 156.431 186.477 156.428C185.541 156.429 184.668 156.636 184.016 157.009C183.466 157.328 183.161 157.718 183.161 158.106C183.163 158.251 183.202 158.395 183.286 158.538C183.423 158.776 183.676 159.008 184.016 159.204C184.664 159.579 185.54 159.784 186.478 159.784C187.415 159.784 188.286 159.578 188.936 159.204C189.488 158.887 189.792 158.495 189.792 158.106C189.792 157.964 189.752 157.82 189.669 157.678Z",
    fill: "#9FA1A3"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M184.168 156.318V157.012C184.196 156.996 184.225 156.979 184.255 156.963C184.842 156.624 185.633 156.434 186.476 156.436C187.322 156.437 188.112 156.622 188.701 156.962C188.728 156.979 188.756 156.995 188.783 157.013L188.782 156.34L189.524 156.338V158.126H189.521C189.488 158.498 189.2 158.86 188.701 159.148C188.112 159.487 187.321 159.674 186.476 159.674C185.633 159.674 184.842 159.486 184.255 159.148C183.724 158.839 183.431 158.452 183.431 158.053L183.428 156.316L184.168 156.318Z",
    fill: "url(#paint51_linear_3744_1590)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M186.476 157.937C187.322 157.937 188.112 157.749 188.701 157.408C189.233 157.102 189.524 156.714 189.524 156.315C189.524 155.918 189.233 155.532 188.701 155.222C188.112 154.884 187.321 154.699 186.476 154.697C185.633 154.699 184.842 154.884 184.255 155.224C183.723 155.532 183.431 155.919 183.428 156.317C183.431 156.715 183.724 157.103 184.255 157.409C184.843 157.749 185.63 157.937 186.476 157.937Z",
    fill: "url(#paint52_linear_3744_1590)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M186.476 157.653C187.174 157.653 187.826 157.499 188.309 157.218C188.747 156.966 188.99 156.647 188.99 156.318C188.99 155.989 188.75 155.669 188.308 155.416C187.826 155.137 187.174 154.982 186.476 154.982C185.78 154.982 185.128 155.136 184.643 155.416C184.206 155.669 183.965 155.991 183.965 156.318C183.963 156.645 184.207 156.967 184.643 157.218C185.129 157.498 185.781 157.653 186.476 157.653Z",
    fill: "url(#paint53_linear_3744_1590)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M184.409 156.398L188.601 156.397C188.635 156.396 188.663 156.369 188.663 156.335C188.663 156.302 188.633 156.275 188.601 156.271L184.409 156.274C184.376 156.274 184.348 156.302 184.348 156.335C184.348 156.371 184.376 156.398 184.409 156.398Z",
    fill: "#A8BAC1"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.998 159.319C189.288 159.153 189.517 158.958 189.675 158.757C189.833 158.552 189.921 158.337 189.924 158.117C189.928 158.106 189.928 158.095 189.928 158.082V157.641C189.924 157.591 189.929 157.545 189.928 157.499V157.081L189.929 156.705C189.929 156.629 189.929 156.558 189.929 156.496C189.929 156.306 189.931 156.176 189.929 156.129C189.931 156.126 189.931 156.126 189.931 156.126C189.929 156.122 189.929 156.118 189.931 156.113C189.931 155.662 189.597 155.222 188.996 154.875C188.329 154.493 187.433 154.279 186.478 154.279C185.517 154.28 184.626 154.492 183.956 154.877C183.399 155.198 183.071 155.603 183.03 156.019C183.03 156.019 183.03 156.019 183.03 156.022C183.025 156.052 183.022 156.085 183.025 156.113C183.025 156.122 183.025 156.13 183.025 156.142L183.022 158.16L183.03 158.163C183.033 158.178 183.033 158.185 183.034 158.198C183.055 158.392 183.144 158.586 183.287 158.768C183.444 158.968 183.671 159.154 183.955 159.319C183.973 159.33 183.991 159.339 184.009 159.346C184.546 159.646 185.229 159.837 185.97 159.898C186.136 159.909 186.305 159.917 186.475 159.917C187.433 159.919 188.33 159.706 188.998 159.319Z",
    fill: "#F0F7FA"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.476 157.948C185.517 157.947 184.625 157.737 183.959 157.35C183.354 157.004 183.026 156.565 183.026 156.113C183.026 155.662 183.355 155.222 183.959 154.877C184.625 154.493 185.517 154.279 186.478 154.279C187.433 154.279 188.329 154.491 188.996 154.875C189.596 155.222 189.929 155.665 189.929 156.115C189.929 156.565 189.597 157.004 188.996 157.354C188.33 157.738 187.436 157.95 186.476 157.948Z",
    fill: "#F0F7FA"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.701 157.495C185.014 157.492 184.377 157.343 183.9 157.071C183.47 156.817 183.233 156.505 183.233 156.183C183.233 155.862 183.47 155.547 183.898 155.3C184.376 155.024 185.014 154.871 185.698 154.873C186.382 154.871 187.021 155.024 187.498 155.296C187.929 155.546 188.164 155.862 188.164 156.183C188.164 156.505 187.929 156.819 187.5 157.067C187.022 157.342 186.382 157.493 185.701 157.495Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.288 158.77C183.288 158.77 183.246 156.884 183.246 156.733C183.11 156.525 183.009 156.311 183.03 156.02C183.023 156.471 183.035 157.148 183.035 158.198C183.055 158.392 183.145 158.587 183.288 158.77Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.971 159.898C185.996 159.128 186.025 158.282 186.026 157.918C185.574 157.897 184.596 157.643 184.084 157.42L184.011 159.346C184.548 159.646 185.231 159.837 185.971 159.898Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.675 158.758C189.833 158.552 189.92 158.337 189.924 158.118C189.924 157.965 189.927 157.803 189.927 157.642C189.924 157.592 189.929 157.545 189.927 157.499C189.924 157.356 189.927 157.215 189.927 157.081C189.927 156.945 189.927 156.82 189.929 156.705C189.929 156.63 189.929 156.558 189.929 156.496C189.929 156.307 189.931 156.177 189.929 156.129C189.924 156.283 189.886 156.451 189.809 156.58C189.776 156.648 189.726 156.712 189.684 156.775L189.675 158.758Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M183.192 147.017C181.677 147.891 181.677 149.307 183.19 150.181C184.704 151.054 187.156 151.054 188.669 150.18C190.182 149.307 190.182 147.891 188.669 147.017C187.157 146.145 184.704 146.145 183.192 147.017Z",
    fill: "#F0F7FA"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M185.928 150.742C186.947 150.742 187.905 150.515 188.621 150.1C189.323 149.692 189.709 149.162 189.709 148.601C189.709 148.038 189.323 147.507 188.621 147.1C187.905 146.688 186.947 146.457 185.928 146.457C184.91 146.457 183.955 146.688 183.239 147.099C182.537 147.504 182.147 148.038 182.148 148.601C182.148 149.162 182.533 149.693 183.239 150.1C183.952 150.515 184.91 150.742 185.928 150.742Z",
    fill: "url(#paint54_linear_3744_1590)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M189.121 148.168C188.983 147.928 188.729 147.695 188.39 147.503C187.741 147.125 186.866 146.922 185.928 146.922C184.992 146.922 184.117 147.125 183.472 147.502C182.918 147.82 182.615 148.21 182.613 148.599C182.613 148.744 182.657 148.888 182.738 149.029C182.877 149.27 183.127 149.498 183.469 149.696C184.115 150.069 184.989 150.275 185.928 150.275C186.867 150.275 187.74 150.072 188.389 149.697C188.939 149.379 189.243 148.989 189.244 148.6C189.246 148.456 189.203 148.31 189.121 148.168Z",
    fill: "#9FA1A3"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M183.623 146.809V147.506C183.651 147.489 183.676 147.472 183.704 147.455C184.297 147.115 185.084 146.928 185.928 146.928C186.773 146.928 187.563 147.115 188.152 147.456C188.183 147.472 188.207 147.489 188.238 147.506V146.833H188.977V148.617H188.972C188.938 148.991 188.651 149.352 188.151 149.64C187.562 149.98 186.774 150.168 185.928 150.168C185.083 150.168 184.296 149.98 183.703 149.64C183.174 149.333 182.883 148.945 182.879 148.548L182.883 146.809H183.623V146.809Z",
    fill: "url(#paint55_linear_3744_1590)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M185.93 148.428C186.773 148.428 187.564 148.242 188.152 147.903C188.686 147.595 188.978 147.208 188.978 146.809C188.978 146.412 188.683 146.025 188.152 145.716C187.563 145.377 186.773 145.19 185.928 145.191C185.084 145.191 184.297 145.378 183.707 145.718C183.175 146.025 182.883 146.411 182.883 146.808C182.883 147.208 183.175 147.595 183.704 147.9C184.295 148.242 185.084 148.43 185.93 148.428Z",
    fill: "url(#paint56_linear_3744_1590)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M185.929 148.145C186.627 148.145 187.277 147.992 187.762 147.711C188.203 147.458 188.442 147.139 188.442 146.809C188.442 146.48 188.202 146.161 187.765 145.911C187.279 145.63 186.628 145.473 185.929 145.475C185.23 145.475 184.58 145.627 184.094 145.907C183.658 146.161 183.417 146.483 183.417 146.809C183.416 147.139 183.659 147.456 184.094 147.711C184.581 147.992 185.235 148.146 185.929 148.145Z",
    fill: "url(#paint57_linear_3744_1590)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M183.861 146.89H188.053C188.087 146.89 188.115 146.861 188.115 146.829C188.117 146.792 188.089 146.765 188.054 146.765L183.861 146.764C183.828 146.765 183.8 146.792 183.798 146.828C183.8 146.861 183.828 146.89 183.861 146.89Z",
    fill: "#A8BAC1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.448 149.812C188.742 149.644 188.971 149.451 189.129 149.25C189.283 149.045 189.373 148.827 189.38 148.609C189.381 148.599 189.38 148.587 189.38 148.575V148.132C189.38 148.084 189.38 148.037 189.38 147.988L189.381 147.571V147.196C189.383 147.122 189.381 147.047 189.384 146.987C189.383 146.8 189.383 146.668 189.383 146.623C189.383 146.617 189.383 146.617 189.384 146.616C189.383 146.613 189.383 146.608 189.383 146.606C189.383 146.154 189.049 145.714 188.448 145.366C187.782 144.984 186.887 144.773 185.93 144.773C184.974 144.773 184.077 144.984 183.411 145.37C182.852 145.692 182.523 146.094 182.483 146.509C182.483 146.509 182.483 146.509 182.482 146.512C182.479 146.544 182.477 146.575 182.479 146.604C182.479 146.613 182.477 146.622 182.479 146.634L182.477 148.655H182.483C182.485 148.667 182.485 148.676 182.488 148.687C182.51 148.885 182.596 149.078 182.739 149.26C182.893 149.46 183.124 149.647 183.41 149.812C183.426 149.822 183.441 149.831 183.462 149.838C184 150.138 184.681 150.33 185.424 150.389C185.588 150.401 185.755 150.408 185.926 150.408C186.887 150.41 187.782 150.199 188.448 149.812Z",
    fill: "#F0F7FA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M185.928 148.441C184.97 148.441 184.077 148.227 183.411 147.843C182.807 147.496 182.478 147.055 182.478 146.604C182.478 146.154 182.808 145.714 183.411 145.368C184.077 144.984 184.974 144.772 185.93 144.773C186.887 144.773 187.782 144.984 188.448 145.366C189.05 145.714 189.383 146.154 189.383 146.606C189.381 147.055 189.049 147.496 188.448 147.843C187.78 148.228 186.887 148.441 185.928 148.441Z",
    fill: "#F0F7FA"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.15 147.988C184.467 147.988 183.829 147.837 183.352 147.56C182.922 147.312 182.686 146.999 182.686 146.678C182.686 146.355 182.922 146.041 183.352 145.793C183.829 145.517 184.467 145.365 185.152 145.365C185.836 145.365 186.475 145.519 186.952 145.793C187.382 146.04 187.615 146.351 187.615 146.677C187.619 146.998 187.382 147.312 186.95 147.56C186.475 147.834 185.836 147.988 185.15 147.988Z",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.74 149.261C182.74 149.261 182.699 147.373 182.699 147.224C182.565 147.016 182.463 146.802 182.484 146.51C182.478 146.963 182.486 147.639 182.489 148.687C182.511 148.885 182.596 149.078 182.74 149.261Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.425 150.391C185.453 149.622 185.478 148.776 185.478 148.412C185.028 148.393 184.05 148.136 183.536 147.914L183.463 149.84C184.001 150.14 184.682 150.332 185.425 150.391Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.129 149.25C189.283 149.045 189.374 148.828 189.38 148.609C189.38 148.456 189.38 148.294 189.38 148.132C189.38 148.084 189.38 148.037 189.38 147.989C189.38 147.849 189.38 147.707 189.381 147.572C189.38 147.439 189.38 147.312 189.381 147.196C189.383 147.122 189.381 147.047 189.384 146.988C189.383 146.801 189.383 146.668 189.383 146.623C189.38 146.775 189.337 146.943 189.262 147.072C189.23 147.14 189.18 147.205 189.14 147.269L189.129 149.25Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M191.778 151.883C190.267 152.756 190.267 154.172 191.779 155.046C193.292 155.919 195.746 155.919 197.256 155.046C198.773 154.172 198.773 152.756 197.258 151.88C195.746 151.011 193.292 151.011 191.778 151.883Z",
    fill: "#F0F7FA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 155.607C195.537 155.607 196.491 155.376 197.21 154.962C197.909 154.558 198.296 154.027 198.298 153.465C198.298 152.904 197.911 152.371 197.21 151.965C196.491 151.551 195.533 151.324 194.518 151.324C193.5 151.324 192.544 151.551 191.825 151.965C191.124 152.371 190.739 152.904 190.738 153.465C190.738 154.027 191.124 154.558 191.825 154.962C192.543 155.379 193.5 155.607 194.518 155.607Z",
    fill: "url(#paint58_linear_3744_1590)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M197.709 153.034C197.571 152.795 197.319 152.563 196.977 152.366C196.329 151.993 195.454 151.787 194.518 151.787C193.578 151.787 192.707 151.994 192.056 152.366C191.507 152.683 191.202 153.075 191.202 153.463C191.202 153.608 191.245 153.751 191.327 153.893C191.465 154.134 191.717 154.363 192.058 154.562C192.705 154.936 193.578 155.141 194.518 155.141C195.454 155.14 196.328 154.935 196.977 154.562C197.528 154.241 197.832 153.851 197.834 153.463C197.832 153.321 197.792 153.176 197.709 153.034Z",
    fill: "#9FA1A3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M192.212 151.674L192.211 152.37C192.239 152.355 192.268 152.337 192.296 152.319C192.883 151.98 193.672 151.793 194.518 151.793C195.363 151.794 196.154 151.979 196.74 152.319C196.77 152.335 196.798 152.355 196.826 152.37L196.825 151.697H197.564V153.482L197.562 153.484C197.528 153.856 197.241 154.217 196.741 154.506C196.153 154.845 195.362 155.031 194.518 155.031C193.672 155.031 192.882 154.843 192.295 154.503C191.763 154.197 191.473 153.811 191.473 153.412L191.469 151.674H192.212Z",
    fill: "url(#paint59_linear_3744_1590)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 153.294C195.363 153.296 196.152 153.108 196.742 152.767C197.274 152.461 197.566 152.074 197.566 151.675C197.566 151.278 197.274 150.889 196.739 150.583C196.154 150.243 195.363 150.055 194.518 150.055C193.672 150.057 192.883 150.243 192.296 150.583C191.76 150.89 191.473 151.278 191.47 151.675C191.473 152.074 191.764 152.461 192.296 152.769C192.883 153.107 193.672 153.293 194.518 153.294Z",
    fill: "url(#paint60_linear_3744_1590)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 153.01C195.217 153.01 195.865 152.856 196.35 152.577C196.79 152.32 197.031 152.006 197.032 151.674C197.032 151.346 196.79 151.027 196.351 150.773C195.865 150.492 195.213 150.338 194.518 150.338C193.82 150.338 193.17 150.491 192.684 150.773C192.246 151.027 192.004 151.347 192.006 151.674C192.006 152.002 192.246 152.323 192.686 152.575C193.17 152.856 193.822 153.009 194.518 153.01Z",
    fill: "url(#paint61_linear_3744_1590)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M192.451 151.755L196.64 151.756C196.675 151.755 196.703 151.727 196.703 151.694C196.703 151.661 196.675 151.632 196.64 151.631H192.449C192.416 151.631 192.388 151.659 192.388 151.694C192.387 151.729 192.417 151.757 192.451 151.755Z",
    fill: "#A8BAC1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.038 154.678C197.33 154.508 197.56 154.317 197.717 154.113C197.872 153.909 197.962 153.696 197.968 153.474C197.968 153.464 197.968 153.452 197.971 153.44L197.968 152.998C197.968 152.95 197.971 152.903 197.968 152.856V152.437V152.063C197.973 151.985 197.968 151.915 197.973 151.851C197.971 151.665 197.973 151.535 197.973 151.488C197.973 151.485 197.973 151.485 197.974 151.481C197.973 151.479 197.971 151.473 197.971 151.47C197.971 151.02 197.638 150.579 197.038 150.232C196.371 149.85 195.476 149.635 194.518 149.637C193.56 149.639 192.665 149.85 191.997 150.235C191.44 150.557 191.115 150.959 191.07 151.376C191.07 151.376 191.07 151.376 191.07 151.38C191.066 151.411 191.064 151.439 191.066 151.468C191.066 151.481 191.066 151.49 191.066 151.498L191.064 153.519L191.07 153.521C191.072 153.533 191.073 153.541 191.076 153.554C191.098 153.751 191.184 153.943 191.328 154.126C191.485 154.324 191.711 154.515 192 154.677C192.016 154.685 192.031 154.696 192.05 154.704C192.59 155.005 193.272 155.194 194.012 155.253C194.176 155.266 194.345 155.272 194.518 155.272C195.475 155.276 196.37 155.063 197.038 154.678Z",
    fill: "#F0F7FA"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M194.519 153.306C193.56 153.305 192.665 153.093 191.999 152.707C191.398 152.36 191.067 151.921 191.065 151.47C191.067 151.02 191.398 150.582 191.999 150.235C192.665 149.85 193.56 149.635 194.519 149.637C195.476 149.635 196.372 149.848 197.036 150.232C197.639 150.581 197.972 151.02 197.972 151.472C197.972 151.924 197.638 152.363 197.039 152.709C196.37 153.093 195.475 153.306 194.519 153.306Z",
    fill: "#F0F7FA"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193.742 152.852C193.055 152.851 192.418 152.7 191.944 152.425C191.511 152.176 191.273 151.859 191.273 151.541C191.277 151.221 191.512 150.904 191.944 150.656C192.417 150.382 193.057 150.229 193.742 150.23C194.422 150.23 195.063 150.382 195.539 150.654C195.972 150.905 196.206 151.219 196.206 151.541C196.204 151.859 195.969 152.177 195.539 152.425C195.063 152.7 194.422 152.851 193.742 152.852Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M191.329 154.127C191.329 154.127 191.287 152.24 191.287 152.091C191.152 151.881 191.053 151.668 191.071 151.377C191.065 151.829 191.074 152.508 191.077 153.555C191.099 153.752 191.185 153.944 191.329 154.127Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.013 155.254C194.038 154.488 194.063 153.642 194.068 153.274C193.615 153.257 192.638 153.004 192.124 152.777L192.051 154.706C192.591 155.006 193.272 155.196 194.013 155.254Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M197.717 154.113C197.872 153.909 197.962 153.696 197.968 153.474C197.968 153.321 197.968 153.16 197.968 152.998C197.968 152.95 197.971 152.903 197.968 152.856C197.968 152.714 197.968 152.571 197.968 152.437C197.971 152.301 197.971 152.176 197.968 152.063C197.973 151.984 197.968 151.915 197.973 151.851C197.971 151.665 197.973 151.534 197.973 151.488C197.968 151.639 197.927 151.805 197.849 151.936C197.816 152.006 197.768 152.071 197.729 152.132L197.717 154.113Z",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M192.619 157.65L192.51 157.764L192.019 158.272L191.888 158.409L191.393 158.916L191.261 159.054L190.777 159.557L190.644 159.695L190.156 160.203L190.021 160.339L189.532 160.842L189.395 160.984L188.912 161.487L188.778 161.625L188.288 162.132L188.157 162.269L187.663 162.776L187.529 162.913L187.044 163.416L186.911 163.554L186.424 164.061L186.291 164.199L186.113 164.376L185.614 164.898L171.261 173.183C170.699 173.509 169.789 173.509 169.22 173.178L151.393 162.886C151.218 162.785 151.096 162.662 151.031 162.539C151.01 162.498 150.992 162.448 150.982 162.397C150.953 162.278 150.972 162.155 151.04 162.04C151.035 161.898 151.095 161.757 151.218 161.625C151.265 161.578 151.32 161.533 151.384 161.487C151.411 161.474 151.434 161.456 151.463 161.437L152.494 160.842L153.369 160.339L153.606 160.196L154.479 159.694L154.718 159.556L155.59 159.053L155.837 158.911L156.711 158.407L156.95 158.27L157.822 157.762L158.059 157.626L159.157 156.995L159.175 156.981L160.049 156.478L160.291 156.34L161.164 155.833L161.403 155.696L162.499 155.061L162.517 155.051L163.391 154.547L164.749 153.766L165.617 153.263L165.86 153.121L166.733 152.617L166.97 152.48L167.844 151.973H167.849L168.091 151.835L168.961 151.332L169.203 151.191L170.071 150.687H170.076L170.314 150.55L171.187 150.043H171.192L171.43 149.905L172.303 149.402L172.545 149.26L173.415 148.756H173.418L173.657 148.62L174.53 148.113H174.534L174.773 147.975L175.646 147.472L175.889 147.33L176.757 146.828H176.762L176.999 146.691L177.877 146.184L178.116 146.047L178.17 146.014L178.207 146.047L178.335 146.147L178.381 146.184L179.012 146.691L179.181 146.828L179.807 147.33L179.982 147.472L180.607 147.975L180.778 148.113L181.409 148.62L181.579 148.756L182.205 149.26L182.264 149.309L182.378 149.402L182.516 149.511L183.005 149.904L183.179 150.042L183.239 150.097L183.253 150.107L183.587 150.371L183.806 150.55L183.98 150.687L184.607 151.191L184.776 151.332L185.402 151.835L185.572 151.973L186.204 152.48L186.378 152.617L187.004 153.125L187.178 153.262L187.8 153.765L187.977 153.906L188.604 154.41L188.773 154.547L189.397 155.051L189.576 155.194L190.201 155.696L190.372 155.833L191.002 156.34L191.171 156.478L191.798 156.981L191.972 157.123L192.599 157.627L192.619 157.65Z",
    fill: "url(#paint62_linear_3744_1590)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M205.574 149.812C205.579 149.945 205.528 150.073 205.423 150.192C205.387 150.242 205.337 150.287 205.273 150.329C205.24 150.361 205.199 150.388 205.153 150.415L185.615 161.696L171.262 169.981C170.7 170.305 169.791 170.305 169.222 169.976L151.395 159.683C151.22 159.583 151.097 159.459 151.033 159.337C151.011 159.295 150.993 159.246 150.984 159.195C150.955 159.076 150.974 158.952 151.042 158.838C151.07 158.788 151.107 158.738 151.153 158.691C151.193 158.641 151.254 158.599 151.316 158.554C151.34 158.537 151.363 158.522 151.389 158.503L151.532 158.422L151.77 158.285L152.644 157.781L152.887 157.639L153.76 157.136L154.005 156.994L154.875 156.492L155.112 156.354L155.986 155.85L156.229 155.708L157.101 155.206L157.34 155.068L158.217 154.561L158.456 154.424L159.327 153.922L159.571 153.779L160.446 153.276L160.682 153.138L161.56 152.631L161.799 152.494L162.671 151.991L162.915 151.848L163.786 151.345L164.026 151.208L164.894 150.705L165.141 150.563L166.013 150.059L166.257 149.918L167.129 149.415L167.366 149.278L168.246 148.77L168.483 148.633L169.357 148.13L169.599 147.989L170.472 147.485L170.71 147.347L171.588 146.84L171.825 146.703L172.7 146.199L172.942 146.057L173.814 145.554L174.053 145.417L174.93 144.91L175.169 144.772L176.042 144.269L176.284 144.128L177.158 143.624L177.397 143.487L178.273 142.98L178.338 142.943L178.512 142.842L179.384 142.34L179.628 142.197L180.501 141.693L180.738 141.555L181.608 141.054L181.853 140.911L182.726 140.408L182.969 140.266L183.843 139.763L184.081 139.625L184.949 139.121L185.197 138.98L185.283 138.929C185.428 138.847 185.597 138.789 185.777 138.747C186.111 138.665 186.494 138.67 186.834 138.747C187.011 138.783 187.179 138.848 187.326 138.929L187.415 138.98L187.66 139.121L188.528 139.625L188.767 139.763L189.645 140.27L189.882 140.408L190.756 140.911L190.998 141.054L191.871 141.555L192.11 141.693L192.979 142.197L193.226 142.34L194.104 142.846L194.332 142.979L195.21 143.486L195.456 143.629L196.321 144.127L196.563 144.268L197.435 144.771L197.674 144.909L198.552 145.416L198.791 145.553L199.659 146.056L199.904 146.199L200.777 146.702L201.02 146.844L201.893 147.347L202.136 147.489L203.009 147.992L203.248 148.13L204.116 148.633L204.353 148.77L205.153 149.232C205.181 149.246 205.203 149.26 205.227 149.278C205.29 149.32 205.35 149.365 205.396 149.416C205.438 149.458 205.469 149.502 205.497 149.548C205.524 149.59 205.546 149.635 205.556 149.681C205.569 149.726 205.574 149.771 205.574 149.812Z",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M205.574 149.812C205.556 149.854 205.528 149.891 205.496 149.927C205.46 149.973 205.405 150.018 205.345 150.064C205.308 150.093 205.268 150.119 205.227 150.143L204.49 150.568L204.243 150.71L203.375 151.213L203.137 151.35L202.264 151.854L202.218 151.881L202.021 151.996L201.148 152.499L200.909 152.636L200.036 153.143H200.031L199.794 153.281L198.921 153.784L198.683 153.927H198.678L197.81 154.429H197.805L197.567 154.566L196.694 155.073H196.689L196.45 155.211L195.577 155.718H195.573L195.34 155.855H195.335L194.466 156.359L194.224 156.497L193.352 157.003H193.347L193.11 157.14L192.24 157.643L191.996 157.786H191.991L191.123 158.289L190.882 158.426L190.009 158.934L189.77 159.072L188.891 159.578H188.887L188.654 159.715H188.65L187.781 160.218L187.537 160.356L186.669 160.864H186.665L186.426 161.001L186.112 161.179L185.553 161.505L185.312 161.646L184.439 162.149L184.2 162.287L183.322 162.794L183.084 162.931L182.211 163.439H182.206L181.969 163.576L181.096 164.08L180.858 164.216L179.985 164.719L179.742 164.862L178.869 165.365L178.63 165.507H178.626L177.753 166.011L177.514 166.147L176.636 166.655L176.4 166.791L175.525 167.295L174.411 167.94L174.172 168.078L173.299 168.584H173.295L173.056 168.721L172.182 169.225L171.941 169.367L171.333 169.719C170.77 170.043 169.856 170.043 169.293 169.719L168.686 169.367L168.447 169.231H168.442L167.565 168.722L167.331 168.585H167.328L166.453 168.079L166.214 167.941L165.342 167.438L165.1 167.295L164.227 166.791L163.988 166.655H163.984L163.116 166.152H163.111L162.872 166.011L161.999 165.507L161.761 165.369H161.757L160.883 164.863H160.878L160.646 164.725H160.641L159.772 164.222L159.571 164.108L159.53 164.081L158.657 163.577H158.652L158.419 163.44H158.413L157.54 162.932L157.302 162.795L156.424 162.288L156.187 162.15L155.315 161.648L155.076 161.51L154.198 161.003L153.959 160.866H153.954L153.087 160.358L152.843 160.221L151.975 159.717H151.972L151.729 159.575L151.459 159.421C151.284 159.324 151.164 159.202 151.102 159.074C151.074 159.027 151.06 158.986 151.052 158.936C151.042 158.904 151.037 158.876 151.037 158.845C151.032 158.703 151.092 158.561 151.215 158.428C151.261 158.384 151.317 158.338 151.381 158.291C151.408 158.277 151.431 158.26 151.459 158.241L152.491 157.647L153.366 157.143L153.603 157.002L154.476 156.499L154.714 156.361L155.587 155.857L155.834 155.716L156.708 155.213L156.946 155.076L157.819 154.568L158.056 154.432L159.154 153.801L159.171 153.786L160.046 153.283L160.287 153.145L161.161 152.638L161.4 152.501L162.496 151.865L162.514 151.855L163.388 151.352L164.746 150.571L165.614 150.067L165.857 149.925L166.73 149.423L166.967 149.285L167.841 148.778H167.846L168.088 148.64L168.958 148.138L169.2 147.996L170.068 147.492H170.072L170.311 147.354L171.184 146.848H171.189L171.427 146.71L172.3 146.207L172.542 146.065L173.412 145.561H173.415L173.654 145.424L174.526 144.917H174.531L174.77 144.779L175.642 144.276L175.886 144.135L176.754 143.631H176.759L176.996 143.494L177.874 142.987L178.112 142.85L178.167 142.819L178.985 142.348L179.227 142.205L180.096 141.701H180.101L180.166 141.665L181.212 141.063L181.455 140.92L182.328 140.417L182.566 140.275H182.571L183.444 139.772L183.682 139.635L184.555 139.131L184.797 138.989L185.352 138.669C185.493 138.587 185.661 138.523 185.841 138.486C186.179 138.408 186.562 138.408 186.901 138.486C187.08 138.528 187.248 138.587 187.39 138.669L187.944 138.989L188.185 139.131L189.06 139.635L189.298 139.772L190.413 140.416L191.285 140.92L191.529 141.062L192.403 141.564L192.64 141.701L193.508 142.205H193.513L193.757 142.348L194.63 142.854L194.862 142.987H194.868L195.744 143.494L195.987 143.637L196.851 144.135H196.855L197.099 144.276L197.967 144.779H197.971L198.205 144.917L199.083 145.424H199.087L199.32 145.561H199.324L200.194 146.065L200.436 146.207H200.44L201.308 146.71H201.314L201.552 146.852H201.557L202.425 147.355L202.672 147.497L203.54 148.001L203.778 148.138L204.647 148.641H204.652L204.884 148.779L205.219 148.97C205.383 149.062 205.496 149.172 205.566 149.286C205.592 149.327 205.612 149.377 205.625 149.424C205.665 149.547 205.646 149.685 205.574 149.812Z",
    fill: "url(#paint63_linear_3744_1590)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M171.943 169.359L172.185 169.219L168.444 169.22L168.685 169.359H171.943Z",
    fill: "#B6BCC1"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M173.058 168.714L173.3 168.576H167.331L167.569 168.715L173.058 168.714Z",
    fill: "#B6BCC1"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M174.173 168.072L174.414 167.934H166.216L166.454 168.072H174.173Z",
    fill: "#B6BCC1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M175.286 167.427L175.525 167.289H165.101L165.345 167.431L175.286 167.427Z",
    fill: "#B6BCC1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M176.4 166.785L176.642 166.648H163.987L164.227 166.787L176.4 166.785Z",
    fill: "#B6BCC1"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M177.518 166.139L177.753 166.004H162.874L163.114 166.144L177.518 166.139Z",
    fill: "#B6BCC1"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M178.63 165.5L178.872 165.361L161.759 165.362L162.001 165.5H178.63Z",
    fill: "#B6BCC1"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M179.742 164.855L179.984 164.715L160.647 164.717L160.883 164.855H179.742Z",
    fill: "#B6BCC1"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M180.859 164.211L181.098 164.075L159.532 164.072L159.772 164.213L180.859 164.211Z",
    fill: "#B6BCC1"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M181.971 163.569L182.212 163.432H158.415L158.657 163.569H181.971Z",
    fill: "#B6BCC1"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M183.084 162.926L183.327 162.787L157.304 162.789L157.543 162.927L183.084 162.926Z",
    fill: "#B6BCC1"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M184.2 162.283L184.441 162.143L156.19 162.147L156.432 162.283H184.2Z",
    fill: "#B6BCC1"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M185.313 161.64L185.557 161.5L155.075 161.502L155.319 161.642L185.313 161.64Z",
    fill: "#B6BCC1"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M186.428 160.996L186.67 160.857H153.959L154.202 160.996H186.428Z",
    fill: "#B6BCC1"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M187.539 160.353L187.782 160.215L152.846 160.216L153.089 160.353H187.539Z",
    fill: "#B6BCC1"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M188.656 159.709L188.894 159.574L151.733 159.572L151.974 159.709H188.656Z",
    fill: "#B6BCC1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M189.77 159.067L190.009 158.93L151.057 158.931C151.065 158.98 151.079 159.024 151.107 159.068L189.77 159.067Z",
    fill: "#B6BCC1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M191.124 158.285L190.882 158.422H181.645C181.645 158.422 181.645 158.422 181.64 158.422H164.563C164.563 158.422 164.558 158.418 164.558 158.422H151.219C151.265 158.377 151.321 158.331 151.385 158.285H181.476C181.476 158.285 181.482 158.281 181.482 158.285H191.124Z",
    fill: "#B6BCC1"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M191.997 157.781L192.239 157.641H152.496L152.252 157.781H191.997Z",
    fill: "#B6BCC1"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M193.348 157.001L193.111 157.138H153.371L153.607 156.996H165.202L175.153 157.001H193.348Z",
    fill: "#B6BCC1"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M194.466 156.357L194.224 156.495H181.226C181.226 156.495 181.226 156.495 181.221 156.495H154.48L154.718 156.357H158.907C158.907 156.357 158.907 156.357 158.912 156.357H194.466Z",
    fill: "#B6BCC1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M195.573 155.715L195.341 155.852H155.592L155.839 155.711H173.287L182.871 155.715H195.573Z",
    fill: "#B6BCC1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M196.689 155.07L196.451 155.208H156.713L156.951 155.07H196.689Z",
    fill: "#B6BCC1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M197.805 154.426L197.567 154.563H157.824L158.061 154.426H197.805Z",
    fill: "#B6BCC1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M198.921 153.781L198.683 153.923H158.938L159.159 153.796L159.176 153.781H189.683C189.683 153.781 189.689 153.777 189.689 153.781H198.921Z",
    fill: "#B6BCC1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M200.031 153.14L199.794 153.278H160.051L160.293 153.14H184.344C184.344 153.14 184.344 153.136 184.349 153.14H200.031Z",
    fill: "#B6BCC1"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M201.148 152.496L200.909 152.633H161.166L161.405 152.496H194.335C194.459 152.501 194.582 152.501 194.705 152.496H201.148Z",
    fill: "#B6BCC1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M202.263 151.851L202.217 151.879L202.025 151.994H162.28L162.501 151.861L162.519 151.851H183.69C183.69 151.851 183.69 151.847 183.696 151.851H202.263Z",
    fill: "#B6BCC1"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M203.138 151.348L203.375 151.211H163.633L163.393 151.348H203.138Z",
    fill: "#B6BCC1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M204.251 150.707L204.49 150.566H164.75L164.51 150.707H204.251Z",
    fill: "#B6BCC1"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M205.496 149.926C205.46 149.972 205.405 150.017 205.345 150.064H165.619L165.863 149.922H181.757L187.001 149.926H193.2C193.2 149.926 193.206 149.926 193.211 149.926H205.496Z",
    fill: "#B6BCC1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M205.628 149.419H166.735L166.973 149.281H205.569C205.596 149.323 205.615 149.374 205.628 149.419Z",
    fill: "#B6BCC1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M204.897 148.774H167.851L168.092 148.637H204.655L204.897 148.774Z",
    fill: "#B6BCC1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M203.781 148.136H168.964L169.205 147.994H178.999C179.005 147.994 179.005 147.994 179.005 147.994H184.605L191.108 147.998H203.545L203.781 148.136Z",
    fill: "#B6BCC1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M202.676 147.494H186.726L185.135 147.489H170.077L170.316 147.352H202.428L202.676 147.494Z",
    fill: "#B6BCC1"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M201.554 146.849H192.377C192.373 146.845 192.368 146.845 192.368 146.849H187.036L185.435 146.845H171.193L171.431 146.707H201.316L201.554 146.849Z",
    fill: "#B6BCC1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M200.438 146.205H172.305L172.546 146.062H200.202L200.438 146.205Z",
    fill: "#B6BCC1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M199.323 145.561H173.42L173.658 145.424H199.09L199.323 145.561Z",
    fill: "#B6BCC1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M198.215 144.917H174.536L174.774 144.779H197.974L198.215 144.917Z",
    fill: "#B6BCC1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M197.102 144.275H175.647L175.89 144.135H196.858L197.102 144.275Z",
    fill: "#B6BCC1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M195.99 143.637H187.595L183.8 143.631H176.763L177 143.494H195.746L195.99 143.637Z",
    fill: "#B6BCC1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M194.864 142.985H177.878L178.116 142.848H183.881L187.302 142.852H194.632L194.864 142.985Z",
    fill: "#B6BCC1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M193.758 142.344L193.517 142.205H179.231L178.989 142.344H193.758Z",
    fill: "#B6BCC1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M192.643 141.703L192.403 141.562H180.346L180.102 141.703L192.643 141.703Z",
    fill: "#B6BCC1"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M191.53 141.06L191.29 140.92H181.457L181.215 141.058L191.53 141.06Z",
    fill: "#B6BCC1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M190.416 140.417L190.176 140.279L182.571 140.277L182.332 140.417H190.416Z",
    fill: "#B6BCC1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M189.303 139.772L189.063 139.634L183.685 139.633L183.445 139.772H189.303Z",
    fill: "#B6BCC1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M188.188 139.13L187.946 138.99H184.8L184.558 139.13H188.188Z",
    fill: "#B6BCC1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M186.904 138.486C186.564 138.409 186.184 138.407 185.845 138.486H186.904Z",
    fill: "#B6BCC1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M159.067 157.746C157.555 158.618 157.555 160.036 159.067 160.909C160.58 161.781 163.031 161.781 164.546 160.909C166.058 160.036 166.06 158.617 164.549 157.746C163.034 156.87 160.58 156.872 159.067 157.746Z",
    fill: "#F0F7FA"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M161.808 161.467C162.827 161.466 163.781 161.241 164.498 160.826C165.2 160.42 165.587 159.888 165.587 159.326C165.587 158.762 165.201 158.233 164.498 157.827C163.78 157.412 162.825 157.184 161.808 157.184C160.788 157.183 159.832 157.412 159.115 157.827C158.414 158.231 158.027 158.762 158.029 159.326C158.029 159.888 158.414 160.42 159.115 160.824C159.832 161.238 160.788 161.467 161.808 161.467Z",
    fill: "url(#paint64_linear_3744_1590)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M164.999 158.895C164.86 158.656 164.608 158.423 164.268 158.23C163.619 157.854 162.744 157.65 161.806 157.65C160.868 157.65 159.997 157.855 159.348 158.23C158.797 158.549 158.492 158.937 158.491 159.326C158.491 159.471 158.533 159.612 158.613 159.758C158.754 159.997 159.005 160.226 159.348 160.425C159.992 160.797 160.867 161.002 161.806 161.002C162.743 161.002 163.62 160.798 164.266 160.425C164.818 160.106 165.123 159.715 165.123 159.326C165.123 159.182 165.081 159.039 164.999 158.895Z",
    fill: "#9FA1A3"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M159.499 157.537L159.5 158.234C159.527 158.216 159.556 158.199 159.585 158.183C160.172 157.843 160.96 157.656 161.808 157.656C162.654 157.655 163.441 157.843 164.03 158.184C164.058 158.2 164.086 158.217 164.113 158.234V157.561L164.853 157.56V159.347L164.852 159.343C164.818 159.717 164.529 160.078 164.029 160.366C163.441 160.708 162.653 160.892 161.806 160.892C160.961 160.892 160.172 160.708 159.585 160.366C159.052 160.061 158.762 159.674 158.762 159.274V157.537H159.499Z",
    fill: "url(#paint65_linear_3744_1590)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M161.807 159.154C162.651 159.154 163.442 158.968 164.03 158.627C164.564 158.321 164.854 157.934 164.854 157.535C164.854 157.138 164.564 156.748 164.03 156.443C163.441 156.105 162.654 155.915 161.81 155.916C160.962 155.916 160.172 156.105 159.585 156.443C159.053 156.75 158.763 157.138 158.763 157.535C158.763 157.934 159.053 158.321 159.584 158.627C160.172 158.967 160.962 159.154 161.807 159.154Z",
    fill: "url(#paint66_linear_3744_1590)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M161.807 158.871C162.505 158.871 163.155 158.718 163.641 158.437C164.081 158.184 164.322 157.864 164.322 157.537C164.322 157.208 164.08 156.888 163.643 156.639C163.155 156.358 162.505 156.201 161.81 156.201C161.11 156.201 160.458 156.354 159.974 156.634C159.535 156.888 159.295 157.21 159.295 157.537C159.295 157.863 159.535 158.184 159.974 158.436C160.458 158.717 161.11 158.874 161.807 158.871Z",
    fill: "url(#paint67_linear_3744_1590)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M159.736 157.618L163.929 157.617C163.964 157.617 163.991 157.589 163.992 157.557C163.991 157.52 163.964 157.494 163.929 157.494L159.736 157.492C159.704 157.494 159.675 157.52 159.675 157.556C159.677 157.589 159.704 157.618 159.736 157.618Z",
    fill: "#A8BAC1"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.328 160.54C164.62 160.373 164.848 160.18 165.005 159.978C165.162 159.773 165.25 159.554 165.259 159.337C165.259 159.326 165.259 159.316 165.259 159.301L165.258 158.86C165.258 158.812 165.259 158.762 165.258 158.716L165.259 158.297V157.923C165.263 157.849 165.259 157.775 165.263 157.714C165.259 157.527 165.263 157.394 165.259 157.349C165.259 157.343 165.259 157.343 165.263 157.343C165.259 157.34 165.259 157.337 165.263 157.333C165.259 156.882 164.929 156.442 164.325 156.094C163.658 155.711 162.765 155.498 161.81 155.498C160.85 155.498 159.953 155.71 159.289 156.094C158.729 156.419 158.403 156.821 158.36 157.237C158.36 157.237 158.36 157.237 158.358 157.239C158.357 157.271 158.357 157.302 158.354 157.333C158.357 157.34 158.357 157.349 158.357 157.36V159.381H158.36C158.361 159.393 158.361 159.403 158.366 159.415C158.387 159.611 158.473 159.804 158.619 159.988C158.772 160.187 158.999 160.374 159.29 160.54C159.304 160.55 159.319 160.558 159.339 160.568C159.878 160.864 160.559 161.055 161.303 161.118C161.465 161.127 161.634 161.134 161.806 161.134C162.762 161.134 163.658 160.926 164.328 160.54Z",
    fill: "#F0F7FA"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.81 159.168C160.85 159.168 159.954 158.956 159.289 158.57C158.686 158.221 158.355 157.781 158.355 157.333C158.355 156.882 158.686 156.442 159.287 156.094C159.954 155.71 160.85 155.498 161.81 155.498C162.765 155.498 163.658 155.711 164.325 156.094C164.928 156.442 165.26 156.883 165.26 157.333C165.26 157.781 164.928 158.221 164.327 158.57C163.658 158.956 162.765 159.168 161.81 159.168Z",
    fill: "#F0F7FA"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.029 158.713C160.343 158.713 159.705 158.563 159.229 158.285C158.799 158.039 158.564 157.725 158.562 157.403C158.562 157.082 158.799 156.766 159.231 156.52C159.704 156.243 160.346 156.09 161.028 156.092C161.711 156.092 162.35 156.243 162.828 156.52C163.257 156.766 163.494 157.079 163.494 157.403C163.498 157.725 163.257 158.038 162.828 158.287C162.35 158.563 161.713 158.713 161.029 158.713Z",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.62 159.987C158.62 159.987 158.574 158.101 158.577 157.951C158.441 157.743 158.341 157.528 158.361 157.236C158.353 157.69 158.364 158.365 158.367 159.414C158.387 159.612 158.473 159.804 158.62 159.987Z",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.303 161.119C161.326 160.349 161.353 159.501 161.357 159.136C160.903 159.118 159.929 158.862 159.415 158.639L159.339 160.569C159.879 160.864 160.559 161.055 161.303 161.119Z",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.005 159.978C165.162 159.773 165.25 159.554 165.259 159.337C165.258 159.182 165.258 159.022 165.258 158.861C165.258 158.812 165.259 158.763 165.258 158.717C165.258 158.576 165.258 158.434 165.259 158.298C165.259 158.164 165.258 158.039 165.259 157.924C165.263 157.85 165.259 157.776 165.263 157.714C165.259 157.528 165.263 157.395 165.259 157.35C165.256 157.502 165.216 157.67 165.138 157.8C165.106 157.868 165.057 157.932 165.015 157.994L165.005 159.978Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M167.656 162.61C166.142 163.484 166.143 164.9 167.656 165.773C169.17 166.646 171.623 166.645 173.136 165.773C174.648 164.9 174.648 163.482 173.136 162.61C171.623 161.737 169.169 161.737 167.656 162.61Z",
    fill: "#F0F7FA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 166.334C171.413 166.334 172.37 166.104 173.086 165.692C173.79 165.287 174.175 164.754 174.175 164.19C174.175 163.63 173.79 163.097 173.087 162.693C172.37 162.278 171.413 162.049 170.395 162.049C169.377 162.049 168.419 162.28 167.704 162.692C167.002 163.097 166.617 163.63 166.616 164.192C166.614 164.754 167.002 165.287 167.704 165.689C168.421 166.108 169.377 166.337 170.395 166.334Z",
    fill: "url(#paint68_linear_3744_1590)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M173.587 163.762C173.448 163.521 173.197 163.29 172.855 163.093C172.209 162.72 171.335 162.513 170.395 162.512C169.457 162.512 168.585 162.72 167.936 163.093C167.385 163.411 167.081 163.801 167.081 164.19C167.081 164.337 167.121 164.48 167.205 164.619C167.342 164.86 167.596 165.092 167.936 165.288C168.583 165.663 169.457 165.868 170.395 165.87C171.332 165.868 172.206 165.662 172.855 165.288C173.406 164.97 173.711 164.579 173.711 164.19C173.71 164.046 173.669 163.904 173.587 163.762Z",
    fill: "#9FA1A3"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M168.089 162.403V163.095C168.114 163.078 168.146 163.065 168.171 163.047C168.762 162.707 169.55 162.519 170.394 162.519C171.24 162.522 172.031 162.707 172.617 163.046C172.646 163.065 172.674 163.079 172.704 163.098L172.7 162.423L173.441 162.422V164.207L173.439 164.209C173.404 164.582 173.118 164.945 172.619 165.232C172.031 165.572 171.239 165.757 170.393 165.759C169.549 165.759 168.758 165.571 168.171 165.231C167.642 164.924 167.346 164.536 167.346 164.138V162.4L168.089 162.403Z",
    fill: "url(#paint69_linear_3744_1590)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 164.021C171.241 164.021 172.029 163.835 172.618 163.493C173.148 163.187 173.442 162.799 173.442 162.401C173.442 162.006 173.148 161.615 172.618 161.309C172.032 160.968 171.241 160.783 170.395 160.783C169.55 160.786 168.762 160.968 168.172 161.309C167.643 161.617 167.347 162.006 167.347 162.401C167.347 162.8 167.643 163.188 168.172 163.493C168.761 163.834 169.55 164.02 170.395 164.021Z",
    fill: "url(#paint70_linear_3744_1590)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 163.737C171.091 163.737 171.743 163.583 172.228 163.303C172.668 163.049 172.906 162.732 172.909 162.403C172.906 162.072 172.668 161.754 172.229 161.501C171.743 161.221 171.091 161.066 170.395 161.066C169.697 161.066 169.046 161.221 168.56 161.501C168.123 161.753 167.885 162.073 167.882 162.402C167.882 162.729 168.125 163.049 168.56 163.303C169.05 163.583 169.697 163.737 170.395 163.737Z",
    fill: "url(#paint71_linear_3744_1590)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M168.326 162.485L172.516 162.483C172.553 162.482 172.581 162.455 172.581 162.422C172.581 162.387 172.554 162.358 172.516 162.357L168.326 162.358C168.294 162.358 168.265 162.387 168.265 162.422C168.267 162.457 168.295 162.485 168.326 162.485Z",
    fill: "#A8BAC1"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.914 165.405C173.206 165.236 173.436 165.043 173.591 164.841C173.75 164.638 173.837 164.421 173.843 164.203C173.845 164.189 173.843 164.179 173.845 164.165V163.724C173.843 163.675 173.845 163.628 173.845 163.583V163.163V162.789C173.849 162.713 173.845 162.641 173.849 162.579C173.845 162.391 173.852 162.259 173.849 162.213C173.849 162.211 173.849 162.211 173.852 162.208C173.849 162.206 173.849 162.201 173.849 162.198C173.849 161.748 173.515 161.306 172.914 160.959C172.247 160.577 171.353 160.363 170.394 160.363C169.435 160.363 168.544 160.576 167.874 160.962C167.315 161.284 166.991 161.686 166.949 162.102C166.949 162.102 166.949 162.102 166.949 162.106C166.943 162.137 166.94 162.166 166.943 162.196C166.943 162.206 166.943 162.214 166.944 162.225L166.94 164.245L166.946 164.247C166.949 164.259 166.949 164.269 166.954 164.28C166.973 164.477 167.062 164.668 167.205 164.851C167.359 165.052 167.588 165.24 167.873 165.404C167.891 165.414 167.907 165.423 167.927 165.432C168.466 165.73 169.149 165.922 169.888 165.982C170.055 165.993 170.221 166 170.393 166C171.353 166.002 172.248 165.79 172.914 165.405Z",
    fill: "#F0F7FA"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.395 164.031C169.436 164.031 168.545 163.821 167.877 163.436C167.273 163.09 166.944 162.649 166.944 162.199C166.944 161.749 167.277 161.309 167.877 160.963C168.544 160.576 169.436 160.363 170.395 160.363C171.354 160.363 172.248 160.576 172.915 160.96C173.516 161.309 173.849 161.749 173.846 162.2C173.849 162.649 173.516 163.09 172.915 163.437C172.248 163.822 171.355 164.033 170.395 164.031Z",
    fill: "#F0F7FA"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.618 163.58C168.932 163.578 168.295 163.429 167.819 163.155C167.387 162.903 167.151 162.59 167.151 162.269C167.151 161.948 167.387 161.633 167.819 161.386C168.294 161.109 168.932 160.957 169.616 160.957C170.301 160.957 170.942 161.108 171.418 161.383C171.845 161.633 172.083 161.945 172.083 162.269C172.08 162.59 171.844 162.905 171.418 163.153C170.941 163.429 170.302 163.578 169.618 163.58Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.206 164.852C167.206 164.852 167.163 162.965 167.163 162.818C167.028 162.61 166.929 162.395 166.95 162.104C166.94 162.555 166.951 163.234 166.955 164.282C166.973 164.479 167.063 164.67 167.206 164.852Z",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.889 165.984C169.913 165.216 169.941 164.369 169.944 164.004C169.493 163.983 168.516 163.728 168.002 163.506L167.929 165.433C168.467 165.732 169.151 165.923 169.889 165.984Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.592 164.841C173.751 164.638 173.838 164.421 173.844 164.203C173.844 164.05 173.845 163.887 173.845 163.724C173.844 163.676 173.845 163.629 173.845 163.583C173.844 163.44 173.844 163.298 173.845 163.163C173.845 163.029 173.845 162.904 173.845 162.79C173.849 162.713 173.845 162.641 173.849 162.579C173.845 162.391 173.853 162.259 173.849 162.213C173.844 162.366 173.803 162.535 173.724 162.664C173.694 162.732 173.647 162.794 173.604 162.859L173.592 164.841Z",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M167.11 153.103C165.595 153.975 165.595 155.391 167.108 156.266C168.62 157.136 171.073 157.136 172.587 156.264C174.102 155.391 174.098 153.975 172.589 153.103C171.074 152.229 168.623 152.229 167.11 153.103Z",
    fill: "#F0F7FA"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M169.846 156.827C170.867 156.827 171.822 156.598 172.539 156.185C173.241 155.778 173.629 155.248 173.629 154.684C173.629 154.122 173.242 153.59 172.541 153.183C171.822 152.771 170.866 152.543 169.848 152.543C168.828 152.543 167.874 152.771 167.157 153.183C166.454 153.59 166.066 154.122 166.068 154.686C166.066 155.248 166.453 155.778 167.157 156.185C167.875 156.598 168.829 156.827 169.846 156.827Z",
    fill: "url(#paint72_linear_3744_1590)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M173.039 154.253C172.901 154.014 172.646 153.782 172.309 153.587C171.66 153.211 170.789 153.005 169.848 153.008C168.912 153.008 168.036 153.212 167.387 153.589C166.837 153.905 166.533 154.294 166.533 154.684C166.533 154.827 166.575 154.973 166.656 155.113C166.794 155.353 167.045 155.583 167.387 155.78C168.034 156.155 168.908 156.361 169.846 156.361C170.783 156.361 171.661 156.155 172.308 155.78C172.858 155.463 173.162 155.072 173.163 154.684C173.164 154.54 173.121 154.394 173.039 154.253Z",
    fill: "#9FA1A3"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M167.542 152.895L167.54 153.591C167.569 153.575 167.596 153.558 167.624 153.541C168.214 153.2 169.002 153.013 169.846 153.013C170.691 153.013 171.481 153.201 172.071 153.541C172.1 153.558 172.128 153.574 172.155 153.591V152.92H172.894V154.702L172.892 154.702C172.859 155.076 172.57 155.436 172.07 155.725C171.482 156.066 170.691 156.253 169.848 156.253C169.002 156.251 168.214 156.066 167.624 155.725C167.095 155.417 166.8 155.03 166.8 154.632V152.895H167.542V152.895Z",
    fill: "url(#paint73_linear_3744_1590)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M169.848 154.514C170.691 154.514 171.484 154.328 172.07 153.986C172.602 153.68 172.897 153.294 172.894 152.893C172.894 152.496 172.602 152.107 172.07 151.801C171.484 151.461 170.691 151.272 169.848 151.275C169.002 151.275 168.214 151.463 167.624 151.804C167.095 152.11 166.8 152.496 166.8 152.894C166.8 153.292 167.095 153.68 167.624 153.986C168.212 154.328 169.002 154.514 169.848 154.514Z",
    fill: "url(#paint74_linear_3744_1590)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M169.846 154.23C170.544 154.23 171.196 154.074 171.682 153.795C172.12 153.541 172.36 153.224 172.36 152.894C172.36 152.566 172.12 152.246 171.683 151.995C171.196 151.713 170.544 151.56 169.848 151.561C169.151 151.56 168.499 151.712 168.012 151.994C167.574 152.246 167.335 152.569 167.335 152.894C167.335 153.221 167.575 153.541 168.015 153.795C168.502 154.078 169.152 154.231 169.846 154.23Z",
    fill: "url(#paint75_linear_3744_1590)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M167.779 152.975H171.97C172.006 152.974 172.033 152.947 172.035 152.916C172.033 152.881 172.005 152.853 171.972 152.853L167.777 152.85C167.746 152.853 167.718 152.879 167.719 152.914C167.718 152.947 167.746 152.975 167.779 152.975Z",
    fill: "#A8BAC1"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.368 155.899C172.66 155.728 172.888 155.538 173.045 155.334C173.203 155.13 173.29 154.913 173.298 154.694C173.299 154.685 173.299 154.672 173.299 154.661L173.298 154.218C173.298 154.17 173.299 154.121 173.299 154.074V153.656V153.282C173.302 153.206 173.299 153.133 173.302 153.073C173.301 152.885 173.302 152.753 173.301 152.707C173.299 152.704 173.299 152.704 173.302 152.702C173.299 152.699 173.301 152.694 173.302 152.691C173.301 152.24 172.967 151.802 172.366 151.452C171.7 151.07 170.807 150.855 169.851 150.855C168.892 150.859 167.995 151.069 167.33 151.453C166.769 151.777 166.446 152.178 166.401 152.596C166.401 152.596 166.401 152.596 166.4 152.598C166.397 152.63 166.395 152.66 166.397 152.691C166.395 152.699 166.395 152.707 166.395 152.719V154.74H166.401C166.401 154.752 166.401 154.763 166.406 154.772C166.426 154.971 166.516 155.162 166.657 155.345C166.813 155.543 167.041 155.732 167.329 155.9C167.345 155.906 167.359 155.917 167.379 155.927C167.918 156.223 168.599 156.416 169.342 156.474C169.505 156.486 169.674 156.495 169.846 156.493C170.804 156.496 171.702 156.284 172.368 155.899Z",
    fill: "#F0F7FA"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.848 154.528C168.892 154.527 167.995 154.315 167.33 153.929C166.727 153.581 166.396 153.141 166.396 152.692C166.396 152.241 166.728 151.801 167.33 151.453C167.997 151.068 168.892 150.856 169.848 150.859C170.805 150.856 171.701 151.071 172.366 151.453C172.968 151.802 173.301 152.241 173.301 152.692C173.299 153.141 172.968 153.583 172.368 153.929C171.7 154.314 170.807 154.525 169.848 154.528Z",
    fill: "#F0F7FA"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.072 154.072C168.387 154.072 167.746 153.923 167.27 153.646C166.842 153.398 166.602 153.084 166.602 152.764C166.602 152.44 166.842 152.124 167.27 151.877C167.745 151.601 168.387 151.451 169.072 151.451C169.755 151.451 170.393 151.602 170.869 151.878C171.298 152.125 171.536 152.439 171.538 152.761C171.538 153.084 171.297 153.398 170.869 153.646C170.393 153.921 169.755 154.072 169.072 154.072Z",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.658 155.345C166.658 155.345 166.617 153.459 166.617 153.308C166.483 153.103 166.379 152.888 166.402 152.596C166.396 153.047 166.407 153.723 166.407 154.772C166.427 154.971 166.516 155.162 166.658 155.345Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.343 156.473C169.367 155.706 169.393 154.859 169.397 154.493C168.946 154.476 167.968 154.218 167.454 153.996L167.38 155.926C167.92 156.223 168.6 156.415 169.343 156.473Z",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.045 155.334C173.203 155.13 173.29 154.913 173.298 154.694C173.298 154.54 173.299 154.381 173.298 154.218C173.298 154.17 173.299 154.121 173.299 154.074C173.299 153.934 173.299 153.791 173.299 153.656C173.299 153.523 173.299 153.397 173.299 153.282C173.302 153.206 173.299 153.133 173.302 153.073C173.301 152.885 173.302 152.752 173.301 152.707C173.298 152.86 173.256 153.027 173.181 153.158C173.146 153.227 173.097 153.291 173.057 153.354L173.045 155.334Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M175.697 157.968C174.185 158.84 174.185 160.256 175.697 161.13C177.21 162.004 179.663 162.004 181.177 161.13C182.688 160.256 182.69 158.84 181.177 157.963C179.663 157.095 177.21 157.095 175.697 157.968Z",
    fill: "#F0F7FA"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 161.691C179.455 161.691 180.409 161.46 181.128 161.046C181.829 160.641 182.214 160.108 182.214 159.547C182.214 158.987 181.829 158.453 181.128 158.048C180.409 157.634 179.454 157.408 178.435 157.408C177.418 157.408 176.463 157.634 175.743 158.048C175.042 158.453 174.656 158.986 174.656 159.547C174.656 160.108 175.042 160.641 175.743 161.044C176.463 161.462 177.418 161.691 178.435 161.691Z",
    fill: "url(#paint76_linear_3744_1590)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M181.627 159.119C181.489 158.879 181.235 158.648 180.897 158.451C180.247 158.078 179.374 157.873 178.434 157.873C177.496 157.873 176.625 158.079 175.974 158.452C175.423 158.77 175.12 159.159 175.12 159.549C175.12 159.694 175.16 159.838 175.241 159.979C175.379 160.222 175.635 160.45 175.973 160.646C176.622 161.022 177.495 161.225 178.433 161.227C179.371 161.225 180.245 161.021 180.895 160.646C181.446 160.327 181.749 159.937 181.751 159.549C181.752 159.405 181.708 159.261 181.627 159.119Z",
    fill: "#9FA1A3"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M176.128 157.758V158.454C176.155 158.44 176.186 158.423 176.214 158.405C176.802 158.065 177.592 157.88 178.436 157.88C179.282 157.88 180.071 158.065 180.659 158.405C180.688 158.422 180.716 158.441 180.743 158.456V157.782H181.482L181.483 159.567L181.478 159.57C181.446 159.942 181.161 160.302 180.661 160.59C180.071 160.931 179.28 161.117 178.434 161.117C177.591 161.117 176.8 160.929 176.213 160.589C175.681 160.283 175.389 159.896 175.389 159.497V157.758H176.128Z",
    fill: "url(#paint77_linear_3744_1590)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 159.378C179.281 159.378 180.071 159.191 180.657 158.851C181.19 158.544 181.484 158.156 181.482 157.757C181.482 157.362 181.19 156.974 180.657 156.666C180.071 156.327 179.282 156.139 178.435 156.139C177.592 156.139 176.801 156.327 176.212 156.666C175.682 156.974 175.39 157.362 175.39 157.757C175.39 158.157 175.682 158.544 176.214 158.852C176.802 159.191 177.59 159.376 178.435 159.378Z",
    fill: "url(#paint78_linear_3744_1590)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 159.094C179.133 159.095 179.783 158.939 180.269 158.659C180.707 158.405 180.95 158.087 180.95 157.759C180.95 157.429 180.707 157.111 180.271 156.855C179.785 156.576 179.133 156.423 178.435 156.422C177.738 156.422 177.088 156.575 176.603 156.856C176.164 157.111 175.925 157.431 175.923 157.756C175.922 158.087 176.165 158.405 176.603 158.657C177.088 158.939 177.738 159.094 178.435 159.094Z",
    fill: "url(#paint79_linear_3744_1590)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M176.368 157.84H180.558C180.593 157.84 180.621 157.813 180.621 157.78C180.621 157.745 180.595 157.717 180.558 157.717H176.368C176.333 157.717 176.305 157.745 176.305 157.777C176.305 157.813 176.334 157.842 176.368 157.84Z",
    fill: "#A8BAC1"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.955 160.762C181.248 160.592 181.477 160.402 181.632 160.199C181.789 159.995 181.879 159.779 181.885 159.559C181.885 159.548 181.885 159.536 181.885 159.525V159.082C181.885 159.033 181.885 158.987 181.885 158.939V158.522L181.887 158.145C181.887 158.069 181.887 157.997 181.887 157.935C181.885 157.75 181.892 157.616 181.887 157.572C181.887 157.568 181.887 157.568 181.892 157.566C181.887 157.562 181.887 157.558 181.887 157.556C181.891 157.105 181.559 156.664 180.955 156.315C180.29 155.933 179.394 155.721 178.436 155.721C177.478 155.722 176.583 155.931 175.916 156.317C175.358 156.642 175.034 157.042 174.988 157.46C174.988 157.46 174.988 157.46 174.988 157.464C174.987 157.495 174.984 157.522 174.984 157.552C174.984 157.564 174.984 157.573 174.985 157.582L174.984 159.603H174.988C174.99 159.617 174.99 159.625 174.994 159.637C175.015 159.836 175.099 160.025 175.249 160.208C175.401 160.409 175.627 160.596 175.916 160.76C175.934 160.771 175.95 160.781 175.967 160.788C176.506 161.089 177.189 161.278 177.931 161.337C178.095 161.351 178.264 161.357 178.435 161.357C179.394 161.359 180.29 161.147 180.955 160.762Z",
    fill: "#F0F7FA"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M178.437 159.392C177.479 159.388 176.583 159.179 175.917 158.794C175.317 158.447 174.986 158.006 174.984 157.558C174.986 157.107 175.318 156.667 175.917 156.317C176.583 155.933 177.478 155.723 178.435 155.723C179.394 155.723 180.29 155.933 180.955 156.317C181.559 156.666 181.887 157.107 181.887 157.558C181.887 158.009 181.558 158.449 180.955 158.794C180.29 159.179 179.395 159.392 178.437 159.392Z",
    fill: "#F0F7FA"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.658 158.936C176.974 158.936 176.337 158.786 175.86 158.51C175.429 158.261 175.191 157.945 175.192 157.625C175.192 157.304 175.429 156.989 175.858 156.741C176.337 156.466 176.976 156.314 177.658 156.314C178.343 156.314 178.981 156.466 179.458 156.74C179.889 156.99 180.125 157.304 180.125 157.625C180.123 157.945 179.889 158.261 179.458 158.51C178.981 158.785 178.342 158.936 177.658 158.936Z",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M175.25 160.21C175.25 160.21 175.205 158.324 175.203 158.174C175.067 157.964 174.969 157.752 174.989 157.461C174.984 157.912 174.994 158.589 174.995 159.638C175.016 159.837 175.099 160.026 175.25 160.21Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.931 161.338C177.956 160.57 177.983 159.724 177.986 159.359C177.532 159.342 176.557 159.085 176.042 158.861L175.967 160.79C176.507 161.091 177.189 161.28 177.931 161.338Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.632 160.198C181.789 159.994 181.879 159.778 181.885 159.559C181.885 159.405 181.885 159.244 181.885 159.082C181.885 159.033 181.885 158.986 181.885 158.939C181.885 158.795 181.885 158.653 181.885 158.522C181.885 158.385 181.885 158.26 181.887 158.145C181.887 158.069 181.887 157.996 181.887 157.935C181.885 157.75 181.892 157.616 181.887 157.572C181.885 157.724 181.846 157.891 181.766 158.02C181.734 158.089 181.685 158.155 181.646 158.215L181.632 160.198Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M175.15 148.46C173.636 149.332 173.637 150.749 175.152 151.623C176.664 152.495 179.116 152.496 180.629 151.622C182.142 150.749 182.142 149.332 180.629 148.46C179.116 147.586 176.663 147.586 175.15 148.46Z",
    fill: "#F0F7FA"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 152.184C178.907 152.182 179.862 151.955 180.581 151.54C181.281 151.137 181.668 150.604 181.668 150.041C181.668 149.478 181.283 148.948 180.58 148.541C179.861 148.127 178.907 147.9 177.889 147.9C176.87 147.899 175.913 148.129 175.197 148.541C174.494 148.948 174.108 149.477 174.11 150.041C174.11 150.604 174.493 151.135 175.197 151.54C175.913 151.954 176.87 152.184 177.89 152.184Z",
    fill: "url(#paint80_linear_3744_1590)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M181.079 149.61C180.942 149.371 180.688 149.139 180.35 148.943C179.701 148.567 178.826 148.364 177.889 148.365C176.953 148.364 176.078 148.572 175.429 148.943C174.876 149.264 174.575 149.651 174.575 150.04C174.575 150.185 174.614 150.329 174.696 150.473C174.836 150.71 175.086 150.939 175.429 151.139C176.078 151.511 176.949 151.717 177.889 151.717C178.826 151.72 179.701 151.513 180.35 151.139C180.9 150.821 181.204 150.429 181.205 150.041C181.204 149.895 181.162 149.752 181.079 149.61Z",
    fill: "#9FA1A3"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M175.582 148.252V148.948C175.609 148.931 175.637 148.914 175.667 148.898C176.254 148.557 177.042 148.369 177.889 148.37C178.732 148.369 179.522 148.557 180.111 148.898C180.141 148.914 180.167 148.931 180.193 148.948V148.275H180.934L180.936 150.059H180.931C180.899 150.433 180.609 150.792 180.11 151.08C179.521 151.422 178.735 151.609 177.889 151.609C177.042 151.609 176.253 151.422 175.664 151.08C175.132 150.774 174.84 150.388 174.84 149.988V148.253L175.582 148.252Z",
    fill: "url(#paint81_linear_3744_1590)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 149.872C178.733 149.871 179.523 149.687 180.114 149.345C180.643 149.039 180.938 148.65 180.936 148.253C180.938 147.856 180.643 147.468 180.112 147.16C179.523 146.821 178.733 146.633 177.89 146.633C177.044 146.633 176.254 146.821 175.667 147.16C175.134 147.469 174.842 147.856 174.842 148.254C174.842 148.651 175.134 149.04 175.666 149.345C176.253 149.683 177.044 149.872 177.89 149.872Z",
    fill: "url(#paint82_linear_3744_1590)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M177.889 149.585C178.587 149.585 179.237 149.432 179.722 149.151C180.16 148.899 180.404 148.579 180.402 148.252C180.402 147.923 180.159 147.603 179.724 147.352C179.237 147.072 178.585 146.916 177.89 146.916C177.192 146.916 176.54 147.069 176.054 147.349C175.615 147.602 175.377 147.926 175.377 148.251C175.374 148.579 175.616 148.899 176.054 149.151C176.542 149.434 177.192 149.588 177.889 149.585Z",
    fill: "url(#paint83_linear_3744_1590)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M175.82 148.335L180.012 148.334C180.046 148.334 180.074 148.306 180.074 148.272C180.073 148.238 180.046 148.211 180.013 148.211H175.818C175.786 148.211 175.757 148.238 175.757 148.271C175.757 148.306 175.786 148.336 175.82 148.335Z",
    fill: "#A8BAC1"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.409 151.255C180.701 151.087 180.929 150.894 181.085 150.693C181.246 150.486 181.33 150.27 181.341 150.052C181.341 150.041 181.341 150.03 181.341 150.016V149.574C181.338 149.527 181.341 149.477 181.341 149.429V149.014V148.638C181.342 148.564 181.341 148.492 181.342 148.429C181.342 148.241 181.342 148.109 181.341 148.064C181.341 148.06 181.341 148.06 181.342 148.059C181.341 148.055 181.342 148.052 181.342 148.05C181.342 147.597 181.009 147.158 180.408 146.807C179.741 146.425 178.845 146.213 177.889 146.213C176.93 146.215 176.036 146.425 175.368 146.81C174.807 147.133 174.486 147.537 174.441 147.953C174.441 147.953 174.441 147.953 174.44 147.955C174.436 147.987 174.435 148.018 174.438 148.047C174.435 148.056 174.435 148.065 174.436 148.076L174.435 150.096H174.44C174.441 150.108 174.441 150.118 174.447 150.128C174.468 150.328 174.554 150.518 174.699 150.702C174.853 150.901 175.08 151.089 175.368 151.255C175.385 151.264 175.401 151.272 175.419 151.28C175.958 151.58 176.641 151.769 177.385 151.831C177.547 151.841 177.715 151.849 177.885 151.849C178.845 151.853 179.742 151.64 180.409 151.255Z",
    fill: "#F0F7FA"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M177.89 149.883C176.931 149.883 176.035 149.671 175.369 149.285C174.768 148.937 174.437 148.498 174.437 148.048C174.437 147.597 174.77 147.158 175.369 146.809C176.037 146.425 176.934 146.213 177.89 146.213C178.846 146.213 179.742 146.425 180.407 146.807C181.011 147.158 181.342 147.597 181.343 148.048C181.342 148.498 181.01 148.938 180.409 149.285C179.742 149.67 178.845 149.883 177.89 149.883Z",
    fill: "#F0F7FA"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.111 149.428C176.427 149.428 175.788 149.28 175.311 149.002C174.881 148.754 174.646 148.44 174.646 148.118C174.646 147.797 174.881 147.482 175.311 147.234C175.79 146.96 176.428 146.806 177.11 146.807C177.795 146.807 178.432 146.96 178.91 147.234C179.343 147.481 179.574 147.796 179.574 148.118C179.578 148.44 179.338 148.753 178.91 149.002C178.433 149.277 177.796 149.428 177.111 149.428Z",
    fill: "white"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.7 150.704C174.7 150.704 174.656 148.818 174.656 148.668C174.521 148.461 174.423 148.245 174.442 147.955C174.436 148.408 174.445 149.083 174.448 150.131C174.469 150.33 174.555 150.521 174.7 150.704Z",
    fill: "white"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.386 151.834C177.406 151.067 177.434 150.218 177.438 149.853C176.987 149.835 176.009 149.578 175.494 149.355L175.421 151.283C175.959 151.582 176.643 151.771 177.386 151.834Z",
    fill: "white"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.086 150.693C181.247 150.486 181.331 150.27 181.341 150.052C181.338 149.896 181.341 149.738 181.341 149.575C181.338 149.527 181.341 149.478 181.341 149.43C181.341 149.29 181.338 149.149 181.341 149.015C181.341 148.879 181.338 148.756 181.341 148.639C181.343 148.565 181.341 148.493 181.343 148.429C181.343 148.242 181.343 148.11 181.341 148.064C181.338 148.217 181.297 148.385 181.222 148.514C181.188 148.583 181.14 148.648 181.099 148.71L181.086 150.693Z",
    fill: "white"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M183.74 153.325C182.227 154.198 182.223 155.616 183.737 156.486C185.25 157.362 187.703 157.362 189.217 156.488C190.73 155.614 190.73 154.199 189.217 153.325C187.703 152.452 185.251 152.451 183.74 153.325Z",
    fill: "#F0F7FA"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M186.478 157.047C187.493 157.049 188.45 156.819 189.168 156.406C189.87 155.999 190.256 155.468 190.256 154.908C190.256 154.344 189.871 153.812 189.168 153.408C188.45 152.994 187.496 152.766 186.477 152.766C185.457 152.766 184.502 152.992 183.786 153.406C183.084 153.812 182.697 154.344 182.697 154.908C182.697 155.468 183.082 156.002 183.783 156.405C184.502 156.822 185.459 157.048 186.478 157.047Z",
    fill: "url(#paint84_linear_3744_1590)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M189.669 154.475C189.53 154.235 189.277 154.003 188.936 153.809C188.287 153.434 187.416 153.229 186.477 153.227C185.541 153.227 184.668 153.434 184.016 153.808C183.466 154.127 183.161 154.516 183.161 154.904C183.163 155.05 183.202 155.193 183.286 155.336C183.423 155.575 183.676 155.806 184.016 156.002C184.664 156.376 185.54 156.583 186.478 156.583C187.415 156.583 188.286 156.376 188.936 156.002C189.488 155.685 189.792 155.292 189.792 154.905C189.792 154.763 189.752 154.618 189.669 154.475Z",
    fill: "#9FA1A3"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M184.168 153.116V153.81C184.196 153.794 184.225 153.777 184.255 153.761C184.842 153.422 185.633 153.232 186.476 153.234C187.322 153.235 188.112 153.42 188.701 153.76C188.728 153.777 188.756 153.793 188.783 153.811L188.782 153.139L189.524 153.137V154.925H189.521C189.488 155.296 189.2 155.657 188.701 155.947C188.112 156.286 187.321 156.473 186.476 156.473C185.633 156.473 184.842 156.285 184.255 155.947C183.724 155.638 183.431 155.251 183.431 154.852L183.428 153.115L184.168 153.116Z",
    fill: "url(#paint85_linear_3744_1590)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M186.476 154.736C187.322 154.736 188.112 154.548 188.701 154.207C189.233 153.901 189.524 153.513 189.524 153.114C189.524 152.717 189.233 152.33 188.701 152.022C188.112 151.682 187.321 151.498 186.476 151.496C185.633 151.498 184.842 151.682 184.255 152.023C183.723 152.331 183.431 152.718 183.428 153.115C183.431 153.514 183.724 153.902 184.255 154.208C184.843 154.548 185.63 154.736 186.476 154.736Z",
    fill: "url(#paint86_linear_3744_1590)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M186.476 154.452C187.174 154.452 187.826 154.299 188.309 154.017C188.747 153.765 188.99 153.446 188.99 153.119C188.99 152.788 188.75 152.469 188.308 152.215C187.826 151.935 187.174 151.781 186.476 151.781C185.78 151.781 185.128 151.935 184.643 152.215C184.206 152.469 183.965 152.789 183.965 153.117C183.963 153.444 184.207 153.766 184.643 154.017C185.129 154.297 185.781 154.452 186.476 154.452Z",
    fill: "url(#paint87_linear_3744_1590)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M184.409 153.198L188.601 153.197C188.635 153.196 188.663 153.169 188.663 153.135C188.663 153.103 188.633 153.075 188.601 153.072L184.409 153.074C184.376 153.074 184.348 153.103 184.348 153.135C184.348 153.171 184.376 153.198 184.409 153.198Z",
    fill: "#A8BAC1"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.998 156.117C189.288 155.951 189.517 155.756 189.675 155.555C189.833 155.35 189.921 155.135 189.924 154.916C189.928 154.904 189.928 154.893 189.928 154.881V154.439C189.924 154.39 189.929 154.343 189.928 154.298V153.879L189.929 153.503C189.929 153.428 189.929 153.356 189.929 153.294C189.929 153.105 189.931 152.974 189.929 152.927C189.931 152.926 189.931 152.926 189.931 152.926C189.929 152.921 189.929 152.917 189.931 152.912C189.931 152.461 189.597 152.022 188.996 151.674C188.329 151.291 187.433 151.078 186.478 151.078C185.517 151.079 184.626 151.291 183.956 151.676C183.399 151.997 183.071 152.402 183.03 152.817C183.03 152.817 183.03 152.817 183.03 152.821C183.025 152.851 183.022 152.883 183.025 152.912C183.025 152.921 183.025 152.929 183.025 152.941L183.022 154.959L183.03 154.962C183.033 154.976 183.033 154.983 183.034 154.995C183.055 155.192 183.144 155.385 183.287 155.566C183.444 155.768 183.671 155.953 183.955 156.119C183.973 156.129 183.991 156.137 184.009 156.145C184.546 156.445 185.229 156.636 185.97 156.697C186.136 156.708 186.305 156.716 186.475 156.716C187.433 156.718 188.33 156.504 188.998 156.117Z",
    fill: "#F0F7FA"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.476 154.746C185.517 154.745 184.625 154.536 183.959 154.149C183.354 153.802 183.026 153.363 183.026 152.912C183.026 152.461 183.355 152.022 183.959 151.676C184.625 151.291 185.517 151.078 186.478 151.078C187.433 151.078 188.329 151.291 188.996 151.674C189.596 152.022 189.929 152.463 189.929 152.914C189.929 153.364 189.597 153.802 188.996 154.153C188.33 154.538 187.436 154.748 186.476 154.746Z",
    fill: "#F0F7FA"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.701 154.294C185.014 154.291 184.377 154.143 183.9 153.869C183.47 153.616 183.233 153.304 183.233 152.981C183.233 152.663 183.47 152.346 183.898 152.098C184.376 151.823 185.014 151.67 185.698 151.672C186.382 151.67 187.021 151.823 187.498 152.096C187.929 152.346 188.164 152.663 188.164 152.981C188.164 153.304 187.929 153.618 187.5 153.866C187.022 154.143 186.382 154.293 185.701 154.294Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.288 155.567C183.288 155.567 183.246 153.68 183.246 153.53C183.11 153.324 183.009 153.108 183.03 152.816C183.023 153.269 183.035 153.947 183.035 154.994C183.055 155.191 183.145 155.384 183.288 155.567Z",
    fill: "white"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.971 156.697C185.996 155.927 186.025 155.08 186.026 154.716C185.574 154.696 184.596 154.441 184.084 154.219L184.011 156.145C184.548 156.445 185.231 156.636 185.971 156.697Z",
    fill: "white"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.675 155.556C189.833 155.351 189.92 155.136 189.924 154.916C189.924 154.764 189.927 154.601 189.927 154.44C189.924 154.39 189.929 154.343 189.927 154.298C189.924 154.154 189.927 154.013 189.927 153.879C189.927 153.743 189.927 153.618 189.929 153.504C189.929 153.428 189.929 153.356 189.929 153.294C189.929 153.105 189.931 152.974 189.929 152.928C189.924 153.082 189.886 153.25 189.809 153.379C189.776 153.447 189.726 153.512 189.684 153.573L189.675 155.556Z",
    fill: "white"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M183.192 143.816C181.677 144.69 181.677 146.106 183.19 146.98C184.704 147.853 187.156 147.853 188.669 146.979C190.182 146.106 190.182 144.69 188.669 143.816C187.157 142.944 184.704 142.944 183.192 143.816Z",
    fill: "#F0F7FA"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M185.928 147.542C186.947 147.542 187.905 147.314 188.621 146.899C189.323 146.492 189.709 145.963 189.709 145.4C189.709 144.838 189.323 144.307 188.621 143.9C187.905 143.488 186.947 143.258 185.928 143.258C184.91 143.258 183.955 143.488 183.239 143.899C182.537 144.305 182.147 144.838 182.148 145.4C182.148 145.963 182.533 146.493 183.239 146.899C183.952 147.314 184.91 147.542 185.928 147.542Z",
    fill: "url(#paint88_linear_3744_1590)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M189.121 144.968C188.983 144.73 188.729 144.496 188.39 144.304C187.741 143.927 186.866 143.723 185.928 143.723C184.992 143.723 184.117 143.928 183.472 144.303C182.918 144.62 182.615 145.011 182.613 145.399C182.613 145.545 182.657 145.689 182.738 145.83C182.877 146.071 183.127 146.299 183.469 146.497C184.115 146.87 184.989 147.076 185.928 147.076C186.867 147.076 187.74 146.873 188.389 146.498C188.939 146.18 189.243 145.79 189.244 145.4C189.246 145.257 189.203 145.111 189.121 144.968Z",
    fill: "#9FA1A3"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M183.623 143.609V144.305C183.651 144.288 183.676 144.273 183.704 144.255C184.297 143.915 185.084 143.728 185.928 143.728C186.773 143.728 187.563 143.915 188.152 144.256C188.183 144.273 188.207 144.288 188.238 144.305V143.633H188.977V145.417H188.972C188.938 145.791 188.651 146.152 188.151 146.44C187.562 146.781 186.774 146.967 185.928 146.967C185.083 146.967 184.296 146.781 183.703 146.44C183.174 146.132 182.883 145.745 182.879 145.348L182.883 143.609H183.623Z",
    fill: "url(#paint89_linear_3744_1590)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M185.93 145.228C186.773 145.228 187.564 145.042 188.152 144.703C188.686 144.396 188.978 144.009 188.978 143.61C188.978 143.212 188.683 142.825 188.152 142.517C187.563 142.178 186.773 141.99 185.928 141.992C185.084 141.992 184.297 142.178 183.707 142.519C183.175 142.826 182.883 143.212 182.883 143.611C182.883 144.011 183.175 144.396 183.704 144.702C184.295 145.042 185.084 145.23 185.93 145.228Z",
    fill: "url(#paint90_linear_3744_1590)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M185.929 144.945C186.627 144.945 187.277 144.793 187.762 144.511C188.203 144.259 188.442 143.94 188.442 143.611C188.442 143.281 188.202 142.962 187.765 142.711C187.279 142.43 186.628 142.274 185.929 142.275C185.23 142.275 184.58 142.428 184.094 142.708C183.658 142.962 183.417 143.284 183.417 143.611C183.416 143.94 183.659 144.257 184.094 144.511C184.581 144.792 185.235 144.947 185.929 144.945Z",
    fill: "url(#paint91_linear_3744_1590)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M183.861 143.691H188.053C188.087 143.691 188.115 143.662 188.115 143.629C188.117 143.593 188.089 143.567 188.054 143.567L183.861 143.564C183.828 143.567 183.8 143.593 183.798 143.629C183.8 143.661 183.828 143.691 183.861 143.691Z",
    fill: "#A8BAC1"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.448 146.614C188.742 146.445 188.971 146.253 189.129 146.051C189.283 145.846 189.373 145.629 189.38 145.41C189.381 145.399 189.38 145.388 189.38 145.375V144.933C189.38 144.885 189.38 144.838 189.38 144.789L189.381 144.372V143.998C189.383 143.923 189.381 143.849 189.384 143.788C189.383 143.601 189.383 143.467 189.383 143.423C189.383 143.418 189.383 143.418 189.384 143.417C189.383 143.414 189.383 143.409 189.383 143.407C189.383 142.955 189.049 142.516 188.448 142.167C187.782 141.784 186.887 141.574 185.93 141.574C184.974 141.574 184.077 141.784 183.411 142.171C182.852 142.493 182.523 142.895 182.483 143.31C182.483 143.31 182.483 143.31 182.482 143.313C182.479 143.346 182.477 143.375 182.479 143.405C182.479 143.414 182.477 143.422 182.479 143.435L182.477 145.456H182.483C182.485 145.468 182.485 145.478 182.488 145.487C182.51 145.686 182.596 145.879 182.739 146.06C182.893 146.261 183.124 146.447 183.41 146.613C183.426 146.623 183.441 146.631 183.462 146.639C184 146.939 184.681 147.13 185.424 147.19C185.588 147.202 185.755 147.209 185.926 147.209C186.887 147.21 187.782 146.999 188.448 146.614Z",
    fill: "#F0F7FA"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M185.928 145.242C184.97 145.242 184.077 145.028 183.411 144.644C182.807 144.297 182.478 143.856 182.478 143.405C182.478 142.955 182.808 142.516 183.411 142.169C184.077 141.784 184.974 141.573 185.93 141.574C186.887 141.574 187.782 141.784 188.448 142.167C189.05 142.516 189.383 142.955 189.383 143.407C189.381 143.856 189.049 144.297 188.448 144.644C187.78 145.028 186.887 145.242 185.928 145.242Z",
    fill: "#F0F7FA"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.15 144.787C184.467 144.787 183.829 144.636 183.352 144.359C182.922 144.111 182.686 143.797 182.686 143.476C182.686 143.152 182.922 142.839 183.352 142.591C183.829 142.316 184.467 142.164 185.152 142.164C185.836 142.164 186.475 142.317 186.952 142.591C187.382 142.839 187.615 143.151 187.615 143.476C187.619 143.797 187.382 144.111 186.95 144.359C186.475 144.634 185.836 144.787 185.15 144.787Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.74 146.061C182.74 146.061 182.699 144.174 182.699 144.025C182.565 143.817 182.463 143.603 182.484 143.311C182.478 143.764 182.486 144.44 182.489 145.488C182.511 145.687 182.596 145.879 182.74 146.061Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.425 147.19C185.453 146.421 185.478 145.575 185.478 145.211C185.028 145.191 184.05 144.934 183.536 144.713L183.463 146.64C184.001 146.939 184.682 147.13 185.425 147.19Z",
    fill: "white"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.129 146.05C189.283 145.845 189.374 145.628 189.38 145.409C189.38 145.256 189.38 145.094 189.38 144.932C189.38 144.885 189.38 144.837 189.38 144.788C189.38 144.648 189.38 144.507 189.381 144.371C189.38 144.237 189.38 144.111 189.381 143.997C189.383 143.922 189.381 143.848 189.384 143.787C189.383 143.6 189.383 143.466 189.383 143.422C189.38 143.574 189.337 143.742 189.262 143.872C189.23 143.94 189.18 144.005 189.14 144.068L189.129 146.05Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M191.778 148.682C190.267 149.556 190.267 150.972 191.779 151.845C193.292 152.718 195.746 152.718 197.256 151.845C198.773 150.972 198.773 149.556 197.258 148.68C195.746 147.809 193.292 147.809 191.778 148.682Z",
    fill: "#F0F7FA"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 152.406C195.537 152.406 196.491 152.175 197.21 151.761C197.909 151.356 198.296 150.825 198.298 150.263C198.298 149.702 197.911 149.169 197.21 148.764C196.491 148.35 195.533 148.123 194.518 148.123C193.5 148.123 192.544 148.35 191.825 148.764C191.124 149.169 190.739 149.702 190.738 150.263C190.738 150.825 191.124 151.357 191.825 151.761C192.543 152.177 193.5 152.406 194.518 152.406Z",
    fill: "url(#paint92_linear_3744_1590)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M197.709 149.833C197.571 149.594 197.319 149.362 196.977 149.166C196.329 148.793 195.454 148.588 194.518 148.586C193.578 148.586 192.707 148.794 192.056 149.166C191.507 149.483 191.202 149.874 191.202 150.263C191.202 150.407 191.245 150.552 191.327 150.693C191.465 150.934 191.717 151.164 192.058 151.362C192.705 151.735 193.578 151.941 194.518 151.941C195.454 151.94 196.328 151.734 196.977 151.362C197.528 151.042 197.832 150.65 197.834 150.263C197.832 150.12 197.792 149.975 197.709 149.833Z",
    fill: "#9FA1A3"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M192.212 148.473L192.211 149.168C192.239 149.153 192.268 149.136 192.296 149.118C192.883 148.779 193.672 148.592 194.518 148.592C195.363 148.595 196.154 148.779 196.74 149.118C196.77 149.135 196.798 149.154 196.826 149.17L196.825 148.495H197.564V150.281L197.562 150.283C197.528 150.655 197.241 151.015 196.741 151.305C196.153 151.644 195.362 151.83 194.518 151.831C193.672 151.831 192.882 151.642 192.295 151.303C191.763 150.996 191.473 150.608 191.473 150.212L191.469 148.473H192.212V148.473Z",
    fill: "url(#paint93_linear_3744_1590)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 150.092C195.363 150.094 196.152 149.906 196.742 149.564C197.274 149.259 197.566 148.872 197.566 148.474C197.566 148.078 197.274 147.688 196.739 147.382C196.154 147.042 195.363 146.854 194.518 146.854C193.672 146.855 192.883 147.042 192.296 147.382C191.76 147.689 191.473 148.078 191.47 148.474C191.473 148.873 191.764 149.26 192.296 149.568C192.883 149.906 193.672 150.091 194.518 150.092Z",
    fill: "url(#paint94_linear_3744_1590)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 149.809C195.217 149.809 195.865 149.654 196.35 149.376C196.79 149.119 197.031 148.804 197.032 148.473C197.032 148.145 196.79 147.825 196.351 147.573C195.865 147.29 195.213 147.137 194.518 147.137C193.82 147.137 193.17 147.289 192.684 147.573C192.246 147.825 192.004 148.146 192.006 148.473C192.006 148.801 192.246 149.122 192.686 149.374C193.17 149.654 193.822 149.809 194.518 149.809Z",
    fill: "url(#paint95_linear_3744_1590)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M192.451 148.553L196.64 148.555C196.675 148.553 196.703 148.526 196.703 148.493C196.703 148.459 196.675 148.43 196.64 148.43H192.449C192.416 148.43 192.388 148.457 192.388 148.493C192.387 148.528 192.417 148.556 192.451 148.553Z",
    fill: "#A8BAC1"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.038 151.476C197.33 151.307 197.56 151.116 197.717 150.912C197.872 150.709 197.962 150.496 197.968 150.274C197.968 150.263 197.968 150.251 197.971 150.238L197.968 149.797C197.968 149.75 197.971 149.701 197.968 149.654V149.236V148.862C197.973 148.784 197.968 148.715 197.973 148.65C197.971 148.465 197.973 148.333 197.973 148.287C197.973 148.285 197.973 148.285 197.974 148.28C197.973 148.278 197.971 148.272 197.971 148.269C197.971 147.819 197.638 147.378 197.038 147.031C196.371 146.648 195.476 146.434 194.518 146.436C193.56 146.438 192.665 146.648 191.997 147.034C191.44 147.356 191.115 147.759 191.07 148.175C191.07 148.175 191.07 148.175 191.07 148.178C191.066 148.21 191.064 148.239 191.066 148.267C191.066 148.279 191.066 148.288 191.066 148.297L191.064 150.318L191.07 150.32C191.072 150.332 191.073 150.341 191.076 150.353C191.098 150.55 191.184 150.742 191.328 150.925C191.485 151.124 191.711 151.313 192 151.476C192.016 151.485 192.031 151.496 192.05 151.503C192.59 151.804 193.272 151.994 194.012 152.052C194.176 152.066 194.345 152.072 194.518 152.072C195.475 152.074 196.37 151.861 197.038 151.476Z",
    fill: "#F0F7FA"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M194.519 150.104C193.56 150.104 192.665 149.892 191.999 149.507C191.398 149.159 191.067 148.719 191.065 148.269C191.067 147.819 191.398 147.381 191.999 147.033C192.665 146.648 193.56 146.434 194.519 146.436C195.476 146.434 196.372 146.647 197.036 147.031C197.639 147.38 197.972 147.819 197.972 148.271C197.972 148.722 197.638 149.161 197.039 149.507C196.37 149.893 195.475 150.104 194.519 150.104Z",
    fill: "#F0F7FA"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193.742 149.651C193.055 149.651 192.418 149.5 191.944 149.225C191.511 148.976 191.273 148.66 191.273 148.341C191.277 148.02 191.512 147.705 191.944 147.457C192.417 147.182 193.057 147.029 193.742 147.031C194.422 147.031 195.063 147.182 195.539 147.455C195.972 147.706 196.206 148.019 196.206 148.341C196.204 148.66 195.969 148.977 195.539 149.225C195.063 149.5 194.422 149.651 193.742 149.651Z",
    fill: "white"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M191.329 150.925C191.329 150.925 191.287 149.037 191.287 148.888C191.152 148.678 191.053 148.466 191.071 148.174C191.065 148.625 191.074 149.305 191.077 150.352C191.099 150.55 191.185 150.742 191.329 150.925Z",
    fill: "white"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.013 152.053C194.038 151.287 194.063 150.44 194.068 150.074C193.615 150.057 192.638 149.802 192.124 149.576L192.051 151.504C192.591 151.804 193.272 151.994 194.013 152.053Z",
    fill: "white"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M197.717 150.912C197.872 150.709 197.962 150.496 197.968 150.273C197.968 150.12 197.968 149.958 197.968 149.797C197.968 149.75 197.971 149.701 197.968 149.654C197.968 149.513 197.968 149.37 197.968 149.236C197.971 149.101 197.971 148.975 197.968 148.862C197.973 148.784 197.968 148.714 197.973 148.649C197.971 148.465 197.973 148.333 197.973 148.287C197.968 148.438 197.927 148.605 197.849 148.735C197.816 148.804 197.768 148.869 197.729 148.931L197.717 150.912Z",
    fill: "white"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M192.619 154.449L192.51 154.563L192.019 155.07L191.888 155.208L191.393 155.715L191.261 155.852L190.777 156.356L190.644 156.494L190.156 157L190.021 157.137L189.532 157.64L189.395 157.783L188.912 158.286L188.778 158.423L188.288 158.931L188.157 159.069L187.663 159.575L187.529 159.712L187.044 160.215L186.911 160.353L186.424 160.861L186.291 160.998L186.113 161.176L185.614 161.698L171.261 169.983C170.699 170.307 169.789 170.307 169.22 169.978L151.393 159.685C151.218 159.585 151.096 159.462 151.031 159.339C151.01 159.297 150.992 159.248 150.982 159.197C150.953 159.078 150.972 158.954 151.04 158.84C151.035 158.698 151.095 158.557 151.218 158.424C151.265 158.379 151.32 158.333 151.384 158.287C151.411 158.273 151.434 158.256 151.463 158.237L152.494 157.642L153.369 157.139L153.606 156.997L154.479 156.495L154.718 156.357L155.59 155.853L155.837 155.711L156.711 155.209L156.95 155.071L157.822 154.564L158.059 154.427L159.157 153.796L159.175 153.781L160.049 153.278L160.291 153.14L161.164 152.633L161.403 152.496L162.499 151.86L162.517 151.851L163.391 151.347L164.749 150.566L165.617 150.062L165.86 149.921L166.733 149.418L166.97 149.28L167.844 148.773H167.849L168.091 148.636L168.961 148.133L169.203 147.991L170.071 147.487H170.076L170.314 147.35L171.187 146.843H171.192L171.43 146.706L172.303 146.202L172.545 146.06L173.415 145.557H173.418L173.657 145.42L174.53 144.913H174.534L174.773 144.775L175.646 144.272L175.889 144.131L176.757 143.627H176.762L176.999 143.49L177.877 142.983L178.116 142.845L178.17 142.814L178.207 142.845L178.335 142.946L178.381 142.983L179.012 143.49L179.181 143.627L179.807 144.131L179.982 144.272L180.607 144.775L180.778 144.913L181.409 145.42L181.579 145.557L182.205 146.06L182.264 146.11L182.378 146.202L182.516 146.311L183.005 146.705L183.179 146.843L183.239 146.897L183.253 146.907L183.587 147.171L183.806 147.35L183.98 147.487L184.607 147.991L184.776 148.133L185.402 148.636L185.572 148.773L186.204 149.28L186.378 149.418L187.004 149.925L187.178 150.062L187.8 150.566L187.977 150.708L188.604 151.211L188.773 151.348L189.397 151.851L189.576 151.994L190.201 152.497L190.372 152.634L191.002 153.141L191.171 153.279L191.798 153.782L191.972 153.924L192.599 154.427L192.619 154.449Z",
    fill: "url(#paint96_linear_3744_1590)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M171.261 166.78L205.153 147.214C205.199 147.189 205.238 147.16 205.274 147.129C205.334 147.088 205.385 147.041 205.423 146.991C205.563 146.834 205.605 146.656 205.555 146.486C205.543 146.438 205.523 146.395 205.496 146.35C205.426 146.233 205.314 146.125 205.153 146.033L187.323 135.74C187.179 135.657 187.011 135.593 186.832 135.554C186.493 135.478 186.111 135.476 185.773 135.554C185.593 135.595 185.425 135.654 185.28 135.74L151.391 155.304C151.363 155.322 151.34 155.339 151.314 155.354C151.251 155.401 151.194 155.444 151.15 155.494C150.998 155.648 150.941 155.826 150.984 155.998C150.991 156.047 151.008 156.095 151.031 156.139C151.096 156.263 151.218 156.386 151.394 156.485L169.221 166.778C169.787 167.103 170.701 167.103 171.261 166.78Z",
    fill: "white"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M171.337 166.51L205.227 146.941C205.27 146.918 205.308 146.889 205.347 146.861C205.407 146.818 205.458 146.77 205.496 146.723C205.634 146.566 205.678 146.386 205.628 146.22C205.616 146.17 205.594 146.124 205.569 146.081C205.499 145.965 205.385 145.858 205.224 145.763L187.394 135.469C187.252 135.387 187.082 135.324 186.905 135.285C186.565 135.208 186.185 135.206 185.846 135.285C185.666 135.323 185.497 135.387 185.353 135.469L151.466 155.034C151.437 155.051 151.412 155.069 151.386 155.084C151.322 155.131 151.265 155.174 151.222 155.222C151.072 155.379 151.016 155.559 151.056 155.73C151.064 155.779 151.078 155.822 151.106 155.867C151.17 155.994 151.29 156.116 151.466 156.215L169.294 166.511C169.86 166.837 170.772 166.834 171.337 166.51Z",
    fill: "url(#paint97_linear_3744_1590)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M171.943 166.157L172.185 166.018L168.444 166.018L168.685 166.157H171.943Z",
    fill: "#B6BCC1"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M173.058 165.513L173.3 165.375H167.331L167.569 165.514L173.058 165.513Z",
    fill: "#B6BCC1"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M174.173 164.872L174.414 164.732H166.216L166.454 164.872H174.173Z",
    fill: "#B6BCC1"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M175.286 164.228L175.525 164.09H165.101L165.345 164.231L175.286 164.228Z",
    fill: "#B6BCC1"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M176.4 163.583L176.642 163.447H163.987L164.227 163.586L176.4 163.583Z",
    fill: "#B6BCC1"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M177.518 162.938L177.753 162.803H162.874L163.114 162.943L177.518 162.938Z",
    fill: "#B6BCC1"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M178.63 162.299L178.872 162.16L161.759 162.162L162.001 162.299H178.63Z",
    fill: "#B6BCC1"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M179.742 161.655L179.984 161.516L160.647 161.519L160.883 161.655H179.742Z",
    fill: "#B6BCC1"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M180.859 161.009L181.098 160.873L159.532 160.871L159.772 161.011L180.859 161.009Z",
    fill: "#B6BCC1"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M181.971 160.368L182.212 160.23H158.415L158.657 160.368H181.971Z",
    fill: "#B6BCC1"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M183.084 159.724L183.327 159.586L157.304 159.588L157.543 159.724L183.084 159.724Z",
    fill: "#B6BCC1"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M184.2 159.081L184.441 158.941L156.19 158.946L156.432 159.081H184.2Z",
    fill: "#B6BCC1"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M185.313 158.439L185.557 158.299L155.075 158.301L155.319 158.44L185.313 158.439Z",
    fill: "#B6BCC1"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M186.428 157.796L186.67 157.656H153.959L154.202 157.796H186.428Z",
    fill: "#B6BCC1"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M187.539 157.151L187.782 157.014L152.846 157.016L153.089 157.151H187.539Z",
    fill: "#B6BCC1"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M188.656 156.509L188.894 156.373L151.733 156.371L151.974 156.509H188.656Z",
    fill: "#B6BCC1"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M189.77 155.866L190.009 155.729L151.057 155.731C151.065 155.779 151.079 155.823 151.107 155.868L189.77 155.866Z",
    fill: "#B6BCC1"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M190.882 155.223L191.124 155.084H151.386C151.322 155.13 151.265 155.174 151.222 155.222L190.882 155.223Z",
    fill: "#B6BCC1"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M191.997 154.579L192.239 154.439H152.496L152.252 154.579H191.997Z",
    fill: "#B6BCC1"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M193.112 153.939L193.352 153.798L153.609 153.797L153.369 153.935L193.112 153.939Z",
    fill: "#B6BCC1"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M194.226 153.295L194.466 153.156H154.721L154.482 153.294L194.226 153.295Z",
    fill: "#B6BCC1"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M195.339 152.65L195.576 152.513L155.838 152.512L155.594 152.65H195.339Z",
    fill: "#B6BCC1"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M196.452 152.007L196.694 151.869H156.949L156.711 152.007H196.452Z",
    fill: "#B6BCC1"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M197.567 151.365L197.81 151.225L158.064 151.226L157.822 151.365H197.567Z",
    fill: "#B6BCC1"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M198.68 150.721L198.921 150.582H159.177L158.937 150.72L198.68 150.721Z",
    fill: "#B6BCC1"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M199.796 150.079L200.034 149.941L160.292 149.939L160.051 150.079H199.796Z",
    fill: "#B6BCC1"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M200.909 149.433L201.149 149.297L161.406 149.295L161.165 149.433H200.909Z",
    fill: "#B6BCC1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M202.025 148.791L202.263 148.652H162.52L162.28 148.791H202.025Z",
    fill: "#B6BCC1"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M203.138 148.149L203.375 148.012H163.633L163.393 148.149H203.138Z",
    fill: "#B6BCC1"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M204.251 147.507L204.49 147.365H164.75L164.51 147.507H204.251Z",
    fill: "#B6BCC1"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M205.347 146.862C205.407 146.819 205.458 146.77 205.496 146.723L165.862 146.721L165.617 146.862L205.347 146.862Z",
    fill: "#B6BCC1"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M205.628 146.22C205.616 146.17 205.594 146.125 205.569 146.082L166.973 146.08L166.735 146.218L205.628 146.22Z",
    fill: "#B6BCC1"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M204.898 145.575L204.655 145.436H168.091L167.848 145.575H204.898Z",
    fill: "#B6BCC1"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M203.782 144.931L203.544 144.795L169.205 144.793L168.964 144.931H203.782Z",
    fill: "#B6BCC1"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M202.672 144.292L202.429 144.152L170.317 144.148L170.074 144.289L202.672 144.292Z",
    fill: "#B6BCC1"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M201.558 143.647L201.315 143.508H171.432L171.189 143.646L201.558 143.647Z",
    fill: "#B6BCC1"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M200.441 143.005L200.202 142.863H172.546L172.305 143.003L200.441 143.005Z",
    fill: "#B6BCC1"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M199.327 142.363L199.089 142.221L173.658 142.222L173.418 142.362L199.327 142.363Z",
    fill: "#B6BCC1"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M198.216 141.718L197.974 141.577L174.774 141.576L174.533 141.718H198.216Z",
    fill: "#B6BCC1"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M197.102 141.073L196.859 140.935L175.89 140.932L175.647 141.073H197.102Z",
    fill: "#B6BCC1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M195.988 140.433L195.746 140.292L177.001 140.291L176.758 140.43L195.988 140.433Z",
    fill: "#B6BCC1"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M194.871 139.785L194.634 139.651L178.115 139.648L177.876 139.787L194.871 139.785Z",
    fill: "#B6BCC1"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M193.758 139.144L193.517 139.004H179.231L178.989 139.144H193.758Z",
    fill: "#B6BCC1"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M192.643 138.502L192.403 138.362L180.346 138.361L180.102 138.501L192.643 138.502Z",
    fill: "#B6BCC1"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M191.53 137.86L191.29 137.719H181.457L181.215 137.858L191.53 137.86Z",
    fill: "#B6BCC1"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M190.416 137.214L190.176 137.076L182.571 137.074L182.332 137.214H190.416Z",
    fill: "#B6BCC1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M189.303 136.572L189.063 136.433L183.685 136.432L183.445 136.572H189.303Z",
    fill: "#B6BCC1"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M188.188 135.928L187.946 135.789H184.8L184.558 135.928H188.188Z",
    fill: "#B6BCC1"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M186.904 135.285C186.564 135.208 186.184 135.206 185.845 135.285H186.904Z",
    fill: "#B6BCC1"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M159.067 154.544C157.555 155.417 157.555 156.833 159.067 157.707C160.58 158.579 163.031 158.579 164.546 157.707C166.058 156.833 166.06 155.416 164.549 154.544C163.034 153.669 160.58 153.672 159.067 154.544Z",
    fill: "#F0F7FA"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M161.808 158.268C162.827 158.266 163.781 158.041 164.498 157.626C165.2 157.22 165.587 156.688 165.587 156.126C165.587 155.563 165.201 155.032 164.498 154.627C163.779 154.213 162.825 153.984 161.808 153.984C160.788 153.983 159.832 154.213 159.115 154.627C158.414 155.031 158.027 155.563 158.029 156.126C158.029 156.688 158.414 157.22 159.115 157.624C159.832 158.038 160.788 158.268 161.808 158.268Z",
    fill: "url(#paint98_linear_3744_1590)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M164.999 155.694C164.859 155.455 164.607 155.222 164.268 155.029C163.619 154.653 162.744 154.449 161.806 154.449C160.868 154.449 159.997 154.655 159.347 155.029C158.796 155.348 158.492 155.736 158.49 156.125C158.49 156.269 158.533 156.412 158.613 156.557C158.753 156.796 159.005 157.024 159.347 157.224C159.992 157.595 160.867 157.801 161.806 157.801C162.743 157.801 163.62 157.597 164.265 157.224C164.818 156.905 165.123 156.514 165.123 156.125C165.123 155.98 165.081 155.837 164.999 155.694Z",
    fill: "#9FA1A3"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M159.499 154.336L159.5 155.032C159.527 155.016 159.556 154.996 159.585 154.982C160.172 154.643 160.96 154.454 161.808 154.454C162.654 154.453 163.441 154.643 164.03 154.982C164.058 154.999 164.086 155.016 164.113 155.032V154.359L164.853 154.359V156.145L164.852 156.143C164.818 156.517 164.529 156.877 164.029 157.164C163.441 157.507 162.653 157.691 161.806 157.691C160.961 157.691 160.172 157.507 159.585 157.164C159.052 156.86 158.762 156.473 158.762 156.072V154.336H159.499Z",
    fill: "url(#paint99_linear_3744_1590)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M161.806 155.954C162.651 155.954 163.442 155.769 164.03 155.427C164.564 155.121 164.854 154.734 164.854 154.335C164.854 153.938 164.564 153.549 164.03 153.243C163.441 152.904 162.654 152.716 161.81 152.717C160.962 152.717 160.172 152.905 159.585 153.243C159.053 153.55 158.763 153.938 158.763 154.335C158.763 154.734 159.053 155.121 159.584 155.427C160.172 155.767 160.962 155.954 161.806 155.954Z",
    fill: "url(#paint100_linear_3744_1590)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M161.806 155.67C162.504 155.67 163.155 155.516 163.641 155.235C164.081 154.982 164.322 154.663 164.322 154.335C164.322 154.006 164.08 153.686 163.643 153.437C163.155 153.156 162.504 153 161.809 153C161.11 153 160.458 153.153 159.973 153.432C159.534 153.686 159.295 154.01 159.295 154.335C159.295 154.661 159.535 154.982 159.973 155.234C160.458 155.516 161.11 155.673 161.806 155.67Z",
    fill: "url(#paint101_linear_3744_1590)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M159.736 154.419L163.929 154.416C163.964 154.416 163.991 154.389 163.992 154.357C163.991 154.32 163.964 154.293 163.929 154.293L159.736 154.291C159.703 154.293 159.675 154.32 159.675 154.355C159.677 154.389 159.703 154.419 159.736 154.419Z",
    fill: "#A8BAC1"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.328 157.339C164.62 157.173 164.848 156.979 165.005 156.777C165.162 156.572 165.25 156.353 165.259 156.136C165.259 156.125 165.259 156.114 165.259 156.1L165.258 155.658C165.258 155.61 165.259 155.562 165.258 155.515L165.259 155.097V154.721C165.262 154.647 165.259 154.574 165.262 154.512C165.259 154.325 165.262 154.192 165.259 154.147C165.259 154.141 165.259 154.142 165.262 154.142C165.259 154.138 165.259 154.134 165.262 154.131C165.259 153.68 164.929 153.24 164.325 152.892C163.658 152.509 162.765 152.297 161.81 152.297C160.85 152.297 159.953 152.508 159.289 152.892C158.729 153.217 158.403 153.619 158.36 154.035C158.36 154.035 158.36 154.035 158.358 154.038C158.357 154.07 158.357 154.1 158.354 154.131C158.357 154.139 158.357 154.146 158.357 154.158V156.179H158.36C158.361 156.191 158.361 156.201 158.366 156.213C158.386 156.41 158.472 156.603 158.619 156.785C158.771 156.985 158.999 157.171 159.29 157.338C159.304 157.347 159.319 157.355 159.339 157.365C159.878 157.661 160.559 157.852 161.302 157.915C161.465 157.925 161.634 157.932 161.806 157.932C162.762 157.933 163.658 157.725 164.328 157.339Z",
    fill: "#F0F7FA"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.81 155.968C160.85 155.968 159.953 155.755 159.289 155.37C158.685 155.02 158.354 154.582 158.354 154.133C158.354 153.682 158.686 153.242 159.287 152.894C159.953 152.51 160.85 152.299 161.81 152.299C162.765 152.299 163.658 152.51 164.325 152.894C164.928 153.242 165.259 153.683 165.259 154.133C165.259 154.582 164.928 155.02 164.327 155.37C163.658 155.756 162.765 155.968 161.81 155.968Z",
    fill: "#F0F7FA"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.028 155.512C160.343 155.512 159.705 155.361 159.228 155.084C158.799 154.837 158.564 154.524 158.562 154.202C158.562 153.881 158.799 153.564 159.231 153.318C159.704 153.042 160.346 152.889 161.028 152.891C161.711 152.891 162.35 153.042 162.828 153.318C163.257 153.563 163.494 153.878 163.494 154.202C163.498 154.524 163.257 154.836 162.828 155.086C162.35 155.361 161.713 155.512 161.028 155.512Z",
    fill: "white"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.62 156.788C158.62 156.788 158.573 154.902 158.577 154.751C158.44 154.544 158.341 154.329 158.361 154.037C158.353 154.492 158.364 155.167 158.367 156.215C158.387 156.412 158.472 156.605 158.62 156.788Z",
    fill: "white"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M161.302 157.917C161.326 157.147 161.353 156.3 161.356 155.934C160.903 155.918 159.929 155.659 159.415 155.438L159.339 157.367C159.879 157.662 160.559 157.853 161.302 157.917Z",
    fill: "white"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.005 156.777C165.162 156.572 165.25 156.354 165.259 156.136C165.258 155.981 165.258 155.822 165.258 155.66C165.258 155.612 165.259 155.563 165.258 155.516C165.258 155.376 165.258 155.234 165.259 155.099C165.259 154.964 165.258 154.838 165.259 154.723C165.262 154.649 165.259 154.575 165.262 154.514C165.259 154.326 165.262 154.194 165.259 154.148C165.256 154.301 165.216 154.469 165.138 154.598C165.106 154.667 165.057 154.731 165.015 154.793L165.005 156.777Z",
    fill: "white"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M167.656 159.408C166.142 160.283 166.143 161.7 167.656 162.572C169.17 163.445 171.623 163.445 173.136 162.572C174.648 161.7 174.648 160.281 173.136 159.408C171.623 158.536 169.169 158.536 167.656 159.408Z",
    fill: "#F0F7FA"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 163.131C171.413 163.131 172.369 162.902 173.086 162.489C173.79 162.084 174.175 161.552 174.175 160.987C174.175 160.427 173.79 159.894 173.087 159.49C172.37 159.075 171.413 158.848 170.395 158.848C169.377 158.848 168.419 159.077 167.703 159.489C167.002 159.894 166.617 160.427 166.616 160.989C166.614 161.552 167.002 162.085 167.703 162.487C168.421 162.906 169.377 163.134 170.395 163.131Z",
    fill: "url(#paint102_linear_3744_1590)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M173.587 160.56C173.448 160.318 173.197 160.088 172.855 159.891C172.209 159.518 171.335 159.312 170.395 159.311C169.457 159.311 168.585 159.519 167.936 159.891C167.385 160.209 167.081 160.6 167.081 160.988C167.081 161.136 167.121 161.279 167.205 161.418C167.342 161.66 167.596 161.89 167.936 162.086C168.583 162.461 169.457 162.667 170.395 162.668C171.332 162.667 172.206 162.46 172.855 162.086C173.406 161.769 173.711 161.377 173.711 160.988C173.71 160.844 173.669 160.702 173.587 160.56Z",
    fill: "#9FA1A3"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M168.089 159.201V159.893C168.114 159.877 168.146 159.862 168.171 159.844C168.762 159.505 169.55 159.316 170.394 159.316C171.24 159.319 172.031 159.505 172.617 159.844C172.646 159.862 172.674 159.877 172.704 159.896L172.7 159.222L173.441 159.221V161.006L173.439 161.007C173.404 161.38 173.118 161.742 172.619 162.03C172.031 162.369 171.239 162.555 170.393 162.556C169.549 162.556 168.758 162.368 168.171 162.028C167.642 161.721 167.346 161.334 167.346 160.935V159.197L168.089 159.201Z",
    fill: "url(#paint103_linear_3744_1590)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 160.82C171.241 160.82 172.029 160.633 172.618 160.292C173.148 159.986 173.442 159.598 173.442 159.2C173.442 158.804 173.148 158.414 172.618 158.108C172.032 157.768 171.241 157.582 170.395 157.582C169.55 157.584 168.762 157.768 168.172 158.108C167.643 158.416 167.347 158.804 167.347 159.2C167.347 159.599 167.643 159.987 168.172 160.292C168.761 160.633 169.55 160.818 170.395 160.82Z",
    fill: "url(#paint104_linear_3744_1590)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M170.395 160.536C171.091 160.536 171.743 160.382 172.228 160.102C172.668 159.848 172.906 159.531 172.909 159.202C172.906 158.872 172.668 158.553 172.229 158.3C171.743 158.02 171.091 157.865 170.395 157.865C169.697 157.865 169.046 158.019 168.56 158.3C168.123 158.552 167.885 158.873 167.882 159.2C167.882 159.528 168.125 159.848 168.56 160.102C169.05 160.382 169.697 160.536 170.395 160.536Z",
    fill: "url(#paint105_linear_3744_1590)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M168.326 159.282L172.516 159.281C172.553 159.279 172.581 159.251 172.581 159.218C172.581 159.184 172.554 159.156 172.516 159.154L168.326 159.156C168.294 159.156 168.265 159.184 168.265 159.218C168.267 159.254 168.295 159.282 168.326 159.282Z",
    fill: "#A8BAC1"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.914 162.203C173.206 162.033 173.436 161.84 173.591 161.637C173.75 161.435 173.837 161.218 173.843 161C173.845 160.985 173.843 160.975 173.845 160.962V160.522C173.843 160.473 173.845 160.425 173.845 160.38V159.96V159.585C173.849 159.51 173.845 159.438 173.849 159.376C173.845 159.188 173.852 159.056 173.849 159.01C173.849 159.008 173.849 159.008 173.852 159.005C173.849 159.002 173.849 158.998 173.849 158.995C173.849 158.544 173.515 158.102 172.914 157.756C172.247 157.374 171.353 157.159 170.394 157.16C169.435 157.16 168.544 157.373 167.874 157.759C167.315 158.081 166.991 158.484 166.949 158.9C166.949 158.9 166.949 158.9 166.949 158.903C166.943 158.933 166.94 158.963 166.943 158.992C166.943 159.002 166.943 159.012 166.944 159.021L166.94 161.042L166.946 161.044C166.949 161.056 166.949 161.065 166.954 161.077C166.973 161.274 167.062 161.465 167.205 161.647C167.359 161.849 167.588 162.036 167.873 162.201C167.891 162.21 167.907 162.219 167.927 162.227C168.466 162.527 169.149 162.718 169.888 162.777C170.055 162.79 170.221 162.797 170.393 162.797C171.353 162.799 172.248 162.587 172.914 162.203Z",
    fill: "#F0F7FA"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.395 160.829C169.436 160.829 168.545 160.62 167.876 160.234C167.273 159.887 166.944 159.446 166.944 158.996C166.944 158.545 167.277 158.106 167.876 157.76C168.544 157.374 169.436 157.16 170.395 157.16C171.354 157.16 172.248 157.374 172.915 157.757C173.516 158.106 173.849 158.545 173.845 158.998C173.849 159.446 173.516 159.887 172.915 160.234C172.248 160.62 171.354 160.831 170.395 160.829Z",
    fill: "#F0F7FA"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.618 160.377C168.932 160.375 168.295 160.226 167.819 159.952C167.387 159.699 167.151 159.386 167.151 159.066C167.151 158.745 167.387 158.43 167.819 158.183C168.294 157.906 168.932 157.754 169.616 157.754C170.301 157.754 170.942 157.905 171.418 158.18C171.845 158.43 172.083 158.742 172.083 159.066C172.08 159.386 171.844 159.701 171.418 159.95C170.941 160.225 170.302 160.375 169.618 160.377Z",
    fill: "white"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M167.206 161.65C167.206 161.65 167.163 159.764 167.163 159.615C167.028 159.408 166.929 159.193 166.95 158.902C166.94 159.353 166.951 160.032 166.955 161.08C166.973 161.277 167.063 161.469 167.206 161.65Z",
    fill: "white"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.889 162.78C169.913 162.013 169.941 161.165 169.944 160.8C169.493 160.78 168.516 160.525 168.002 160.303L167.929 162.23C168.467 162.529 169.151 162.721 169.889 162.78Z",
    fill: "white"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.592 161.638C173.751 161.436 173.838 161.219 173.844 161.001C173.844 160.848 173.845 160.684 173.845 160.523C173.844 160.474 173.845 160.427 173.845 160.381C173.844 160.238 173.844 160.096 173.845 159.961C173.845 159.827 173.845 159.702 173.845 159.587C173.849 159.511 173.845 159.439 173.849 159.377C173.845 159.189 173.853 159.057 173.849 159.012C173.844 159.164 173.803 159.333 173.724 159.462C173.694 159.53 173.647 159.592 173.604 159.657L173.592 161.638Z",
    fill: "white"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M167.109 149.903C165.595 150.774 165.595 152.191 167.108 153.065C168.62 153.936 171.073 153.936 172.587 153.064C174.101 152.191 174.098 150.774 172.589 149.903C171.073 149.027 168.623 149.027 167.109 149.903Z",
    fill: "#F0F7FA"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M169.846 153.624C170.867 153.624 171.822 153.395 172.539 152.982C173.241 152.576 173.629 152.045 173.629 151.48C173.629 150.919 173.242 150.387 172.541 149.98C171.822 149.568 170.866 149.34 169.848 149.34C168.828 149.34 167.874 149.568 167.157 149.98C166.454 150.387 166.066 150.919 166.068 151.483C166.066 152.045 166.453 152.576 167.157 152.982C167.875 153.395 168.829 153.624 169.846 153.624Z",
    fill: "url(#paint106_linear_3744_1590)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M173.039 151.052C172.901 150.812 172.646 150.581 172.308 150.385C171.66 150.01 170.789 149.804 169.848 149.807C168.912 149.807 168.036 150.011 167.387 150.387C166.837 150.704 166.533 151.093 166.533 151.483C166.533 151.625 166.575 151.77 166.656 151.913C166.794 152.153 167.045 152.381 167.387 152.579C168.034 152.954 168.908 153.16 169.846 153.16C170.783 153.16 171.661 152.954 172.308 152.579C172.858 152.263 173.161 151.873 173.163 151.484C173.164 151.339 173.121 151.193 173.039 151.052Z",
    fill: "#9FA1A3"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M167.542 149.693L167.54 150.39C167.569 150.373 167.595 150.356 167.624 150.339C168.214 149.999 169.002 149.812 169.846 149.812C170.691 149.812 171.48 149.999 172.071 150.339C172.099 150.356 172.128 150.372 172.155 150.39V149.718H172.894V151.501L172.892 151.5C172.859 151.875 172.57 152.235 172.07 152.524C171.482 152.864 170.691 153.052 169.848 153.052C169.002 153.051 168.214 152.864 167.624 152.524C167.095 152.216 166.8 151.83 166.8 151.431V149.694L167.542 149.693Z",
    fill: "url(#paint107_linear_3744_1590)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M169.848 151.311C170.691 151.311 171.484 151.126 172.07 150.785C172.602 150.478 172.897 150.092 172.894 149.692C172.894 149.296 172.602 148.906 172.07 148.6C171.484 148.26 170.691 148.071 169.848 148.074C169.002 148.074 168.214 148.262 167.624 148.603C167.095 148.909 166.8 149.296 166.8 149.693C166.8 150.091 167.095 150.479 167.624 150.785C168.211 151.126 169.002 151.311 169.848 151.311Z",
    fill: "url(#paint108_linear_3744_1590)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M169.846 151.028C170.544 151.028 171.196 150.872 171.681 150.593C172.12 150.338 172.36 150.021 172.36 149.692C172.36 149.364 172.12 149.044 171.683 148.793C171.196 148.511 170.544 148.357 169.848 148.357C169.151 148.357 168.499 148.509 168.012 148.791C167.574 149.044 167.335 149.366 167.335 149.692C167.335 150.018 167.575 150.338 168.015 150.593C168.502 150.876 169.152 151.029 169.846 151.028Z",
    fill: "url(#paint109_linear_3744_1590)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M167.779 149.775H171.97C172.006 149.774 172.033 149.745 172.035 149.715C172.033 149.679 172.005 149.651 171.972 149.651L167.777 149.648C167.746 149.651 167.718 149.677 167.719 149.713C167.718 149.745 167.746 149.775 167.779 149.775Z",
    fill: "#A8BAC1"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.368 152.698C172.66 152.527 172.887 152.336 173.045 152.134C173.203 151.929 173.29 151.713 173.298 151.492C173.299 151.483 173.299 151.471 173.299 151.459L173.298 151.017C173.298 150.969 173.299 150.92 173.299 150.873V150.455V150.081C173.302 150.005 173.299 149.932 173.302 149.87C173.301 149.683 173.302 149.55 173.301 149.505C173.299 149.502 173.299 149.502 173.302 149.5C173.299 149.497 173.301 149.492 173.302 149.49C173.301 149.037 172.967 148.599 172.366 148.25C171.699 147.868 170.807 147.652 169.851 147.652C168.891 147.656 167.995 147.867 167.33 148.251C166.769 148.574 166.446 148.977 166.401 149.394C166.401 149.394 166.401 149.394 166.4 149.396C166.396 149.427 166.395 149.459 166.396 149.489C166.395 149.497 166.395 149.505 166.395 149.517V151.538H166.401C166.401 151.55 166.401 151.56 166.406 151.569C166.426 151.769 166.515 151.96 166.657 152.142C166.813 152.341 167.041 152.529 167.329 152.697C167.345 152.703 167.359 152.714 167.379 152.722C167.918 153.021 168.599 153.214 169.342 153.27C169.505 153.283 169.674 153.291 169.845 153.29C170.803 153.293 171.702 153.082 172.368 152.698Z",
    fill: "#F0F7FA"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.848 151.326C168.892 151.326 167.995 151.113 167.33 150.728C166.727 150.38 166.396 149.94 166.396 149.491C166.396 149.039 166.728 148.6 167.33 148.252C167.997 147.867 168.892 147.657 169.848 147.658C170.805 147.657 171.701 147.87 172.366 148.252C172.967 148.601 173.301 149.039 173.301 149.491C173.299 149.94 172.967 150.382 172.368 150.728C171.7 151.113 170.807 151.324 169.848 151.326Z",
    fill: "#F0F7FA"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.071 150.869C168.387 150.869 167.746 150.72 167.27 150.443C166.842 150.196 166.602 149.88 166.602 149.56C166.602 149.237 166.842 148.922 167.27 148.674C167.745 148.398 168.387 148.248 169.071 148.248C169.755 148.248 170.393 148.398 170.868 148.675C171.298 148.922 171.536 149.236 171.538 149.558C171.538 149.88 171.297 150.194 170.868 150.443C170.393 150.719 169.755 150.869 169.071 150.869Z",
    fill: "white"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M166.658 152.144C166.658 152.144 166.616 150.258 166.616 150.107C166.483 149.902 166.379 149.687 166.402 149.395C166.396 149.847 166.407 150.521 166.407 151.57C166.427 151.77 166.516 151.962 166.658 152.144Z",
    fill: "white"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M169.343 153.271C169.366 152.505 169.393 151.658 169.397 151.291C168.945 151.275 167.968 151.016 167.454 150.795L167.379 152.723C167.919 153.022 168.599 153.215 169.343 153.271Z",
    fill: "white"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M173.045 152.133C173.203 151.928 173.29 151.712 173.298 151.491C173.298 151.338 173.299 151.179 173.298 151.016C173.298 150.968 173.299 150.919 173.299 150.872C173.299 150.731 173.299 150.589 173.299 150.454C173.299 150.321 173.299 150.196 173.299 150.08C173.302 150.004 173.299 149.931 173.302 149.869C173.301 149.682 173.302 149.549 173.301 149.504C173.298 149.657 173.256 149.824 173.181 149.955C173.146 150.024 173.097 150.088 173.057 150.151L173.045 152.133Z",
    fill: "white"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M175.697 154.769C174.185 155.641 174.185 157.057 175.697 157.931C177.21 158.805 179.663 158.805 181.177 157.931C182.688 157.057 182.69 155.641 181.177 154.766C179.663 153.895 177.21 153.895 175.697 154.769Z",
    fill: "#F0F7FA"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 158.491C179.454 158.491 180.409 158.261 181.128 157.847C181.829 157.442 182.214 156.909 182.214 156.348C182.214 155.788 181.829 155.254 181.128 154.849C180.409 154.435 179.454 154.209 178.435 154.209C177.418 154.209 176.462 154.435 175.743 154.849C175.042 155.254 174.655 155.787 174.655 156.348C174.655 156.909 175.042 157.442 175.743 157.845C176.462 158.264 177.418 158.491 178.435 158.491Z",
    fill: "url(#paint110_linear_3744_1590)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M181.627 155.92C181.489 155.68 181.235 155.447 180.897 155.251C180.246 154.879 179.374 154.674 178.434 154.674C177.496 154.674 176.625 154.88 175.974 155.252C175.423 155.57 175.12 155.96 175.12 156.349C175.12 156.496 175.159 156.638 175.241 156.778C175.379 157.022 175.634 157.251 175.973 157.447C176.622 157.822 177.495 158.026 178.433 158.027C179.371 158.026 180.245 157.822 180.894 157.447C181.445 157.128 181.749 156.738 181.751 156.349C181.751 156.205 181.708 156.062 181.627 155.92Z",
    fill: "#9FA1A3"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M176.128 154.557V155.253C176.155 155.239 176.186 155.222 176.214 155.203C176.802 154.863 177.592 154.677 178.436 154.677C179.282 154.677 180.07 154.863 180.659 155.202C180.688 155.22 180.716 155.239 180.743 155.254V154.58H181.481L181.483 156.364L181.478 156.368C181.446 156.74 181.161 157.1 180.661 157.387C180.071 157.729 179.28 157.915 178.434 157.915C177.591 157.915 176.8 157.727 176.213 157.387C175.681 157.081 175.389 156.695 175.389 156.294V154.557H176.128V154.557Z",
    fill: "url(#paint111_linear_3744_1590)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 156.179C179.281 156.179 180.07 155.992 180.657 155.652C181.19 155.344 181.484 154.957 181.482 154.558C181.482 154.162 181.19 153.774 180.657 153.466C180.07 153.127 179.282 152.939 178.435 152.939C177.592 152.939 176.801 153.127 176.212 153.466C175.681 153.774 175.39 154.162 175.39 154.558C175.39 154.957 175.681 155.344 176.214 155.653C176.802 155.992 177.59 156.177 178.435 156.179Z",
    fill: "url(#paint112_linear_3744_1590)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M178.435 155.895C179.133 155.895 179.783 155.74 180.269 155.46C180.707 155.206 180.95 154.887 180.95 154.56C180.95 154.231 180.707 153.911 180.271 153.655C179.785 153.377 179.133 153.223 178.435 153.223C177.738 153.223 177.088 153.376 176.603 153.657C176.164 153.911 175.925 154.231 175.923 154.558C175.922 154.887 176.165 155.206 176.603 155.459C177.088 155.74 177.738 155.895 178.435 155.895Z",
    fill: "url(#paint113_linear_3744_1590)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M176.368 154.64H180.558C180.593 154.64 180.621 154.613 180.621 154.58C180.621 154.545 180.595 154.518 180.558 154.518H176.368C176.333 154.518 176.305 154.545 176.305 154.577C176.305 154.614 176.334 154.643 176.368 154.64Z",
    fill: "#A8BAC1"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.955 157.562C181.248 157.393 181.477 157.202 181.632 156.999C181.789 156.794 181.879 156.579 181.885 156.359C181.885 156.348 181.885 156.336 181.885 156.325V155.882C181.885 155.834 181.885 155.787 181.885 155.74V155.323L181.887 154.946C181.887 154.869 181.887 154.797 181.887 154.736C181.885 154.55 181.892 154.417 181.887 154.373C181.887 154.368 181.887 154.368 181.892 154.367C181.887 154.363 181.887 154.358 181.887 154.357C181.891 153.906 181.559 153.465 180.955 153.117C180.29 152.734 179.393 152.521 178.436 152.521C177.478 152.523 176.583 152.732 175.916 153.118C175.357 153.443 175.034 153.843 174.988 154.26C174.988 154.26 174.988 154.26 174.988 154.264C174.987 154.295 174.983 154.324 174.983 154.353C174.983 154.365 174.983 154.374 174.985 154.382L174.983 156.405H174.988C174.99 156.418 174.99 156.427 174.994 156.438C175.015 156.636 175.098 156.827 175.249 157.009C175.401 157.209 175.627 157.396 175.916 157.562C175.933 157.571 175.95 157.582 175.967 157.589C176.506 157.89 177.189 158.079 177.931 158.137C178.095 158.152 178.264 158.157 178.435 158.157C179.393 158.159 180.29 157.947 180.955 157.562Z",
    fill: "#F0F7FA"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M178.437 156.191C177.479 156.187 176.583 155.979 175.916 155.592C175.317 155.246 174.986 154.807 174.984 154.357C174.986 153.906 175.318 153.466 175.916 153.117C176.583 152.732 177.478 152.521 178.435 152.521C179.394 152.521 180.29 152.732 180.955 153.117C181.559 153.465 181.887 153.906 181.887 154.357C181.887 154.808 181.558 155.248 180.955 155.593C180.29 155.978 179.395 156.191 178.437 156.191Z",
    fill: "#F0F7FA"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.658 155.737C176.974 155.737 176.337 155.587 175.86 155.311C175.429 155.062 175.191 154.745 175.192 154.426C175.192 154.105 175.429 153.789 175.858 153.542C176.336 153.266 176.976 153.114 177.658 153.115C178.343 153.114 178.981 153.266 179.458 153.54C179.889 153.791 180.124 154.104 180.124 154.426C180.123 154.745 179.889 155.061 179.458 155.311C178.981 155.586 178.342 155.737 177.658 155.737Z",
    fill: "white"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M175.249 157.009C175.249 157.009 175.205 155.123 175.203 154.974C175.067 154.765 174.969 154.552 174.989 154.26C174.984 154.711 174.994 155.388 174.995 156.437C175.015 156.635 175.098 156.827 175.249 157.009Z",
    fill: "white"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.931 158.137C177.956 157.37 177.982 156.523 177.986 156.159C177.532 156.141 176.557 155.885 176.042 155.66L175.967 157.589C176.507 157.891 177.189 158.079 177.931 158.137Z",
    fill: "white"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.632 156.999C181.789 156.794 181.879 156.579 181.885 156.359C181.885 156.206 181.885 156.044 181.885 155.882C181.885 155.834 181.885 155.787 181.885 155.74C181.885 155.596 181.885 155.454 181.885 155.323C181.885 155.186 181.885 155.061 181.887 154.946C181.887 154.869 181.887 154.797 181.887 154.735C181.885 154.55 181.892 154.417 181.887 154.373C181.885 154.525 181.846 154.692 181.766 154.821C181.734 154.89 181.685 154.955 181.646 155.016L181.632 156.999Z",
    fill: "white"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M175.15 145.259C173.636 146.132 173.637 147.548 175.152 148.422C176.664 149.294 179.116 149.295 180.629 148.421C182.142 147.548 182.142 146.13 180.629 145.259C179.116 144.385 176.663 144.385 175.15 145.259Z",
    fill: "#F0F7FA"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 148.983C178.907 148.982 179.862 148.754 180.581 148.339C181.281 147.935 181.668 147.402 181.668 146.84C181.668 146.277 181.283 145.746 180.58 145.34C179.861 144.925 178.907 144.699 177.889 144.699C176.87 144.697 175.913 144.928 175.197 145.34C174.494 145.746 174.108 146.276 174.11 146.84C174.11 147.402 174.493 147.933 175.197 148.339C175.913 148.752 176.87 148.983 177.89 148.983Z",
    fill: "url(#paint114_linear_3744_1590)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M181.079 146.41C180.942 146.172 180.688 145.939 180.35 145.743C179.701 145.368 178.826 145.165 177.889 145.166C176.953 145.165 176.078 145.373 175.429 145.743C174.876 146.064 174.575 146.453 174.575 146.841C174.575 146.986 174.614 147.13 174.696 147.274C174.836 147.512 175.086 147.741 175.429 147.94C176.078 148.311 176.949 148.517 177.889 148.517C178.826 148.52 179.701 148.313 180.35 147.94C180.9 147.622 181.204 147.23 181.205 146.842C181.204 146.696 181.162 146.552 181.079 146.41Z",
    fill: "#9FA1A3"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M175.582 145.051V145.747C175.609 145.731 175.637 145.714 175.667 145.697C176.254 145.356 177.042 145.169 177.889 145.17C178.732 145.169 179.522 145.356 180.111 145.697C180.141 145.714 180.167 145.732 180.193 145.749V145.075H180.934L180.936 146.859L180.931 146.858C180.899 147.233 180.609 147.592 180.11 147.88C179.521 148.22 178.735 148.408 177.889 148.408C177.042 148.408 176.253 148.22 175.664 147.88C175.132 147.574 174.84 147.187 174.84 146.787V145.052L175.582 145.051Z",
    fill: "url(#paint115_linear_3744_1590)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M177.89 146.67C178.733 146.669 179.523 146.485 180.114 146.143C180.643 145.838 180.938 145.449 180.936 145.051C180.938 144.654 180.643 144.265 180.112 143.959C179.523 143.619 178.733 143.432 177.89 143.432C177.044 143.432 176.254 143.621 175.667 143.959C175.134 144.267 174.842 144.655 174.842 145.052C174.842 145.45 175.134 145.839 175.666 146.144C176.253 146.482 177.044 146.67 177.89 146.67Z",
    fill: "url(#paint116_linear_3744_1590)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M177.889 146.386C178.587 146.386 179.237 146.233 179.722 145.952C180.16 145.7 180.404 145.378 180.402 145.052C180.402 144.723 180.159 144.403 179.724 144.152C179.237 143.871 178.585 143.715 177.89 143.715C177.192 143.715 176.54 143.868 176.054 144.148C175.615 144.402 175.377 144.725 175.377 145.051C175.374 145.378 175.616 145.699 176.054 145.951C176.542 146.233 177.192 146.387 177.889 146.386Z",
    fill: "url(#paint117_linear_3744_1590)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M175.82 145.134L180.012 145.133C180.046 145.133 180.074 145.106 180.074 145.072C180.073 145.037 180.046 145.01 180.013 145.01H175.818C175.786 145.01 175.757 145.036 175.757 145.07C175.757 145.106 175.786 145.135 175.82 145.134Z",
    fill: "#A8BAC1"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.409 148.053C180.701 147.886 180.929 147.693 181.085 147.492C181.246 147.285 181.33 147.07 181.341 146.85C181.341 146.84 181.341 146.829 181.341 146.814V146.373C181.338 146.325 181.341 146.276 181.341 146.228V145.813V145.437C181.342 145.363 181.341 145.291 181.342 145.228C181.342 145.04 181.342 144.909 181.341 144.863C181.341 144.859 181.341 144.859 181.342 144.858C181.341 144.853 181.342 144.851 181.342 144.849C181.342 144.396 181.009 143.956 180.408 143.607C179.741 143.224 178.845 143.012 177.889 143.012C176.93 143.013 176.036 143.224 175.368 143.609C174.807 143.932 174.486 144.336 174.441 144.751C174.441 144.751 174.441 144.751 174.44 144.754C174.436 144.785 174.435 144.816 174.438 144.845C174.435 144.855 174.435 144.863 174.436 144.874L174.435 146.896H174.44C174.441 146.908 174.441 146.917 174.447 146.928C174.468 147.126 174.554 147.318 174.699 147.501C174.853 147.7 175.08 147.887 175.368 148.054C175.385 148.063 175.401 148.071 175.419 148.079C175.958 148.379 176.641 148.568 177.385 148.63C177.547 148.64 177.715 148.648 177.885 148.647C178.845 148.652 179.742 148.44 180.409 148.053Z",
    fill: "#F0F7FA"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M177.89 146.682C176.931 146.682 176.035 146.47 175.369 146.084C174.768 145.736 174.437 145.297 174.437 144.847C174.437 144.396 174.77 143.956 175.369 143.608C176.037 143.224 176.934 143.012 177.89 143.012C178.846 143.012 179.742 143.224 180.407 143.607C181.011 143.956 181.342 144.396 181.343 144.847C181.342 145.297 181.01 145.737 180.409 146.084C179.742 146.469 178.845 146.682 177.89 146.682Z",
    fill: "#F0F7FA"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.111 146.226C176.427 146.226 175.788 146.078 175.311 145.8C174.881 145.551 174.646 145.238 174.646 144.916C174.646 144.595 174.881 144.28 175.311 144.032C175.79 143.757 176.428 143.603 177.11 143.604C177.795 143.604 178.432 143.757 178.91 144.032C179.343 144.279 179.574 144.594 179.574 144.916C179.578 145.238 179.338 145.551 178.91 145.8C178.433 146.075 177.796 146.226 177.111 146.226Z",
    fill: "white"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M174.7 147.502C174.7 147.502 174.656 145.615 174.656 145.465C174.521 145.258 174.423 145.042 174.442 144.752C174.436 145.205 174.445 145.88 174.448 146.928C174.469 147.127 174.555 147.32 174.7 147.502Z",
    fill: "white"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M177.386 148.632C177.406 147.865 177.434 147.016 177.438 146.65C176.987 146.633 176.009 146.376 175.494 146.152L175.421 148.081C175.959 148.38 176.643 148.57 177.386 148.632Z",
    fill: "white"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M181.086 147.492C181.247 147.285 181.331 147.069 181.341 146.85C181.338 146.695 181.341 146.536 181.341 146.374C181.338 146.326 181.341 146.277 181.341 146.229C181.341 146.089 181.338 145.948 181.341 145.813C181.341 145.678 181.338 145.554 181.341 145.438C181.343 145.364 181.341 145.292 181.343 145.229C181.343 145.041 181.343 144.909 181.341 144.863C181.338 145.016 181.297 145.184 181.222 145.313C181.188 145.382 181.14 145.447 181.099 145.509L181.086 147.492Z",
    fill: "white"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M183.74 150.123C182.226 150.996 182.223 152.414 183.737 153.284C185.25 154.16 187.702 154.16 189.217 153.286C190.73 152.412 190.73 150.997 189.217 150.123C187.703 149.251 185.251 149.25 183.74 150.123Z",
    fill: "#F0F7FA"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M186.478 153.846C187.493 153.848 188.45 153.618 189.168 153.204C189.87 152.799 190.256 152.266 190.256 151.707C190.256 151.144 189.871 150.609 189.168 150.207C188.45 149.793 187.496 149.564 186.477 149.564C185.457 149.564 184.502 149.791 183.786 150.205C183.084 150.609 182.697 151.144 182.697 151.707C182.697 152.266 183.082 152.801 183.783 153.203C184.501 153.621 185.459 153.848 186.478 153.846Z",
    fill: "url(#paint118_linear_3744_1590)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M189.669 151.275C189.53 151.035 189.277 150.803 188.936 150.608C188.287 150.234 187.416 150.029 186.477 150.025C185.541 150.027 184.667 150.234 184.016 150.608C183.466 150.925 183.161 151.316 183.161 151.704C183.162 151.85 183.202 151.993 183.286 152.135C183.423 152.375 183.676 152.606 184.016 152.801C184.664 153.175 185.54 153.382 186.478 153.382C187.415 153.382 188.286 153.175 188.936 152.801C189.488 152.484 189.792 152.092 189.792 151.705C189.792 151.561 189.752 151.417 189.669 151.275Z",
    fill: "#9FA1A3"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M184.168 149.916V150.61C184.196 150.593 184.225 150.578 184.255 150.56C184.842 150.222 185.633 150.031 186.476 150.034C187.322 150.035 188.112 150.219 188.701 150.56C188.728 150.577 188.756 150.593 188.783 150.611L188.782 149.938L189.524 149.936V151.722H189.52C189.488 152.096 189.2 152.457 188.701 152.745C188.112 153.084 187.32 153.271 186.476 153.271C185.633 153.271 184.842 153.084 184.255 152.745C183.724 152.437 183.431 152.051 183.431 151.651L183.428 149.914L184.168 149.916Z",
    fill: "url(#paint119_linear_3744_1590)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M186.476 151.535C187.322 151.535 188.112 151.346 188.701 151.006C189.233 150.699 189.524 150.312 189.524 149.913C189.524 149.517 189.233 149.13 188.701 148.821C188.112 148.482 187.32 148.297 186.476 148.295C185.633 148.297 184.842 148.482 184.255 148.822C183.723 149.129 183.431 149.517 183.428 149.914C183.431 150.313 183.724 150.7 184.255 151.006C184.843 151.346 185.63 151.535 186.476 151.535Z",
    fill: "url(#paint120_linear_3744_1590)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M186.476 151.251C187.174 151.251 187.826 151.098 188.309 150.816C188.747 150.562 188.99 150.245 188.99 149.918C188.99 149.587 188.75 149.268 188.307 149.014C187.826 148.734 187.174 148.58 186.476 148.58C185.78 148.58 185.128 148.733 184.643 149.014C184.206 149.268 183.965 149.588 183.965 149.916C183.963 150.242 184.207 150.564 184.643 150.816C185.128 151.096 185.78 151.251 186.476 151.251Z",
    fill: "url(#paint121_linear_3744_1590)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M184.408 149.996L188.601 149.995C188.635 149.994 188.663 149.967 188.663 149.933C188.663 149.901 188.633 149.873 188.601 149.871L184.408 149.872C184.376 149.872 184.347 149.901 184.347 149.933C184.347 149.969 184.376 149.996 184.408 149.996Z",
    fill: "#A8BAC1"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.998 152.917C189.288 152.75 189.517 152.556 189.675 152.355C189.833 152.15 189.92 151.934 189.924 151.715C189.927 151.704 189.927 151.692 189.927 151.679V151.239C189.924 151.189 189.929 151.142 189.927 151.096V150.678L189.929 150.303C189.929 150.225 189.929 150.153 189.929 150.091C189.929 149.903 189.931 149.773 189.929 149.725C189.931 149.722 189.931 149.722 189.931 149.722C189.929 149.718 189.929 149.715 189.931 149.71C189.931 149.259 189.597 148.82 188.996 148.471C188.329 148.089 187.433 147.875 186.478 147.875C185.517 147.877 184.626 148.089 183.956 148.474C183.399 148.795 183.071 149.2 183.029 149.616C183.029 149.616 183.029 149.616 183.029 149.619C183.025 149.648 183.022 149.681 183.025 149.71C183.025 149.718 183.025 149.727 183.025 149.739L183.022 151.757L183.029 151.76C183.033 151.774 183.033 151.781 183.034 151.793C183.054 151.989 183.144 152.183 183.287 152.364C183.444 152.564 183.67 152.751 183.955 152.917C183.973 152.926 183.99 152.935 184.009 152.942C184.546 153.241 185.229 153.435 185.97 153.494C186.136 153.506 186.305 153.513 186.475 153.513C187.433 153.517 188.33 153.304 188.998 152.917Z",
    fill: "#F0F7FA"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M186.476 151.545C185.517 151.543 184.624 151.333 183.958 150.947C183.353 150.6 183.026 150.161 183.026 149.71C183.026 149.259 183.355 148.82 183.958 148.474C184.625 148.089 185.517 147.875 186.478 147.875C187.433 147.875 188.329 148.088 188.996 148.471C189.596 148.82 189.929 149.262 189.929 149.712C189.929 150.162 189.597 150.6 188.996 150.951C188.33 151.335 187.436 151.546 186.476 151.545Z",
    fill: "#F0F7FA"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.701 151.092C185.014 151.089 184.377 150.941 183.9 150.668C183.47 150.416 183.233 150.102 183.233 149.781C183.233 149.462 183.47 149.145 183.898 148.897C184.376 148.622 185.014 148.468 185.698 148.471C186.381 148.468 187.021 148.622 187.498 148.895C187.929 149.145 188.164 149.462 188.164 149.781C188.164 150.102 187.929 150.417 187.5 150.664C187.022 150.941 186.381 151.092 185.701 151.092Z",
    fill: "white"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M183.288 152.367C183.288 152.367 183.246 150.48 183.246 150.33C183.11 150.124 183.009 149.908 183.03 149.617C183.022 150.069 183.035 150.746 183.035 151.794C183.055 151.992 183.145 152.185 183.288 152.367Z",
    fill: "white"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.971 153.495C185.996 152.726 186.024 151.879 186.026 151.515C185.574 151.495 184.596 151.24 184.084 151.018L184.011 152.944C184.548 153.243 185.231 153.436 185.971 153.495Z",
    fill: "white"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.675 152.355C189.833 152.15 189.92 151.935 189.923 151.716C189.923 151.563 189.927 151.401 189.927 151.24C189.923 151.191 189.929 151.144 189.927 151.098C189.923 150.954 189.927 150.812 189.927 150.679C189.927 150.544 189.927 150.418 189.929 150.304C189.929 150.227 189.929 150.155 189.929 150.093C189.929 149.904 189.93 149.774 189.929 149.727C189.923 149.88 189.886 150.048 189.809 150.177C189.776 150.245 189.725 150.31 189.684 150.372L189.675 152.355Z",
    fill: "white"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M183.192 140.615C181.677 141.489 181.677 142.905 183.19 143.779C184.704 144.652 187.156 144.652 188.669 143.779C190.182 142.905 190.182 141.489 188.669 140.615C187.157 139.743 184.704 139.743 183.192 140.615Z",
    fill: "#F0F7FA"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M185.928 144.339C186.947 144.339 187.904 144.112 188.621 143.698C189.323 143.29 189.709 142.76 189.709 142.198C189.709 141.636 189.323 141.103 188.621 140.698C187.904 140.286 186.947 140.055 185.928 140.055C184.91 140.055 183.955 140.286 183.238 140.696C182.537 141.102 182.147 141.636 182.148 142.198C182.148 142.76 182.533 143.29 183.238 143.698C183.952 144.112 184.91 144.339 185.928 144.339Z",
    fill: "url(#paint122_linear_3744_1590)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M189.121 141.767C188.983 141.528 188.729 141.295 188.39 141.102C187.741 140.724 186.866 140.521 185.928 140.521C184.992 140.521 184.117 140.726 183.472 141.101C182.918 141.418 182.615 141.809 182.613 142.197C182.613 142.342 182.657 142.487 182.738 142.628C182.877 142.869 183.127 143.097 183.469 143.295C184.115 143.668 184.989 143.874 185.928 143.874C186.867 143.874 187.74 143.671 188.389 143.296C188.939 142.978 189.243 142.588 189.244 142.198C189.246 142.055 189.203 141.909 189.121 141.767Z",
    fill: "#9FA1A3"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M183.623 140.408V141.104C183.651 141.088 183.676 141.071 183.704 141.053C184.297 140.714 185.084 140.526 185.928 140.526C186.773 140.526 187.562 140.714 188.152 141.054C188.183 141.071 188.207 141.088 188.238 141.104V140.432H188.977V142.217H188.972C188.938 142.59 188.651 142.951 188.151 143.239C187.562 143.579 186.774 143.766 185.928 143.766C185.083 143.766 184.296 143.579 183.703 143.239C183.174 142.931 182.882 142.544 182.879 142.146L182.882 140.408H183.623Z",
    fill: "url(#paint123_linear_3744_1590)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M185.93 142.026C186.773 142.026 187.564 141.841 188.152 141.501C188.686 141.193 188.977 140.806 188.977 140.407C188.977 140.009 188.682 139.622 188.152 139.314C187.562 138.975 186.773 138.787 185.928 138.789C185.084 138.789 184.297 138.975 183.707 139.317C183.175 139.623 182.883 140.008 182.883 140.407C182.883 140.806 183.175 141.192 183.704 141.499C184.295 141.841 185.084 142.028 185.93 142.026Z",
    fill: "url(#paint124_linear_3744_1590)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M185.928 141.742C186.627 141.742 187.277 141.591 187.762 141.308C188.203 141.056 188.442 140.736 188.442 140.407C188.442 140.078 188.202 139.76 187.765 139.508C187.278 139.227 186.628 139.071 185.928 139.072C185.23 139.072 184.58 139.225 184.094 139.505C183.658 139.76 183.417 140.081 183.417 140.407C183.415 140.736 183.659 141.054 184.094 141.308C184.581 141.591 185.235 141.744 185.928 141.742Z",
    fill: "url(#paint125_linear_3744_1590)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M183.861 140.489H188.052C188.087 140.489 188.115 140.461 188.115 140.428C188.117 140.392 188.088 140.366 188.054 140.366L183.861 140.363C183.828 140.366 183.8 140.392 183.798 140.427C183.8 140.461 183.828 140.489 183.861 140.489Z",
    fill: "#A8BAC1"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M188.448 143.411C188.742 143.244 188.971 143.051 189.128 142.848C189.283 142.643 189.373 142.427 189.38 142.209C189.381 142.197 189.38 142.187 189.38 142.174V141.731C189.38 141.684 189.38 141.636 189.38 141.588L189.381 141.171V140.796C189.383 140.721 189.381 140.646 189.384 140.586C189.383 140.398 189.383 140.265 189.383 140.22C189.383 140.216 189.383 140.216 189.384 140.215C189.383 140.212 189.383 140.206 189.383 140.206C189.383 139.753 189.049 139.313 188.448 138.964C187.782 138.582 186.887 138.371 185.93 138.371C184.973 138.371 184.077 138.582 183.411 138.968C182.852 139.29 182.523 139.693 182.483 140.107C182.483 140.107 182.483 140.107 182.482 140.111C182.479 140.144 182.477 140.173 182.479 140.203C182.479 140.212 182.477 140.22 182.479 140.232L182.477 142.254H182.483C182.485 142.265 182.485 142.276 182.488 142.285C182.51 142.484 182.596 142.676 182.739 142.859C182.893 143.057 183.124 143.245 183.41 143.411C183.425 143.42 183.441 143.428 183.461 143.437C184 143.737 184.681 143.928 185.423 143.986C185.588 144 185.755 144.007 185.926 144.007C186.887 144.008 187.782 143.798 188.448 143.411Z",
    fill: "#F0F7FA"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M185.928 142.039C184.97 142.039 184.077 141.826 183.411 141.441C182.807 141.095 182.478 140.653 182.478 140.203C182.478 139.753 182.808 139.313 183.411 138.966C184.077 138.582 184.973 138.37 185.93 138.371C186.887 138.371 187.781 138.582 188.448 138.964C189.05 139.313 189.383 139.753 189.383 140.206C189.381 140.653 189.049 141.095 188.448 141.441C187.78 141.826 186.887 142.039 185.928 142.039Z",
    fill: "#F0F7FA"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.15 141.585C184.467 141.585 183.829 141.435 183.352 141.157C182.922 140.91 182.686 140.596 182.686 140.275C182.686 139.953 182.922 139.638 183.352 139.389C183.828 139.115 184.467 138.963 185.152 138.963C185.836 138.963 186.474 139.116 186.952 139.389C187.382 139.637 187.615 139.95 187.615 140.275C187.619 140.595 187.382 140.909 186.95 141.157C186.474 141.432 185.836 141.585 185.15 141.585Z",
    fill: "white"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M182.74 142.86C182.74 142.86 182.698 140.971 182.698 140.823C182.565 140.615 182.463 140.401 182.484 140.107C182.478 140.562 182.486 141.237 182.489 142.285C182.511 142.484 182.596 142.677 182.74 142.86Z",
    fill: "white"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M185.425 143.989C185.452 143.221 185.477 142.374 185.477 142.01C185.027 141.991 184.05 141.734 183.536 141.512L183.463 143.439C184.001 143.739 184.682 143.931 185.425 143.989Z",
    fill: "white"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M189.128 142.849C189.283 142.644 189.373 142.428 189.38 142.209C189.38 142.055 189.38 141.894 189.38 141.731C189.38 141.684 189.38 141.636 189.38 141.588C189.38 141.448 189.38 141.306 189.381 141.171C189.38 141.038 189.38 140.911 189.381 140.796C189.383 140.721 189.381 140.646 189.384 140.586C189.383 140.398 189.383 140.265 189.383 140.221C189.38 140.373 189.337 140.541 189.261 140.671C189.229 140.739 189.18 140.803 189.14 140.869L189.128 142.849Z",
    fill: "white"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M191.778 145.481C190.267 146.354 190.267 147.771 191.779 148.645C193.292 149.517 195.746 149.517 197.256 148.645C198.773 147.771 198.773 146.354 197.258 145.479C195.746 144.608 193.292 144.608 191.778 145.481Z",
    fill: "#F0F7FA"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 149.206C195.537 149.206 196.491 148.974 197.21 148.56C197.909 148.156 198.296 147.625 198.298 147.062C198.298 146.502 197.911 145.969 197.21 145.564C196.491 145.149 195.533 144.922 194.518 144.922C193.5 144.922 192.544 145.149 191.825 145.564C191.124 145.969 190.739 146.502 190.738 147.062C190.738 147.625 191.124 148.156 191.825 148.56C192.543 148.977 193.5 149.206 194.518 149.206Z",
    fill: "url(#paint126_linear_3744_1590)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M197.709 146.632C197.571 146.394 197.319 146.162 196.977 145.965C196.329 145.592 195.454 145.386 194.518 145.385C193.578 145.385 192.707 145.593 192.056 145.965C191.507 146.282 191.202 146.673 191.202 147.061C191.202 147.206 191.245 147.35 191.327 147.492C191.465 147.733 191.717 147.963 192.058 148.161C192.705 148.535 193.578 148.74 194.518 148.74C195.454 148.739 196.328 148.534 196.977 148.161C197.528 147.841 197.832 147.449 197.834 147.061C197.832 146.919 197.792 146.776 197.709 146.632Z",
    fill: "#9FA1A3"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M192.212 145.273L192.211 145.968C192.239 145.952 192.268 145.936 192.296 145.918C192.883 145.577 193.672 145.391 194.518 145.391C195.363 145.394 196.154 145.577 196.74 145.918C196.77 145.934 196.798 145.952 196.826 145.969L196.825 145.295H197.564V147.08L197.562 147.082C197.528 147.453 197.241 147.815 196.741 148.104C196.153 148.443 195.362 148.629 194.518 148.63C193.672 148.63 192.882 148.441 192.295 148.101C191.763 147.795 191.473 147.408 191.473 147.01L191.469 145.271L192.212 145.273Z",
    fill: "url(#paint127_linear_3744_1590)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 146.891C195.363 146.892 196.152 146.705 196.742 146.364C197.274 146.057 197.566 145.67 197.566 145.272C197.566 144.876 197.274 144.487 196.739 144.181C196.154 143.841 195.363 143.652 194.518 143.652C193.672 143.655 192.883 143.841 192.296 144.181C191.76 144.487 191.473 144.876 191.47 145.272C191.473 145.671 191.764 146.058 192.296 146.366C192.883 146.705 193.672 146.89 194.518 146.891Z",
    fill: "url(#paint128_linear_3744_1590)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M194.518 146.609C195.217 146.609 195.865 146.454 196.35 146.175C196.79 145.92 197.031 145.604 197.032 145.273C197.032 144.943 196.79 144.625 196.351 144.373C195.865 144.091 195.213 143.938 194.518 143.938C193.82 143.938 193.17 144.09 192.684 144.373C192.246 144.625 192.004 144.946 192.006 145.273C192.006 145.601 192.246 145.921 192.686 146.174C193.17 146.454 193.822 146.608 194.518 146.609Z",
    fill: "url(#paint129_linear_3744_1590)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M192.451 145.353L196.64 145.355C196.675 145.353 196.703 145.327 196.703 145.294C196.703 145.259 196.675 145.231 196.64 145.23H192.449C192.416 145.23 192.388 145.259 192.388 145.294C192.387 145.328 192.417 145.356 192.451 145.353Z",
    fill: "#A8BAC1"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.038 148.277C197.33 148.107 197.56 147.916 197.717 147.713C197.872 147.508 197.962 147.295 197.968 147.074C197.968 147.062 197.968 147.051 197.971 147.039L197.968 146.598C197.968 146.55 197.971 146.501 197.968 146.454V146.035V145.66C197.973 145.584 197.968 145.513 197.973 145.448C197.971 145.263 197.973 145.132 197.973 145.086C197.973 145.084 197.973 145.084 197.974 145.08C197.973 145.077 197.971 145.071 197.971 145.069C197.971 144.618 197.638 144.177 197.038 143.83C196.371 143.447 195.476 143.234 194.518 143.234C193.56 143.237 192.665 143.446 191.997 143.833C191.44 144.155 191.115 144.557 191.07 144.973C191.07 144.973 191.07 144.973 191.07 144.977C191.066 145.009 191.064 145.037 191.066 145.066C191.066 145.077 191.066 145.088 191.066 145.096L191.064 147.117L191.07 147.119C191.072 147.13 191.073 147.14 191.076 147.151C191.098 147.349 191.184 147.54 191.328 147.723C191.485 147.922 191.711 148.112 192 148.274C192.016 148.283 192.031 148.294 192.05 148.301C192.59 148.602 193.272 148.792 194.012 148.851C194.176 148.865 194.345 148.871 194.518 148.871C195.475 148.874 196.37 148.662 197.038 148.277Z",
    fill: "#F0F7FA"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M194.519 146.905C193.56 146.904 192.665 146.693 191.999 146.308C191.398 145.961 191.066 145.52 191.065 145.071C191.066 144.62 191.398 144.182 191.999 143.833C192.665 143.449 193.56 143.236 194.519 143.236C195.476 143.236 196.372 143.447 197.035 143.832C197.639 144.181 197.971 144.62 197.971 145.072C197.971 145.523 197.638 145.962 197.039 146.309C196.37 146.693 195.475 146.905 194.519 146.905Z",
    fill: "#F0F7FA"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M193.742 146.451C193.055 146.45 192.418 146.298 191.944 146.025C191.511 145.775 191.273 145.458 191.273 145.14C191.277 144.819 191.512 144.503 191.944 144.256C192.417 143.981 193.057 143.829 193.742 143.83C194.422 143.83 195.063 143.98 195.539 144.253C195.972 144.505 196.206 144.818 196.206 145.14C196.204 145.458 195.969 145.777 195.539 146.025C195.063 146.298 194.422 146.449 193.742 146.451Z",
    fill: "white"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M191.329 147.726C191.329 147.726 191.287 145.839 191.287 145.689C191.152 145.479 191.053 145.266 191.071 144.975C191.065 145.426 191.074 146.105 191.077 147.152C191.099 147.351 191.185 147.542 191.329 147.726Z",
    fill: "white"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M194.013 148.854C194.038 148.086 194.063 147.239 194.068 146.874C193.615 146.857 192.638 146.602 192.124 146.377L192.051 148.304C192.591 148.605 193.272 148.794 194.013 148.854Z",
    fill: "white"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M197.717 147.712C197.872 147.507 197.962 147.294 197.968 147.073C197.968 146.92 197.968 146.758 197.968 146.598C197.968 146.55 197.971 146.501 197.968 146.454C197.968 146.312 197.968 146.171 197.968 146.035C197.971 145.9 197.971 145.775 197.968 145.66C197.973 145.584 197.968 145.513 197.973 145.448C197.971 145.263 197.973 145.132 197.973 145.086C197.968 145.237 197.927 145.404 197.849 145.534C197.816 145.603 197.768 145.668 197.729 145.73L197.717 147.712Z",
    fill: "white"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6414 50.3435L107.238 60.3399L185.839 14.959L168.525 9.99639L159.93 0L81.3291 45.3817L98.6414 50.3435Z",
    fill: "white"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3379 45.2852L99.0867 50.0874L107.403 59.7574L146.118 37.4058L184.83 15.0542L168.082 10.2529L159.764 0.582031L121.05 22.9328L82.3379 45.2852Z",
    fill: "#CAD2DA"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3098 172.489L102.578 172.593L191.639 120.394L167.935 114.539L156.165 100.852L24.5791 153.734L57.3098 172.489Z",
    fill: "url(#paint130_linear_3744_1590)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M159.764 0.582031V29.5256L184.83 15.0542L168.082 10.2529L159.764 0.582031Z",
    fill: "#B2C4D3"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M168.042 24.7715L184.83 15.0553L168.042 10.2539V24.7715Z",
    fill: "#BCCDD8"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M185.839 14.959L191.639 120.394L104.315 170.813L94.7643 159.706L75.5283 154.192L81.3291 45.3817L98.6414 50.3435L107.238 60.3399L185.839 14.959Z",
    fill: "#EEF0F3"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M104.315 170.812L94.7643 159.705L75.5283 154.191L81.3291 45.3809L98.6414 50.3427L107.238 60.339L104.315 170.812Z",
    fill: "#BCCDD8"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M104.315 170.813L94.7643 159.706L98.6414 50.3438L107.238 60.3401L104.315 170.813Z",
    fill: "#B2C4D3"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M128.433 126.598C129.246 126.129 129.893 126.051 130.374 126.364C130.82 126.669 131.043 127.26 131.045 128.138L131.043 129.993C131.043 130.835 130.789 131.701 130.283 132.592C129.772 133.485 129.157 134.14 128.433 134.555L127.47 135.11V139.922L125.802 140.884V128.116L128.433 126.598ZM129.43 129.099C129.428 128.766 129.341 128.549 129.17 128.447C128.993 128.344 128.763 128.372 128.474 128.54L127.468 129.119V133.206L128.474 132.625C128.74 132.474 128.966 132.232 129.15 131.908C129.335 131.585 129.429 131.272 129.427 130.966L129.43 129.099Z",
    fill: "#F98700"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M133.422 131.074V136.483L131.756 137.446V124.678L133.428 123.715V129.138L135.435 127.975V122.552L137.103 121.588V134.361L135.435 135.324V129.909L133.422 131.074Z",
    fill: "#F98700"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M140.019 129.741L139.614 132.913L137.88 133.914L139.758 120.058L142.052 118.734L143.909 130.432L142.15 131.446L141.763 128.735L140.019 129.741ZM140.894 122.324L140.28 127.718L141.515 127.004L140.894 122.324Z",
    fill: "#F98700"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M147.317 115.695C148.248 115.157 148.929 115.059 149.364 115.399C149.748 115.695 149.939 116.305 149.939 117.229V119.084C149.939 119.986 149.639 120.922 149.045 121.891L150.283 126.752L148.479 127.794L147.467 123.569C147.42 123.595 147.369 123.625 147.315 123.654L146.352 124.208V129.018L144.687 129.983V117.212L147.317 115.695ZM148.314 118.198C148.316 117.455 147.999 117.267 147.362 117.635L146.353 118.217V122.303L147.362 121.722C147.624 121.57 147.853 121.332 148.037 121.009C148.225 120.681 148.314 120.368 148.314 120.061V118.198Z",
    fill: "#F98700"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M152.759 125.321L151.09 126.283V113.503L153.482 112.122L155.04 120.405L156.532 110.363L158.833 109.035V121.815L157.161 122.776V114.748L155.713 123.616L154.373 124.387L152.76 117.311L152.759 125.321Z",
    fill: "#F98700"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M161.749 117.197L161.342 120.369L159.606 121.371L161.484 107.517L163.778 106.191L165.633 117.889L163.881 118.902L163.489 116.195L161.749 117.197ZM162.624 109.783L162.006 115.176L163.242 114.461L162.624 109.783Z",
    fill: "#F98700"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M168.805 116.221C168.071 116.646 167.446 116.71 166.93 116.412C166.417 116.114 166.158 115.543 166.158 114.704V107.73C166.158 106.879 166.419 106.01 166.934 105.119C167.454 104.223 168.076 103.566 168.806 103.146C169.541 102.719 170.163 102.661 170.678 102.962C171.193 103.263 171.445 103.837 171.445 104.677V106.136L169.715 107.135V105.638C169.715 105.331 169.622 105.122 169.434 105.017C169.245 104.908 169.016 104.93 168.752 105.081C168.49 105.236 168.262 105.472 168.077 105.799C167.889 106.123 167.801 106.436 167.801 106.744V113.734C167.801 114.038 167.893 114.246 168.077 114.355C168.262 114.46 168.49 114.437 168.752 114.285C169.021 114.133 169.245 113.893 169.434 113.572C169.622 113.248 169.715 112.935 169.715 112.626V110.864L171.445 109.865V111.647C171.445 112.497 171.188 113.368 170.67 114.257C170.152 115.149 169.531 115.803 168.805 116.221Z",
    fill: "#F98700"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M173.684 107.891L171.451 101.75L173.287 100.691L174.521 104.566L175.746 99.2702L177.593 98.2051L175.353 106.93V112.277L173.683 113.24V107.891H173.684Z",
    fill: "#F98700"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M167.344 65.8795L155.159 72.9145V58.8398L141.5 66.7255V80.7993L129.309 87.8382V103.606L141.501 96.5668V110.647L155.159 102.762V88.6819L167.344 81.6469V65.8795Z",
    fill: "#F98700"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M107.647 59.7641L104.315 170.812L107.159 59.75L107.647 59.7641Z",
    fill: "white"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M162.696 36.3371C162.694 35.3103 161.972 34.894 161.085 35.4074C160.191 35.9215 159.47 37.1706 159.47 38.2013C159.469 39.2265 160.192 39.6437 161.084 39.1311C161.972 38.6138 162.692 37.3655 162.696 36.3371Z",
    fill: "#4C4C4C"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M162.386 36.518C162.387 35.6853 161.802 35.3472 161.08 35.7652C160.362 36.1807 159.78 37.1895 159.776 38.023C159.776 38.8557 160.362 39.1938 161.08 38.7775C161.805 38.3588 162.387 37.3484 162.386 36.518Z",
    fill: "#ADBCC1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M161.775 36.8699C161.772 36.4293 161.464 36.2516 161.083 36.4708C160.702 36.6969 160.394 37.2299 160.392 37.6689C160.392 38.1096 160.7 38.288 161.083 38.0681C161.464 37.8482 161.772 37.3144 161.775 36.8699Z",
    fill: "#14161A"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M134.597 52.5624C134.597 51.5317 133.877 51.1161 132.985 51.6311C132.096 52.1437 131.374 53.3943 131.373 54.4235C131.374 55.4518 132.095 55.8682 132.986 55.354C133.876 54.839 134.599 53.5884 134.597 52.5624Z",
    fill: "#4C4C4C"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M134.287 52.7384C134.287 51.9073 133.7 51.5684 132.984 51.9847C132.264 52.3995 131.677 53.4146 131.68 54.2449C131.674 55.0753 132.262 55.415 132.984 54.9986C133.704 54.5838 134.289 53.5688 134.287 52.7384Z",
    fill: "#ADBCC1"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M133.674 53.0957C133.672 52.6543 133.361 52.4751 132.985 52.6965C132.606 52.9133 132.294 53.4518 132.295 53.8924C132.291 54.3291 132.601 54.5075 132.985 54.2899C133.362 54.0692 133.674 53.5308 133.674 53.0957Z",
    fill: "#14161A"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 75.3506C141.315 75.3506 140.207 74.9969 139.342 74.5453C134.693 72.1153 132.079 64.2053 132.521 53.9022C132.533 53.6329 132.766 53.4295 133.028 53.4365C133.297 53.4475 133.506 53.6752 133.493 53.9436C133.067 63.8649 135.481 71.4281 139.792 73.6805C142.472 75.0814 145.823 74.3496 149.481 71.5651C160.317 63.3202 160.881 45.0046 160.62 37.5133C160.611 37.2449 160.821 37.0187 161.091 37.0101C161.383 36.9999 161.584 37.2105 161.595 37.4797C161.911 46.5573 160.797 54.3803 158.289 60.7321C155.79 67.0611 152.441 70.5391 150.074 72.3407C147.097 74.6063 144.628 75.3506 142.667 75.3506Z",
    fill: "url(#paint131_linear_3744_1590)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M144.645 70.1428C143.008 70.1428 141.624 69.7202 140.53 69.1896C135.85 66.9161 132.63 60.7835 132.521 53.9309C132.517 53.6625 132.731 53.4402 133 53.4363C133.002 53.4363 133.006 53.4363 133.008 53.4363C133.274 53.4363 133.489 53.6491 133.495 53.9152C133.597 60.3084 136.665 66.229 140.954 68.3123C144.296 69.9362 148.112 69.2311 151.995 66.2751C157.728 61.9144 161.274 50.0898 160.62 37.5225C160.605 37.2533 160.813 37.0248 161.083 37.0107C161.342 36.9942 161.58 37.2024 161.594 37.4709C162.273 50.5461 158.653 62.4333 152.584 67.0499C149.539 69.3704 146.861 70.1428 144.645 70.1428Z",
    fill: "#50B09B"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M86.975 153.349C91.8812 156.288 91.8812 161.054 86.975 163.99C82.0774 166.932 74.1252 166.932 69.2221 163.99C64.3205 161.054 64.3205 156.288 69.2221 153.349C74.1252 150.41 82.0774 150.41 86.975 153.349Z",
    fill: "url(#paint132_linear_3744_1590)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6549 127.959H65.5485V158.051H90.6549V127.959Z",
    fill: "url(#paint133_linear_3744_1590)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M86.975 122.775C91.8812 125.718 91.8812 130.488 86.975 133.424C82.0774 136.368 74.1252 136.368 69.2221 133.424C64.3205 130.489 64.3205 125.718 69.2221 122.775C74.1252 119.838 82.0774 119.838 86.975 122.775Z",
    fill: "url(#paint134_linear_3744_1590)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3793 127.226C89.4004 128.843 89.4004 131.467 85.3793 133.081C81.359 134.703 74.8398 134.703 70.8234 133.081C66.8038 131.467 66.8038 128.843 70.8234 127.226C74.8398 125.607 81.359 125.607 85.3793 127.226Z",
    fill: "url(#paint135_linear_3744_1590)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M86.975 152.728C91.8812 155.662 91.8812 160.43 86.975 163.376C82.0774 166.314 74.1252 166.314 69.2221 163.376C64.3205 160.429 64.3205 155.662 69.2221 152.728C74.1252 149.789 82.0774 149.789 86.975 152.728Z",
    fill: "url(#paint136_linear_3744_1590)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5648 128.072C75.969 128.072 74.4625 127.708 73.3198 127.049C72.1005 126.345 71.4259 125.378 71.4259 124.33C71.4259 123.28 72.1013 122.321 73.3198 121.614C74.4625 120.952 75.969 120.588 77.5648 120.588C79.1613 120.588 80.6694 120.952 81.8097 121.614C83.036 122.32 83.7075 123.28 83.7075 124.33C83.7075 125.378 83.036 126.344 81.8097 127.049C80.6694 127.708 79.1613 128.072 77.5648 128.072Z",
    fill: "url(#paint137_linear_3744_1590)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5485 151.066V151.214C65.5485 151.171 65.5485 151.117 65.5547 151.066H65.5485Z",
    fill: "url(#paint138_linear_3744_1590)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6478 151.066C90.6549 151.117 90.6549 151.172 90.6549 151.214V151.066H90.6478Z",
    fill: "url(#paint139_linear_3744_1590)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2442 135.554C81.3129 138.083 73.8929 137.951 69.2231 135.151C66.7711 133.681 65.5494 131.758 65.5494 129.828V158.056C65.5494 159.982 66.775 161.899 69.2231 163.377C73.8898 166.174 81.3129 166.305 86.2442 163.769V135.554Z",
    fill: "url(#paint140_linear_3744_1590)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8326 122.672C82.8326 122.93 82.7778 123.183 82.6729 123.427C82.6432 123.492 82.6158 123.559 82.5782 123.619C82.4921 123.78 82.3794 123.931 82.2448 124.076C82.2151 124.117 82.183 124.155 82.1501 124.178C82.0476 124.284 81.9396 124.385 81.8159 124.471C81.787 124.493 81.7541 124.519 81.7228 124.546C81.6172 124.621 81.5076 124.689 81.3879 124.757C81.3808 124.757 81.3761 124.757 81.3738 124.767C81.3464 124.781 81.319 124.792 81.29 124.805C81.1844 124.875 81.0725 124.925 80.9598 124.972C80.9308 124.993 80.894 125.013 80.8612 125.021C80.7563 125.073 80.6467 125.118 80.5324 125.154C80.5019 125.166 80.4698 125.177 80.4409 125.181C80.3274 125.227 80.2202 125.257 80.1036 125.285C80.0746 125.298 80.0449 125.303 80.0089 125.314C79.9001 125.344 79.7913 125.372 79.6786 125.392C79.6504 125.397 79.6176 125.405 79.58 125.408C79.4728 125.433 79.3624 125.453 79.2466 125.463C79.2224 125.476 79.1879 125.476 79.1535 125.481C79.0447 125.495 78.9351 125.511 78.8193 125.514C78.7903 125.526 78.7575 125.526 78.7246 125.526C78.6166 125.54 78.5078 125.54 78.392 125.54C78.3615 125.548 78.3302 125.548 78.2965 125.548C78.2323 125.555 78.1658 125.555 78.1016 125.555C78.057 125.555 78.0069 125.555 77.9639 125.548C77.931 125.555 77.8982 125.548 77.8684 125.54C77.7526 125.548 77.6438 125.54 77.5342 125.529C77.4998 125.529 77.4693 125.529 77.4395 125.519C77.3237 125.514 77.2141 125.506 77.1069 125.49C77.0694 125.49 77.0443 125.481 77.0107 125.475C76.8956 125.462 76.7868 125.441 76.6781 125.427C76.6421 125.416 76.6131 125.416 76.5834 125.405C76.4675 125.38 76.358 125.358 76.25 125.325C76.214 125.325 76.1842 125.314 76.1553 125.304C76.0402 125.271 75.9299 125.242 75.8211 125.203C75.7851 125.197 75.7561 125.184 75.724 125.173C75.6106 125.134 75.4947 125.091 75.393 125.042C75.3578 125.036 75.3241 125.022 75.2991 125.007C75.1833 124.952 75.0666 124.899 74.9649 124.836C74.9289 124.829 74.9007 124.806 74.871 124.788C74.8569 124.781 74.8389 124.776 74.828 124.767C74.7262 124.708 74.6245 124.651 74.5337 124.579C74.5016 124.56 74.4719 124.538 74.4429 124.521C74.3247 124.43 74.2112 124.339 74.1095 124.241C74.0766 124.209 74.0446 124.18 74.0148 124.144C73.888 124.008 73.7738 123.87 73.6806 123.726C73.6446 123.672 73.6157 123.621 73.5867 123.561C73.4419 123.276 73.3691 122.974 73.3691 122.674C73.3691 122.369 73.4419 122.068 73.5867 121.789C73.6157 121.734 73.6446 121.675 73.6806 121.621C73.7745 121.476 73.8888 121.334 74.0148 121.201C74.0446 121.167 74.0758 121.135 74.1095 121.105C74.2112 121.004 74.3239 120.918 74.4429 120.831C74.4719 120.809 74.5016 120.781 74.5337 120.762C74.6245 120.693 74.7262 120.634 74.828 120.582C74.8389 120.57 74.8577 120.555 74.871 120.555C74.9007 120.533 74.9289 120.516 74.9649 120.508C75.0666 120.449 75.1833 120.389 75.2991 120.341C75.3233 120.327 75.3578 120.315 75.393 120.301C75.4947 120.256 75.6106 120.206 75.724 120.174C75.7553 120.163 75.7851 120.152 75.8211 120.142C75.9299 120.106 76.0402 120.068 76.1553 120.043C76.185 120.035 76.214 120.025 76.25 120.019C76.358 119.989 76.4675 119.962 76.5834 119.945C76.6123 119.931 76.6421 119.92 76.6781 119.92C76.7868 119.899 76.8956 119.882 77.0107 119.866C77.0435 119.863 77.0694 119.859 77.1069 119.859C77.2141 119.838 77.3237 119.83 77.4395 119.824C77.4693 119.814 77.499 119.814 77.5342 119.814C77.6438 119.808 77.7526 119.8 77.8684 119.8C77.8982 119.8 77.9302 119.789 77.9639 119.8C78.0069 119.789 78.057 119.789 78.1016 119.789C78.1666 119.789 78.2323 119.789 78.2965 119.8C78.3302 119.8 78.3622 119.8 78.392 119.8C78.5078 119.8 78.6166 119.809 78.7246 119.822C78.7575 119.822 78.7903 119.822 78.8193 119.83C78.9351 119.834 79.0447 119.851 79.1535 119.863C79.1879 119.866 79.2224 119.878 79.2466 119.878C79.3624 119.892 79.4728 119.91 79.58 119.932C79.6168 119.941 79.6497 119.946 79.6786 119.952C79.7913 119.975 79.9001 120 80.0089 120.036C80.0449 120.036 80.0738 120.051 80.1036 120.064C80.2202 120.091 80.3282 120.123 80.4409 120.164C80.4706 120.175 80.5027 120.18 80.5324 120.192C80.6467 120.235 80.7571 120.274 80.8612 120.328C80.894 120.342 80.9308 120.353 80.9598 120.367C81.0717 120.417 81.1844 120.473 81.29 120.533C81.319 120.548 81.3464 120.566 81.3738 120.583C81.3761 120.583 81.3808 120.583 81.3879 120.588C81.5076 120.655 81.6172 120.726 81.7228 120.802C81.7541 120.825 81.787 120.851 81.8159 120.875C81.9396 120.963 82.0476 121.059 82.1501 121.162C82.1822 121.193 82.2151 121.231 82.2448 121.264C82.3794 121.411 82.4921 121.57 82.5782 121.727C82.6158 121.789 82.6432 121.858 82.6729 121.92C82.7786 122.164 82.8326 122.408 82.8326 122.672Z",
    fill: "url(#paint141_linear_3744_1590)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8325 117.379H73.3699V122.661H82.8325V117.379Z",
    fill: "url(#paint142_linear_3744_1590)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6729 117.971V123.428C82.6432 123.493 82.6158 123.559 82.5782 123.62V117.971H82.6729Z",
    fill: "#D3D4D6"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2448 117.949V124.077C82.2151 124.118 82.183 124.155 82.1501 124.179V117.949H82.2448Z",
    fill: "#D3D4D6"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M81.816 117.93V124.472C81.7871 124.494 81.7542 124.52 81.7229 124.547V117.93H81.816Z",
    fill: "#D3D4D6"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3887 117.906V124.759C81.3817 124.759 81.377 124.759 81.3746 124.768C81.3472 124.782 81.3199 124.793 81.2909 124.807V117.907L81.3887 117.906Z",
    fill: "#D3D4D6"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9606 117.885V124.973C80.9316 124.994 80.8948 125.014 80.8619 125.021V117.886L80.9606 117.885Z",
    fill: "#D3D4D6"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5332 117.862V125.154C80.5027 125.166 80.4706 125.177 80.4417 125.18V117.861H80.5332V117.862Z",
    fill: "#D3D4D6"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1036 117.834V125.285C80.0747 125.298 80.0449 125.303 80.0089 125.314V117.834H80.1036Z",
    fill: "#D3D4D6"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6794 117.816V125.393C79.6512 125.398 79.6184 125.406 79.5808 125.409V117.817H79.6794V117.816Z",
    fill: "#D3D4D6"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2474 117.793V125.463C79.2232 125.475 79.1887 125.475 79.1543 125.481V117.793H79.2474Z",
    fill: "#D3D4D6"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8193 117.768V125.513C78.7904 125.525 78.7575 125.525 78.7246 125.525V117.768H78.8193Z",
    fill: "#D3D4D6"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M78.392 117.746V125.539C78.3615 125.547 78.3302 125.547 78.2965 125.547V117.746H78.392Z",
    fill: "#D3D4D6"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9639 117.725V125.546C77.931 125.554 77.8981 125.546 77.8684 125.538V117.725H77.9639Z",
    fill: "#D3D4D6"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5351 117.699V125.528C77.5007 125.528 77.4702 125.528 77.4404 125.518V117.699H77.5351Z",
    fill: "#D3D4D6"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1077 117.679V125.49C77.0702 125.49 77.0451 125.481 77.0115 125.475V117.678H77.1077V117.679Z",
    fill: "#D3D4D6"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6797 117.656V125.428C76.6437 125.417 76.6147 125.417 76.585 125.406V117.657L76.6797 117.656Z",
    fill: "#D3D4D6"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2516 117.631V125.326C76.2156 125.326 76.1858 125.315 76.1569 125.304V117.631H76.2516Z",
    fill: "#D3D4D6"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8219 117.607V125.203C75.7859 125.196 75.7569 125.184 75.7249 125.173V117.607H75.8219Z",
    fill: "#D3D4D6"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3946 117.588V125.042C75.3594 125.035 75.3257 125.021 75.3007 125.006V117.588H75.3946Z",
    fill: "#D3D4D6"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9665 117.562V124.836C74.9305 124.829 74.9023 124.806 74.8726 124.788V117.562H74.9665Z",
    fill: "#D3D4D6"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5345 117.539V124.579C74.5024 124.56 74.4727 124.538 74.4437 124.521V117.539H74.5345Z",
    fill: "#D3D4D6"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1103 117.52V124.241C74.0775 124.209 74.0454 124.18 74.0156 124.144V117.52H74.1103Z",
    fill: "#D3D4D6"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6814 117.492V123.726C73.6454 123.672 73.6165 123.62 73.5875 123.56V117.492H73.6814Z",
    fill: "#D3D4D6"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1018 120.259C76.8676 120.259 75.707 119.98 74.8289 119.473C73.8859 118.928 73.3701 118.183 73.3701 117.38C73.3701 116.573 73.8859 115.829 74.8289 115.285C75.707 114.774 76.8676 114.498 78.1018 114.498C79.3321 114.498 80.4919 114.774 81.3747 115.285C82.3139 115.829 82.8328 116.573 82.8328 117.38C82.8328 118.183 82.3139 118.927 81.3747 119.473C80.4919 119.98 79.3321 120.259 78.1018 120.259Z",
    fill: "white"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1017 120.155C76.905 120.155 75.7718 119.882 74.9156 119.39C74.0086 118.864 73.5077 118.152 73.5077 117.381C73.5077 116.604 74.0086 115.894 74.9156 115.374C75.7718 114.876 76.905 114.609 78.1017 114.609C79.2983 114.609 80.43 114.875 81.2877 115.374C82.1893 115.894 82.6902 116.604 82.6902 117.381C82.6902 118.152 82.1893 118.864 81.2877 119.39C80.43 119.882 79.2983 120.155 78.1017 120.155Z",
    fill: "url(#paint143_linear_3744_1590)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M81.258 115.485C83.0024 116.535 83.0024 118.227 81.258 119.275C79.5159 120.321 76.6867 120.321 74.9446 119.275C73.1962 118.227 73.1962 116.535 74.9446 115.485C76.6867 114.437 79.5166 114.437 81.258 115.485Z",
    fill: "#F5F5F7"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5992 161.549C67.7045 162.809 67.7045 164.854 65.5992 166.113C63.4987 167.374 60.0881 167.374 57.9852 166.113C55.883 164.854 55.883 162.809 57.9852 161.549C60.0873 160.289 63.4987 160.289 65.5992 161.549Z",
    fill: "url(#paint144_linear_3744_1590)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1786 150.656H56.4098V163.567H67.1786V150.656Z",
    fill: "url(#paint145_linear_3744_1590)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5992 148.433C67.7045 149.696 67.7045 151.741 65.5992 153.002C63.4987 154.262 60.0881 154.262 57.9852 153.002C55.883 151.742 55.883 149.696 57.9852 148.433C60.0873 147.173 63.4987 147.173 65.5992 148.433Z",
    fill: "url(#paint146_linear_3744_1590)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1786 163.568C67.1786 164.333 66.7231 165.104 65.8121 165.718C65.7432 165.761 65.6712 165.806 65.6 165.851C64.7227 166.376 63.6247 166.683 62.4836 166.769C62.3435 166.779 62.2027 166.788 62.0626 166.794C61.7104 166.802 61.3574 166.794 61.0076 166.762C59.901 166.666 58.8366 166.361 57.9836 165.851C56.9333 165.219 56.4105 164.393 56.4121 163.568H56.4089V163.492C56.4395 162.686 56.9638 161.893 57.9836 161.284C58.8366 160.771 59.901 160.468 61.0076 160.371C61.3574 160.342 61.7096 160.332 62.0626 160.342C62.2027 160.345 62.3435 160.354 62.4836 160.365C63.6239 160.45 64.7227 160.759 65.6 161.284C65.6712 161.327 65.7432 161.372 65.8121 161.416C66.7238 162.028 67.1786 162.797 67.1786 163.568Z",
    fill: "url(#paint147_linear_3744_1590)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5633 150.707C60.8785 150.707 60.2328 150.551 59.7421 150.268C59.2185 149.967 58.929 149.552 58.929 149.102C58.929 148.652 59.2185 148.239 59.7421 147.937C60.232 147.653 60.8785 147.498 61.5633 147.498C62.2473 147.498 62.8953 147.653 63.3836 147.937C63.9103 148.24 64.1975 148.652 64.1975 149.102C64.1975 149.552 63.9095 149.968 63.3836 150.268C62.8945 150.551 62.2473 150.707 61.5633 150.707Z",
    fill: "url(#paint148_linear_3744_1590)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4082 160.568V160.633C56.4082 160.613 56.4082 160.59 56.4113 160.568H56.4082Z",
    fill: "url(#paint149_linear_3744_1590)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1738 160.568C67.177 160.59 67.177 160.613 67.177 160.633V160.568H67.1738Z",
    fill: "url(#paint150_linear_3744_1590)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M65.813 150.656V165.717C65.7441 165.761 65.6721 165.805 65.6009 165.85C64.7236 166.375 63.6256 166.683 62.4845 166.768V150.656H65.813Z",
    fill: "url(#paint151_linear_3744_1590)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0634 150.656V166.793C61.7112 166.802 61.3583 166.793 61.0084 166.761V150.656H62.0634Z",
    fill: "url(#paint152_linear_3744_1590)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0455 150.535C67.0455 150.821 66.9845 151.104 66.8686 151.373C66.8342 151.445 66.8037 151.519 66.763 151.586C66.6675 151.764 66.5415 151.932 66.392 152.094C66.3592 152.139 66.3239 152.18 66.2879 152.207C66.1745 152.325 66.0539 152.437 65.917 152.532C65.8849 152.557 65.8489 152.586 65.8129 152.614C65.6963 152.697 65.5742 152.773 65.4411 152.849C65.4341 152.849 65.4286 152.849 65.4255 152.86C65.3958 152.876 65.3644 152.888 65.3316 152.904C65.215 152.981 65.0905 153.036 64.9653 153.089C64.9332 153.112 64.8918 153.133 64.8565 153.142C64.7399 153.2 64.6186 153.25 64.491 153.289C64.4582 153.302 64.4222 153.314 64.3909 153.317C64.2649 153.37 64.1443 153.402 64.0152 153.434C63.9839 153.448 63.9503 153.454 63.9111 153.465C63.7906 153.499 63.6693 153.531 63.5441 153.551C63.5136 153.558 63.476 153.568 63.4353 153.571C63.3148 153.597 63.1927 153.618 63.0659 153.63C63.0377 153.643 63.0009 153.643 62.9618 153.651C62.8405 153.667 62.7184 153.683 62.5901 153.687C62.5572 153.7 62.522 153.7 62.4844 153.7C62.3647 153.715 62.2442 153.715 62.1158 153.715C62.0829 153.724 62.0477 153.724 62.0101 153.724C61.9389 153.733 61.8654 153.733 61.7941 153.733C61.7448 153.733 61.6885 153.733 61.6408 153.724C61.604 153.733 61.568 153.724 61.5351 153.715C61.4067 153.724 61.2847 153.715 61.1649 153.704C61.125 153.704 61.0914 153.704 61.0593 153.691C60.9309 153.687 60.8104 153.679 60.6899 153.659C60.6492 153.659 60.621 153.651 60.5842 153.643C60.4567 153.629 60.3361 153.606 60.214 153.59C60.1749 153.578 60.1428 153.578 60.1099 153.568C59.9808 153.538 59.8595 153.515 59.739 153.478C59.6999 153.478 59.6662 153.464 59.6333 153.454C59.5058 153.416 59.3852 153.385 59.2632 153.341C59.224 153.333 59.1912 153.322 59.1559 153.308C59.0299 153.265 58.9024 153.217 58.7881 153.164C58.749 153.156 58.7114 153.141 58.6832 153.123C58.5549 153.062 58.4265 153.003 58.3131 152.934C58.2724 152.927 58.2411 152.902 58.2082 152.883C58.1925 152.875 58.1722 152.869 58.1604 152.859C58.0478 152.794 57.9343 152.729 57.8341 152.648C57.7989 152.629 57.766 152.603 57.7331 152.585C57.6001 152.483 57.4757 152.383 57.3622 152.275C57.3254 152.237 57.2902 152.206 57.2589 152.166C57.1172 152.017 56.992 151.863 56.8863 151.702C56.8472 151.642 56.8151 151.585 56.7823 151.518C56.6218 151.203 56.542 150.869 56.542 150.534C56.542 150.196 56.6218 149.862 56.7823 149.551C56.8151 149.492 56.8472 149.427 56.8863 149.366C56.9912 149.205 57.1172 149.048 57.2589 148.898C57.291 148.862 57.3262 148.826 57.3622 148.794C57.4757 148.679 57.6009 148.584 57.7331 148.488C57.7652 148.464 57.7981 148.435 57.8341 148.411C57.9343 148.334 58.0478 148.269 58.1604 148.211C58.1722 148.196 58.1925 148.18 58.2082 148.18C58.2411 148.157 58.2724 148.138 58.3131 148.129C58.4273 148.063 58.5557 147.997 58.6832 147.944C58.7122 147.927 58.749 147.915 58.7881 147.898C58.9024 147.85 59.0299 147.795 59.1559 147.757C59.1912 147.745 59.224 147.735 59.2632 147.721C59.3852 147.683 59.5058 147.642 59.6333 147.613C59.6654 147.605 59.6991 147.592 59.739 147.588C59.8595 147.553 59.9816 147.524 60.1099 147.505C60.1428 147.49 60.1749 147.477 60.214 147.477C60.3361 147.452 60.4567 147.437 60.5842 147.417C60.621 147.411 60.6492 147.407 60.6899 147.407C60.8104 147.384 60.9309 147.375 61.0593 147.372C61.0914 147.358 61.125 147.358 61.1649 147.358C61.2847 147.35 61.4067 147.344 61.5351 147.344C61.5672 147.344 61.6032 147.33 61.6408 147.344C61.6885 147.33 61.7448 147.33 61.7941 147.33C61.8654 147.33 61.9389 147.33 62.0101 147.344C62.0477 147.344 62.0837 147.344 62.1158 147.344C62.2442 147.344 62.3647 147.35 62.4844 147.366C62.522 147.366 62.5572 147.366 62.5901 147.375C62.7184 147.378 62.8405 147.4 62.9618 147.411C63.0017 147.416 63.0385 147.427 63.0659 147.427C63.1935 147.444 63.3148 147.465 63.4353 147.489C63.476 147.499 63.5136 147.505 63.5441 147.511C63.6693 147.537 63.7906 147.565 63.9111 147.605C63.9503 147.605 63.9839 147.62 64.0152 147.636C64.1451 147.667 64.2657 147.701 64.3909 147.745C64.4222 147.757 64.4582 147.765 64.491 147.778C64.6186 147.827 64.7399 147.866 64.8565 147.926C64.8918 147.944 64.9332 147.957 64.9653 147.973C65.0905 148.027 65.215 148.089 65.3316 148.157C65.3644 148.172 65.3958 148.193 65.4255 148.21C65.4286 148.21 65.4333 148.21 65.4411 148.217C65.5742 148.289 65.6955 148.369 65.8129 148.455C65.8489 148.481 65.8849 148.507 65.917 148.535C66.0539 148.631 66.1745 148.741 66.2879 148.852C66.3239 148.889 66.3592 148.93 66.392 148.967C66.5415 149.13 66.6667 149.305 66.763 149.481C66.8037 149.55 66.8342 149.626 66.8686 149.694C66.9845 149.972 67.0455 150.24 67.0455 150.535Z",
    fill: "url(#paint153_linear_3744_1590)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0454 144.658H56.5411V150.521H67.0454V144.658Z",
    fill: "url(#paint154_linear_3744_1590)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8686 145.314V151.372C66.8342 151.444 66.8036 151.517 66.7629 151.585V145.314H66.8686Z",
    fill: "#D3D4D6"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3921 145.289V152.093C66.3592 152.139 66.324 152.179 66.288 152.206V145.289H66.3921Z",
    fill: "#D3D4D6"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9177 145.266V152.531C65.8856 152.556 65.8496 152.585 65.8136 152.612V145.266H65.9177V145.266Z",
    fill: "#D3D4D6"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4418 145.242V152.849C65.4348 152.849 65.4293 152.849 65.4262 152.86C65.3965 152.877 65.3651 152.888 65.3323 152.904V145.243H65.4418V145.242Z",
    fill: "#D3D4D6"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9668 145.217V153.087C64.9347 153.11 64.8933 153.131 64.858 153.14V145.217H64.9668Z",
    fill: "#D3D4D6"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4918 145.193V153.288C64.4589 153.301 64.4229 153.313 64.3916 153.316V145.193H64.4918Z",
    fill: "#D3D4D6"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0152 145.162V153.434C63.9839 153.448 63.9503 153.454 63.9111 153.465V145.162H64.0152Z",
    fill: "#D3D4D6"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5441 145.141V153.551C63.5136 153.558 63.476 153.568 63.4353 153.57V145.141H63.5441Z",
    fill: "#D3D4D6"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0659 145.117V153.631C63.0377 153.644 63.0009 153.644 62.9618 153.652V145.117H63.0659Z",
    fill: "#D3D4D6"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M62.59 145.088V153.688C62.5572 153.701 62.5219 153.701 62.4844 153.701V145.088H62.59Z",
    fill: "#D3D4D6"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1158 145.064V153.715C62.0829 153.723 62.0477 153.723 62.0101 153.723V145.064H62.1158Z",
    fill: "#D3D4D6"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6407 145.041V153.724C61.6039 153.734 61.5679 153.724 61.535 153.716V145.041H61.6407Z",
    fill: "#D3D4D6"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1649 145.013V153.703C61.1249 153.703 61.0913 153.703 61.0592 153.691V145.012H61.1649V145.013Z",
    fill: "#D3D4D6"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6899 144.987V153.659C60.6492 153.659 60.621 153.651 60.5842 153.642V144.986H60.6899V144.987Z",
    fill: "#D3D4D6"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2132 144.965V153.592C60.1741 153.579 60.142 153.579 60.1091 153.569V144.966H60.2132V144.965Z",
    fill: "#D3D4D6"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M59.739 144.936V153.478C59.6998 153.478 59.6662 153.464 59.6333 153.454V144.936H59.739Z",
    fill: "#D3D4D6"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2631 144.912V153.342C59.224 153.333 59.1911 153.322 59.1559 153.309V144.912H59.2631Z",
    fill: "#D3D4D6"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7881 144.887V153.162C58.749 153.154 58.7114 153.139 58.6832 153.121V144.887H58.7881Z",
    fill: "#D3D4D6"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3123 144.859V152.935C58.2716 152.927 58.2403 152.903 58.2074 152.884V144.86H58.3123V144.859Z",
    fill: "#D3D4D6"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8333 144.834V152.647C57.798 152.628 57.7652 152.602 57.7323 152.584V144.834H57.8333Z",
    fill: "#D3D4D6"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3614 144.812V152.275C57.3246 152.237 57.2894 152.206 57.2581 152.166V144.812H57.3614Z",
    fill: "#D3D4D6"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8863 144.781V151.702C56.8472 151.642 56.8151 151.585 56.7822 151.518V144.782H56.8863V144.781Z",
    fill: "#D3D4D6"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7933 147.855C60.423 147.855 59.1348 147.545 58.1596 146.983C57.1117 146.379 56.5404 145.551 56.5404 144.659C56.5404 143.764 57.1117 142.938 58.1596 142.335C59.134 141.764 60.4222 141.459 61.7933 141.459C63.1574 141.459 64.4464 141.765 65.4263 142.335C66.4679 142.938 67.0455 143.764 67.0455 144.659C67.0455 145.551 66.4679 146.378 65.4263 146.983C64.4464 147.546 63.1582 147.855 61.7933 147.855Z",
    fill: "white"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7933 147.738C60.4628 147.738 59.2067 147.438 58.2558 146.891C57.2486 146.305 56.6937 145.515 56.6937 144.659C56.6937 143.794 57.2486 143.008 58.2558 142.43C59.2067 141.878 60.4628 141.582 61.7933 141.582C63.1214 141.582 64.3783 141.878 65.3291 142.43C66.3317 143.007 66.8881 143.794 66.8881 144.659C66.8881 145.515 66.3325 146.305 65.3291 146.891C64.3783 147.438 63.1214 147.738 61.7933 147.738Z",
    fill: "url(#paint155_linear_3744_1590)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2971 142.557C67.2349 143.72 67.2349 145.601 65.2971 146.764C63.3641 147.927 60.2234 147.927 58.2888 146.764C56.3471 145.601 56.3471 143.72 58.2888 142.557C60.2234 141.392 63.3633 141.392 65.2971 142.557Z",
    fill: "url(#paint156_linear_3744_1590)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7934 146.406C61.0444 146.406 60.34 146.236 59.8071 145.929C59.235 145.598 58.9227 145.146 58.9227 144.659C58.9227 144.17 59.235 143.719 59.8071 143.389C60.34 143.078 61.0444 142.91 61.7934 142.91C62.5392 142.91 63.2436 143.078 63.7781 143.389C64.3486 143.719 64.6617 144.17 64.6617 144.659C64.6617 145.146 64.3478 145.598 63.7781 145.929C63.2436 146.236 62.54 146.406 61.7934 146.406Z",
    fill: "url(#paint157_linear_3744_1590)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7934 146.342C61.0664 146.342 60.3785 146.176 59.8604 145.879C59.3094 145.56 59.0057 145.127 59.0057 144.658C59.0057 144.188 59.3094 143.757 59.8604 143.439C60.3792 143.138 61.0664 142.977 61.7934 142.977C62.5181 142.977 63.2061 143.138 63.7249 143.439C64.2728 143.756 64.5756 144.187 64.5756 144.658C64.5756 145.127 64.2728 145.559 63.7249 145.879C63.2061 146.176 62.5189 146.342 61.7934 146.342Z",
    fill: "#6B6660"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4989 144.467C64.4833 143.892 64.1788 138.988 64.0974 138.215C64.0113 137.399 63.7914 136.592 63.0401 136.148C62.6958 135.945 62.1972 135.777 61.7926 135.777C61.1642 135.777 60.596 136.032 60.1828 136.444C59.6655 136.961 59.534 137.6 59.4956 138.303C59.4487 139.151 59.2421 142.39 59.1849 143.159C59.1442 143.694 59.0112 144.284 59.0973 144.818C59.1669 145.257 59.5121 145.59 59.8799 145.811C60.4074 146.128 61.1008 146.286 61.795 146.286C62.4868 146.286 63.181 146.128 63.7092 145.811C64.2383 145.492 64.5036 145.076 64.5036 144.661C64.502 144.596 64.5013 144.531 64.4989 144.467Z",
    fill: "url(#paint158_linear_3744_1590)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7186 174.22C91.5596 175.927 91.5596 178.691 88.7186 180.397C85.8746 182.104 81.2611 182.104 78.4194 180.397C75.5746 178.691 75.5746 175.927 78.4194 174.22C81.2611 172.515 85.8746 172.515 88.7186 174.22Z",
    fill: "#F5F5F7"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8489 165.693H76.2867V176.947H90.8489V165.693Z",
    fill: "url(#paint159_linear_3744_1590)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7186 162.69C91.5596 164.395 91.5596 167.16 88.7186 168.866C85.8746 170.572 81.2611 170.572 78.4194 168.866C75.5746 167.16 75.5746 164.395 78.4194 162.69C81.2611 160.986 85.8746 160.986 88.7186 162.69Z",
    fill: "#F5F5F7"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7186 173.859C91.5596 175.564 91.5596 178.33 88.7186 180.035C85.8746 181.741 81.2611 181.741 78.4194 180.035C75.5746 178.33 75.5746 175.564 78.4194 173.859C81.2611 172.154 85.8746 172.154 88.7186 173.859Z",
    fill: "url(#paint160_linear_3744_1590)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5508 165.243C90.5508 165.628 90.4741 166.001 90.3175 166.361C90.2776 166.451 90.2338 166.548 90.179 166.641C90.0507 166.88 89.884 167.105 89.6875 167.324C89.6461 167.371 89.5952 167.43 89.5467 167.472C89.3972 167.624 89.2368 167.765 89.0544 167.901C89.0121 167.935 88.9605 167.969 88.9112 168.003C88.7578 168.118 88.5974 168.222 88.4205 168.322C88.4134 168.328 88.4072 168.328 88.3993 168.335C88.3657 168.356 88.3219 168.377 88.2812 168.4C88.1231 168.491 87.9572 168.575 87.7889 168.646C87.7451 168.673 87.6973 168.694 87.648 168.707C87.4853 168.785 87.324 168.849 87.1565 168.905C87.1135 168.926 87.0665 168.939 87.0227 168.948C86.8591 169.011 86.6979 169.059 86.5305 169.102C86.4882 169.115 86.4381 169.129 86.3896 169.144C86.2284 169.187 86.0656 169.228 85.8997 169.257C85.8574 169.27 85.8058 169.278 85.7572 169.284C85.596 169.319 85.4348 169.348 85.265 169.369C85.2235 169.382 85.1734 169.382 85.1257 169.39C84.9637 169.41 84.8024 169.432 84.6326 169.439C84.5911 169.453 84.5418 169.453 84.4925 169.453C84.3321 169.475 84.1701 169.481 83.9987 169.481C83.9588 169.488 83.9079 169.488 83.8602 169.488C83.7694 169.497 83.67 169.497 83.5729 169.497C83.4994 169.497 83.4313 169.497 83.3687 169.488C83.3194 169.497 83.2685 169.488 83.2278 169.481C83.058 169.488 82.896 169.475 82.7355 169.46C82.6839 169.46 82.6361 169.46 82.5939 169.447C82.4248 169.439 82.2628 169.426 82.1024 169.396C82.0531 169.396 82.0093 169.391 81.9607 169.382C81.7925 169.363 81.6313 169.333 81.4685 169.306C81.4192 169.299 81.3777 169.291 81.3276 169.278C81.1601 169.241 80.9966 169.206 80.8361 169.165C80.7876 169.157 80.7391 169.144 80.696 169.129C80.5285 169.087 80.365 169.037 80.2038 168.975C80.156 168.968 80.1138 168.954 80.0645 168.933C79.8946 168.876 79.7279 168.813 79.5722 168.744C79.5229 168.728 79.4752 168.707 79.4305 168.687C79.2631 168.609 79.0956 168.534 78.9398 168.441C78.8905 168.427 78.8475 168.4 78.806 168.371C78.7794 168.364 78.7567 168.352 78.7364 168.335C78.59 168.251 78.4397 168.159 78.3083 168.06C78.2582 168.032 78.2183 167.999 78.1752 167.969C77.9976 167.836 77.8301 167.702 77.683 167.555C77.6329 167.512 77.5851 167.463 77.5413 167.413C77.3527 167.218 77.1836 167.013 77.0498 166.796C76.9935 166.719 76.9528 166.635 76.9089 166.548C76.6976 166.134 76.5873 165.692 76.5873 165.243C76.5873 164.793 76.6976 164.349 76.9089 163.933C76.9528 163.857 76.9935 163.772 77.0498 163.689C77.1836 163.477 77.3527 163.266 77.5413 163.07C77.5851 163.02 77.6321 162.972 77.683 162.93C77.8309 162.782 77.9983 162.646 78.1752 162.52C78.219 162.486 78.2582 162.451 78.3083 162.422C78.4397 162.325 78.59 162.234 78.7364 162.149C78.7575 162.135 78.7794 162.12 78.806 162.113C78.8475 162.086 78.8905 162.057 78.9398 162.043C79.0956 161.953 79.2631 161.875 79.4305 161.797C79.4744 161.777 79.5229 161.762 79.5722 161.741C79.7279 161.671 79.8954 161.607 80.0645 161.552C80.1145 161.536 80.156 161.515 80.2038 161.508C80.365 161.454 80.5285 161.403 80.696 161.361C80.7383 161.346 80.7876 161.332 80.8361 161.324C80.9973 161.274 81.1609 161.241 81.3276 161.212C81.3777 161.198 81.4192 161.184 81.4685 161.177C81.6313 161.15 81.7925 161.123 81.9607 161.099C82.0093 161.093 82.0531 161.086 82.1024 161.086C82.2628 161.056 82.4256 161.043 82.5939 161.036C82.6361 161.02 82.6839 161.02 82.7355 161.02C82.8968 161.007 83.0588 160.994 83.2278 160.999C83.2685 160.994 83.3186 160.986 83.3687 160.994C83.4313 160.986 83.4994 160.986 83.5729 160.986C83.67 160.986 83.7694 160.986 83.8602 160.994C83.9079 160.994 83.9588 160.994 83.9987 160.999C84.1709 160.999 84.3321 161.007 84.4925 161.028C84.5418 161.028 84.5911 161.028 84.6326 161.043C84.8032 161.05 84.9644 161.071 85.1257 161.093C85.1734 161.099 85.2227 161.105 85.265 161.113C85.4348 161.134 85.596 161.163 85.7572 161.198C85.8065 161.205 85.8574 161.211 85.8997 161.225C86.0656 161.261 86.2284 161.295 86.3896 161.345C86.4389 161.352 86.4882 161.366 86.5305 161.385C86.6979 161.422 86.8591 161.479 87.0227 161.533C87.0658 161.55 87.1127 161.562 87.1565 161.576C87.324 161.641 87.4845 161.704 87.648 161.774C87.6973 161.795 87.7451 161.817 87.7889 161.836C87.9579 161.915 88.1231 161.99 88.2812 162.083C88.3219 162.104 88.3657 162.125 88.3993 162.146C88.408 162.154 88.4134 162.154 88.4205 162.161C88.5981 162.257 88.7578 162.365 88.9112 162.476C88.9605 162.512 89.0114 162.548 89.0544 162.581C89.236 162.715 89.3972 162.855 89.5467 163.01C89.5944 163.052 89.6453 163.109 89.6875 163.157C89.884 163.376 90.0507 163.607 90.179 163.848C90.2338 163.939 90.2776 164.036 90.3175 164.129C90.4741 164.491 90.5508 164.856 90.5508 165.243Z",
    fill: "url(#paint161_linear_3744_1590)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5562 157.43H76.5834V165.221H90.5562V157.43Z",
    fill: "url(#paint162_linear_3744_1590)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3176 158.305V166.361C90.2777 166.451 90.2339 166.549 90.1791 166.641V158.305H90.3176Z",
    fill: "#D3D4D6"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6876 158.268V167.323C89.6462 167.37 89.5953 167.429 89.5468 167.471V158.268H89.6876V158.268Z",
    fill: "#D3D4D6"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0545 158.234V167.902C89.0122 167.936 88.9606 167.97 88.9113 168.005V158.235H89.0545V158.234Z",
    fill: "#D3D4D6"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4206 158.207V168.323C88.4135 168.329 88.4073 168.329 88.3994 168.336C88.3658 168.358 88.3219 168.379 88.2812 168.401V158.208L88.4206 158.207Z",
    fill: "#D3D4D6"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7889 158.17V168.646C87.7451 168.673 87.6974 168.695 87.6481 168.707V158.17H87.7889Z",
    fill: "#D3D4D6"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1567 158.135V168.906C87.1136 168.927 87.0667 168.94 87.0228 168.949V158.136H87.1567V158.135Z",
    fill: "#D3D4D6"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5305 158.102V169.104C86.4883 169.117 86.4382 169.131 86.3896 169.146V158.102H86.5305V158.102Z",
    fill: "#D3D4D6"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8989 158.07V169.256C85.8567 169.27 85.805 169.277 85.7565 169.284V158.07H85.8989Z",
    fill: "#D3D4D6"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2643 158.038V169.369C85.2228 169.383 85.1727 169.383 85.125 169.391V158.037H85.2643V158.038Z",
    fill: "#D3D4D6"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6319 158.004V169.44C84.5904 169.454 84.5411 169.454 84.4918 169.454V158.004H84.6319Z",
    fill: "#D3D4D6"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9972 157.967V169.481C83.9573 169.488 83.9064 169.488 83.8586 169.488V157.967H83.9972Z",
    fill: "#D3D4D6"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3679 157.932V169.489C83.3186 169.497 83.2677 169.489 83.2271 169.482V157.932H83.3679Z",
    fill: "#D3D4D6"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7348 157.902V169.46C82.6831 169.46 82.6354 169.46 82.5931 169.448V157.902H82.7348Z",
    fill: "#D3D4D6"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1017 157.869V169.396C82.0524 169.396 82.0086 169.392 81.9601 169.383V157.869H82.1017Z",
    fill: "#D3D4D6"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4678 157.834V169.306C81.4185 169.3 81.377 169.292 81.3269 169.279V157.834H81.4678Z",
    fill: "#D3D4D6"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8354 157.799V169.166C80.7869 169.158 80.7384 169.145 80.6953 169.13V157.799H80.8354Z",
    fill: "#D3D4D6"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M80.203 157.768V168.975C80.1553 168.968 80.113 168.954 80.0637 168.932V157.768H80.203V157.768Z",
    fill: "#D3D4D6"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5707 157.734V168.745C79.5214 168.729 79.4737 168.707 79.4291 168.688V157.735H79.5707V157.734Z",
    fill: "#D3D4D6"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9384 157.699V168.441C78.8891 168.427 78.846 168.4 78.8046 168.371V157.699H78.9384Z",
    fill: "#D3D4D6"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M78.306 157.664V168.06C78.2559 168.032 78.216 167.999 78.173 167.969V157.664H78.306Z",
    fill: "#D3D4D6"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6799 157.637V167.555C77.6298 167.512 77.582 167.463 77.5382 167.413V157.637H77.6799Z",
    fill: "#D3D4D6"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0467 157.602V166.796C76.9904 166.719 76.9497 166.635 76.9059 166.548V157.602H77.0467Z",
    fill: "#D3D4D6"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5683 161.683C81.7518 161.683 80.0371 161.272 78.738 160.521C77.3473 159.72 76.5826 158.62 76.5826 157.43C76.5826 156.24 77.3473 155.142 78.738 154.338C80.0371 153.588 81.7518 153.176 83.5683 153.176C85.3832 153.176 87.1026 153.588 88.3994 154.338C89.7893 155.142 90.5555 156.24 90.5555 157.43C90.5555 158.621 89.7893 159.72 88.3994 160.521C87.1026 161.27 85.384 161.683 83.5683 161.683Z",
    fill: "white"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5683 161.527C81.7973 161.527 80.1295 161.127 78.8671 160.398C77.5281 159.626 76.7916 158.569 76.7916 157.43C76.7916 156.288 77.5281 155.234 78.8671 154.463C80.1295 153.733 81.7973 153.33 83.5683 153.33C85.3386 153.33 87.0064 153.734 88.2695 154.463C89.6078 155.234 90.345 156.288 90.345 157.43C90.345 158.571 89.607 159.626 88.2695 160.398C87.0071 161.127 85.3394 161.527 83.5683 161.527Z",
    fill: "url(#paint163_linear_3744_1590)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2304 154.638C90.8036 156.181 90.8036 158.685 88.2304 160.23C85.6571 161.773 81.4811 161.773 78.9055 160.23C76.3307 158.685 76.3307 156.181 78.9055 154.638C81.4811 153.092 85.6579 153.092 88.2304 154.638Z",
    fill: "#F5F5F7"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M76.287 172.898V172.983C76.287 172.954 76.287 172.926 76.2901 172.898H76.287Z",
    fill: "url(#paint164_linear_3744_1590)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8474 172.898C90.8498 172.926 90.8498 172.954 90.8498 172.983V172.898H90.8474Z",
    fill: "url(#paint165_linear_3744_1590)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M90.849 176.942V172.982C90.849 174.099 90.1399 175.218 88.7156 176.071C85.8731 177.776 81.2619 177.776 78.4187 176.071C76.9966 175.218 76.286 174.098 76.286 172.982V176.946C76.286 178.065 76.9966 179.181 78.4187 180.033C81.2603 181.738 85.8739 181.738 88.7179 180.033C90.1399 179.182 90.8513 178.063 90.849 176.942Z",
    fill: "url(#paint166_linear_3744_1590)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M90.849 171.539V172.261C90.849 173.378 90.1399 174.498 88.7156 175.353C85.8731 177.057 81.2619 177.057 78.4187 175.353C77.7088 174.923 77.1751 174.432 76.819 173.906C76.4613 173.381 76.286 172.821 76.286 172.262C76.286 172.262 76.286 172.262 76.286 172.261V171.544C76.286 172.101 76.4621 172.66 76.819 173.187C77.1751 173.712 77.7088 174.203 78.4187 174.63C81.2619 176.337 85.8731 176.337 88.7156 174.63C90.1399 173.777 90.849 172.657 90.849 171.539Z",
    fill: "url(#paint167_linear_3744_1590)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M155.58 174.411C156.77 175.096 156.77 176.208 155.58 176.895L149.289 180.528C148.102 181.215 146.175 181.215 144.987 180.528C143.8 179.843 143.8 178.73 144.987 178.045L151.28 174.411C152.468 173.725 154.391 173.725 155.58 174.411Z",
    fill: "url(#paint168_linear_3744_1590)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M150.445 174.443C150.719 174.288 150.988 174.134 151.258 173.979C151.723 173.716 152.18 173.446 152.648 173.191C153.163 172.904 153.657 172.656 154.25 172.553C154.373 172.533 154.506 172.511 154.629 172.532C154.897 172.569 155.168 172.653 155.416 172.798C156.151 173.227 156.621 174.147 156.427 174.993C156.317 175.476 156.086 175.955 155.682 176.257C155.532 176.367 155.359 176.448 155.197 176.538L152.526 178.072L150.445 174.443Z",
    fill: "url(#paint169_linear_3744_1590)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M150.003 175.404C150.003 174.463 150.664 174.079 151.482 174.553C152.3 175.024 152.964 176.171 152.964 177.114C152.964 178.056 152.3 178.439 151.482 177.967C150.664 177.498 150.003 176.351 150.003 175.404Z",
    fill: "url(#paint170_linear_3744_1590)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M150.433 174.451L147.802 175.98C147.664 176.03 147.553 176.104 147.439 176.18C147.1 176.404 146.837 176.718 146.675 177.107C146.574 177.358 146.511 177.632 146.511 177.921C146.511 178.984 147.302 179.873 148.341 179.998C148.427 180.025 148.516 180.025 148.616 180.025C148.892 180.025 149.168 179.976 149.405 179.873C149.419 179.873 149.432 179.862 149.432 179.862L149.855 179.61L152.526 178.071L150.433 174.451Z",
    fill: "url(#paint171_linear_3744_1590)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M155.589 173.482C155.814 173.871 155.68 174.37 155.291 174.594L148.529 178.498C148.138 178.724 147.639 178.591 147.413 178.201C147.19 177.81 147.324 177.312 147.712 177.086L154.476 173.183C154.866 172.96 155.363 173.091 155.589 173.482Z",
    fill: "white"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M132.921 166.661C131.731 167.347 131.731 168.458 132.921 169.145L139.212 172.778C140.398 173.465 142.326 173.465 143.514 172.778C144.7 172.093 144.7 170.98 143.514 170.295L137.221 166.661C136.032 165.975 134.107 165.975 132.921 166.661Z",
    fill: "url(#paint172_linear_3744_1590)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M140.734 166.694C140.46 166.539 140.19 166.385 139.92 166.229C139.455 165.966 138.999 165.697 138.531 165.442C138.015 165.156 137.521 164.907 136.927 164.803C136.804 164.783 136.673 164.761 136.548 164.782C136.281 164.819 136.01 164.903 135.763 165.048C135.027 165.477 134.557 166.397 134.752 167.243C134.861 167.726 135.093 168.206 135.497 168.507C135.647 168.617 135.819 168.698 135.982 168.788L138.654 170.322L140.734 166.694Z",
    fill: "url(#paint173_linear_3744_1590)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M141.175 167.656C141.175 166.715 140.514 166.331 139.696 166.805C138.878 167.276 138.214 168.423 138.214 169.366C138.214 170.309 138.878 170.691 139.696 170.219C140.514 169.75 141.175 168.602 141.175 167.656Z",
    fill: "url(#paint174_linear_3744_1590)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M140.746 166.701L143.376 168.23C143.514 168.28 143.626 168.355 143.741 168.43C144.079 168.654 144.342 168.968 144.503 169.358C144.605 169.609 144.667 169.883 144.667 170.171C144.667 171.235 143.876 172.124 142.838 172.249C142.751 172.276 142.663 172.276 142.563 172.276C142.288 172.276 142.011 172.226 141.774 172.124C141.761 172.124 141.747 172.113 141.747 172.113L141.324 171.861L138.653 170.322L140.746 166.701Z",
    fill: "url(#paint175_linear_3744_1590)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M135.59 165.73C135.364 166.119 135.498 166.618 135.888 166.842L142.65 170.746C143.039 170.972 143.539 170.839 143.766 170.45C143.988 170.058 143.853 169.56 143.465 169.334L136.702 165.431C136.313 165.208 135.816 165.339 135.59 165.73Z",
    fill: "white"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M143.989 182.25V189.567L129.889 197.743V190.389L143.989 182.25Z",
    fill: "#EEF0F3"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 197.934L143.99 189.565L144.038 189.531L143.886 189.445L129.957 197.664L129.8 197.934Z",
    fill: "#F4F7F9"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 190.295L101.85 174.157L109.579 169.695L111.757 168.438L116.195 165.877L144.144 182.014L139.708 184.574L137.53 185.833L129.8 190.295Z",
    fill: "#F5F5F7"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M112.251 168.147L116.195 165.877L144.144 182.012L140.202 184.284L112.251 168.147Z",
    fill: "#038471"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M137.53 185.832L109.579 169.694L111.757 168.438L139.708 184.574L137.53 185.832Z",
    fill: "#50B09B"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M129.8 197.934V191.713V190.293L144.144 182.014L144.142 182.168L144.038 189.531L143.886 189.445L143.989 182.273L129.954 190.384V197.703L129.8 197.934Z",
    fill: "#F4F7F9"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M101.85 174.139V181.797L129.8 197.933V190.275L101.85 174.139Z",
    fill: "#CAD2DA"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M95.446 150.837L102.376 146.836L117.824 155.718L110.861 159.735L95.446 150.837Z",
    fill: "#BCC6CE"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M102.376 146.836V154.836L95.4045 150.837L102.376 146.836Z",
    fill: "#ACB9C1"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M118.126 155.736L102.376 146.836L102.317 146.811L102.319 146.999L117.783 155.736H118.126Z",
    fill: "#F4F7F9"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M117.065 141.21V169.711C117.065 169.748 117.063 169.783 117.06 169.818C117.054 169.871 117.042 169.92 117.027 169.963C116.977 170.108 116.882 170.199 116.755 170.229C116.723 170.241 116.685 170.244 116.646 170.244C116.551 170.242 116.439 170.207 116.322 170.143L103.335 162.643C103.231 162.583 103.13 162.499 103.041 162.401C102.867 162.216 102.728 161.976 102.654 161.732C102.614 161.604 102.591 161.478 102.591 161.355L102.593 132.852C102.593 132.83 102.594 132.808 102.595 132.787C102.598 132.732 102.607 132.679 102.621 132.632C102.664 132.481 102.756 132.381 102.879 132.345C102.911 132.331 102.947 132.326 102.985 132.325C103.089 132.319 103.21 132.351 103.336 132.426L116.322 139.921C116.733 140.159 117.065 140.736 117.065 141.21Z",
    fill: "white"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 141.354V169.857C116.922 169.892 116.92 169.927 116.917 169.962C116.91 170.015 116.899 170.063 116.883 170.108C116.834 170.252 116.735 170.345 116.611 170.374C116.579 170.385 116.542 170.389 116.502 170.387C116.404 170.386 116.295 170.353 116.178 170.285L103.192 162.788C103.088 162.728 102.987 162.643 102.897 162.546C102.724 162.361 102.585 162.119 102.511 161.878C102.472 161.751 102.448 161.621 102.448 161.5V133C102.448 132.976 102.45 132.954 102.45 132.933C102.455 132.876 102.465 132.824 102.479 132.778C102.522 132.626 102.614 132.526 102.737 132.489C102.771 132.477 102.805 132.47 102.842 132.469C102.947 132.465 103.067 132.497 103.193 132.57L116.181 140.068C116.591 140.303 116.922 140.879 116.922 141.354Z",
    fill: "url(#paint176_linear_3744_1590)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 141.867V142.069L115.561 139.709L115.735 139.811L116.922 141.867Z",
    fill: "#B6BCC1"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 142.804V143.005L114.748 139.24L114.923 139.34L116.922 142.804Z",
    fill: "#B6BCC1"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 143.74V143.942L113.936 138.77L114.111 138.871L116.922 143.74Z",
    fill: "#B6BCC1"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 144.677V144.879L113.125 138.303L113.301 138.404L116.922 144.677Z",
    fill: "#B6BCC1"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 145.612V145.814L112.314 137.834L112.49 137.935L116.922 145.612Z",
    fill: "#B6BCC1"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 146.552V146.752L111.503 137.365L111.679 137.467L116.922 146.552Z",
    fill: "#B6BCC1"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 147.487V147.69L110.691 136.896L110.866 136.997L116.922 147.487Z",
    fill: "#B6BCC1"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 148.424V148.628L109.88 136.43L110.054 136.53L116.922 148.424Z",
    fill: "#B6BCC1"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 149.361V149.563L109.068 135.961L109.244 136.061L116.922 149.361Z",
    fill: "#B6BCC1"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 150.299V150.501L108.256 135.492L108.434 135.594L116.922 150.299Z",
    fill: "#B6BCC1"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 151.236V151.438L107.448 135.025L107.621 135.125L116.922 151.236Z",
    fill: "#B6BCC1"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 152.174V152.376L106.634 134.555L106.81 134.656L116.922 152.174Z",
    fill: "#B6BCC1"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 153.109V153.313L105.823 134.088L105.998 134.188L116.922 153.109Z",
    fill: "#B6BCC1"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 154.047V154.249L105.011 133.617L105.188 133.72L116.922 154.047Z",
    fill: "#B6BCC1"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 154.981V155.185L104.201 133.148L104.376 133.249L116.922 154.981Z",
    fill: "#B6BCC1"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 155.921V156.121L103.388 132.682L103.564 132.783L116.922 155.921Z",
    fill: "#B6BCC1"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 156.857V157.058L102.736 132.486C102.77 132.475 102.804 132.468 102.841 132.467L116.922 156.857Z",
    fill: "#B6BCC1"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 157.793V157.996L102.45 132.932C102.455 132.875 102.465 132.823 102.479 132.777L116.922 157.793Z",
    fill: "#B6BCC1"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 158.731V158.933L102.448 133.865V133.662L116.922 158.731Z",
    fill: "#B6BCC1"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 159.664V159.871L102.448 134.802V134.598L116.922 159.664Z",
    fill: "#B6BCC1"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 160.606V160.807L102.448 135.737V135.535L116.922 160.606Z",
    fill: "#B6BCC1"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 161.54V161.741L102.448 136.674V136.471L116.922 161.54Z",
    fill: "#B6BCC1"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 162.479V162.682L102.448 137.611V137.41L116.922 162.479Z",
    fill: "#B6BCC1"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 163.415V163.62L102.448 138.548V138.346L116.922 163.415Z",
    fill: "#B6BCC1"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 164.35V164.553L102.448 139.485V139.283L116.922 164.35Z",
    fill: "#B6BCC1"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 165.288V165.488L102.448 140.421V140.219L116.922 165.288Z",
    fill: "#B6BCC1"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 166.225V166.427L102.448 141.359V141.154L116.922 166.225Z",
    fill: "#B6BCC1"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 167.161V167.365L102.448 142.296V142.094L116.922 167.161Z",
    fill: "#B6BCC1"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 168.102V168.301L102.448 143.234V143.031L116.922 168.102Z",
    fill: "#B6BCC1"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M116.922 169.035V169.238L102.448 144.169V143.967L116.922 169.035Z",
    fill: "#B6BCC1"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M116.917 169.962C116.91 170.015 116.899 170.063 116.883 170.108L102.448 145.108V144.904L116.917 169.962Z",
    fill: "#B6BCC1"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M116.611 170.372C116.579 170.383 116.542 170.387 116.502 170.385L102.448 146.041V145.842L116.611 170.372Z",
    fill: "#B6BCC1"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M115.941 170.146L115.764 170.045L102.448 146.982V146.777L115.941 170.146Z",
    fill: "#B6BCC1"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M115.13 169.677L114.954 169.577L102.448 147.917V147.715L115.13 169.677Z",
    fill: "#B6BCC1"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M114.319 169.211L114.141 169.11L102.448 148.855V148.65L114.319 169.211Z",
    fill: "#B6BCC1"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M113.508 168.744L113.332 168.64L102.448 149.791V149.59L113.508 168.744Z",
    fill: "#B6BCC1"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M112.695 168.273L112.519 168.172L102.448 150.727V150.525L112.695 168.273Z",
    fill: "#B6BCC1"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M111.884 167.804L111.71 167.703L102.448 151.663V151.463L111.884 167.804Z",
    fill: "#B6BCC1"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M111.071 167.336L110.897 167.234L102.448 152.602V152.4L111.071 167.336Z",
    fill: "#B6BCC1"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M110.26 166.87L110.086 166.766L102.448 153.541V153.336L110.26 166.87Z",
    fill: "#B6BCC1"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M109.45 166.4L109.274 166.298L102.448 154.475V154.271L109.45 166.4Z",
    fill: "#B6BCC1"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M108.637 165.93L108.463 165.831L102.448 155.411V155.211L108.637 165.93Z",
    fill: "#B6BCC1"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M107.828 165.462L107.653 165.363L102.448 156.35V156.146L107.828 165.462Z",
    fill: "#B6BCC1"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M107.015 164.994L106.84 164.891L102.448 157.286V157.082L107.015 164.994Z",
    fill: "#B6BCC1"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M106.205 164.525L106.028 164.424L102.448 158.223V158.02L106.205 164.525Z",
    fill: "#B6BCC1"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M105.392 164.058L105.219 163.956L102.448 159.159V158.957L105.392 164.058Z",
    fill: "#B6BCC1"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M104.582 163.588L104.405 163.487L102.448 160.096V159.895L104.582 163.588Z",
    fill: "#B6BCC1"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M103.769 163.12L103.596 163.019L102.448 161.033V160.832L103.769 163.12Z",
    fill: "#B6BCC1"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M102.897 162.545C102.724 162.36 102.585 162.118 102.511 161.877L102.897 162.545Z",
    fill: "#B6BCC1"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M104.906 137.972C104.906 136.699 105.799 136.183 106.903 136.819C108.002 137.456 108.897 139.003 108.896 140.276C108.897 141.548 108.002 142.063 106.903 141.429C105.799 140.792 104.906 139.245 104.906 137.972Z",
    fill: "#F0F7FA"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M108.254 138.345C108.623 138.987 108.827 139.673 108.827 140.277C108.827 140.866 108.632 141.305 108.277 141.509C107.923 141.714 107.447 141.663 106.936 141.369C106.413 141.067 105.922 140.547 105.55 139.905C105.179 139.263 104.976 138.576 104.976 137.973C104.976 137.382 105.171 136.945 105.525 136.741C105.879 136.537 106.356 136.586 106.867 136.88C107.39 137.183 107.881 137.703 108.254 138.345Z",
    fill: "url(#paint177_linear_3744_1590)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M107.792 141.293C107.591 141.293 107.353 141.219 107.106 141.076C106.633 140.803 106.186 140.328 105.844 139.736C105.503 139.145 105.315 138.519 105.315 137.973C105.315 137.509 105.449 137.175 105.695 137.033C105.786 136.981 105.892 136.955 106.011 136.955C106.212 136.955 106.45 137.03 106.698 137.173C107.17 137.445 107.618 137.922 107.959 138.513C108.301 139.106 108.491 139.732 108.491 140.277C108.491 140.741 108.354 141.074 108.109 141.215C108.018 141.268 107.912 141.293 107.792 141.293Z",
    fill: "#9FA1A3"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M104.934 138.321L105.374 138.068C105.372 138.091 105.37 138.116 105.37 138.14C105.37 138.634 105.54 139.2 105.848 139.732C106.156 140.266 106.562 140.696 106.99 140.943C107.012 140.956 107.032 140.967 107.053 140.978L106.63 141.223L106.899 141.691L108.024 141.04L108.023 141.039C108.247 140.882 108.368 140.568 108.368 140.15C108.369 139.653 108.2 139.088 107.892 138.554C107.584 138.021 107.179 137.592 106.75 137.344C106.363 137.122 106.012 137.078 105.762 137.223L104.665 137.856L104.934 138.321Z",
    fill: "url(#paint178_linear_3744_1590)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M106.794 139.186C107.103 139.718 107.271 140.285 107.271 140.779C107.271 141.227 107.134 141.552 106.882 141.696C106.63 141.841 106.28 141.798 105.891 141.574C105.464 141.329 105.059 140.899 104.751 140.365C104.442 139.832 104.273 139.266 104.273 138.77C104.273 138.324 104.412 137.999 104.662 137.854C104.913 137.708 105.266 137.753 105.652 137.975C106.08 138.224 106.486 138.653 106.794 139.186Z",
    fill: "url(#paint179_linear_3744_1590)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M106.615 139.288C106.868 139.729 107.009 140.195 107.009 140.605C107.009 140.973 106.895 141.241 106.688 141.361C106.48 141.48 106.191 141.445 105.871 141.26C105.518 141.055 105.183 140.702 104.93 140.263C104.675 139.823 104.535 139.356 104.535 138.947C104.535 138.58 104.65 138.31 104.856 138.19C105.063 138.071 105.354 138.107 105.671 138.29C106.028 138.495 106.361 138.85 106.615 139.288Z",
    fill: "url(#paint180_linear_3744_1590)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M105.071 138.441L106.597 141.086C106.609 141.107 106.602 141.135 106.58 141.146C106.559 141.159 106.532 141.152 106.52 141.13L104.992 138.485C104.978 138.464 104.986 138.436 105.007 138.423C105.03 138.412 105.057 138.42 105.071 138.441Z",
    fill: "#A8BAC1"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.585 140.272C108.585 140.517 108.548 140.732 108.476 140.905C108.406 141.078 108.301 141.212 108.164 141.296C108.158 141.301 108.15 141.305 108.143 141.31L107.864 141.47C107.833 141.488 107.803 141.506 107.775 141.521L107.511 141.673L107.275 141.812C107.228 141.839 107.181 141.866 107.142 141.889C107.025 141.956 106.941 142.005 106.913 142.022C106.911 142.024 106.91 142.025 106.91 142.025C106.908 142.025 106.905 142.027 106.904 142.028C106.619 142.193 106.22 142.143 105.782 141.889C105.297 141.609 104.838 141.122 104.488 140.518C104.141 139.914 103.948 139.271 103.948 138.711C103.948 138.24 104.083 137.888 104.33 137.709C104.33 137.709 104.33 137.709 104.33 137.708C104.351 137.694 104.369 137.683 104.388 137.672C104.395 137.669 104.401 137.665 104.406 137.661L105.681 136.925L105.684 136.928C105.691 136.925 105.698 136.922 105.705 136.921C105.838 136.861 105.99 136.845 106.159 136.872C106.341 136.897 106.542 136.971 106.751 137.093C106.764 137.1 106.774 137.107 106.786 137.114C107.173 137.346 107.54 137.706 107.847 138.152C107.914 138.252 107.981 138.356 108.044 138.464C108.392 139.068 108.585 139.71 108.585 140.272Z",
    fill: "#F0F7FA"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M106.802 139.182C106.452 138.577 105.994 138.09 105.508 137.81C105.069 137.556 104.671 137.507 104.387 137.672C104.103 137.836 103.946 138.204 103.946 138.711C103.946 139.271 104.139 139.912 104.488 140.517C104.837 141.122 105.296 141.608 105.781 141.889C106.22 142.14 106.618 142.191 106.903 142.026C107.185 141.862 107.342 141.493 107.342 140.988C107.343 140.426 107.152 139.786 106.802 139.182Z",
    fill: "#F0F7FA"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.231 138.855C105.982 138.423 105.656 138.077 105.306 137.876C104.994 137.695 104.71 137.66 104.508 137.776C104.303 137.894 104.193 138.157 104.193 138.52C104.193 138.92 104.329 139.379 104.579 139.81C104.827 140.242 105.156 140.59 105.503 140.791C105.815 140.971 106.101 141.005 106.304 140.889C106.506 140.772 106.618 140.508 106.618 140.147C106.618 139.746 106.481 139.287 106.231 138.855Z",
    fill: "white"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.158 136.871C106.158 136.871 104.952 137.53 104.858 137.584C104.677 137.576 104.507 137.592 104.329 137.709C104.612 137.541 105.042 137.301 105.705 136.921C105.836 136.861 105.989 136.846 106.158 136.871Z",
    fill: "white"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.847 138.153C107.372 138.449 106.848 138.774 106.619 138.908C106.443 138.631 105.924 138.108 105.597 137.864L106.786 137.115C107.172 137.347 107.539 137.707 107.847 138.153Z",
    fill: "white"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.476 140.904C108.406 141.077 108.301 141.212 108.164 141.296C108.067 141.352 107.967 141.41 107.864 141.47C107.833 141.488 107.803 141.506 107.775 141.522C107.685 141.573 107.594 141.625 107.511 141.674C107.426 141.723 107.347 141.769 107.275 141.812C107.228 141.84 107.181 141.866 107.142 141.89C107.025 141.956 106.941 142.005 106.913 142.023C107.009 141.963 107.098 141.877 107.154 141.782C107.183 141.735 107.206 141.681 107.232 141.632L108.476 140.904Z",
    fill: "white"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M111.103 141.618C111.103 140.346 111.995 139.829 113.097 140.466C114.199 141.103 115.094 142.651 115.094 143.922C115.094 145.193 114.199 145.71 113.097 145.074C111.995 144.438 111.103 142.89 111.103 141.618Z",
    fill: "#F0F7FA"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M114.45 141.99C114.82 142.633 115.024 143.319 115.024 143.922C115.022 144.512 114.828 144.95 114.473 145.155C114.118 145.36 113.643 145.309 113.132 145.014C112.61 144.712 112.117 144.192 111.746 143.55C111.375 142.908 111.171 142.221 111.171 141.618C111.171 141.028 111.366 140.592 111.721 140.387C112.075 140.181 112.552 140.23 113.064 140.526C113.587 140.828 114.078 141.347 114.45 141.99Z",
    fill: "url(#paint181_linear_3744_1590)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M113.988 144.94C113.787 144.94 113.549 144.864 113.302 144.722C112.829 144.449 112.382 143.974 112.041 143.381C111.697 142.79 111.511 142.164 111.509 141.619C111.509 141.154 111.644 140.822 111.891 140.679C111.98 140.629 112.086 140.6 112.206 140.6C112.408 140.6 112.646 140.676 112.894 140.82C113.366 141.093 113.812 141.568 114.154 142.159C114.496 142.751 114.684 143.378 114.684 143.922C114.684 144.385 114.55 144.721 114.304 144.861C114.214 144.913 114.109 144.94 113.988 144.94Z",
    fill: "#9FA1A3"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M111.13 141.967L111.569 141.714C111.567 141.737 111.567 141.761 111.567 141.786C111.567 142.28 111.736 142.847 112.045 143.38C112.353 143.913 112.758 144.342 113.186 144.589C113.208 144.602 113.229 144.613 113.25 144.625L112.826 144.871L113.093 145.336L114.22 144.687L114.219 144.685C114.441 144.528 114.565 144.216 114.565 143.795C114.565 143.3 114.394 142.735 114.087 142.201C113.778 141.668 113.373 141.238 112.945 140.992C112.56 140.767 112.209 140.724 111.956 140.869L110.86 141.502L111.13 141.967Z",
    fill: "url(#paint182_linear_3744_1590)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M112.991 142.833C113.297 143.366 113.468 143.931 113.468 144.426C113.468 144.873 113.329 145.199 113.078 145.345C112.827 145.488 112.476 145.446 112.089 145.222C111.662 144.974 111.253 144.545 110.948 144.012C110.639 143.479 110.47 142.913 110.47 142.419C110.47 141.971 110.608 141.646 110.858 141.5C111.11 141.355 111.461 141.398 111.846 141.622C112.277 141.869 112.683 142.3 112.991 142.833Z",
    fill: "url(#paint183_linear_3744_1590)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M112.811 142.935C113.065 143.376 113.204 143.842 113.204 144.25C113.204 144.618 113.091 144.888 112.884 145.008C112.676 145.125 112.387 145.09 112.066 144.906C111.716 144.703 111.381 144.348 111.126 143.909C110.872 143.469 110.732 143.001 110.732 142.593C110.732 142.224 110.846 141.957 111.052 141.838C111.26 141.717 111.55 141.753 111.868 141.937C112.225 142.141 112.558 142.497 112.811 142.935Z",
    fill: "url(#paint184_linear_3744_1590)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M111.267 142.087L112.792 144.731C112.807 144.753 112.799 144.781 112.777 144.794C112.756 144.806 112.727 144.799 112.715 144.777L111.188 142.133C111.175 142.111 111.182 142.083 111.202 142.07C111.227 142.059 111.254 142.066 111.267 142.087Z",
    fill: "#A8BAC1"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.781 143.917C114.781 144.163 114.743 144.377 114.673 144.55C114.602 144.724 114.498 144.857 114.361 144.942C114.355 144.946 114.346 144.951 114.338 144.956L114.06 145.117C114.031 145.134 114 145.153 113.971 145.169L113.707 145.321L113.47 145.457C113.424 145.486 113.377 145.51 113.338 145.535C113.222 145.603 113.137 145.652 113.109 145.668C113.107 145.669 113.107 145.669 113.106 145.671C113.104 145.671 113.1 145.672 113.098 145.674C112.815 145.838 112.415 145.788 111.978 145.535C111.494 145.256 111.033 144.769 110.684 144.164C110.337 143.56 110.144 142.918 110.144 142.356C110.144 141.886 110.278 141.535 110.525 141.356C110.525 141.356 110.525 141.356 110.526 141.355C110.545 141.34 110.565 141.329 110.583 141.319C110.59 141.315 110.595 141.312 110.601 141.308L111.875 140.572L111.879 140.575C111.886 140.572 111.893 140.568 111.901 140.566C112.033 140.508 112.185 140.493 112.354 140.517C112.538 140.542 112.737 140.616 112.947 140.738C112.959 140.745 112.97 140.752 112.981 140.759C113.367 140.992 113.737 141.352 114.043 141.798C114.11 141.897 114.176 142.001 114.238 142.109C114.588 142.714 114.781 143.356 114.781 143.917Z",
    fill: "#F0F7FA"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M112.997 142.828C112.648 142.225 112.191 141.736 111.705 141.456C111.266 141.203 110.867 141.153 110.585 141.318C110.302 141.483 110.144 141.851 110.144 142.356C110.144 142.919 110.336 143.56 110.684 144.164C111.033 144.769 111.492 145.257 111.978 145.535C112.415 145.788 112.815 145.838 113.098 145.672C113.384 145.509 113.54 145.141 113.54 144.634C113.54 144.074 113.347 143.431 112.997 142.828Z",
    fill: "#F0F7FA"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.428 142.502C112.179 142.07 111.851 141.724 111.504 141.523C111.191 141.343 110.904 141.308 110.704 141.426C110.502 141.542 110.388 141.806 110.39 142.168C110.39 142.567 110.525 143.027 110.775 143.458C111.023 143.889 111.352 144.238 111.698 144.438C112.012 144.617 112.296 144.653 112.499 144.536C112.703 144.418 112.815 144.155 112.815 143.793C112.815 143.392 112.677 142.934 112.428 142.502Z",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.354 140.517C112.354 140.517 111.149 141.178 111.053 141.232C110.874 141.221 110.704 141.237 110.525 141.355C110.809 141.187 111.238 140.947 111.901 140.565C112.033 140.508 112.185 140.493 112.354 140.517Z",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.044 141.798C113.57 142.094 113.045 142.418 112.815 142.555C112.639 142.276 112.123 141.754 111.794 141.509L112.981 140.76C113.367 140.992 113.737 141.352 114.044 141.798Z",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.673 144.551C114.601 144.725 114.497 144.858 114.36 144.942C114.263 144.997 114.161 145.058 114.06 145.117C114.031 145.134 114 145.153 113.971 145.169C113.881 145.219 113.791 145.271 113.707 145.322C113.622 145.37 113.541 145.416 113.47 145.457C113.424 145.486 113.377 145.51 113.338 145.535C113.222 145.603 113.137 145.652 113.109 145.668C113.203 145.61 113.294 145.524 113.348 145.427C113.377 145.382 113.403 145.327 113.426 145.279L114.673 144.551Z",
    fill: "white"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M104.906 144.736C104.906 143.462 105.799 142.947 106.903 143.583C108.002 144.22 108.897 145.767 108.896 147.039C108.897 148.311 108.002 148.826 106.903 148.192C105.799 147.554 104.906 146.008 104.906 144.736Z",
    fill: "#F0F7FA"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M108.254 145.107C108.623 145.749 108.827 146.436 108.827 147.039C108.827 147.629 108.632 148.065 108.277 148.272C107.923 148.476 107.447 148.427 106.936 148.131C106.413 147.83 105.922 147.31 105.55 146.667C105.179 146.025 104.976 145.339 104.976 144.736C104.976 144.145 105.171 143.708 105.525 143.503C105.879 143.298 106.356 143.348 106.867 143.643C107.39 143.944 107.881 144.464 108.254 145.107Z",
    fill: "url(#paint185_linear_3744_1590)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M107.792 148.058C107.591 148.058 107.353 147.981 107.106 147.838C106.633 147.566 106.186 147.092 105.844 146.499C105.503 145.908 105.315 145.282 105.315 144.736C105.315 144.272 105.449 143.938 105.695 143.796C105.786 143.745 105.892 143.719 106.011 143.719C106.212 143.719 106.45 143.794 106.698 143.936C107.17 144.208 107.618 144.685 107.959 145.276C108.301 145.868 108.491 146.495 108.491 147.039C108.491 147.503 108.354 147.838 108.109 147.979C108.018 148.032 107.912 148.058 107.792 148.058Z",
    fill: "#9FA1A3"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M104.934 145.083L105.374 144.829C105.372 144.853 105.37 144.877 105.37 144.902C105.37 145.396 105.54 145.962 105.848 146.495C106.156 147.03 106.562 147.458 106.99 147.707C107.012 147.718 107.032 147.729 107.053 147.741L106.63 147.984L106.899 148.454L108.024 147.802L108.023 147.801C108.247 147.645 108.368 147.331 108.368 146.911C108.369 146.415 108.2 145.849 107.892 145.317C107.584 144.784 107.179 144.355 106.75 144.107C106.363 143.883 106.012 143.84 105.762 143.984L104.665 144.617L104.934 145.083Z",
    fill: "url(#paint186_linear_3744_1590)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M106.794 145.95C107.103 146.484 107.271 147.049 107.271 147.544C107.271 147.992 107.134 148.317 106.882 148.462C106.63 148.606 106.28 148.563 105.891 148.34C105.464 148.094 105.059 147.663 104.751 147.131C104.442 146.597 104.273 146.031 104.273 145.535C104.273 145.089 104.412 144.764 104.662 144.617C104.913 144.472 105.266 144.516 105.652 144.74C106.08 144.987 106.486 145.418 106.794 145.95Z",
    fill: "url(#paint187_linear_3744_1590)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M106.615 146.052C106.868 146.491 107.009 146.959 107.009 147.368C107.009 147.736 106.895 148.005 106.688 148.125C106.48 148.243 106.191 148.21 105.871 148.024C105.518 147.818 105.183 147.466 104.93 147.026C104.675 146.585 104.535 146.12 104.535 145.71C104.535 145.341 104.65 145.073 104.856 144.954C105.063 144.834 105.354 144.871 105.671 145.053C106.028 145.259 106.361 145.612 106.615 146.052Z",
    fill: "url(#paint188_linear_3744_1590)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M105.071 145.207L106.597 147.85C106.609 147.871 106.602 147.898 106.58 147.912C106.559 147.925 106.532 147.916 106.52 147.895L104.992 145.25C104.978 145.229 104.986 145.203 105.007 145.189C105.03 145.178 105.057 145.184 105.071 145.207Z",
    fill: "#A8BAC1"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.585 147.034C108.585 147.279 108.548 147.493 108.476 147.666C108.406 147.84 108.301 147.975 108.164 148.057C108.158 148.062 108.15 148.068 108.143 148.072L107.864 148.233C107.833 148.251 107.803 148.269 107.775 148.285L107.511 148.436L107.275 148.574C107.228 148.602 107.181 148.627 107.142 148.652C107.025 148.719 106.941 148.768 106.913 148.785C106.911 148.786 106.911 148.786 106.91 148.788C106.908 148.788 106.905 148.788 106.904 148.792C106.619 148.955 106.22 148.905 105.782 148.652C105.297 148.372 104.838 147.884 104.488 147.281C104.141 146.675 103.948 146.034 103.948 145.473C103.948 145.005 104.083 144.652 104.33 144.473C104.33 144.473 104.33 144.473 104.33 144.472C104.351 144.459 104.369 144.445 104.388 144.437C104.395 144.432 104.401 144.429 104.406 144.425L105.681 143.689L105.684 143.693C105.691 143.689 105.698 143.684 105.705 143.682C105.838 143.624 105.99 143.61 106.159 143.635C106.341 143.66 106.542 143.734 106.751 143.856C106.764 143.863 106.774 143.868 106.786 143.878C107.173 144.108 107.54 144.469 107.847 144.914C107.914 145.015 107.981 145.119 108.044 145.226C108.392 145.83 108.585 146.471 108.585 147.034Z",
    fill: "#F0F7FA"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M106.802 145.945C106.452 145.34 105.994 144.853 105.508 144.573C105.069 144.321 104.671 144.271 104.387 144.436C104.103 144.599 103.946 144.968 103.946 145.474C103.946 146.035 104.139 146.676 104.488 147.28C104.837 147.885 105.296 148.372 105.781 148.652C106.22 148.904 106.618 148.955 106.903 148.79C107.185 148.626 107.342 148.256 107.342 147.751C107.343 147.19 107.152 146.549 106.802 145.945Z",
    fill: "#F0F7FA"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.231 145.617C105.982 145.185 105.656 144.838 105.306 144.636C104.994 144.457 104.71 144.421 104.508 144.539C104.303 144.656 104.193 144.921 104.193 145.281C104.193 145.683 104.329 146.14 104.579 146.57C104.827 147.003 105.156 147.35 105.503 147.549C105.815 147.73 106.101 147.767 106.304 147.649C106.506 147.531 106.618 147.27 106.618 146.908C106.618 146.509 106.481 146.048 106.231 145.617Z",
    fill: "white"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.158 143.635C106.158 143.635 104.952 144.295 104.858 144.348C104.677 144.339 104.507 144.354 104.329 144.473C104.612 144.303 105.042 144.063 105.705 143.681C105.836 143.623 105.989 143.61 106.158 143.635Z",
    fill: "white"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.847 144.916C107.372 145.212 106.848 145.536 106.619 145.672C106.443 145.394 105.924 144.871 105.597 144.628L106.786 143.879C107.172 144.109 107.539 144.47 107.847 144.916Z",
    fill: "white"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.476 147.666C108.406 147.84 108.301 147.974 108.164 148.057C108.067 148.114 107.967 148.172 107.864 148.233C107.833 148.251 107.803 148.269 107.775 148.285C107.685 148.335 107.594 148.388 107.511 148.436C107.426 148.485 107.347 148.532 107.275 148.574C107.228 148.602 107.181 148.627 107.142 148.652C107.025 148.719 106.941 148.768 106.913 148.785C107.009 148.726 107.098 148.64 107.154 148.543C107.183 148.496 107.206 148.442 107.232 148.394L108.476 147.666Z",
    fill: "white"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M111.103 148.381C111.103 147.109 111.995 146.593 113.097 147.23C114.199 147.865 115.094 149.412 115.094 150.684C115.094 151.958 114.199 152.473 113.097 151.837C111.995 151.202 111.103 149.654 111.103 148.381Z",
    fill: "#F0F7FA"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M114.45 148.754C114.82 149.396 115.024 150.082 115.024 150.684C115.022 151.276 114.828 151.713 114.473 151.918C114.118 152.122 113.643 152.072 113.132 151.778C112.61 151.475 112.117 150.955 111.746 150.314C111.375 149.671 111.171 148.985 111.171 148.381C111.171 147.792 111.366 147.353 111.721 147.15C112.075 146.945 112.552 146.994 113.064 147.29C113.587 147.592 114.078 148.111 114.45 148.754Z",
    fill: "url(#paint189_linear_3744_1590)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M113.988 151.704C113.787 151.704 113.549 151.627 113.302 151.485C112.829 151.211 112.382 150.736 112.041 150.143C111.697 149.553 111.511 148.927 111.509 148.381C111.509 147.917 111.644 147.585 111.891 147.443C111.98 147.391 112.086 147.363 112.206 147.363C112.408 147.363 112.646 147.438 112.894 147.582C113.366 147.856 113.812 148.331 114.154 148.922C114.496 149.515 114.684 150.141 114.684 150.684C114.684 151.15 114.55 151.483 114.304 151.624C114.214 151.677 114.109 151.704 113.988 151.704Z",
    fill: "#9FA1A3"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M111.13 148.731L111.569 148.477C111.567 148.499 111.567 148.525 111.567 148.549C111.567 149.043 111.736 149.61 112.045 150.142C112.353 150.677 112.758 151.105 113.186 151.352C113.208 151.366 113.229 151.375 113.25 151.386L112.826 151.633L113.093 152.099L114.22 151.449L114.219 151.447C114.441 151.29 114.565 150.978 114.565 150.557C114.565 150.062 114.394 149.496 114.087 148.963C113.778 148.43 113.373 148 112.945 147.754C112.56 147.53 112.209 147.485 111.956 147.632L110.86 148.265L111.13 148.731Z",
    fill: "url(#paint190_linear_3744_1590)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M112.991 149.595C113.297 150.13 113.468 150.695 113.468 151.19C113.468 151.635 113.329 151.962 113.078 152.106C112.827 152.251 112.476 152.209 112.089 151.985C111.662 151.739 111.253 151.308 110.948 150.775C110.639 150.242 110.47 149.675 110.47 149.18C110.47 148.735 110.608 148.409 110.858 148.264C111.11 148.119 111.461 148.162 111.846 148.386C112.277 148.632 112.683 149.062 112.991 149.595Z",
    fill: "url(#paint191_linear_3744_1590)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M112.811 149.699C113.065 150.138 113.204 150.605 113.204 151.014C113.204 151.382 113.091 151.651 112.884 151.771C112.676 151.89 112.387 151.854 112.066 151.67C111.716 151.466 111.381 151.112 111.126 150.673C110.872 150.233 110.732 149.766 110.732 149.358C110.732 148.988 110.846 148.72 111.052 148.6C111.26 148.481 111.55 148.517 111.868 148.702C112.225 148.904 112.558 149.258 112.811 149.699Z",
    fill: "url(#paint192_linear_3744_1590)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M111.267 148.851L112.792 151.495C112.807 151.516 112.799 151.545 112.777 151.558C112.756 151.568 112.727 151.563 112.715 151.541L111.188 148.896C111.175 148.875 111.182 148.846 111.202 148.834C111.227 148.822 111.254 148.829 111.267 148.851Z",
    fill: "#A8BAC1"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.781 150.681C114.781 150.926 114.743 151.142 114.673 151.313C114.602 151.487 114.498 151.622 114.361 151.706C114.355 151.712 114.346 151.715 114.338 151.72L114.06 151.881C114.031 151.898 114 151.915 113.971 151.933L113.707 152.085L113.47 152.222C113.424 152.25 113.377 152.275 113.338 152.298C113.222 152.367 113.137 152.416 113.109 152.431C113.107 152.433 113.107 152.433 113.106 152.435C113.104 152.435 113.1 152.437 113.098 152.438C112.815 152.603 112.415 152.553 111.978 152.298C111.494 152.019 111.033 151.532 110.684 150.928C110.337 150.323 110.144 149.684 110.144 149.121C110.144 148.651 110.278 148.299 110.525 148.119C110.525 148.119 110.525 148.119 110.526 148.118C110.545 148.105 110.565 148.094 110.583 148.082C110.59 148.079 110.595 148.077 110.601 148.073L111.875 147.336L111.879 147.339C111.886 147.336 111.893 147.333 111.901 147.332C112.033 147.272 112.185 147.255 112.354 147.282C112.538 147.308 112.737 147.381 112.947 147.502C112.959 147.509 112.97 147.516 112.981 147.524C113.367 147.756 113.737 148.116 114.043 148.563C114.11 148.661 114.176 148.765 114.238 148.873C114.588 149.477 114.781 150.119 114.781 150.681Z",
    fill: "#F0F7FA"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M112.997 149.592C112.648 148.989 112.191 148.5 111.705 148.219C111.266 147.967 110.867 147.917 110.585 148.082C110.302 148.246 110.144 148.617 110.144 149.122C110.144 149.684 110.336 150.323 110.684 150.928C111.033 151.531 111.492 152.018 111.978 152.298C112.415 152.553 112.815 152.602 113.098 152.438C113.384 152.272 113.54 151.905 113.54 151.398C113.54 150.838 113.347 150.196 112.997 149.592Z",
    fill: "#F0F7FA"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.428 149.266C112.179 148.835 111.851 148.488 111.504 148.287C111.191 148.107 110.904 148.072 110.704 148.189C110.502 148.304 110.388 148.568 110.39 148.931C110.39 149.331 110.525 149.789 110.775 150.221C111.023 150.652 111.352 150.999 111.698 151.2C112.012 151.38 112.296 151.416 112.499 151.298C112.703 151.182 112.815 150.918 112.815 150.555C112.815 150.156 112.677 149.698 112.428 149.266Z",
    fill: "white"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.354 147.282C112.354 147.282 111.149 147.942 111.053 147.996C110.874 147.985 110.704 148.001 110.525 148.118C110.809 147.95 111.238 147.711 111.901 147.331C112.033 147.272 112.185 147.255 112.354 147.282Z",
    fill: "white"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.044 148.564C113.57 148.858 113.045 149.184 112.815 149.321C112.639 149.041 112.123 148.518 111.794 148.274L112.981 147.525C113.367 147.756 113.737 148.117 114.044 148.564Z",
    fill: "white"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.673 151.312C114.601 151.487 114.497 151.622 114.36 151.705C114.263 151.762 114.161 151.822 114.06 151.881C114.031 151.897 114 151.914 113.971 151.932C113.881 151.983 113.791 152.037 113.707 152.084C113.622 152.133 113.541 152.179 113.47 152.221C113.424 152.249 113.377 152.274 113.338 152.298C113.222 152.367 113.137 152.415 113.109 152.431C113.203 152.374 113.294 152.288 113.348 152.191C113.377 152.145 113.403 152.09 113.426 152.043L114.673 151.312Z",
    fill: "white"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M104.906 151.499C104.906 150.225 105.799 149.711 106.903 150.347C108.002 150.983 108.897 152.53 108.896 153.803C108.897 155.076 108.002 155.59 106.903 154.954C105.799 154.318 104.906 152.77 104.906 151.499Z",
    fill: "#F0F7FA"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M108.254 151.87C108.623 152.512 108.827 153.199 108.827 153.804C108.827 154.394 108.632 154.831 108.277 155.035C107.923 155.24 107.447 155.191 106.936 154.895C106.413 154.594 105.922 154.073 105.55 153.433C105.179 152.789 104.976 152.103 104.976 151.499C104.976 150.909 105.171 150.471 105.525 150.267C105.879 150.062 106.356 150.112 106.867 150.406C107.39 150.707 107.881 151.229 108.254 151.87Z",
    fill: "url(#paint193_linear_3744_1590)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M107.792 154.82C107.591 154.82 107.353 154.745 107.106 154.601C106.633 154.329 106.186 153.854 105.844 153.26C105.503 152.67 105.315 152.044 105.315 151.498C105.315 151.034 105.449 150.701 105.695 150.561C105.786 150.508 105.892 150.48 106.011 150.48C106.212 150.48 106.45 150.556 106.698 150.7C107.17 150.971 107.618 151.446 107.959 152.04C108.301 152.63 108.491 153.256 108.491 153.803C108.491 154.266 108.354 154.599 108.109 154.742C108.018 154.793 107.912 154.82 107.792 154.82Z",
    fill: "#9FA1A3"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M104.934 151.848L105.374 151.593C105.372 151.616 105.37 151.642 105.37 151.666C105.37 152.161 105.54 152.726 105.848 153.258C106.156 153.792 106.562 154.222 106.99 154.47C107.012 154.482 107.032 154.494 107.053 154.504L106.63 154.749L106.899 155.217L108.024 154.567L108.023 154.564C108.247 154.409 108.368 154.095 108.368 153.672C108.369 153.178 108.2 152.613 107.892 152.08C107.584 151.547 107.179 151.118 106.75 150.87C106.363 150.647 106.012 150.603 105.762 150.749L104.665 151.382L104.934 151.848Z",
    fill: "url(#paint194_linear_3744_1590)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M106.794 152.713C107.103 153.247 107.271 153.812 107.271 154.307C107.271 154.753 107.134 155.079 106.882 155.225C106.63 155.369 106.28 155.326 105.891 155.102C105.464 154.856 105.059 154.426 104.751 153.892C104.442 153.358 104.273 152.793 104.273 152.298C104.273 151.852 104.412 151.527 104.662 151.382C104.913 151.236 105.266 151.279 105.652 151.503C106.08 151.749 106.486 152.181 106.794 152.713Z",
    fill: "url(#paint195_linear_3744_1590)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M106.615 152.815C106.868 153.254 107.009 153.721 107.009 154.13C107.009 154.498 106.895 154.768 106.688 154.887C106.48 155.005 106.191 154.969 105.871 154.786C105.518 154.581 105.183 154.228 104.93 153.788C104.675 153.349 104.535 152.881 104.535 152.473C104.535 152.105 104.65 151.836 104.856 151.716C105.063 151.596 105.354 151.633 105.671 151.816C106.028 152.021 106.361 152.376 106.615 152.815Z",
    fill: "url(#paint196_linear_3744_1590)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M105.071 151.968L106.597 154.614C106.609 154.634 106.602 154.662 106.58 154.674C106.559 154.686 106.532 154.678 106.52 154.657L104.992 152.013C104.978 151.992 104.986 151.964 105.007 151.952C105.03 151.939 105.057 151.946 105.071 151.968Z",
    fill: "#A8BAC1"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.585 153.799C108.585 154.044 108.548 154.258 108.476 154.431C108.406 154.605 108.301 154.738 108.164 154.823C108.158 154.829 108.15 154.833 108.143 154.837L107.864 154.999C107.833 155.015 107.803 155.034 107.775 155.05L107.511 155.201L107.275 155.339C107.228 155.367 107.181 155.393 107.142 155.417C107.025 155.484 106.941 155.533 106.913 155.548C106.911 155.55 106.911 155.55 106.91 155.552C106.908 155.552 106.905 155.555 106.904 155.557C106.619 155.72 106.22 155.67 105.782 155.417C105.297 155.137 104.838 154.649 104.488 154.047C104.141 153.44 103.948 152.8 103.948 152.238C103.948 151.767 104.083 151.417 104.33 151.237C104.33 151.237 104.33 151.237 104.33 151.236C104.351 151.223 104.369 151.21 104.388 151.201C104.395 151.197 104.401 151.194 104.406 151.19L105.681 150.453L105.684 150.456C105.691 150.453 105.698 150.449 105.705 150.448C105.838 150.388 105.99 150.373 106.159 150.398C106.341 150.424 106.542 150.499 106.751 150.62C106.764 150.628 106.774 150.633 106.786 150.643C107.173 150.873 107.54 151.233 107.847 151.68C107.914 151.78 107.981 151.882 108.044 151.991C108.392 152.594 108.585 153.236 108.585 153.799Z",
    fill: "#F0F7FA"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M106.802 152.708C106.452 152.105 105.994 151.616 105.508 151.337C105.069 151.085 104.671 151.034 104.387 151.199C104.103 151.363 103.946 151.732 103.946 152.239C103.946 152.8 104.139 153.44 104.488 154.045C104.837 154.649 105.296 155.136 105.781 155.417C106.22 155.669 106.618 155.719 106.903 155.555C107.185 155.391 107.342 155.02 107.342 154.515C107.343 153.953 107.152 153.313 106.802 152.708Z",
    fill: "#F0F7FA"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.231 152.385C105.982 151.953 105.656 151.607 105.306 151.404C104.994 151.225 104.71 151.189 104.508 151.307C104.303 151.424 104.193 151.687 104.193 152.049C104.193 152.451 104.329 152.908 104.579 153.339C104.827 153.77 105.156 154.118 105.503 154.317C105.815 154.499 106.101 154.534 106.304 154.415C106.506 154.299 106.618 154.036 106.618 153.673C106.618 153.274 106.481 152.815 106.231 152.385Z",
    fill: "white"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.158 150.398C106.158 150.398 104.952 151.06 104.858 151.113C104.677 151.103 104.507 151.118 104.329 151.237C104.612 151.068 105.042 150.827 105.705 150.447C105.836 150.388 105.989 150.373 106.158 150.398Z",
    fill: "white"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.847 151.681C107.372 151.976 106.848 152.3 106.619 152.437C106.443 152.158 105.924 151.635 105.597 151.392L106.786 150.645C107.172 150.874 107.539 151.235 107.847 151.681Z",
    fill: "white"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.476 154.432C108.406 154.605 108.301 154.738 108.164 154.824C108.067 154.879 107.967 154.939 107.864 154.999C107.833 155.015 107.803 155.034 107.775 155.051C107.685 155.101 107.594 155.153 107.511 155.202C107.426 155.252 107.347 155.297 107.275 155.339C107.228 155.368 107.181 155.393 107.142 155.418C107.025 155.484 106.941 155.534 106.913 155.548C107.009 155.492 107.098 155.405 107.154 155.309C107.183 155.263 107.206 155.209 107.232 155.16L108.476 154.432Z",
    fill: "white"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M111.103 155.144C111.103 153.872 111.995 153.355 113.097 153.991C114.199 154.627 115.094 156.175 115.094 157.446C115.094 158.719 114.199 159.236 113.097 158.599C111.995 157.964 111.103 156.417 111.103 155.144Z",
    fill: "#F0F7FA"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M114.45 155.516C114.82 156.158 115.024 156.843 115.024 157.447C115.022 158.038 114.828 158.475 114.473 158.679C114.118 158.885 113.643 158.834 113.132 158.539C112.61 158.237 112.117 157.718 111.746 157.075C111.375 156.433 111.171 155.747 111.171 155.144C111.171 154.554 111.366 154.116 111.721 153.911C112.075 153.707 112.552 153.756 113.064 154.052C113.587 154.353 114.078 154.873 114.45 155.516Z",
    fill: "url(#paint197_linear_3744_1590)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M113.988 158.465C113.787 158.465 113.549 158.389 113.302 158.247C112.829 157.975 112.382 157.497 112.041 156.906C111.697 156.313 111.511 155.689 111.509 155.143C111.509 154.678 111.644 154.345 111.891 154.204C111.98 154.152 112.086 154.125 112.206 154.125C112.408 154.125 112.646 154.2 112.894 154.343C113.366 154.616 113.812 155.092 114.154 155.683C114.496 156.276 114.684 156.903 114.684 157.446C114.684 157.911 114.55 158.245 114.304 158.386C114.214 158.44 114.109 158.465 113.988 158.465Z",
    fill: "#9FA1A3"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M111.13 155.491L111.569 155.239C111.567 155.261 111.567 155.286 111.567 155.311C111.567 155.804 111.736 156.371 112.045 156.903C112.353 157.437 112.758 157.866 113.186 158.114C113.208 158.127 113.229 158.138 113.25 158.148L112.826 158.393L113.093 158.861L114.22 158.211L114.219 158.208C114.441 158.051 114.565 157.738 114.565 157.32C114.565 156.823 114.394 156.258 114.087 155.725C113.778 155.192 113.373 154.762 112.945 154.514C112.56 154.292 112.209 154.247 111.956 154.393L110.86 155.027L111.13 155.491Z",
    fill: "url(#paint198_linear_3744_1590)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M112.991 156.356C113.297 156.889 113.468 157.457 113.468 157.951C113.468 158.397 113.329 158.724 113.078 158.868C112.827 159.013 112.476 158.969 112.089 158.747C111.662 158.5 111.253 158.069 110.948 157.537C110.639 157.004 110.47 156.437 110.47 155.941C110.47 155.496 110.608 155.171 110.858 155.026C111.11 154.881 111.461 154.923 111.846 155.146C112.277 155.394 112.683 155.823 112.991 156.356Z",
    fill: "url(#paint199_linear_3744_1590)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M112.811 156.46C113.065 156.901 113.204 157.366 113.204 157.775C113.204 158.146 113.091 158.413 112.884 158.531C112.676 158.651 112.387 158.616 112.066 158.431C111.716 158.228 111.381 157.873 111.126 157.435C110.872 156.995 110.732 156.528 110.732 156.12C110.732 155.75 110.846 155.482 111.052 155.363C111.26 155.243 111.55 155.278 111.868 155.463C112.225 155.666 112.558 156.02 112.811 156.46Z",
    fill: "url(#paint200_linear_3744_1590)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M111.267 155.612L112.792 158.258C112.807 158.279 112.799 158.308 112.777 158.32C112.756 158.331 112.727 158.324 112.715 158.303L111.188 155.659C111.175 155.638 111.182 155.609 111.202 155.596C111.227 155.583 111.254 155.591 111.267 155.612Z",
    fill: "#A8BAC1"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.781 157.444C114.781 157.686 114.743 157.902 114.673 158.074C114.602 158.25 114.498 158.383 114.361 158.467C114.355 158.473 114.346 158.477 114.338 158.481L114.06 158.642C114.031 158.66 114 158.677 113.971 158.693L113.707 158.845L113.47 158.982C113.424 159.01 113.377 159.036 113.338 159.06C113.222 159.129 113.137 159.175 113.109 159.193C113.107 159.194 113.107 159.194 113.106 159.196C113.104 159.196 113.1 159.197 113.098 159.199C112.815 159.363 112.415 159.314 111.978 159.06C111.494 158.78 111.033 158.293 110.684 157.689C110.337 157.084 110.144 156.443 110.144 155.881C110.144 155.412 110.278 155.06 110.525 154.881C110.525 154.881 110.525 154.881 110.526 154.879C110.545 154.866 110.565 154.855 110.583 154.844C110.59 154.841 110.595 154.837 110.601 154.834L111.875 154.097L111.879 154.1C111.886 154.097 111.893 154.095 111.901 154.092C112.033 154.034 112.185 154.017 112.354 154.043C112.538 154.068 112.737 154.144 112.947 154.264C112.959 154.271 112.97 154.278 112.981 154.286C113.367 154.517 113.737 154.877 114.043 155.324C114.11 155.424 114.176 155.527 114.238 155.635C114.588 156.239 114.781 156.882 114.781 157.444Z",
    fill: "#F0F7FA"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M112.997 156.354C112.648 155.749 112.191 155.262 111.705 154.981C111.266 154.729 110.867 154.679 110.585 154.843C110.302 155.008 110.144 155.378 110.144 155.882C110.144 156.444 110.336 157.084 110.684 157.689C111.033 158.292 111.492 158.781 111.978 159.06C112.415 159.314 112.815 159.363 113.098 159.199C113.384 159.033 113.54 158.666 113.54 158.159C113.54 157.599 113.347 156.956 112.997 156.354Z",
    fill: "#F0F7FA"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.428 156.027C112.179 155.597 111.851 155.249 111.504 155.05C111.191 154.869 110.904 154.834 110.704 154.951C110.502 155.066 110.388 155.331 110.39 155.692C110.39 156.094 110.525 156.551 110.775 156.983C111.023 157.415 111.352 157.762 111.698 157.962C112.012 158.142 112.296 158.178 112.499 158.061C112.703 157.944 112.815 157.681 112.815 157.318C112.815 156.918 112.677 156.46 112.428 156.027Z",
    fill: "white"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.354 154.043C112.354 154.043 111.149 154.703 111.053 154.758C110.874 154.748 110.704 154.763 110.525 154.881C110.809 154.712 111.238 154.474 111.901 154.092C112.033 154.034 112.185 154.017 112.354 154.043Z",
    fill: "white"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.044 155.324C113.57 155.62 113.045 155.944 112.815 156.078C112.639 155.8 112.123 155.278 111.794 155.034L112.981 154.285C113.367 154.517 113.737 154.877 114.044 155.324Z",
    fill: "white"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.673 158.074C114.601 158.25 114.497 158.383 114.36 158.467C114.263 158.523 114.161 158.583 114.06 158.642C114.031 158.66 114 158.677 113.971 158.693C113.881 158.744 113.791 158.797 113.707 158.845C113.622 158.894 113.541 158.94 113.47 158.982C113.424 159.009 113.377 159.036 113.338 159.06C113.222 159.128 113.137 159.175 113.109 159.193C113.203 159.134 113.294 159.049 113.348 158.951C113.377 158.908 113.403 158.852 113.426 158.804L114.673 158.074Z",
    fill: "white"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M104.906 158.262C104.906 156.988 105.799 156.473 106.903 157.108C108.002 157.745 108.897 159.292 108.896 160.563C108.897 161.837 108.002 162.352 106.903 161.716C105.799 161.08 104.906 159.533 104.906 158.262Z",
    fill: "#F0F7FA"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M108.254 158.633C108.623 159.274 108.827 159.96 108.827 160.564C108.827 161.154 108.632 161.592 108.277 161.797C107.923 162.001 107.447 161.95 106.936 161.656C106.413 161.354 105.922 160.834 105.55 160.193C105.179 159.55 104.976 158.863 104.976 158.262C104.976 157.671 105.171 157.232 105.525 157.029C105.879 156.823 106.356 156.874 106.867 157.168C107.39 157.47 107.881 157.989 108.254 158.633Z",
    fill: "url(#paint201_linear_3744_1590)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M107.792 161.582C107.591 161.582 107.353 161.508 107.106 161.365C106.633 161.092 106.186 160.616 105.844 160.025C105.503 159.433 105.315 158.808 105.315 158.263C105.315 157.798 105.449 157.465 105.695 157.323C105.786 157.271 105.892 157.244 106.011 157.244C106.212 157.244 106.45 157.319 106.698 157.463C107.17 157.735 107.618 158.21 107.959 158.802C108.301 159.394 108.491 160.02 108.491 160.565C108.491 161.03 108.354 161.363 108.109 161.506C108.018 161.557 107.912 161.582 107.792 161.582Z",
    fill: "#9FA1A3"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M104.934 158.61L105.374 158.355C105.372 158.38 105.37 158.404 105.37 158.429C105.37 158.924 105.54 159.489 105.848 160.022C106.156 160.555 106.562 160.985 106.99 161.233C107.012 161.245 107.032 161.256 107.053 161.266L106.63 161.512L106.899 161.979L108.024 161.329L108.023 161.328C108.247 161.169 108.368 160.856 108.368 160.436C108.369 159.941 108.2 159.376 107.892 158.842C107.584 158.31 107.179 157.879 106.75 157.632C106.363 157.408 106.012 157.365 105.762 157.51L104.665 158.144L104.934 158.61Z",
    fill: "url(#paint202_linear_3744_1590)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M106.794 159.475C107.103 160.008 107.271 160.574 107.271 161.069C107.271 161.516 107.134 161.841 106.882 161.986C106.63 162.131 106.28 162.087 105.891 161.864C105.464 161.618 105.059 161.187 104.751 160.655C104.442 160.121 104.273 159.555 104.273 159.06C104.273 158.613 104.412 158.288 104.662 158.143C104.913 157.998 105.266 158.041 105.652 158.264C106.08 158.512 106.486 158.941 106.794 159.475Z",
    fill: "url(#paint203_linear_3744_1590)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M106.615 159.578C106.868 160.018 107.009 160.483 107.009 160.892C107.009 161.262 106.895 161.531 106.688 161.65C106.48 161.769 106.191 161.733 105.871 161.549C105.518 161.345 105.183 160.991 104.93 160.552C104.675 160.113 104.535 159.645 104.535 159.237C104.535 158.867 104.65 158.599 104.856 158.479C105.063 158.36 105.354 158.396 105.671 158.58C106.028 158.783 106.361 159.139 106.615 159.578Z",
    fill: "url(#paint204_linear_3744_1590)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M105.071 158.729L106.597 161.374C106.609 161.396 106.602 161.423 106.58 161.436C106.559 161.45 106.532 161.439 106.52 161.418L104.992 158.775C104.978 158.753 104.986 158.726 105.007 158.714C105.03 158.7 105.057 158.708 105.071 158.729Z",
    fill: "#A8BAC1"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M108.585 160.56C108.585 160.806 108.548 161.02 108.476 161.194C108.406 161.367 108.301 161.501 108.164 161.585C108.158 161.59 108.15 161.595 108.143 161.599L107.864 161.759C107.833 161.776 107.803 161.795 107.775 161.812L107.511 161.963L107.275 162.099C107.228 162.129 107.181 162.155 107.142 162.179C107.025 162.247 106.941 162.294 106.913 162.31C106.911 162.312 106.911 162.312 106.91 162.313C106.908 162.313 106.905 162.315 106.904 162.318C106.619 162.481 106.22 162.431 105.782 162.179C105.297 161.898 104.838 161.411 104.488 160.807C104.141 160.202 103.948 159.561 103.948 159C103.948 158.529 104.083 158.178 104.33 158C104.33 158 104.33 158 104.33 157.998C104.351 157.984 104.369 157.971 104.388 157.963C104.395 157.959 104.401 157.954 104.406 157.952L105.681 157.215L105.684 157.218C105.691 157.215 105.698 157.21 105.705 157.209C105.838 157.15 105.99 157.135 106.159 157.16C106.341 157.184 106.542 157.259 106.751 157.383C106.764 157.388 106.774 157.395 106.786 157.404C107.173 157.635 107.54 157.995 107.847 158.442C107.914 158.541 107.981 158.644 108.044 158.752C108.392 159.357 108.585 159.999 108.585 160.56Z",
    fill: "#F0F7FA"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M106.802 159.47C106.452 158.866 105.994 158.378 105.508 158.098C105.069 157.845 104.671 157.797 104.387 157.961C104.103 158.124 103.946 158.494 103.946 158.999C103.946 159.561 104.139 160.202 104.488 160.806C104.837 161.41 105.296 161.897 105.781 162.178C106.22 162.43 106.618 162.48 106.903 162.316C107.185 162.152 107.342 161.781 107.342 161.275C107.343 160.715 107.152 160.073 106.802 159.47Z",
    fill: "#F0F7FA"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.231 159.144C105.982 158.713 105.656 158.365 105.306 158.165C104.994 157.985 104.71 157.949 104.508 158.065C104.303 158.184 104.193 158.446 104.193 158.808C104.193 159.21 104.329 159.667 104.579 160.099C104.827 160.531 105.156 160.879 105.503 161.078C105.815 161.26 106.101 161.294 106.304 161.176C106.506 161.059 106.618 160.797 106.618 160.434C106.618 160.034 106.481 159.575 106.231 159.144Z",
    fill: "white"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.158 157.16C106.158 157.16 104.952 157.821 104.858 157.875C104.677 157.866 104.507 157.88 104.329 158C104.612 157.83 105.042 157.589 105.705 157.208C105.836 157.15 105.989 157.135 106.158 157.16Z",
    fill: "white"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.847 158.443C107.372 158.736 106.848 159.062 106.619 159.197C106.443 158.918 105.924 158.397 105.597 158.152L106.786 157.404C107.172 157.634 107.539 157.995 107.847 158.443Z",
    fill: "white"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M108.476 161.193C108.406 161.366 108.301 161.5 108.164 161.585C108.067 161.639 107.967 161.7 107.864 161.758C107.833 161.776 107.803 161.794 107.775 161.812C107.685 161.863 107.594 161.915 107.511 161.963C107.426 162.013 107.347 162.057 107.275 162.099C107.228 162.129 107.181 162.154 107.142 162.179C107.025 162.246 106.941 162.294 106.913 162.309C107.009 162.252 107.098 162.165 107.154 162.069C107.183 162.025 107.206 161.97 107.232 161.92L108.476 161.193Z",
    fill: "white"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M111.103 161.905C111.103 160.636 111.995 160.118 113.097 160.755C114.199 161.389 115.094 162.938 115.094 164.209C115.094 165.483 114.199 165.999 113.097 165.364C111.995 164.728 111.103 163.178 111.103 161.905Z",
    fill: "#F0F7FA"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M114.45 162.279C114.82 162.923 115.024 163.607 115.024 164.21C115.022 164.802 114.828 165.239 114.473 165.444C114.118 165.649 113.643 165.598 113.132 165.303C112.61 165.001 112.117 164.481 111.746 163.84C111.375 163.197 111.171 162.511 111.171 161.905C111.171 161.318 111.366 160.88 111.721 160.674C112.075 160.47 112.552 160.521 113.064 160.815C113.587 161.117 114.078 161.637 114.45 162.279Z",
    fill: "url(#paint205_linear_3744_1590)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M113.988 165.23C113.787 165.23 113.549 165.152 113.302 165.009C112.829 164.737 112.382 164.261 112.041 163.67C111.697 163.078 111.511 162.452 111.509 161.905C111.509 161.443 111.644 161.109 111.891 160.968C111.98 160.916 112.086 160.889 112.206 160.889C112.408 160.889 112.646 160.965 112.894 161.106C113.366 161.379 113.812 161.855 114.154 162.448C114.496 163.041 114.684 163.667 114.684 164.209C114.684 164.673 114.55 165.008 114.304 165.149C114.214 165.202 114.109 165.23 113.988 165.23Z",
    fill: "#9FA1A3"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M111.13 162.254L111.569 162.001C111.567 162.025 111.567 162.05 111.567 162.072C111.567 162.567 111.736 163.135 112.045 163.667C112.353 164.2 112.758 164.63 113.186 164.877C113.208 164.888 113.229 164.901 113.25 164.911L112.826 165.157L113.093 165.623L114.22 164.973L114.219 164.971C114.441 164.816 114.565 164.502 114.565 164.083C114.565 163.587 114.394 163.022 114.087 162.487C113.778 161.955 113.373 161.525 112.945 161.277C112.56 161.055 112.209 161.012 111.956 161.156L110.86 161.789L111.13 162.254Z",
    fill: "url(#paint206_linear_3744_1590)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M112.991 163.121C113.297 163.654 113.468 164.221 113.468 164.715C113.468 165.162 113.329 165.487 113.078 165.631C112.827 165.777 112.476 165.733 112.089 165.51C111.662 165.264 111.253 164.833 110.948 164.3C110.639 163.766 110.47 163.202 110.47 162.706C110.47 162.26 110.608 161.934 110.858 161.789C111.11 161.645 111.461 161.687 111.846 161.911C112.277 162.159 112.683 162.588 112.991 163.121Z",
    fill: "url(#paint207_linear_3744_1590)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M112.811 163.221C113.065 163.662 113.204 164.128 113.204 164.536C113.204 164.906 113.091 165.173 112.884 165.295C112.676 165.414 112.387 165.378 112.066 165.193C111.716 164.989 111.381 164.635 111.126 164.197C110.872 163.756 110.732 163.29 110.732 162.88C110.732 162.512 110.846 162.243 111.052 162.124C111.26 162.004 111.55 162.04 111.868 162.224C112.225 162.428 112.558 162.782 112.811 163.221Z",
    fill: "url(#paint208_linear_3744_1590)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M111.267 162.376L112.792 165.019C112.807 165.041 112.799 165.069 112.777 165.083C112.756 165.094 112.727 165.087 112.715 165.066L111.188 162.42C111.175 162.4 111.182 162.373 111.202 162.36C111.227 162.347 111.254 162.355 111.267 162.376Z",
    fill: "#A8BAC1"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M114.781 164.206C114.781 164.452 114.743 164.667 114.673 164.838C114.602 165.014 114.498 165.148 114.361 165.232C114.355 165.236 114.346 165.24 114.338 165.246L114.06 165.405C114.031 165.423 114 165.44 113.971 165.457L113.707 165.61L113.47 165.746C113.424 165.775 113.377 165.8 113.338 165.825C113.222 165.892 113.137 165.942 113.109 165.957C113.107 165.959 113.107 165.959 113.106 165.961C113.104 165.961 113.1 165.962 113.098 165.963C112.815 166.127 112.415 166.079 111.978 165.825C111.494 165.545 111.033 165.057 110.684 164.453C110.337 163.848 110.144 163.208 110.144 162.645C110.144 162.177 110.278 161.824 110.525 161.646C110.525 161.646 110.525 161.646 110.526 161.644C110.545 161.63 110.565 161.619 110.583 161.607C110.59 161.604 110.595 161.601 110.601 161.598L111.875 160.859L111.879 160.864C111.886 160.859 111.893 160.857 111.901 160.856C112.033 160.798 112.185 160.781 112.354 160.806C112.538 160.832 112.737 160.906 112.947 161.029C112.959 161.035 112.97 161.042 112.981 161.05C113.367 161.281 113.737 161.641 114.043 162.087C114.11 162.187 114.176 162.29 114.238 162.399C114.588 163.003 114.781 163.645 114.781 164.206Z",
    fill: "#F0F7FA"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M112.997 163.118C112.648 162.513 112.191 162.026 111.705 161.745C111.266 161.493 110.867 161.443 110.585 161.606C110.302 161.771 110.144 162.141 110.144 162.646C110.144 163.208 110.336 163.848 110.684 164.452C111.033 165.056 111.492 165.545 111.978 165.823C112.415 166.077 112.815 166.127 113.098 165.962C113.384 165.797 113.54 165.429 113.54 164.922C113.54 164.363 113.347 163.723 112.997 163.118Z",
    fill: "#F0F7FA"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.428 162.79C112.179 162.359 111.851 162.011 111.504 161.812C111.191 161.63 110.904 161.596 110.704 161.712C110.502 161.828 110.388 162.093 110.39 162.455C110.39 162.855 110.525 163.314 110.775 163.743C111.023 164.176 111.352 164.524 111.698 164.725C112.012 164.905 112.296 164.941 112.499 164.823C112.703 164.707 112.815 164.442 112.815 164.081C112.815 163.68 112.677 163.221 112.428 162.79Z",
    fill: "white"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.354 160.806C112.354 160.806 111.149 161.466 111.053 161.52C110.874 161.512 110.704 161.527 110.525 161.645C110.809 161.477 111.238 161.237 111.901 160.855C112.033 160.798 112.185 160.781 112.354 160.806Z",
    fill: "white"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.044 162.088C113.57 162.384 113.045 162.709 112.815 162.845C112.639 162.565 112.123 162.042 111.794 161.8L112.981 161.051C113.367 161.282 113.737 161.642 114.044 162.088Z",
    fill: "white"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M114.673 164.838C114.601 165.013 114.497 165.148 114.36 165.232C114.263 165.286 114.161 165.346 114.06 165.405C114.031 165.423 114 165.44 113.971 165.456C113.881 165.508 113.791 165.56 113.707 165.61C113.622 165.657 113.541 165.703 113.47 165.746C113.424 165.775 113.377 165.8 113.338 165.825C113.222 165.892 113.137 165.941 113.109 165.957C113.203 165.898 113.294 165.812 113.348 165.715C113.377 165.67 113.403 165.617 113.426 165.568L114.673 164.838Z",
    fill: "white"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M114.956 156.949V185.451C114.956 185.488 114.953 185.524 114.949 185.558C114.943 185.611 114.933 185.657 114.915 185.702C114.866 185.848 114.769 185.938 114.644 185.97C114.609 185.98 114.574 185.983 114.535 185.983C114.437 185.98 114.327 185.948 114.211 185.883L101.224 178.383C101.118 178.323 101.018 178.238 100.928 178.14C100.755 177.955 100.618 177.714 100.543 177.473C100.503 177.346 100.48 177.218 100.48 177.094V148.595C100.48 148.572 100.481 148.548 100.484 148.528C100.488 148.471 100.495 148.419 100.511 148.373C100.554 148.222 100.646 148.121 100.769 148.084C100.802 148.073 100.838 148.064 100.874 148.063C100.978 148.06 101.099 148.093 101.225 148.165L114.212 155.662C114.623 155.899 114.956 156.475 114.956 156.949Z",
    fill: "white"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 157.091V185.593C114.813 185.629 114.808 185.666 114.806 185.701C114.8 185.754 114.788 185.802 114.773 185.845C114.722 185.99 114.626 186.083 114.501 186.113C114.468 186.123 114.432 186.126 114.394 186.126C114.295 186.123 114.186 186.09 114.069 186.025L101.082 178.527C100.977 178.465 100.876 178.382 100.787 178.284C100.614 178.098 100.475 177.858 100.402 177.615C100.362 177.49 100.339 177.361 100.339 177.24V148.738C100.339 148.713 100.341 148.691 100.342 148.672C100.346 148.615 100.354 148.562 100.37 148.518C100.413 148.364 100.504 148.264 100.627 148.227C100.66 148.216 100.695 148.209 100.731 148.208C100.835 148.202 100.956 148.235 101.082 148.308L114.068 155.805C114.479 156.04 114.813 156.619 114.813 157.091Z",
    fill: "url(#paint209_linear_3744_1590)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 157.603V157.804L113.451 155.445L113.625 155.545L114.813 157.603Z",
    fill: "#B6BCC1"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 158.541V158.743L112.638 154.977L112.812 155.078L114.813 158.541Z",
    fill: "#B6BCC1"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 159.479V159.681L111.827 154.51L112.001 154.612L114.813 159.479Z",
    fill: "#B6BCC1"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 160.415V160.617L111.016 154.041L111.191 154.143L114.813 160.415Z",
    fill: "#B6BCC1"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 161.353V161.554L110.202 153.572L110.378 153.673L114.813 161.353Z",
    fill: "#B6BCC1"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 162.289V162.492L109.393 153.105L109.568 153.206L114.813 162.289Z",
    fill: "#B6BCC1"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 163.227V163.43L108.582 152.637L108.756 152.738L114.813 163.227Z",
    fill: "#B6BCC1"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 164.163V164.367L107.771 152.168L107.944 152.268L114.813 164.163Z",
    fill: "#B6BCC1"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 165.1V165.302L106.957 151.697L107.134 151.799L114.813 165.1Z",
    fill: "#B6BCC1"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 166.035V166.241L106.147 151.23L106.323 151.331L114.813 166.035Z",
    fill: "#B6BCC1"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 166.973V167.175L105.336 150.762L105.51 150.863L114.813 166.973Z",
    fill: "#B6BCC1"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 167.91V168.113L104.524 150.293L104.701 150.394L114.813 167.91Z",
    fill: "#B6BCC1"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 168.848V169.05L103.712 149.826L103.888 149.926L114.813 168.848Z",
    fill: "#B6BCC1"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 169.784V169.989L102.901 149.357L103.077 149.458L114.813 169.784Z",
    fill: "#B6BCC1"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 170.72V170.924L102.091 148.889L102.265 148.99L114.813 170.72Z",
    fill: "#B6BCC1"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 171.658V171.86L101.277 148.418L101.454 148.521L114.813 171.658Z",
    fill: "#B6BCC1"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 172.596V172.798L100.626 148.227C100.659 148.215 100.694 148.209 100.73 148.207L114.813 172.596Z",
    fill: "#B6BCC1"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 173.532V173.734L100.341 148.672C100.345 148.615 100.353 148.562 100.369 148.518L114.813 173.532Z",
    fill: "#B6BCC1"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 174.47V174.671L100.337 149.604V149.4L114.813 174.47Z",
    fill: "#B6BCC1"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 175.404V175.608L100.337 150.538V150.334L114.813 175.404Z",
    fill: "#B6BCC1"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 176.342V176.543L100.337 151.475V151.273L114.813 176.342Z",
    fill: "#B6BCC1"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 177.281V177.481L100.337 152.413V152.211L114.813 177.281Z",
    fill: "#B6BCC1"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 178.217V178.421L100.337 153.35V153.148L114.813 178.217Z",
    fill: "#B6BCC1"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 179.152V179.356L100.337 154.284V154.082L114.813 179.152Z",
    fill: "#B6BCC1"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 180.091V180.293L100.337 155.223V155.023L114.813 180.091Z",
    fill: "#B6BCC1"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 181.026V181.227L100.337 156.161V155.957L114.813 181.026Z",
    fill: "#B6BCC1"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 181.963V182.167L100.337 157.098V156.893L114.813 181.963Z",
    fill: "#B6BCC1"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 182.902V183.104L100.337 158.033V157.832L114.813 182.902Z",
    fill: "#B6BCC1"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 183.839V184.04L100.337 158.969V158.768L114.813 183.839Z",
    fill: "#B6BCC1"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M114.813 184.775V184.978L100.337 159.909V159.705L114.813 184.775Z",
    fill: "#B6BCC1"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M114.806 185.702C114.8 185.754 114.788 185.803 114.773 185.845L100.338 160.847V160.643L114.806 185.702Z",
    fill: "#B6BCC1"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M114.5 186.112C114.467 186.121 114.431 186.125 114.393 186.125L100.337 161.78V161.58L114.5 186.112Z",
    fill: "#B6BCC1"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M113.829 185.887L113.654 185.784L100.337 162.72V162.518L113.829 185.887Z",
    fill: "#B6BCC1"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M113.02 185.417L112.844 185.317L100.337 163.656V163.453L113.02 185.417Z",
    fill: "#B6BCC1"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M112.209 184.949L112.031 184.848L100.337 164.591V164.389L112.209 184.949Z",
    fill: "#B6BCC1"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M111.396 184.48L111.222 184.38L100.337 165.529V165.328L111.396 184.48Z",
    fill: "#B6BCC1"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M110.585 184.012L110.409 183.911L100.337 166.466V166.266L110.585 184.012Z",
    fill: "#B6BCC1"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M109.773 183.543L109.598 183.443L100.337 167.402V167.201L109.773 183.543Z",
    fill: "#B6BCC1"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M108.961 183.074L108.786 182.973L100.337 168.34V168.139L108.961 183.074Z",
    fill: "#B6BCC1"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M108.15 182.606L107.976 182.504L100.337 169.278V169.074L108.15 182.606Z",
    fill: "#B6BCC1"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M107.34 182.139L107.165 182.037L100.337 170.215V170.012L107.34 182.139Z",
    fill: "#B6BCC1"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M106.527 181.67L106.353 181.57L100.337 171.15V170.949L106.527 181.67Z",
    fill: "#B6BCC1"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M105.716 181.203L105.542 181.1L100.337 172.089V171.887L105.716 181.203Z",
    fill: "#B6BCC1"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M104.905 180.732L104.728 180.63L100.337 173.027V172.822L104.905 180.732Z",
    fill: "#B6BCC1"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M104.094 180.264L103.919 180.162L100.337 173.959V173.758L104.094 180.264Z",
    fill: "#B6BCC1"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M103.282 179.798L103.107 179.696L100.337 174.898V174.697L103.282 179.798Z",
    fill: "#B6BCC1"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M102.47 179.329L102.295 179.226L100.337 175.836V175.635L102.47 179.329Z",
    fill: "#B6BCC1"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M101.659 178.858L101.484 178.757L100.337 176.772V176.568L101.659 178.858Z",
    fill: "#B6BCC1"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M100.786 178.282C100.613 178.096 100.474 177.856 100.401 177.613L100.786 178.282Z",
    fill: "#B6BCC1"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M102.796 153.712C102.797 152.438 103.689 151.924 104.791 152.559C105.892 153.196 106.787 154.743 106.785 156.015C106.787 157.288 105.892 157.802 104.791 157.167C103.689 156.53 102.797 154.983 102.796 153.712Z",
    fill: "#F0F7FA"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M106.142 154.083C106.512 154.726 106.719 155.412 106.719 156.016C106.717 156.605 106.522 157.043 106.168 157.247C105.813 157.453 105.338 157.403 104.825 157.107C104.303 156.806 103.811 156.286 103.44 155.643C103.069 155 102.865 154.314 102.865 153.712C102.865 153.122 103.059 152.685 103.414 152.479C103.769 152.274 104.247 152.325 104.757 152.62C105.28 152.921 105.77 153.441 106.142 154.083Z",
    fill: "url(#paint210_linear_3744_1590)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 157.033C105.48 157.033 105.243 156.956 104.996 156.815C104.522 156.542 104.074 156.067 103.732 155.475C103.391 154.883 103.203 154.257 103.203 153.712C103.203 153.248 103.339 152.914 103.583 152.771C103.675 152.721 103.779 152.693 103.9 152.693C104.102 152.693 104.341 152.769 104.587 152.913C105.06 153.185 105.508 153.661 105.849 154.252C106.191 154.844 106.379 155.47 106.379 156.016C106.379 156.479 106.244 156.813 105.999 156.955C105.908 157.006 105.802 157.033 105.681 157.033Z",
    fill: "#9FA1A3"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M102.824 154.06L103.261 153.806C103.261 153.831 103.26 153.853 103.26 153.878C103.26 154.375 103.429 154.939 103.737 155.472C104.045 156.005 104.45 156.435 104.88 156.682C104.901 156.696 104.924 156.706 104.943 156.718L104.519 156.963L104.787 157.429L105.913 156.78L105.91 156.777C106.136 156.621 106.256 156.307 106.256 155.887C106.256 155.392 106.089 154.827 105.78 154.294C105.471 153.761 105.066 153.331 104.639 153.083C104.251 152.86 103.901 152.816 103.65 152.96L102.553 153.595L102.824 154.06Z",
    fill: "url(#paint211_linear_3744_1590)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M104.684 154.927C104.992 155.46 105.162 156.024 105.162 156.52C105.162 156.966 105.024 157.292 104.772 157.438C104.522 157.583 104.17 157.539 103.782 157.316C103.356 157.068 102.949 156.639 102.64 156.105C102.335 155.572 102.165 155.007 102.165 154.512C102.165 154.065 102.304 153.739 102.555 153.595C102.805 153.449 103.156 153.491 103.543 153.716C103.97 153.964 104.376 154.394 104.684 154.927Z",
    fill: "url(#paint212_linear_3744_1590)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M104.506 155.029C104.759 155.469 104.899 155.936 104.899 156.344C104.899 156.711 104.784 156.981 104.578 157.1C104.371 157.219 104.081 157.183 103.762 157C103.408 156.797 103.075 156.441 102.819 156.002C102.566 155.561 102.427 155.095 102.427 154.686C102.427 154.317 102.541 154.049 102.746 153.93C102.954 153.812 103.244 153.846 103.564 154.031C103.917 154.234 104.251 154.591 104.506 155.029Z",
    fill: "url(#paint213_linear_3744_1590)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M102.961 154.181L104.486 156.825C104.5 156.845 104.492 156.873 104.47 156.886C104.448 156.9 104.421 156.891 104.409 156.87L102.882 154.227C102.868 154.205 102.877 154.176 102.898 154.165C102.92 154.152 102.947 154.159 102.961 154.181Z",
    fill: "#A8BAC1"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.475 156.012C106.475 156.257 106.437 156.472 106.367 156.644C106.294 156.818 106.19 156.951 106.055 157.036C106.048 157.042 106.041 157.045 106.033 157.05L105.754 157.21C105.725 157.228 105.694 157.246 105.664 157.264L105.401 157.415L105.165 157.552C105.119 157.581 105.072 157.605 105.033 157.629C104.916 157.697 104.832 157.746 104.804 157.762C104.802 157.763 104.802 157.763 104.801 157.765C104.799 157.765 104.796 157.767 104.793 157.768C104.51 157.933 104.111 157.883 103.673 157.629C103.187 157.349 102.728 156.862 102.379 156.259C102.033 155.655 101.839 155.012 101.839 154.451C101.839 153.981 101.975 153.63 102.22 153.451C102.22 153.451 102.22 153.451 102.222 153.449C102.241 153.434 102.259 153.423 102.278 153.413C102.285 153.41 102.29 153.406 102.297 153.403L103.571 152.667L103.573 152.669C103.582 152.667 103.587 152.662 103.598 152.66C103.728 152.602 103.881 152.586 104.05 152.611C104.233 152.638 104.432 152.711 104.642 152.833C104.654 152.84 104.665 152.846 104.676 152.855C105.063 153.087 105.432 153.448 105.739 153.893C105.806 153.993 105.871 154.096 105.933 154.204C106.281 154.808 106.475 155.45 106.475 156.012Z",
    fill: "#F0F7FA"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.692 154.922C104.343 154.319 103.883 153.832 103.398 153.553C102.959 153.298 102.562 153.25 102.276 153.413C101.992 153.578 101.835 153.947 101.835 154.453C101.835 155.013 102.029 155.656 102.376 156.259C102.724 156.863 103.184 157.35 103.67 157.63C104.107 157.883 104.506 157.931 104.79 157.769C105.074 157.605 105.23 157.236 105.23 156.728C105.232 156.167 105.04 155.526 104.692 154.922Z",
    fill: "#F0F7FA"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.122 154.596C103.873 154.165 103.544 153.817 103.198 153.615C102.884 153.435 102.599 153.4 102.397 153.517C102.195 153.634 102.082 153.898 102.082 154.26C102.082 154.66 102.217 155.119 102.468 155.551C102.717 155.981 103.045 156.329 103.392 156.53C103.705 156.71 103.989 156.746 104.193 156.627C104.396 156.51 104.506 156.249 104.508 155.885C104.507 155.485 104.371 155.027 104.122 154.596Z",
    fill: "white"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.049 152.611C104.049 152.611 102.842 153.272 102.746 153.326C102.568 153.316 102.396 153.331 102.218 153.451C102.501 153.281 102.933 153.041 103.597 152.66C103.727 152.602 103.88 152.586 104.049 152.611Z",
    fill: "white"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.737 153.894C105.261 154.189 104.737 154.514 104.509 154.65C104.331 154.371 103.815 153.849 103.487 153.604L104.675 152.855C105.061 153.088 105.43 153.449 105.737 153.894Z",
    fill: "white"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.367 156.645C106.294 156.819 106.19 156.952 106.054 157.037C105.957 157.092 105.855 157.152 105.754 157.21C105.725 157.228 105.694 157.246 105.664 157.264C105.575 157.314 105.485 157.366 105.401 157.415C105.316 157.465 105.237 157.51 105.165 157.552C105.118 157.581 105.072 157.606 105.033 157.63C104.916 157.698 104.832 157.746 104.804 157.762C104.899 157.705 104.989 157.618 105.045 157.521C105.075 157.476 105.097 157.422 105.122 157.373L106.367 156.645Z",
    fill: "white"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M108.992 157.358C108.993 156.087 109.886 155.57 110.986 156.205C112.09 156.842 112.982 158.39 112.982 159.661C112.982 160.934 112.09 161.451 110.986 160.814C109.886 160.177 108.993 158.63 108.992 157.358Z",
    fill: "#F0F7FA"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M112.338 157.731C112.709 158.373 112.912 159.058 112.912 159.662C112.912 160.253 112.717 160.69 112.362 160.894C112.008 161.099 111.531 161.049 111.022 160.754C110.5 160.452 110.007 159.931 109.637 159.291C109.265 158.648 109.061 157.963 109.061 157.358C109.061 156.768 109.256 156.331 109.611 156.125C109.967 155.922 110.442 155.972 110.953 156.266C111.476 156.568 111.968 157.087 112.338 157.731Z",
    fill: "url(#paint214_linear_3744_1590)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M111.879 160.679C111.677 160.679 111.438 160.604 111.191 160.459C110.72 160.189 110.271 159.711 109.929 159.122C109.588 158.529 109.399 157.903 109.399 157.358C109.399 156.893 109.536 156.56 109.781 156.42C109.871 156.366 109.979 156.34 110.096 156.34C110.299 156.34 110.536 156.417 110.785 156.557C111.254 156.831 111.704 157.305 112.046 157.899C112.388 158.49 112.576 159.117 112.576 159.66C112.575 160.125 112.44 160.457 112.194 160.6C112.105 160.654 111.999 160.679 111.879 160.679Z",
    fill: "#9FA1A3"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M109.019 157.706L109.458 157.452C109.457 157.477 109.457 157.502 109.457 157.524C109.457 158.02 109.626 158.587 109.935 159.119C110.241 159.653 110.647 160.083 111.076 160.33C111.097 160.343 111.118 160.353 111.14 160.364L110.715 160.609L110.983 161.077L112.11 160.427L112.108 160.424C112.331 160.268 112.453 159.954 112.453 159.535C112.453 159.039 112.284 158.474 111.977 157.941C111.667 157.407 111.264 156.978 110.835 156.729C110.447 156.507 110.097 156.462 109.845 156.609L108.749 157.243L109.019 157.706Z",
    fill: "url(#paint215_linear_3744_1590)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M110.881 158.57C111.189 159.105 111.357 159.671 111.357 160.166C111.357 160.613 111.218 160.937 110.969 161.082C110.718 161.228 110.368 161.185 109.98 160.961C109.551 160.715 109.146 160.283 108.838 159.752C108.532 159.217 108.362 158.651 108.362 158.157C108.362 157.711 108.5 157.384 108.75 157.24C109.001 157.096 109.352 157.138 109.741 157.362C110.167 157.607 110.573 158.038 110.881 158.57Z",
    fill: "url(#paint216_linear_3744_1590)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M110.702 158.675C110.955 159.115 111.095 159.581 111.095 159.99C111.095 160.359 110.981 160.627 110.773 160.748C110.566 160.867 110.278 160.831 109.959 160.646C109.604 160.442 109.272 160.089 109.016 159.65C108.763 159.211 108.623 158.743 108.623 158.333C108.623 157.965 108.737 157.696 108.943 157.577C109.151 157.458 109.441 157.494 109.76 157.677C110.112 157.881 110.448 158.235 110.702 158.675Z",
    fill: "url(#paint217_linear_3744_1590)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 157.827L110.682 160.472C110.695 160.493 110.687 160.521 110.666 160.534C110.647 160.547 110.616 160.538 110.605 160.517L109.077 157.872C109.066 157.852 109.072 157.823 109.095 157.811C109.117 157.799 109.145 157.804 109.156 157.827Z",
    fill: "#A8BAC1"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M112.668 159.657C112.668 159.903 112.633 160.118 112.561 160.29C112.491 160.465 112.385 160.598 112.249 160.683C112.246 160.688 112.236 160.691 112.228 160.696L111.95 160.857C111.919 160.875 111.888 160.892 111.861 160.909L111.597 161.059L111.36 161.198C111.312 161.227 111.265 161.252 111.227 161.276C111.109 161.344 111.026 161.391 110.999 161.408C110.998 161.41 110.998 161.41 110.996 161.412C110.993 161.412 110.99 161.414 110.987 161.415C110.703 161.579 110.306 161.531 109.866 161.276C109.381 160.997 108.921 160.508 108.574 159.905C108.226 159.299 108.033 158.66 108.033 158.098C108.033 157.628 108.167 157.275 108.413 157.098C108.413 157.098 108.413 157.098 108.416 157.095C108.434 157.082 108.453 157.071 108.472 157.059C108.478 157.056 108.484 157.052 108.49 157.05L109.764 156.312L109.767 156.315C109.776 156.312 109.781 156.31 109.79 156.308C109.921 156.247 110.073 156.232 110.242 156.259C110.424 156.284 110.625 156.357 110.833 156.48C110.845 156.486 110.857 156.494 110.869 156.502C111.254 156.735 111.624 157.093 111.931 157.539C111.999 157.639 112.066 157.743 112.128 157.85C112.478 158.453 112.668 159.097 112.668 159.657Z",
    fill: "#F0F7FA"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.887 158.568C110.54 157.964 110.079 157.478 109.594 157.198C109.156 156.943 108.758 156.894 108.474 157.058C108.19 157.223 108.034 157.591 108.034 158.098C108.034 158.659 108.225 159.3 108.574 159.905C108.922 160.508 109.381 160.996 109.867 161.276C110.306 161.529 110.704 161.578 110.987 161.413C111.273 161.25 111.429 160.881 111.429 160.373C111.429 159.813 111.237 159.171 110.887 158.568Z",
    fill: "#F0F7FA"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.319 158.244C110.069 157.812 109.74 157.465 109.395 157.265C109.082 157.084 108.795 157.049 108.596 157.165C108.393 157.282 108.279 157.545 108.279 157.906C108.279 158.309 108.416 158.766 108.666 159.196C108.916 159.629 109.243 159.976 109.59 160.177C109.903 160.357 110.188 160.393 110.391 160.275C110.592 160.158 110.705 159.895 110.705 159.532C110.704 159.133 110.567 158.675 110.319 158.244Z",
    fill: "white"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.244 156.259C110.244 156.259 109.037 156.919 108.942 156.973C108.763 156.964 108.592 156.979 108.414 157.098C108.697 156.928 109.129 156.688 109.791 156.308C109.924 156.247 110.075 156.232 110.244 156.259Z",
    fill: "white"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.933 157.539C111.459 157.836 110.935 158.16 110.704 158.294C110.528 158.016 110.011 157.494 109.683 157.25L110.871 156.502C111.256 156.734 111.625 157.093 111.933 157.539Z",
    fill: "white"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.562 160.289C112.492 160.464 112.386 160.597 112.25 160.682C112.153 160.738 112.051 160.797 111.951 160.856C111.92 160.874 111.889 160.891 111.862 160.908C111.772 160.958 111.682 161.012 111.598 161.058C111.513 161.109 111.432 161.155 111.361 161.197C111.313 161.226 111.266 161.251 111.228 161.275C111.11 161.343 111.027 161.39 111 161.407C111.093 161.35 111.185 161.263 111.239 161.166C111.268 161.121 111.295 161.067 111.317 161.018L112.562 160.289Z",
    fill: "white"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M102.796 160.473C102.797 159.201 103.689 158.685 104.791 159.321C105.892 159.957 106.787 161.505 106.785 162.778C106.787 164.05 105.892 164.565 104.791 163.929C103.689 163.293 102.797 161.745 102.796 160.473Z",
    fill: "#F0F7FA"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M106.142 160.846C106.512 161.487 106.719 162.174 106.719 162.778C106.717 163.367 106.522 163.805 106.168 164.009C105.813 164.215 105.338 164.163 104.825 163.869C104.303 163.567 103.811 163.047 103.44 162.405C103.069 161.763 102.865 161.077 102.865 160.472C102.865 159.884 103.059 159.445 103.414 159.242C103.769 159.036 104.247 159.087 104.757 159.381C105.28 159.683 105.77 160.203 106.142 160.846Z",
    fill: "url(#paint218_linear_3744_1590)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 163.794C105.48 163.794 105.243 163.72 104.996 163.576C104.522 163.303 104.074 162.827 103.732 162.236C103.391 161.645 103.203 161.019 103.203 160.472C103.203 160.01 103.339 159.676 103.583 159.534C103.675 159.482 103.779 159.455 103.9 159.455C104.102 159.455 104.341 159.532 104.587 159.674C105.06 159.947 105.508 160.422 105.849 161.014C106.191 161.606 106.379 162.232 106.379 162.778C106.379 163.241 106.244 163.575 105.999 163.716C105.908 163.767 105.802 163.794 105.681 163.794Z",
    fill: "#9FA1A3"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M102.824 160.824L103.261 160.569C103.261 160.592 103.26 160.617 103.26 160.641C103.26 161.136 103.429 161.702 103.737 162.234C104.045 162.768 104.45 163.197 104.88 163.445C104.901 163.459 104.924 163.469 104.943 163.481L104.519 163.725L104.787 164.193L105.913 163.543L105.91 163.542C106.136 163.385 106.256 163.071 106.256 162.65C106.256 162.156 106.089 161.59 105.78 161.056C105.471 160.523 105.066 160.093 104.639 159.846C104.251 159.624 103.901 159.579 103.65 159.725L102.553 160.357L102.824 160.824Z",
    fill: "url(#paint219_linear_3744_1590)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M104.684 161.688C104.992 162.223 105.162 162.788 105.162 163.283C105.162 163.728 105.024 164.055 104.772 164.2C104.522 164.345 104.17 164.302 103.782 164.078C103.356 163.832 102.949 163.402 102.64 162.868C102.335 162.334 102.165 161.769 102.165 161.275C102.165 160.827 102.304 160.502 102.555 160.356C102.805 160.21 103.156 160.254 103.543 160.477C103.97 160.725 104.376 161.155 104.684 161.688Z",
    fill: "url(#paint220_linear_3744_1590)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M104.506 161.791C104.759 162.231 104.899 162.696 104.899 163.105C104.899 163.475 104.784 163.742 104.578 163.863C104.371 163.982 104.081 163.946 103.762 163.763C103.408 163.557 103.075 163.204 102.819 162.764C102.566 162.325 102.427 161.858 102.427 161.45C102.427 161.08 102.541 160.813 102.746 160.692C102.954 160.573 103.244 160.608 103.564 160.794C103.917 160.997 104.251 161.351 104.506 161.791Z",
    fill: "url(#paint221_linear_3744_1590)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M102.961 160.943L104.486 163.586C104.5 163.608 104.492 163.637 104.47 163.649C104.448 163.661 104.421 163.653 104.409 163.632L102.882 160.989C102.868 160.967 102.877 160.938 102.898 160.927C102.92 160.913 102.947 160.92 102.961 160.943Z",
    fill: "#A8BAC1"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.475 162.774C106.475 163.02 106.437 163.233 106.367 163.405C106.294 163.581 106.19 163.713 106.055 163.797C106.048 163.803 106.041 163.807 106.033 163.812L105.754 163.972C105.725 163.988 105.694 164.008 105.664 164.024L105.401 164.176L105.165 164.313C105.119 164.342 105.072 164.367 105.033 164.391C104.916 164.46 104.832 164.507 104.804 164.524C104.802 164.524 104.802 164.524 104.801 164.528C104.799 164.528 104.796 164.528 104.793 164.53C104.51 164.694 104.111 164.644 103.673 164.391C103.187 164.111 102.728 163.624 102.379 163.02C102.033 162.415 101.839 161.774 101.839 161.213C101.839 160.741 101.975 160.391 102.22 160.212C102.22 160.212 102.22 160.212 102.222 160.21C102.241 160.197 102.259 160.185 102.278 160.175C102.285 160.172 102.29 160.168 102.297 160.165L103.571 159.427L103.573 159.431C103.582 159.427 103.587 159.425 103.598 159.423C103.728 159.363 103.881 159.347 104.05 159.373C104.233 159.398 104.432 159.473 104.642 159.595C104.654 159.602 104.665 159.609 104.676 159.618C105.063 159.849 105.432 160.208 105.739 160.654C105.806 160.753 105.871 160.856 105.933 160.966C106.281 161.569 106.475 162.211 106.475 162.774Z",
    fill: "#F0F7FA"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.692 161.682C104.343 161.078 103.883 160.59 103.398 160.311C102.959 160.058 102.562 160.01 102.276 160.173C101.992 160.336 101.835 160.707 101.835 161.213C101.835 161.774 102.029 162.415 102.376 163.02C102.724 163.623 103.184 164.111 103.67 164.39C104.107 164.644 104.506 164.692 104.79 164.528C105.074 164.365 105.23 163.996 105.23 163.488C105.232 162.928 105.04 162.288 104.692 161.682Z",
    fill: "#F0F7FA"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.122 161.358C103.873 160.927 103.544 160.579 103.198 160.379C102.884 160.198 102.599 160.165 102.397 160.28C102.195 160.397 102.082 160.66 102.082 161.022C102.082 161.425 102.217 161.882 102.468 162.312C102.717 162.743 103.045 163.092 103.392 163.291C103.705 163.473 103.989 163.507 104.193 163.39C104.396 163.273 104.506 163.011 104.508 162.647C104.507 162.248 104.371 161.791 104.122 161.358Z",
    fill: "white"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.049 159.373C104.049 159.373 102.842 160.034 102.746 160.088C102.568 160.079 102.396 160.092 102.218 160.212C102.501 160.041 102.933 159.802 103.597 159.423C103.727 159.363 103.88 159.348 104.049 159.373Z",
    fill: "white"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.737 160.655C105.261 160.951 104.737 161.276 104.509 161.411C104.331 161.132 103.815 160.611 103.487 160.367L104.675 159.619C105.061 159.85 105.43 160.209 105.737 160.655Z",
    fill: "white"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.367 163.404C106.294 163.581 106.19 163.713 106.054 163.797C105.957 163.854 105.855 163.913 105.754 163.972C105.725 163.988 105.694 164.008 105.664 164.024C105.575 164.075 105.485 164.127 105.401 164.176C105.316 164.224 105.237 164.27 105.165 164.313C105.118 164.342 105.072 164.367 105.033 164.39C104.916 164.459 104.832 164.507 104.804 164.523C104.899 164.466 104.989 164.38 105.045 164.283C105.075 164.238 105.097 164.183 105.122 164.134L106.367 163.404Z",
    fill: "white"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M108.992 164.12C108.993 162.848 109.886 162.331 110.986 162.968C112.09 163.603 112.982 165.15 112.982 166.423C112.982 167.696 112.09 168.213 110.986 167.575C109.886 166.939 108.993 165.391 108.992 164.12Z",
    fill: "#F0F7FA"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M112.338 164.491C112.709 165.132 112.912 165.818 112.912 166.423C112.912 167.013 112.717 167.45 112.362 167.654C112.008 167.859 111.531 167.81 111.022 167.515C110.5 167.212 110.007 166.693 109.637 166.05C109.265 165.408 109.061 164.721 109.061 164.12C109.061 163.529 109.256 163.091 109.611 162.886C109.967 162.681 110.442 162.73 110.953 163.027C111.476 163.328 111.968 163.849 112.338 164.491Z",
    fill: "url(#paint222_linear_3744_1590)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M111.879 167.442C111.677 167.442 111.438 167.366 111.191 167.223C110.72 166.95 110.271 166.474 109.929 165.883C109.588 165.292 109.399 164.665 109.399 164.121C109.399 163.656 109.536 163.322 109.781 163.181C109.871 163.128 109.979 163.102 110.096 163.102C110.299 163.102 110.536 163.177 110.785 163.321C111.254 163.593 111.704 164.068 112.046 164.661C112.388 165.252 112.576 165.878 112.576 166.423C112.575 166.886 112.44 167.22 112.194 167.361C112.105 167.415 111.999 167.442 111.879 167.442Z",
    fill: "#9FA1A3"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M109.019 164.466L109.458 164.213C109.457 164.238 109.457 164.26 109.457 164.284C109.457 164.78 109.626 165.347 109.935 165.88C110.241 166.412 110.647 166.842 111.076 167.09C111.097 167.101 111.118 167.112 111.14 167.124L110.715 167.37L110.983 167.835L112.11 167.186L112.108 167.184C112.331 167.028 112.453 166.713 112.453 166.294C112.453 165.798 112.284 165.232 111.977 164.699C111.667 164.167 111.264 163.737 110.835 163.49C110.447 163.266 110.097 163.222 109.845 163.368L108.749 164.002L109.019 164.466Z",
    fill: "url(#paint223_linear_3744_1590)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M110.881 165.333C111.189 165.866 111.357 166.432 111.357 166.927C111.357 167.374 111.218 167.7 110.969 167.845C110.718 167.99 110.368 167.947 109.98 167.723C109.551 167.475 109.146 167.046 108.838 166.513C108.532 165.979 108.362 165.414 108.362 164.919C108.362 164.472 108.5 164.147 108.75 164.003C109.001 163.857 109.352 163.901 109.741 164.123C110.167 164.371 110.573 164.801 110.881 165.333Z",
    fill: "url(#paint224_linear_3744_1590)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M110.702 165.436C110.955 165.877 111.095 166.343 111.095 166.752C111.095 167.12 110.981 167.389 110.773 167.509C110.566 167.627 110.278 167.593 109.959 167.408C109.604 167.205 109.272 166.851 109.016 166.411C108.763 165.97 108.623 165.504 108.623 165.096C108.623 164.726 108.737 164.459 108.943 164.339C109.151 164.22 109.441 164.255 109.76 164.439C110.112 164.643 110.448 164.998 110.702 165.436Z",
    fill: "url(#paint225_linear_3744_1590)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 164.588L110.682 167.233C110.695 167.255 110.687 167.283 110.666 167.294C110.647 167.308 110.616 167.301 110.605 167.279L109.077 164.634C109.066 164.613 109.072 164.584 109.095 164.572C109.117 164.56 109.145 164.568 109.156 164.588Z",
    fill: "#A8BAC1"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M112.668 166.419C112.668 166.664 112.633 166.877 112.561 167.052C112.491 167.226 112.385 167.36 112.249 167.444C112.246 167.449 112.236 167.453 112.228 167.456L111.95 167.617C111.919 167.635 111.888 167.653 111.861 167.67L111.597 167.822L111.36 167.959C111.312 167.988 111.265 168.013 111.227 168.038C111.109 168.104 111.026 168.154 110.999 168.169C110.998 168.172 110.998 168.172 110.996 168.173C110.993 168.173 110.99 168.174 110.987 168.177C110.703 168.34 110.306 168.292 109.866 168.038C109.381 167.757 108.921 167.269 108.574 166.666C108.226 166.062 108.033 165.421 108.033 164.857C108.033 164.388 108.167 164.037 108.413 163.859C108.413 163.859 108.413 163.859 108.416 163.857C108.434 163.842 108.453 163.833 108.472 163.82C108.478 163.817 108.484 163.814 108.49 163.81L109.764 163.074L109.767 163.077C109.776 163.074 109.781 163.07 109.79 163.069C109.921 163.009 110.073 162.994 110.242 163.02C110.424 163.044 110.625 163.119 110.833 163.241C110.845 163.247 110.857 163.255 110.869 163.261C111.254 163.493 111.624 163.855 111.931 164.3C111.999 164.399 112.066 164.503 112.128 164.611C112.478 165.216 112.668 165.859 112.668 166.419Z",
    fill: "#F0F7FA"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.887 165.328C110.54 164.726 110.079 164.239 109.594 163.958C109.156 163.704 108.758 163.656 108.474 163.82C108.19 163.984 108.034 164.354 108.034 164.86C108.034 165.421 108.225 166.061 108.574 166.666C108.922 167.269 109.381 167.757 109.867 168.036C110.306 168.29 110.704 168.34 110.987 168.175C111.273 168.011 111.429 167.642 111.429 167.135C111.429 166.576 111.237 165.932 110.887 165.328Z",
    fill: "#F0F7FA"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.319 165.004C110.069 164.572 109.74 164.224 109.395 164.023C109.082 163.843 108.795 163.809 108.596 163.925C108.393 164.041 108.279 164.306 108.279 164.666C108.279 165.068 108.416 165.528 108.666 165.958C108.916 166.39 109.243 166.737 109.59 166.938C109.903 167.118 110.188 167.152 110.391 167.036C110.592 166.918 110.705 166.654 110.705 166.293C110.704 165.892 110.567 165.433 110.319 165.004Z",
    fill: "white"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.244 163.02C110.244 163.02 109.037 163.679 108.942 163.734C108.763 163.723 108.592 163.739 108.414 163.858C108.697 163.688 109.129 163.448 109.791 163.068C109.924 163.009 110.075 162.994 110.244 163.02Z",
    fill: "white"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.933 164.3C111.459 164.595 110.935 164.921 110.704 165.055C110.528 164.778 110.011 164.254 109.683 164.011L110.871 163.262C111.256 163.493 111.625 163.855 111.933 164.3Z",
    fill: "white"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.562 167.051C112.492 167.225 112.386 167.359 112.25 167.444C112.153 167.5 112.051 167.558 111.951 167.617C111.92 167.635 111.889 167.653 111.862 167.669C111.772 167.719 111.682 167.772 111.598 167.821C111.513 167.87 111.432 167.916 111.361 167.959C111.313 167.987 111.266 168.013 111.228 168.037C111.11 168.103 111.027 168.153 111 168.168C111.093 168.112 111.185 168.024 111.239 167.928C111.268 167.883 111.295 167.829 111.317 167.779L112.562 167.051Z",
    fill: "white"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M102.796 167.238C102.797 165.965 103.689 165.449 104.791 166.084C105.892 166.721 106.787 168.268 106.785 169.541C106.787 170.813 105.892 171.328 104.791 170.693C103.689 170.057 102.797 168.51 102.796 167.238Z",
    fill: "#F0F7FA"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M106.142 167.61C106.512 168.252 106.719 168.937 106.719 169.541C106.717 170.131 106.522 170.569 106.168 170.773C105.813 170.977 105.338 170.927 104.825 170.631C104.303 170.332 103.811 169.811 103.44 169.168C103.069 168.528 102.865 167.84 102.865 167.237C102.865 166.648 103.059 166.209 103.414 166.006C103.769 165.8 104.247 165.849 104.757 166.146C105.28 166.446 105.77 166.966 106.142 167.61Z",
    fill: "url(#paint226_linear_3744_1590)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 170.559C105.48 170.559 105.243 170.484 104.996 170.342C104.522 170.068 104.074 169.593 103.732 168.999C103.391 168.41 103.203 167.783 103.203 167.238C103.203 166.774 103.339 166.439 103.583 166.298C103.675 166.246 103.779 166.219 103.9 166.219C104.102 166.219 104.341 166.295 104.587 166.437C105.06 166.711 105.508 167.186 105.849 167.778C106.191 168.37 106.379 168.996 106.379 169.541C106.379 170.004 106.244 170.339 105.999 170.48C105.908 170.533 105.802 170.559 105.681 170.559Z",
    fill: "#9FA1A3"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M102.824 167.587L103.261 167.334C103.261 167.356 103.26 167.379 103.26 167.405C103.26 167.9 103.429 168.465 103.737 168.997C104.045 169.531 104.45 169.961 104.88 170.209C104.901 170.222 104.924 170.231 104.943 170.244L104.519 170.489L104.787 170.954L105.913 170.305L105.91 170.304C106.136 170.147 106.256 169.833 106.256 169.413C106.256 168.919 106.089 168.352 105.78 167.819C105.471 167.285 105.066 166.856 104.639 166.608C104.251 166.385 103.901 166.341 103.65 166.488L102.553 167.12L102.824 167.587Z",
    fill: "url(#paint227_linear_3744_1590)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M104.684 168.454C104.992 168.986 105.162 169.551 105.162 170.046C105.162 170.492 105.024 170.819 104.772 170.963C104.522 171.109 104.17 171.065 103.782 170.842C103.356 170.595 102.949 170.164 102.64 169.631C102.335 169.099 102.165 168.533 102.165 168.037C102.165 167.591 102.304 167.266 102.555 167.12C102.805 166.974 103.156 167.017 103.543 167.24C103.97 167.488 104.376 167.918 104.684 168.454Z",
    fill: "url(#paint228_linear_3744_1590)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M104.506 168.554C104.759 168.995 104.899 169.46 104.899 169.871C104.899 170.239 104.784 170.508 104.578 170.627C104.371 170.745 104.081 170.71 103.762 170.526C103.408 170.323 103.075 169.968 102.819 169.528C102.566 169.089 102.427 168.621 102.427 168.214C102.427 167.844 102.541 167.577 102.746 167.455C102.954 167.336 103.244 167.373 103.564 167.557C103.917 167.76 104.251 168.114 104.506 168.554Z",
    fill: "url(#paint229_linear_3744_1590)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M102.961 167.706L104.486 170.351C104.5 170.373 104.492 170.4 104.47 170.413C104.448 170.426 104.421 170.418 104.409 170.396L102.882 167.753C102.868 167.732 102.877 167.702 102.898 167.691C102.92 167.677 102.947 167.684 102.961 167.706Z",
    fill: "#A8BAC1"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.475 169.538C106.475 169.781 106.437 169.996 106.367 170.168C106.294 170.344 106.19 170.476 106.055 170.562C106.048 170.567 106.041 170.571 106.033 170.575L105.754 170.735C105.725 170.752 105.694 170.77 105.664 170.787L105.401 170.938L105.165 171.076C105.119 171.106 105.072 171.13 105.033 171.154C104.916 171.222 104.832 171.272 104.804 171.286C104.802 171.287 104.802 171.287 104.801 171.289C104.799 171.289 104.796 171.291 104.793 171.294C104.51 171.457 104.111 171.407 103.673 171.154C103.187 170.874 102.728 170.387 102.379 169.783C102.033 169.179 101.839 168.537 101.839 167.976C101.839 167.505 101.975 167.155 102.22 166.975C102.22 166.975 102.22 166.975 102.222 166.974C102.241 166.96 102.259 166.949 102.278 166.937C102.285 166.933 102.29 166.93 102.297 166.927L103.571 166.191L103.573 166.194C103.582 166.191 103.587 166.188 103.598 166.186C103.728 166.128 103.881 166.111 104.05 166.136C104.233 166.161 104.432 166.237 104.642 166.358C104.654 166.364 104.665 166.372 104.676 166.378C105.063 166.611 105.432 166.971 105.739 167.418C105.806 167.516 105.871 167.619 105.933 167.73C106.281 168.333 106.475 168.975 106.475 169.538Z",
    fill: "#F0F7FA"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.692 168.444C104.343 167.84 103.883 167.352 103.398 167.073C102.959 166.821 102.562 166.771 102.276 166.935C101.992 167.099 101.835 167.47 101.835 167.975C101.835 168.535 102.029 169.177 102.376 169.781C102.724 170.384 103.184 170.871 103.67 171.153C104.107 171.405 104.506 171.454 104.79 171.29C105.074 171.127 105.23 170.757 105.23 170.252C105.232 169.69 105.04 169.048 104.692 168.444Z",
    fill: "#F0F7FA"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.122 168.119C103.873 167.689 103.544 167.34 103.198 167.141C102.884 166.961 102.599 166.926 102.397 167.042C102.195 167.16 102.082 167.423 102.082 167.785C102.082 168.185 102.217 168.643 102.468 169.074C102.717 169.506 103.045 169.854 103.392 170.054C103.705 170.234 103.989 170.27 104.193 170.152C104.396 170.036 104.506 169.772 104.508 169.41C104.507 169.01 104.371 168.553 104.122 168.119Z",
    fill: "white"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.049 166.137C104.049 166.137 102.842 166.797 102.746 166.852C102.568 166.841 102.396 166.855 102.218 166.974C102.501 166.807 102.933 166.566 103.597 166.186C103.727 166.127 103.88 166.111 104.049 166.137Z",
    fill: "white"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.737 167.419C105.261 167.715 104.737 168.037 104.509 168.173C104.331 167.896 103.815 167.373 103.487 167.129L104.675 166.379C105.061 166.611 105.43 166.971 105.737 167.419Z",
    fill: "white"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.367 170.168C106.294 170.343 106.19 170.476 106.054 170.562C105.957 170.617 105.855 170.676 105.754 170.735C105.725 170.752 105.694 170.77 105.664 170.787C105.575 170.838 105.485 170.89 105.401 170.938C105.316 170.989 105.237 171.034 105.165 171.076C105.118 171.106 105.072 171.13 105.033 171.154C104.916 171.221 104.832 171.271 104.804 171.286C104.899 171.228 104.989 171.142 105.045 171.045C105.075 171.001 105.097 170.945 105.122 170.897L106.367 170.168Z",
    fill: "white"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M108.992 170.882C108.993 169.609 109.886 169.094 110.986 169.729C112.09 170.366 112.982 171.913 112.982 173.186C112.982 174.457 112.09 174.975 110.986 174.337C109.886 173.702 108.993 172.154 108.992 170.882Z",
    fill: "#F0F7FA"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M112.338 171.253C112.709 171.896 112.912 172.583 112.912 173.186C112.912 173.776 112.717 174.213 112.362 174.417C112.008 174.623 111.531 174.573 111.022 174.277C110.5 173.975 110.007 173.455 109.637 172.813C109.265 172.17 109.061 171.486 109.061 170.881C109.061 170.291 109.256 169.855 109.611 169.649C109.967 169.445 110.442 169.495 110.953 169.79C111.476 170.091 111.968 170.61 112.338 171.253Z",
    fill: "url(#paint230_linear_3744_1590)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M111.879 174.205C111.677 174.205 111.438 174.129 111.191 173.985C110.72 173.713 110.271 173.237 109.929 172.646C109.588 172.053 109.399 171.427 109.399 170.882C109.399 170.419 109.536 170.083 109.781 169.944C109.871 169.891 109.979 169.863 110.096 169.863C110.299 169.863 110.536 169.941 110.785 170.082C111.254 170.356 111.704 170.831 112.046 171.424C112.388 172.016 112.576 172.643 112.576 173.186C112.575 173.65 112.44 173.983 112.194 174.125C112.105 174.176 111.999 174.205 111.879 174.205Z",
    fill: "#9FA1A3"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M109.019 171.23L109.458 170.976C109.457 171.001 109.457 171.025 109.457 171.048C109.457 171.544 109.626 172.109 109.935 172.643C110.241 173.176 110.647 173.605 111.076 173.854C111.097 173.864 111.118 173.876 111.14 173.886L110.715 174.133L110.983 174.599L112.11 173.948L112.108 173.947C112.331 173.792 112.453 173.477 112.453 173.057C112.453 172.562 112.284 171.997 111.977 171.464C111.667 170.929 111.264 170.502 110.835 170.253C110.447 170.03 110.097 169.986 109.845 170.131L108.749 170.765L109.019 171.23Z",
    fill: "url(#paint231_linear_3744_1590)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M110.881 172.096C111.189 172.629 111.357 173.194 111.357 173.689C111.357 174.136 111.218 174.462 110.969 174.607C110.718 174.752 110.368 174.709 109.98 174.485C109.551 174.238 109.146 173.808 108.838 173.275C108.532 172.743 108.362 172.177 108.362 171.682C108.362 171.234 108.5 170.909 108.75 170.764C109.001 170.619 109.352 170.662 109.741 170.885C110.167 171.133 110.573 171.562 110.881 172.096Z",
    fill: "url(#paint232_linear_3744_1590)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M110.702 172.198C110.955 172.638 111.095 173.106 111.095 173.513C111.095 173.882 110.981 174.151 110.773 174.269C110.566 174.391 110.278 174.355 109.959 174.17C109.604 173.967 109.272 173.611 109.016 173.173C108.763 172.731 108.623 172.265 108.623 171.857C108.623 171.488 108.737 171.22 108.943 171.101C109.151 170.982 109.441 171.016 109.76 171.201C110.112 171.405 110.448 171.756 110.702 172.198Z",
    fill: "url(#paint233_linear_3744_1590)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 171.352L110.682 173.995C110.695 174.017 110.687 174.045 110.666 174.056C110.647 174.07 110.616 174.063 110.605 174.04L109.077 171.396C109.066 171.374 109.072 171.346 109.095 171.334C109.117 171.322 109.145 171.328 109.156 171.352Z",
    fill: "#A8BAC1"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M112.668 173.18C112.668 173.425 112.633 173.641 112.561 173.812C112.491 173.989 112.385 174.122 112.249 174.206C112.246 174.211 112.236 174.214 112.228 174.22L111.95 174.38C111.919 174.396 111.888 174.416 111.861 174.433L111.597 174.584L111.36 174.722C111.312 174.75 111.265 174.775 111.227 174.799C111.109 174.868 111.026 174.916 110.999 174.932C110.998 174.933 110.998 174.933 110.996 174.934C110.993 174.934 110.99 174.937 110.987 174.938C110.703 175.102 110.306 175.054 109.866 174.799C109.381 174.519 108.921 174.032 108.574 173.428C108.226 172.823 108.033 172.183 108.033 171.621C108.033 171.151 108.167 170.8 108.413 170.621C108.413 170.621 108.413 170.621 108.416 170.62C108.434 170.604 108.453 170.593 108.472 170.584C108.478 170.58 108.484 170.576 108.49 170.573L109.764 169.836L109.767 169.84C109.776 169.836 109.781 169.832 109.79 169.83C109.921 169.771 110.073 169.756 110.242 169.781C110.424 169.807 110.625 169.881 110.833 170.001C110.845 170.008 110.857 170.017 110.869 170.024C111.254 170.257 111.624 170.617 111.931 171.063C111.999 171.163 112.066 171.265 112.128 171.373C112.478 171.977 112.668 172.62 112.668 173.18Z",
    fill: "#F0F7FA"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.887 172.091C110.54 171.488 110.079 171.001 109.594 170.72C109.156 170.466 108.758 170.418 108.474 170.582C108.19 170.745 108.034 171.115 108.034 171.62C108.034 172.182 108.225 172.823 108.574 173.427C108.922 174.03 109.381 174.519 109.867 174.798C110.306 175.051 110.704 175.101 110.987 174.937C111.273 174.773 111.429 174.403 111.429 173.897C111.429 173.336 111.237 172.696 110.887 172.091Z",
    fill: "#F0F7FA"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.319 171.766C110.069 171.334 109.74 170.987 109.395 170.786C109.082 170.605 108.795 170.57 108.596 170.686C108.393 170.804 108.279 171.067 108.279 171.429C108.279 171.83 108.416 172.288 108.666 172.72C108.916 173.151 109.243 173.497 109.59 173.699C109.903 173.88 110.188 173.914 110.391 173.798C110.592 173.681 110.705 173.418 110.705 173.056C110.704 172.656 110.567 172.197 110.319 171.766Z",
    fill: "white"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.244 169.781C110.244 169.781 109.037 170.441 108.942 170.495C108.763 170.487 108.592 170.503 108.414 170.621C108.697 170.452 109.129 170.211 109.791 169.829C109.924 169.771 110.075 169.757 110.244 169.781Z",
    fill: "white"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.933 171.064C111.459 171.36 110.935 171.684 110.704 171.818C110.528 171.541 110.011 171.018 109.683 170.773L110.871 170.025C111.256 170.257 111.625 170.617 111.933 171.064Z",
    fill: "white"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.562 173.811C112.492 173.987 112.386 174.12 112.25 174.205C112.153 174.26 112.051 174.32 111.951 174.379C111.92 174.394 111.889 174.415 111.862 174.431C111.772 174.482 111.682 174.534 111.598 174.582C111.513 174.633 111.432 174.677 111.361 174.721C111.313 174.749 111.266 174.774 111.228 174.797C111.11 174.866 111.027 174.915 111 174.93C111.093 174.872 111.185 174.786 111.239 174.69C111.268 174.643 111.295 174.591 111.317 174.542L112.562 173.811Z",
    fill: "white"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M102.796 174C102.797 172.728 103.689 172.213 104.791 172.848C105.892 173.483 106.787 175.033 106.785 176.303C106.787 177.577 105.892 178.093 104.791 177.457C103.689 176.82 102.797 175.274 102.796 174Z",
    fill: "#F0F7FA"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M106.142 174.373C106.512 175.015 106.719 175.701 106.719 176.304C106.717 176.895 106.522 177.332 106.168 177.537C105.813 177.742 105.338 177.691 104.825 177.397C104.303 177.094 103.811 176.575 103.44 175.932C103.069 175.289 102.865 174.604 102.865 174C102.865 173.411 103.059 172.972 103.414 172.768C103.769 172.564 104.247 172.614 104.757 172.91C105.28 173.21 105.77 173.73 106.142 174.373Z",
    fill: "url(#paint234_linear_3744_1590)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M105.681 177.324C105.48 177.324 105.243 177.246 104.996 177.104C104.522 176.831 104.074 176.355 103.732 175.765C103.391 175.171 103.203 174.545 103.203 174C103.203 173.536 103.339 173.203 103.583 173.061C103.675 173.009 103.779 172.982 103.9 172.982C104.102 172.982 104.341 173.058 104.587 173.202C105.06 173.474 105.508 173.949 105.849 174.54C106.191 175.134 106.379 175.759 106.379 176.303C106.379 176.767 106.244 177.102 105.999 177.244C105.908 177.296 105.802 177.324 105.681 177.324Z",
    fill: "#9FA1A3"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M102.824 174.348L103.261 174.095C103.261 174.118 103.26 174.143 103.26 174.166C103.26 174.66 103.429 175.227 103.737 175.761C104.045 176.294 104.45 176.724 104.88 176.97C104.901 176.984 104.924 176.994 104.943 177.005L104.519 177.25L104.787 177.717L105.913 177.067L105.91 177.064C106.136 176.91 106.256 176.596 106.256 176.177C106.256 175.682 106.089 175.116 105.78 174.581C105.471 174.05 105.066 173.618 104.639 173.372C104.251 173.149 103.901 173.105 103.65 173.251L102.553 173.883L102.824 174.348Z",
    fill: "url(#paint235_linear_3744_1590)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M104.684 175.216C104.992 175.75 105.162 176.314 105.162 176.809C105.162 177.255 105.024 177.582 104.772 177.726C104.522 177.872 104.17 177.827 103.782 177.605C103.356 177.358 102.949 176.927 102.64 176.394C102.335 175.861 102.165 175.296 102.165 174.801C102.165 174.355 102.304 174.029 102.555 173.883C102.805 173.738 103.156 173.781 103.543 174.004C103.97 174.253 104.376 174.681 104.684 175.216Z",
    fill: "url(#paint236_linear_3744_1590)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M104.506 175.319C104.759 175.759 104.899 176.224 104.899 176.632C104.899 177.002 104.784 177.27 104.578 177.39C104.371 177.51 104.081 177.474 103.762 177.291C103.408 177.085 103.075 176.73 102.819 176.291C102.566 175.852 102.427 175.384 102.427 174.977C102.427 174.607 102.541 174.339 102.746 174.22C102.954 174.1 103.244 174.137 103.564 174.319C103.917 174.524 104.251 174.878 104.506 175.319Z",
    fill: "url(#paint237_linear_3744_1590)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M102.961 174.469L104.486 177.113C104.5 177.134 104.492 177.163 104.47 177.175C104.448 177.188 104.421 177.181 104.409 177.159L102.882 174.516C102.868 174.492 102.877 174.466 102.898 174.455C102.92 174.44 102.947 174.448 102.961 174.469Z",
    fill: "#A8BAC1"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.475 176.298C106.475 176.544 106.437 176.76 106.367 176.931C106.294 177.107 106.19 177.241 106.055 177.323C106.048 177.329 106.041 177.332 106.033 177.339L105.754 177.499C105.725 177.515 105.694 177.533 105.664 177.549L105.401 177.703L105.165 177.841C105.119 177.868 105.072 177.893 105.033 177.917C104.916 177.987 104.832 178.034 104.804 178.05C104.802 178.051 104.801 178.052 104.801 178.052C104.799 178.052 104.796 178.054 104.793 178.057C104.51 178.221 104.111 178.172 103.673 177.917C103.187 177.637 102.728 177.15 102.379 176.546C102.033 175.941 101.839 175.3 101.839 174.739C101.839 174.269 101.975 173.915 102.22 173.738C102.22 173.738 102.22 173.738 102.222 173.737C102.241 173.722 102.259 173.712 102.278 173.7C102.285 173.697 102.29 173.694 102.297 173.69L103.571 172.954L103.573 172.958C103.582 172.954 103.587 172.95 103.598 172.948C103.728 172.89 103.881 172.872 104.05 172.899C104.233 172.924 104.432 172.998 104.642 173.12C104.654 173.128 104.665 173.134 104.676 173.142C105.063 173.373 105.432 173.733 105.739 174.18C105.806 174.281 105.871 174.383 105.933 174.491C106.281 175.095 106.475 175.738 106.475 176.298Z",
    fill: "#F0F7FA"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M104.692 175.21C104.343 174.606 103.883 174.118 103.398 173.837C102.959 173.585 102.562 173.535 102.276 173.697C101.992 173.863 101.835 174.233 101.835 174.738C101.835 175.3 102.029 175.941 102.376 176.544C102.724 177.148 103.184 177.636 103.67 177.917C104.107 178.169 104.506 178.218 104.79 178.054C105.074 177.891 105.23 177.521 105.23 177.014C105.232 176.454 105.04 175.814 104.692 175.21Z",
    fill: "#F0F7FA"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.122 174.886C103.873 174.454 103.544 174.105 103.198 173.905C102.884 173.724 102.599 173.689 102.397 173.806C102.195 173.923 102.082 174.187 102.082 174.547C102.082 174.948 102.217 175.406 102.468 175.837C102.717 176.269 103.045 176.618 103.392 176.817C103.705 176.999 103.989 177.032 104.193 176.916C104.396 176.799 104.506 176.535 104.508 176.173C104.507 175.773 104.371 175.315 104.122 174.886Z",
    fill: "white"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.049 172.899C104.049 172.899 102.842 173.56 102.746 173.614C102.568 173.606 102.396 173.618 102.218 173.737C102.501 173.569 102.933 173.33 103.597 172.948C103.727 172.891 103.88 172.872 104.049 172.899Z",
    fill: "white"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.737 174.181C105.261 174.477 104.737 174.802 104.509 174.937C104.331 174.657 103.815 174.137 103.487 173.892L104.675 173.143C105.061 173.373 105.43 173.734 105.737 174.181Z",
    fill: "white"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.367 176.932C106.294 177.108 106.19 177.242 106.054 177.324C105.957 177.381 105.855 177.439 105.754 177.499C105.725 177.515 105.694 177.533 105.664 177.55C105.575 177.603 105.485 177.655 105.401 177.703C105.316 177.753 105.237 177.797 105.165 177.841C105.118 177.868 105.072 177.893 105.033 177.918C104.916 177.987 104.832 178.034 104.804 178.05C104.899 177.993 104.989 177.906 105.045 177.808C105.075 177.764 105.097 177.71 105.122 177.661L106.367 176.932Z",
    fill: "white"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M108.992 177.644C108.993 176.373 109.886 175.857 110.986 176.493C112.09 177.129 112.982 178.676 112.982 179.948C112.982 181.221 112.09 181.737 110.986 181.099C109.886 180.464 108.993 178.917 108.992 177.644Z",
    fill: "#F0F7FA"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M112.338 178.015C112.709 178.66 112.912 179.346 112.912 179.949C112.912 180.539 112.717 180.977 112.362 181.181C112.008 181.386 111.531 181.336 111.022 181.041C110.5 180.74 110.007 180.219 109.637 179.577C109.265 178.935 109.061 178.248 109.061 177.643C109.061 177.056 109.256 176.618 109.611 176.412C109.967 176.209 110.442 176.258 110.953 176.553C111.476 176.856 111.968 177.374 112.338 178.015Z",
    fill: "url(#paint238_linear_3744_1590)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M111.879 180.966C111.677 180.966 111.438 180.89 111.191 180.747C110.72 180.475 110.271 180 109.929 179.408C109.588 178.816 109.399 178.189 109.399 177.644C109.399 177.181 109.536 176.846 109.781 176.704C109.871 176.654 109.979 176.627 110.096 176.627C110.299 176.627 110.536 176.702 110.785 176.844C111.254 177.118 111.704 177.593 112.046 178.186C112.388 178.777 112.576 179.404 112.576 179.948C112.575 180.412 112.44 180.747 112.194 180.888C112.105 180.939 111.999 180.966 111.879 180.966Z",
    fill: "#9FA1A3"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M109.019 177.993L109.458 177.74C109.457 177.764 109.457 177.787 109.457 177.812C109.457 178.307 109.626 178.871 109.935 179.406C110.241 179.938 110.647 180.368 111.076 180.616C111.097 180.628 111.118 180.638 111.14 180.651L110.715 180.897L110.983 181.363L112.11 180.714L112.108 180.712C112.331 180.556 112.453 180.24 112.453 179.821C112.453 179.325 112.284 178.76 111.977 178.228C111.667 177.693 111.264 177.265 110.835 177.017C110.447 176.793 110.097 176.75 109.845 176.895L108.749 177.527L109.019 177.993Z",
    fill: "url(#paint239_linear_3744_1590)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M110.881 178.859C111.189 179.392 111.357 179.958 111.357 180.453C111.357 180.899 111.218 181.226 110.969 181.372C110.718 181.516 110.368 181.472 109.98 181.249C109.551 181.001 109.146 180.572 108.838 180.039C108.532 179.506 108.362 178.94 108.362 178.446C108.362 177.999 108.5 177.672 108.75 177.526C109.001 177.382 109.352 177.427 109.741 177.65C110.167 177.897 110.573 178.325 110.881 178.859Z",
    fill: "url(#paint240_linear_3744_1590)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M110.702 178.963C110.955 179.402 111.095 179.87 111.095 180.278C111.095 180.647 110.981 180.915 110.773 181.033C110.566 181.155 110.278 181.116 109.959 180.934C109.604 180.73 109.272 180.375 109.016 179.936C108.763 179.495 108.623 179.031 108.623 178.62C108.623 178.253 108.737 177.983 108.943 177.864C109.151 177.746 109.441 177.78 109.76 177.965C110.112 178.17 110.448 178.524 110.702 178.963Z",
    fill: "url(#paint241_linear_3744_1590)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M109.156 178.114L110.682 180.759C110.695 180.778 110.687 180.806 110.666 180.82C110.647 180.833 110.616 180.825 110.605 180.804L109.077 178.159C109.066 178.138 109.072 178.109 109.095 178.097C109.117 178.086 109.145 178.093 109.156 178.114Z",
    fill: "#A8BAC1"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M112.668 179.944C112.668 180.19 112.633 180.404 112.561 180.576C112.491 180.75 112.385 180.883 112.249 180.969C112.246 180.973 112.236 180.976 112.228 180.982L111.95 181.142C111.919 181.158 111.888 181.176 111.861 181.194L111.597 181.346L111.36 181.484C111.312 181.512 111.265 181.538 111.227 181.561C111.109 181.629 111.026 181.677 110.999 181.693C110.998 181.695 110.998 181.695 110.996 181.699C110.993 181.699 110.99 181.699 110.987 181.7C110.703 181.866 110.306 181.816 109.866 181.561C109.381 181.28 108.921 180.794 108.574 180.191C108.226 179.584 108.033 178.944 108.033 178.384C108.033 177.912 108.167 177.561 108.413 177.383C108.413 177.383 108.413 177.383 108.416 177.381C108.434 177.366 108.453 177.355 108.472 177.345C108.478 177.341 108.484 177.338 108.49 177.335L109.764 176.597L109.767 176.6C109.776 176.597 109.781 176.594 109.79 176.592C109.921 176.533 110.073 176.518 110.242 176.542C110.424 176.567 110.625 176.642 110.833 176.765C110.845 176.772 110.857 176.777 110.869 176.787C111.254 177.019 111.624 177.378 111.931 177.824C111.999 177.924 112.066 178.027 112.128 178.136C112.478 178.74 112.668 179.383 112.668 179.944Z",
    fill: "#F0F7FA"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M110.887 178.853C110.54 178.249 110.079 177.762 109.594 177.482C109.156 177.227 108.758 177.179 108.474 177.344C108.19 177.507 108.034 177.876 108.034 178.383C108.034 178.944 108.225 179.585 108.574 180.189C108.922 180.792 109.381 181.28 109.867 181.559C110.306 181.814 110.704 181.863 110.987 181.698C111.273 181.536 111.429 181.164 111.429 180.66C111.429 180.098 111.237 179.455 110.887 178.853Z",
    fill: "#F0F7FA"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.319 178.527C110.069 178.095 109.74 177.747 109.395 177.547C109.082 177.366 108.795 177.333 108.596 177.448C108.393 177.567 108.279 177.828 108.279 178.192C108.279 178.591 108.416 179.051 108.666 179.482C108.916 179.913 109.243 180.26 109.59 180.46C109.903 180.642 110.188 180.677 110.391 180.56C110.592 180.444 110.705 180.179 110.705 179.818C110.704 179.417 110.567 178.958 110.319 178.527Z",
    fill: "white"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.244 176.543C110.244 176.543 109.037 177.204 108.942 177.257C108.763 177.247 108.592 177.263 108.414 177.383C108.697 177.214 109.129 176.973 109.791 176.592C109.924 176.533 110.075 176.518 110.244 176.543Z",
    fill: "white"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M111.933 177.824C111.459 178.12 110.935 178.445 110.704 178.581C110.528 178.301 110.011 177.779 109.683 177.536L110.871 176.787C111.256 177.02 111.625 177.379 111.933 177.824Z",
    fill: "white"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M112.562 180.576C112.492 180.75 112.386 180.883 112.25 180.969C112.153 181.024 112.051 181.083 111.951 181.142C111.92 181.158 111.889 181.176 111.862 181.194C111.772 181.245 111.682 181.297 111.598 181.346C111.513 181.396 111.432 181.441 111.361 181.484C111.313 181.512 111.266 181.538 111.228 181.561C111.11 181.629 111.027 181.677 111 181.693C111.093 181.636 111.185 181.55 111.239 181.454C111.268 181.407 111.295 181.354 111.317 181.305L112.562 180.576Z",
    fill: "white"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M112.443 158.563V187.066C112.443 187.1 112.44 187.137 112.434 187.172C112.43 187.225 112.418 187.272 112.402 187.316C112.353 187.46 112.257 187.552 112.131 187.582C112.096 187.593 112.063 187.595 112.023 187.595C111.926 187.594 111.815 187.561 111.699 187.495L98.7119 179.996C98.6086 179.934 98.5068 179.851 98.4153 179.754C98.2446 179.569 98.1061 179.328 98.0302 179.085C97.9903 178.959 97.9684 178.829 97.9684 178.709L97.9692 150.206C97.9692 150.183 97.97 150.163 97.9707 150.141C97.9754 150.085 97.984 150.031 97.9989 149.987C98.042 149.834 98.1343 149.735 98.2564 149.698C98.2893 149.685 98.3245 149.678 98.3628 149.676C98.4653 149.672 98.5851 149.705 98.7127 149.778L111.698 157.275C112.111 157.512 112.443 158.088 112.443 158.563Z",
    fill: "white"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 158.705V187.207C112.3 187.243 112.297 187.281 112.293 187.314C112.285 187.367 112.277 187.415 112.259 187.458C112.209 187.602 112.113 187.696 111.987 187.725C111.953 187.736 111.917 187.739 111.88 187.739C111.783 187.737 111.671 187.703 111.555 187.636L98.5679 180.139C98.4631 180.078 98.3629 179.995 98.2721 179.898C98.1015 179.713 97.9614 179.47 97.8863 179.23C97.8471 179.102 97.8229 178.972 97.8229 178.853V150.349C97.8229 150.326 97.8252 150.304 97.8268 150.284C97.8315 150.226 97.8417 150.175 97.8558 150.13C97.8988 149.977 97.9888 149.878 98.1125 149.84C98.1453 149.828 98.1813 149.823 98.2173 149.821C98.3222 149.816 98.4427 149.849 98.5679 149.922L111.555 157.418C111.968 157.653 112.3 158.23 112.3 158.705Z",
    fill: "url(#paint242_linear_3744_1590)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 159.217V159.419L110.937 157.059L111.112 157.16L112.3 159.217Z",
    fill: "#B6BCC1"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 160.156V160.358L110.126 156.592L110.302 156.692L112.3 160.156Z",
    fill: "#B6BCC1"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 161.093V161.295L109.315 156.123L109.489 156.226L112.3 161.093Z",
    fill: "#B6BCC1"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 162.03V162.233L108.502 155.656L108.678 155.756L112.3 162.03Z",
    fill: "#B6BCC1"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 162.967V163.168L107.691 155.188L107.867 155.288L112.3 162.967Z",
    fill: "#B6BCC1"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 163.904V164.105L106.88 154.719L107.055 154.819L112.3 163.904Z",
    fill: "#B6BCC1"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 164.839V165.043L106.068 154.248L106.244 154.351L112.3 164.839Z",
    fill: "#B6BCC1"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 165.776V165.98L105.258 153.781L105.43 153.882L112.3 165.776Z",
    fill: "#B6BCC1"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 166.713V166.914L104.443 153.312L104.621 153.413L112.3 166.713Z",
    fill: "#B6BCC1"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 167.65V167.854L103.635 152.844L103.811 152.945L112.3 167.65Z",
    fill: "#B6BCC1"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 168.588V168.79L102.824 152.377L102.997 152.478L112.3 168.588Z",
    fill: "#B6BCC1"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 169.526V169.728L102.011 151.908L102.187 152.008L112.3 169.526Z",
    fill: "#B6BCC1"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 170.462V170.664L101.201 151.439L101.374 151.54L112.3 170.462Z",
    fill: "#B6BCC1"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 171.399V171.602L100.388 150.971L100.565 151.072L112.3 171.399Z",
    fill: "#B6BCC1"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 172.335V172.537L99.5767 150.502L99.752 150.604L112.3 172.335Z",
    fill: "#B6BCC1"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 173.274V173.473L98.7651 150.033L98.9412 150.136L112.3 173.274Z",
    fill: "#B6BCC1"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 174.21V174.411L98.1132 149.84C98.146 149.827 98.182 149.823 98.218 149.82L112.3 174.21Z",
    fill: "#B6BCC1"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 175.146V175.351L97.8275 150.285C97.8322 150.227 97.8424 150.176 97.8565 150.131L112.3 175.146Z",
    fill: "#B6BCC1"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 176.082V176.284L97.8236 151.216V151.014L112.3 176.082Z",
    fill: "#B6BCC1"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 177.019V177.222L97.8236 152.153V151.949L112.3 177.019Z",
    fill: "#B6BCC1"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 177.957V178.158L97.8236 153.089V152.889L112.3 177.957Z",
    fill: "#B6BCC1"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 178.894V179.095L97.8236 154.028V153.824L112.3 178.894Z",
    fill: "#B6BCC1"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 179.832V180.036L97.8236 154.962V154.762L112.3 179.832Z",
    fill: "#B6BCC1"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 180.766V180.972L97.8236 155.9V155.697L112.3 180.766Z",
    fill: "#B6BCC1"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 181.702V181.905L97.8236 156.836V156.637L112.3 181.702Z",
    fill: "#B6BCC1"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 182.641V182.842L97.8236 157.776V157.572L112.3 182.641Z",
    fill: "#B6BCC1"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 183.577V183.781L97.8236 158.71V158.508L112.3 183.577Z",
    fill: "#B6BCC1"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 184.515V184.717L97.8236 159.648V159.447L112.3 184.515Z",
    fill: "#B6BCC1"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 185.454V185.654L97.8236 160.586V160.385L112.3 185.454Z",
    fill: "#B6BCC1"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M112.3 186.389V186.591L97.8236 161.522V161.318L112.3 186.389Z",
    fill: "#B6BCC1"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M112.293 187.314C112.285 187.367 112.277 187.414 112.259 187.458L97.8236 162.458V162.254L112.293 187.314Z",
    fill: "#B6BCC1"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M111.987 187.726C111.953 187.736 111.917 187.739 111.88 187.739L97.8236 163.396V163.195L111.987 187.726Z",
    fill: "#B6BCC1"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M111.318 187.5L111.141 187.399L97.8236 164.333V164.129L111.318 187.5Z",
    fill: "#B6BCC1"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M110.507 187.03L110.331 186.93L97.8236 165.268V165.066L110.507 187.03Z",
    fill: "#B6BCC1"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M109.696 186.563L109.52 186.462L97.8236 166.207V166.004L109.696 186.563Z",
    fill: "#B6BCC1"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M108.883 186.092L108.709 185.992L97.8236 167.142V166.939L108.883 186.092Z",
    fill: "#B6BCC1"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M108.071 185.626L107.896 185.525L97.8236 168.079V167.879L108.071 185.626Z",
    fill: "#B6BCC1"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M107.262 185.157L107.087 185.056L97.8236 169.016V168.814L107.262 185.157Z",
    fill: "#B6BCC1"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M106.45 184.688L106.274 184.587L97.8236 169.953V169.752L106.45 184.688Z",
    fill: "#B6BCC1"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M105.638 184.221L105.462 184.119L97.8236 170.893V170.689L105.638 184.221Z",
    fill: "#B6BCC1"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M104.826 183.754L104.651 183.651L97.8236 171.829V171.625L104.826 183.754Z",
    fill: "#B6BCC1"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M104.014 183.284L103.841 183.184L97.8236 172.766V172.564L104.014 183.284Z",
    fill: "#B6BCC1"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M103.203 182.816L103.029 182.715L97.8236 173.702V173.5L103.203 182.816Z",
    fill: "#B6BCC1"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M102.393 182.346L102.216 182.244L97.8236 174.64V174.436L102.393 182.346Z",
    fill: "#B6BCC1"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M101.583 181.876L101.405 181.776L97.8236 175.574V175.371L101.583 181.876Z",
    fill: "#B6BCC1"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M100.77 181.41L100.596 181.309L97.8236 176.512V176.311L100.77 181.41Z",
    fill: "#B6BCC1"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9578 180.942L99.7841 180.84L97.8236 177.449V177.248L99.9578 180.942Z",
    fill: "#B6BCC1"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1462 180.473L98.9717 180.372L97.8236 178.387V178.182L99.1462 180.473Z",
    fill: "#B6BCC1"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2728 179.898C98.1022 179.713 97.9621 179.471 97.887 179.23L98.2728 179.898Z",
    fill: "#B6BCC1"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M100.282 155.325C100.283 154.052 101.176 153.537 102.277 154.173C103.378 154.81 104.274 156.357 104.273 157.629C104.274 158.901 103.379 159.416 102.277 158.78C101.176 158.146 100.283 156.596 100.282 155.325Z",
    fill: "#F0F7FA"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M103.629 155.696C104.002 156.339 104.204 157.025 104.204 157.629C104.204 158.217 104.009 158.655 103.656 158.86C103.301 159.064 102.824 159.015 102.314 158.721C101.791 158.419 101.299 157.899 100.928 157.256C100.555 156.615 100.352 155.928 100.352 155.324C100.352 154.735 100.548 154.296 100.902 154.093C101.256 153.888 101.734 153.937 102.244 154.233C102.768 154.535 103.258 155.055 103.629 155.696Z",
    fill: "url(#paint243_linear_3744_1590)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M103.169 158.648C102.967 158.648 102.73 158.572 102.482 158.429C102.01 158.156 101.561 157.682 101.22 157.088C100.878 156.498 100.69 155.872 100.69 155.326C100.69 154.863 100.826 154.529 101.071 154.387C101.161 154.336 101.268 154.309 101.387 154.309C101.588 154.309 101.826 154.384 102.076 154.527C102.545 154.798 102.993 155.275 103.335 155.865C103.678 156.458 103.865 157.084 103.865 157.63C103.865 158.094 103.73 158.428 103.484 158.568C103.395 158.62 103.289 158.648 103.169 158.648Z",
    fill: "#9FA1A3"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 155.674L100.75 155.419C100.748 155.444 100.747 155.468 100.747 155.493C100.747 155.988 100.917 156.553 101.223 157.086C101.533 157.619 101.938 158.049 102.366 158.297C102.387 158.309 102.409 158.32 102.429 158.332L102.005 158.577L102.275 159.043L103.401 158.394V158.392C103.623 158.234 103.745 157.923 103.745 157.501C103.745 157.006 103.575 156.442 103.268 155.907C102.96 155.375 102.555 154.945 102.127 154.698C101.739 154.475 101.389 154.431 101.137 154.576L100.042 155.208L100.309 155.674Z",
    fill: "url(#paint244_linear_3744_1590)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M102.173 156.54C102.48 157.073 102.648 157.638 102.648 158.133C102.648 158.58 102.511 158.907 102.257 159.051C102.008 159.196 101.656 159.152 101.27 158.929C100.842 158.68 100.435 158.252 100.129 157.719C99.8194 157.185 99.6504 156.621 99.6504 156.124C99.6504 155.679 99.7889 155.353 100.04 155.207C100.291 155.062 100.642 155.105 101.029 155.329C101.457 155.578 101.864 156.007 102.173 156.54Z",
    fill: "url(#paint245_linear_3744_1590)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 156.642C102.246 157.083 102.385 157.549 102.385 157.957C102.385 158.326 102.273 158.595 102.065 158.715C101.857 158.833 101.569 158.797 101.25 158.614C100.895 158.409 100.561 158.055 100.307 157.615C100.054 157.175 99.9125 156.709 99.9125 156.301C99.9125 155.932 100.028 155.664 100.234 155.544C100.441 155.424 100.73 155.46 101.05 155.644C101.405 155.849 101.738 156.203 101.992 156.642Z",
    fill: "url(#paint246_linear_3744_1590)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M100.448 155.795L101.975 158.44C101.988 158.46 101.979 158.487 101.958 158.501C101.937 158.513 101.91 158.507 101.896 158.483L100.37 155.841C100.356 155.819 100.365 155.792 100.386 155.778C100.407 155.764 100.435 155.773 100.448 155.795Z",
    fill: "#A8BAC1"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.962 157.625C103.962 157.87 103.923 158.086 103.854 158.258C103.782 158.432 103.678 158.565 103.541 158.649C103.534 158.653 103.526 158.659 103.521 158.664L103.242 158.824C103.21 158.841 103.181 158.86 103.152 158.875L102.888 159.028L102.652 159.166C102.604 159.193 102.558 159.218 102.519 159.243C102.401 159.311 102.317 159.359 102.29 159.374C102.289 159.376 102.289 159.376 102.287 159.377C102.285 159.377 102.281 159.381 102.28 159.383C101.997 159.545 101.596 159.497 101.158 159.243C100.673 158.963 100.214 158.476 99.8663 157.872C99.5165 157.268 99.324 156.625 99.324 156.064C99.324 155.594 99.4594 155.243 99.7059 155.063C99.7059 155.063 99.7059 155.063 99.7075 155.062C99.727 155.049 99.745 155.037 99.7638 155.027C99.7685 155.023 99.7763 155.019 99.7834 155.016L101.058 154.278L101.06 154.283C101.068 154.278 101.075 154.274 101.083 154.274C101.214 154.215 101.367 154.199 101.536 154.224C101.718 154.25 101.917 154.325 102.128 154.447C102.14 154.454 102.152 154.461 102.163 154.469C102.548 154.699 102.918 155.06 103.225 155.506C103.292 155.606 103.358 155.71 103.419 155.819C103.767 156.422 103.962 157.064 103.962 157.625Z",
    fill: "#F0F7FA"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.179 156.535C101.83 155.93 101.371 155.443 100.885 155.163C100.446 154.91 100.049 154.861 99.7654 155.026C99.4805 155.19 99.324 155.558 99.324 156.064C99.324 156.625 99.5165 157.266 99.864 157.871C100.214 158.475 100.673 158.962 101.158 159.242C101.597 159.494 101.994 159.544 102.279 159.38C102.562 159.216 102.721 158.847 102.721 158.341C102.721 157.78 102.527 157.139 102.179 156.535Z",
    fill: "#F0F7FA"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.608 156.209C101.36 155.777 101.032 155.431 100.685 155.23C100.37 155.048 100.088 155.014 99.8835 155.13C99.6816 155.247 99.5681 155.512 99.5681 155.873C99.5681 156.274 99.7074 156.732 99.9563 157.162C100.204 157.594 100.532 157.942 100.881 158.143C101.192 158.323 101.477 158.358 101.681 158.24C101.883 158.124 101.995 157.861 101.997 157.498C101.994 157.099 101.857 156.641 101.608 156.209Z",
    fill: "white"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.535 154.224C101.535 154.224 100.33 154.885 100.235 154.939C100.056 154.931 99.8844 154.945 99.7059 155.063C99.9892 154.895 100.42 154.654 101.083 154.274C101.213 154.215 101.366 154.2 101.535 154.224Z",
    fill: "white"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.225 155.506C102.749 155.802 102.224 156.126 101.996 156.262C101.819 155.984 101.302 155.461 100.974 155.219L102.162 154.469C102.548 154.7 102.917 155.06 103.225 155.506Z",
    fill: "white"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.854 158.258C103.782 158.432 103.678 158.565 103.541 158.648C103.442 158.705 103.343 158.763 103.241 158.824C103.21 158.841 103.18 158.86 103.151 158.875C103.061 158.926 102.973 158.979 102.887 159.028C102.803 159.077 102.724 159.123 102.652 159.166C102.603 159.193 102.557 159.218 102.519 159.243C102.4 159.31 102.317 159.359 102.289 159.374C102.384 159.317 102.476 159.229 102.53 159.134C102.559 159.089 102.584 159.033 102.608 158.985L103.854 158.258Z",
    fill: "white"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M106.479 158.971C106.479 157.699 107.372 157.183 108.476 157.819C109.576 158.454 110.471 160.004 110.469 161.274C110.471 162.548 109.576 163.062 108.476 162.427C107.372 161.791 106.479 160.243 106.479 158.971Z",
    fill: "#F0F7FA"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M109.826 159.344C110.198 159.987 110.401 160.671 110.401 161.275C110.401 161.866 110.206 162.302 109.852 162.508C109.497 162.712 109.021 162.662 108.509 162.368C107.986 162.064 107.496 161.546 107.124 160.904C106.751 160.26 106.548 159.575 106.548 158.971C106.548 158.381 106.744 157.945 107.098 157.739C107.452 157.535 107.93 157.585 108.441 157.88C108.963 158.182 109.455 158.701 109.826 159.344Z",
    fill: "url(#paint247_linear_3744_1590)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M109.366 162.294C109.165 162.294 108.925 162.218 108.679 162.074C108.207 161.801 107.757 161.325 107.415 160.735C107.074 160.143 106.886 159.517 106.886 158.971C106.886 158.508 107.022 158.175 107.267 158.033C107.357 157.981 107.465 157.953 107.584 157.953C107.786 157.953 108.023 158.03 108.271 158.171C108.743 158.445 109.191 158.92 109.534 159.512C109.875 160.105 110.062 160.731 110.062 161.275C110.062 161.738 109.927 162.073 109.68 162.214C109.591 162.267 109.485 162.294 109.366 162.294Z",
    fill: "#9FA1A3"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M106.506 159.32L106.945 159.066C106.944 159.09 106.944 159.114 106.944 159.138C106.944 159.633 107.113 160.2 107.421 160.733C107.728 161.266 108.135 161.696 108.561 161.943C108.585 161.956 108.604 161.966 108.626 161.977L108.201 162.221L108.472 162.689L109.597 162.039L109.597 162.036C109.82 161.88 109.942 161.567 109.942 161.148C109.942 160.652 109.773 160.087 109.464 159.554C109.157 159.02 108.751 158.591 108.322 158.342C107.936 158.119 107.585 158.076 107.332 158.221L106.237 158.854L106.506 159.32Z",
    fill: "url(#paint248_linear_3744_1590)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M108.366 160.186C108.675 160.719 108.845 161.285 108.845 161.78C108.845 162.226 108.706 162.551 108.455 162.697C108.204 162.842 107.853 162.799 107.466 162.576C107.038 162.328 106.632 161.898 106.325 161.365C106.016 160.833 105.847 160.266 105.847 159.772C105.847 159.325 105.986 158.999 106.235 158.854C106.487 158.71 106.838 158.751 107.225 158.975C107.653 159.223 108.06 159.653 108.366 160.186Z",
    fill: "url(#paint249_linear_3744_1590)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M108.189 160.288C108.442 160.729 108.582 161.194 108.581 161.603C108.581 161.972 108.467 162.24 108.261 162.36C108.053 162.479 107.764 162.445 107.446 162.259C107.092 162.055 106.756 161.701 106.504 161.262C106.248 160.822 106.108 160.355 106.108 159.947C106.108 159.576 106.223 159.31 106.43 159.19C106.637 159.072 106.927 159.106 107.246 159.291C107.6 159.494 107.935 159.848 108.189 160.288Z",
    fill: "url(#paint250_linear_3744_1590)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M106.645 159.441L108.172 162.084C108.183 162.106 108.176 162.135 108.155 162.147C108.133 162.159 108.106 162.152 108.093 162.129L106.566 159.487C106.553 159.465 106.56 159.437 106.583 159.424C106.604 159.412 106.631 159.419 106.645 159.441Z",
    fill: "#A8BAC1"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.157 161.27C110.157 161.516 110.121 161.73 110.05 161.902C109.979 162.078 109.875 162.211 109.739 162.295C109.732 162.301 109.724 162.303 109.717 162.31L109.437 162.47C109.408 162.486 109.378 162.506 109.349 162.521L109.084 162.673L108.847 162.81C108.799 162.839 108.755 162.864 108.715 162.889C108.597 162.958 108.514 163.004 108.485 163.022C108.485 163.023 108.485 163.023 108.482 163.024C108.482 163.024 108.477 163.026 108.477 163.027C108.193 163.192 107.793 163.142 107.355 162.889C106.869 162.608 106.41 162.119 106.062 161.518C105.713 160.913 105.522 160.272 105.522 159.71C105.522 159.24 105.657 158.889 105.904 158.709C105.904 158.709 105.904 158.709 105.906 158.709C105.925 158.694 105.944 158.683 105.961 158.673C105.967 158.67 105.972 158.666 105.979 158.663L107.253 157.925L107.255 157.928C107.264 157.925 107.271 157.922 107.279 157.92C107.412 157.861 107.564 157.846 107.733 157.871C107.915 157.896 108.114 157.97 108.324 158.092C108.337 158.098 108.347 158.105 108.359 158.115C108.745 158.346 109.114 158.706 109.421 159.151C109.488 159.249 109.555 159.354 109.617 159.462C109.965 160.067 110.157 160.708 110.157 161.27Z",
    fill: "#F0F7FA"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.376 160.181C108.026 159.577 107.566 159.09 107.082 158.81C106.644 158.557 106.246 158.508 105.961 158.67C105.677 158.835 105.521 159.206 105.521 159.71C105.521 160.272 105.712 160.913 106.061 161.518C106.41 162.12 106.868 162.609 107.354 162.889C107.792 163.142 108.192 163.191 108.476 163.027C108.759 162.862 108.916 162.493 108.916 161.987C108.916 161.428 108.723 160.786 108.376 160.181Z",
    fill: "#F0F7FA"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.806 159.856C107.556 159.427 107.228 159.077 106.882 158.877C106.568 158.696 106.284 158.662 106.08 158.779C105.878 158.896 105.766 159.159 105.766 159.521C105.766 159.922 105.903 160.379 106.152 160.811C106.402 161.242 106.728 161.589 107.076 161.79C107.39 161.971 107.672 162.006 107.876 161.888C108.08 161.772 108.192 161.508 108.192 161.146C108.192 160.745 108.053 160.287 107.806 159.856Z",
    fill: "white"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.732 157.871C107.732 157.871 106.525 158.531 106.431 158.586C106.251 158.576 106.079 158.591 105.903 158.709C106.185 158.54 106.615 158.299 107.278 157.919C107.411 157.861 107.563 157.846 107.732 157.871Z",
    fill: "white"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.42 159.151C108.947 159.447 108.422 159.772 108.192 159.907C108.014 159.629 107.498 159.108 107.17 158.863L108.359 158.115C108.745 158.347 109.114 158.706 109.42 159.151Z",
    fill: "white"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.05 161.902C109.979 162.078 109.874 162.211 109.739 162.296C109.64 162.352 109.539 162.412 109.437 162.471C109.408 162.487 109.377 162.507 109.348 162.521C109.258 162.572 109.168 162.626 109.084 162.674C108.999 162.723 108.92 162.768 108.847 162.811C108.798 162.839 108.754 162.865 108.715 162.889C108.597 162.958 108.514 163.005 108.485 163.022C108.578 162.964 108.671 162.878 108.725 162.782C108.756 162.734 108.779 162.682 108.805 162.633L110.05 161.902Z",
    fill: "white"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M100.282 162.088C100.283 160.816 101.176 160.301 102.277 160.936C103.378 161.573 104.274 163.121 104.273 164.392C104.274 165.666 103.379 166.179 102.277 165.546C101.176 164.909 100.283 163.361 100.282 162.088Z",
    fill: "#F0F7FA"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M103.629 162.462C104.002 163.104 104.204 163.789 104.204 164.393C104.204 164.984 104.009 165.42 103.656 165.624C103.301 165.83 102.824 165.779 102.314 165.485C101.791 165.183 101.299 164.664 100.928 164.022C100.555 163.379 100.352 162.692 100.352 162.088C100.352 161.498 100.548 161.06 100.902 160.857C101.256 160.652 101.734 160.702 102.244 160.998C102.768 161.297 103.258 161.818 103.629 162.462Z",
    fill: "url(#paint251_linear_3744_1590)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M103.169 165.409C102.967 165.409 102.73 165.333 102.482 165.19C102.01 164.918 101.561 164.443 101.22 163.851C100.878 163.26 100.69 162.633 100.69 162.088C100.69 161.624 100.826 161.29 101.071 161.15C101.161 161.097 101.268 161.07 101.387 161.07C101.588 161.07 101.826 161.147 102.076 161.289C102.545 161.561 102.993 162.036 103.335 162.629C103.678 163.22 103.865 163.846 103.865 164.392C103.865 164.855 103.73 165.188 103.484 165.329C103.395 165.383 103.289 165.409 103.169 165.409Z",
    fill: "#9FA1A3"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 162.438L100.75 162.183C100.748 162.207 100.747 162.23 100.747 162.255C100.747 162.751 100.917 163.317 101.223 163.85C101.533 164.384 101.938 164.812 102.366 165.058C102.387 165.072 102.409 165.084 102.429 165.095L102.005 165.338L102.275 165.805L103.401 165.156V165.153C103.623 164.998 103.745 164.685 103.745 164.264C103.745 163.768 103.575 163.204 103.268 162.669C102.96 162.137 102.555 161.707 102.127 161.459C101.739 161.237 101.389 161.193 101.137 161.338L100.042 161.971L100.309 162.438Z",
    fill: "url(#paint252_linear_3744_1590)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M102.173 163.304C102.48 163.837 102.648 164.401 102.648 164.897C102.648 165.343 102.511 165.67 102.257 165.815C102.008 165.959 101.656 165.915 101.27 165.693C100.842 165.445 100.435 165.017 100.129 164.483C99.8194 163.948 99.6504 163.384 99.6504 162.889C99.6504 162.443 99.7889 162.117 100.04 161.971C100.291 161.826 100.642 161.869 101.029 162.093C101.457 162.341 101.864 162.769 102.173 163.304Z",
    fill: "url(#paint253_linear_3744_1590)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 163.406C102.246 163.846 102.385 164.311 102.385 164.721C102.385 165.09 102.273 165.358 102.065 165.478C101.857 165.596 101.569 165.56 101.25 165.379C100.895 165.171 100.561 164.818 100.307 164.379C100.054 163.94 99.9125 163.472 99.9125 163.063C99.9125 162.695 100.028 162.427 100.234 162.308C100.441 162.188 100.73 162.224 101.05 162.407C101.405 162.612 101.738 162.966 101.992 163.406Z",
    fill: "url(#paint254_linear_3744_1590)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M100.448 162.558L101.975 165.203C101.988 165.224 101.979 165.253 101.958 165.265C101.937 165.277 101.91 165.269 101.896 165.248L100.37 162.603C100.356 162.582 100.365 162.553 100.386 162.542C100.407 162.528 100.435 162.535 100.448 162.558Z",
    fill: "#A8BAC1"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.962 164.387C103.962 164.632 103.923 164.847 103.854 165.019C103.782 165.194 103.678 165.327 103.541 165.411C103.534 165.417 103.526 165.421 103.521 165.427L103.242 165.586C103.21 165.603 103.181 165.622 103.152 165.638L102.888 165.79L102.652 165.928C102.604 165.957 102.558 165.98 102.519 166.006C102.401 166.073 102.317 166.122 102.29 166.136C102.289 166.139 102.289 166.139 102.287 166.14C102.285 166.14 102.281 166.144 102.28 166.145C101.997 166.307 101.596 166.259 101.158 166.006C100.673 165.726 100.214 165.238 99.8663 164.634C99.5165 164.029 99.324 163.387 99.324 162.826C99.324 162.357 99.4594 162.004 99.7059 161.826C99.7059 161.826 99.7059 161.826 99.7075 161.824C99.727 161.811 99.745 161.799 99.7638 161.788C99.7685 161.785 99.7763 161.781 99.7834 161.778L101.058 161.041L101.06 161.045C101.068 161.041 101.075 161.038 101.083 161.036C101.214 160.976 101.367 160.961 101.536 160.986C101.718 161.013 101.917 161.086 102.128 161.208C102.14 161.215 102.152 161.22 102.163 161.231C102.548 161.461 102.918 161.821 103.225 162.268C103.292 162.368 103.358 162.471 103.419 162.577C103.767 163.183 103.962 163.824 103.962 164.387Z",
    fill: "#F0F7FA"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.179 163.297C101.83 162.693 101.371 162.205 100.885 161.925C100.446 161.672 100.049 161.623 99.7654 161.786C99.4805 161.95 99.324 162.321 99.324 162.826C99.324 163.387 99.5165 164.028 99.864 164.633C100.214 165.238 100.673 165.725 101.158 166.005C101.597 166.257 101.994 166.307 102.279 166.143C102.562 165.979 102.721 165.609 102.721 165.103C102.721 164.543 102.527 163.902 102.179 163.297Z",
    fill: "#F0F7FA"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.608 162.972C101.36 162.54 101.032 162.193 100.685 161.992C100.37 161.812 100.088 161.778 99.8835 161.893C99.6816 162.011 99.5681 162.275 99.5681 162.636C99.5681 163.038 99.7074 163.495 99.9563 163.926C100.204 164.358 100.532 164.705 100.881 164.904C101.192 165.086 101.477 165.12 101.681 165.004C101.883 164.886 101.995 164.622 101.997 164.262C101.994 163.862 101.857 163.403 101.608 162.972Z",
    fill: "white"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.535 160.987C101.535 160.987 100.33 161.649 100.235 161.701C100.056 161.693 99.8844 161.707 99.7059 161.826C99.9892 161.656 100.42 161.416 101.083 161.035C101.213 160.976 101.366 160.961 101.535 160.987Z",
    fill: "white"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.225 162.269C102.749 162.564 102.224 162.89 101.996 163.025C101.819 162.745 101.302 162.224 100.974 161.98L102.162 161.232C102.548 161.463 102.917 161.822 103.225 162.269Z",
    fill: "white"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.854 165.02C103.782 165.194 103.678 165.328 103.541 165.412C103.442 165.466 103.343 165.527 103.241 165.586C103.21 165.603 103.18 165.622 103.151 165.639C103.061 165.69 102.973 165.742 102.887 165.79C102.803 165.841 102.724 165.884 102.652 165.928C102.603 165.957 102.557 165.981 102.519 166.006C102.4 166.074 102.317 166.122 102.289 166.136C102.384 166.08 102.476 165.994 102.53 165.897C102.559 165.85 102.584 165.797 102.608 165.748L103.854 165.02Z",
    fill: "white"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M106.479 165.733C106.479 164.462 107.372 163.944 108.476 164.581C109.576 165.218 110.471 166.764 110.469 168.037C110.471 169.309 109.576 169.826 108.476 169.189C107.372 168.554 106.479 167.006 106.479 165.733Z",
    fill: "#F0F7FA"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M109.826 166.108C110.198 166.748 110.401 167.435 110.401 168.038C110.401 168.629 110.206 169.066 109.852 169.27C109.497 169.476 109.021 169.427 108.509 169.13C107.986 168.83 107.496 168.308 107.124 167.667C106.751 167.025 106.548 166.339 106.548 165.734C106.548 165.146 106.744 164.708 107.098 164.502C107.452 164.299 107.93 164.348 108.441 164.643C108.963 164.945 109.455 165.464 109.826 166.108Z",
    fill: "url(#paint255_linear_3744_1590)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M109.366 169.055C109.165 169.055 108.925 168.979 108.679 168.837C108.207 168.565 107.757 168.087 107.415 167.496C107.074 166.904 106.886 166.278 106.886 165.732C106.886 165.268 107.022 164.936 107.267 164.794C107.357 164.741 107.465 164.715 107.584 164.715C107.786 164.715 108.023 164.791 108.271 164.932C108.743 165.207 109.191 165.681 109.534 166.274C109.875 166.866 110.062 167.492 110.062 168.036C110.062 168.499 109.927 168.835 109.68 168.976C109.591 169.029 109.485 169.055 109.366 169.055Z",
    fill: "#9FA1A3"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M106.506 166.084L106.945 165.83C106.944 165.852 106.944 165.877 106.944 165.9C106.944 166.395 107.113 166.963 107.421 167.496C107.728 168.029 108.135 168.458 108.561 168.706C108.585 168.718 108.604 168.73 108.626 168.74L108.201 168.984L108.472 169.452L109.597 168.803L109.597 168.8C109.82 168.644 109.942 168.331 109.942 167.91C109.942 167.416 109.773 166.851 109.464 166.317C109.157 165.783 108.751 165.354 108.322 165.105C107.936 164.883 107.585 164.839 107.332 164.985L106.237 165.618L106.506 166.084Z",
    fill: "url(#paint256_linear_3744_1590)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M108.366 166.946C108.675 167.481 108.845 168.047 108.845 168.54C108.845 168.987 108.706 169.314 108.455 169.459C108.204 169.604 107.853 169.563 107.466 169.337C107.038 169.09 106.632 168.661 106.325 168.127C106.016 167.594 105.847 167.027 105.847 166.533C105.847 166.086 105.986 165.761 106.235 165.616C106.487 165.471 106.838 165.513 107.225 165.736C107.653 165.985 108.06 166.414 108.366 166.946Z",
    fill: "url(#paint257_linear_3744_1590)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M108.189 167.05C108.442 167.489 108.582 167.957 108.581 168.365C108.581 168.735 108.467 169.002 108.261 169.122C108.053 169.242 107.764 169.206 107.446 169.021C107.092 168.818 106.756 168.464 106.504 168.024C106.248 167.585 106.108 167.119 106.108 166.71C106.108 166.341 106.223 166.07 106.43 165.952C106.637 165.833 106.927 165.869 107.246 166.053C107.6 166.256 107.935 166.611 108.189 167.05Z",
    fill: "url(#paint258_linear_3744_1590)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M106.645 166.201L108.172 168.846C108.183 168.868 108.176 168.895 108.155 168.908C108.133 168.92 108.106 168.914 108.093 168.892L106.566 166.248C106.553 166.225 106.56 166.198 106.583 166.185C106.604 166.174 106.631 166.18 106.645 166.201Z",
    fill: "#A8BAC1"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.157 168.034C110.157 168.279 110.121 168.492 110.05 168.665C109.979 168.841 109.875 168.973 109.739 169.058C109.732 169.063 109.724 169.067 109.717 169.071L109.437 169.231C109.408 169.249 109.378 169.267 109.349 169.284L109.084 169.435L108.847 169.572C108.799 169.602 108.755 169.627 108.715 169.651C108.597 169.719 108.514 169.768 108.485 169.784C108.485 169.784 108.485 169.784 108.482 169.786C108.482 169.786 108.477 169.786 108.477 169.79C108.193 169.954 107.793 169.904 107.355 169.651C106.869 169.371 106.41 168.882 106.062 168.28C105.713 167.675 105.522 167.036 105.522 166.473C105.522 166.002 105.657 165.651 105.904 165.472C105.904 165.472 105.904 165.472 105.906 165.468C105.925 165.456 105.944 165.447 105.961 165.433C105.967 165.43 105.972 165.428 105.979 165.424L107.253 164.688L107.255 164.691C107.264 164.688 107.271 164.685 107.279 164.682C107.412 164.622 107.564 164.608 107.733 164.633C107.915 164.658 108.114 164.733 108.324 164.854C108.337 164.861 108.347 164.87 108.359 164.875C108.745 165.108 109.114 165.466 109.421 165.913C109.488 166.012 109.555 166.115 109.617 166.224C109.965 166.829 110.157 167.472 110.157 168.034Z",
    fill: "#F0F7FA"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.376 166.943C108.026 166.339 107.566 165.851 107.082 165.571C106.644 165.319 106.246 165.269 105.961 165.433C105.677 165.597 105.521 165.968 105.521 166.473C105.521 167.036 105.712 167.674 106.061 168.279C106.41 168.883 106.868 169.37 107.354 169.65C107.792 169.903 108.192 169.953 108.476 169.788C108.759 169.624 108.916 169.255 108.916 168.749C108.916 168.188 108.723 167.547 108.376 166.943Z",
    fill: "#F0F7FA"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.806 166.615C107.556 166.185 107.228 165.836 106.882 165.638C106.568 165.455 106.284 165.422 106.08 165.539C105.878 165.654 105.766 165.918 105.766 166.281C105.766 166.682 105.903 167.141 106.152 167.571C106.402 168.001 106.728 168.35 107.076 168.55C107.39 168.73 107.672 168.766 107.876 168.649C108.08 168.532 108.192 168.269 108.192 167.906C108.192 167.506 108.053 167.048 107.806 166.615Z",
    fill: "white"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.732 164.634C107.732 164.634 106.525 165.294 106.431 165.347C106.251 165.337 106.079 165.353 105.903 165.471C106.185 165.302 106.615 165.063 107.278 164.681C107.411 164.621 107.563 164.608 107.732 164.634Z",
    fill: "white"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.42 165.915C108.947 166.211 108.422 166.534 108.192 166.671C108.014 166.393 107.498 165.869 107.17 165.627L108.359 164.877C108.745 165.109 109.114 165.467 109.42 165.915Z",
    fill: "white"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.05 168.664C109.979 168.84 109.874 168.972 109.739 169.057C109.64 169.113 109.539 169.172 109.437 169.231C109.408 169.249 109.377 169.266 109.348 169.283C109.258 169.334 109.168 169.386 109.084 169.434C108.999 169.483 108.92 169.53 108.847 169.571C108.798 169.602 108.754 169.626 108.715 169.65C108.597 169.718 108.514 169.768 108.485 169.783C108.578 169.725 108.671 169.639 108.725 169.542C108.756 169.497 108.779 169.442 108.805 169.393L110.05 168.664Z",
    fill: "white"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M100.282 168.85C100.283 167.578 101.176 167.062 102.277 167.698C103.378 168.335 104.274 169.882 104.273 171.154C104.274 172.427 103.379 172.943 102.277 172.306C101.176 171.669 100.283 170.123 100.282 168.85Z",
    fill: "#F0F7FA"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M103.629 169.222C104.002 169.864 104.204 170.551 104.204 171.155C104.204 171.743 104.009 172.182 103.656 172.386C103.301 172.593 102.824 172.542 102.314 172.247C101.791 171.945 101.299 171.425 100.928 170.782C100.555 170.139 100.352 169.453 100.352 168.849C100.352 168.262 100.548 167.823 100.902 167.618C101.256 167.413 101.734 167.464 102.244 167.758C102.768 168.059 103.258 168.58 103.629 169.222Z",
    fill: "url(#paint259_linear_3744_1590)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M103.169 172.172C102.967 172.172 102.73 172.097 102.482 171.953C102.01 171.681 101.561 171.206 101.22 170.611C100.878 170.023 100.69 169.396 100.69 168.849C100.69 168.387 100.826 168.053 101.071 167.911C101.161 167.859 101.268 167.832 101.387 167.832C101.588 167.832 101.826 167.907 102.076 168.051C102.545 168.323 102.993 168.799 103.335 169.391C103.678 169.982 103.865 170.608 103.865 171.154C103.865 171.617 103.73 171.951 103.484 172.093C103.395 172.145 103.289 172.172 103.169 172.172Z",
    fill: "#9FA1A3"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 169.2L100.75 168.945C100.748 168.969 100.747 168.993 100.747 169.017C100.747 169.511 100.917 170.079 101.223 170.61C101.533 171.144 101.938 171.573 102.366 171.821C102.387 171.832 102.409 171.846 102.429 171.856L102.005 172.102L102.275 172.568L103.401 171.918V171.916C103.623 171.76 103.745 171.447 103.745 171.026C103.745 170.531 103.575 169.965 103.268 169.432C102.96 168.899 102.555 168.469 102.127 168.222C101.739 167.998 101.389 167.955 101.137 168.1L100.042 168.733L100.309 169.2Z",
    fill: "url(#paint260_linear_3744_1590)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M102.173 170.061C102.48 170.596 102.648 171.161 102.648 171.657C102.648 172.104 102.511 172.429 102.257 172.573C102.008 172.718 101.656 172.676 101.27 172.452C100.842 172.205 100.435 171.775 100.129 171.242C99.8194 170.708 99.6504 170.143 99.6504 169.648C99.6504 169.201 99.7889 168.876 100.04 168.731C100.291 168.586 100.642 168.629 101.029 168.852C101.457 169.1 101.864 169.53 102.173 170.061Z",
    fill: "url(#paint261_linear_3744_1590)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 170.167C102.246 170.606 102.385 171.072 102.385 171.482C102.385 171.85 102.273 172.119 102.065 172.239C101.857 172.359 101.569 172.322 101.25 172.138C100.895 171.933 100.561 171.58 100.307 171.141C100.054 170.701 99.9125 170.234 99.9125 169.826C99.9125 169.458 100.028 169.188 100.234 169.069C100.441 168.95 100.73 168.986 101.05 169.169C101.405 169.373 101.738 169.726 101.992 170.167Z",
    fill: "url(#paint262_linear_3744_1590)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M100.448 169.321L101.975 171.963C101.988 171.985 101.979 172.013 101.958 172.025C101.937 172.039 101.91 172.032 101.896 172.009L100.37 169.364C100.356 169.342 100.365 169.314 100.386 169.302C100.407 169.291 100.435 169.299 100.448 169.321Z",
    fill: "#A8BAC1"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.962 171.148C103.962 171.393 103.923 171.608 103.854 171.781C103.782 171.953 103.678 172.089 103.541 172.173C103.534 172.179 103.526 172.182 103.521 172.188L103.242 172.348C103.21 172.366 103.181 172.382 103.152 172.4L102.888 172.551L102.652 172.689C102.604 172.717 102.558 172.743 102.519 172.767C102.401 172.835 102.317 172.882 102.29 172.898C102.289 172.9 102.289 172.9 102.287 172.902C102.285 172.902 102.281 172.903 102.28 172.908C101.997 173.069 101.596 173.019 101.158 172.767C100.673 172.486 100.214 172 99.8663 171.397C99.5165 170.791 99.324 170.15 99.324 169.588C99.324 169.118 99.4594 168.766 99.7059 168.587C99.7059 168.587 99.7059 168.587 99.7075 168.584C99.727 168.571 99.745 168.561 99.7638 168.55C99.7685 168.547 99.7763 168.543 99.7834 168.538L101.058 167.803L101.06 167.806C101.068 167.803 101.075 167.799 101.083 167.797C101.214 167.738 101.367 167.723 101.536 167.749C101.718 167.774 101.917 167.848 102.128 167.97C102.14 167.977 102.152 167.983 102.163 167.991C102.548 168.223 102.918 168.582 103.225 169.029C103.292 169.128 103.358 169.232 103.419 169.34C103.767 169.944 103.962 170.587 103.962 171.148Z",
    fill: "#F0F7FA"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.179 170.058C101.83 169.455 101.371 168.968 100.885 168.687C100.446 168.435 100.049 168.384 99.7654 168.548C99.4805 168.713 99.324 169.082 99.324 169.589C99.324 170.149 99.5165 170.79 99.864 171.394C100.214 171.999 100.673 172.485 101.158 172.766C101.597 173.018 101.994 173.068 102.279 172.904C102.562 172.741 102.721 172.37 102.721 171.864C102.721 171.304 102.527 170.661 102.179 170.058Z",
    fill: "#F0F7FA"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.608 169.733C101.36 169.301 101.032 168.954 100.685 168.754C100.37 168.574 100.088 168.539 99.8835 168.655C99.6816 168.773 99.5681 169.036 99.5681 169.398C99.5681 169.798 99.7074 170.256 99.9563 170.687C100.204 171.119 100.532 171.467 100.881 171.667C101.192 171.849 101.477 171.883 101.681 171.766C101.883 171.648 101.995 171.386 101.997 171.024C101.994 170.623 101.857 170.164 101.608 169.733Z",
    fill: "white"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.535 167.749C101.535 167.749 100.33 168.41 100.235 168.462C100.056 168.454 99.8844 168.468 99.7059 168.586C99.9892 168.417 100.42 168.178 101.083 167.796C101.213 167.738 101.366 167.723 101.535 167.749Z",
    fill: "white"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.225 169.03C102.749 169.326 102.224 169.65 101.996 169.784C101.819 169.508 101.302 168.985 100.974 168.742L102.162 167.992C102.548 168.224 102.917 168.583 103.225 169.03Z",
    fill: "white"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.854 171.781C103.782 171.953 103.678 172.089 103.541 172.173C103.442 172.23 103.343 172.288 103.241 172.348C103.21 172.366 103.18 172.382 103.151 172.4C103.061 172.45 102.973 172.504 102.887 172.551C102.803 172.601 102.724 172.648 102.652 172.689C102.603 172.717 102.557 172.743 102.519 172.767C102.4 172.835 102.317 172.882 102.289 172.898C102.384 172.842 102.476 172.754 102.53 172.659C102.559 172.612 102.584 172.558 102.608 172.51L103.854 171.781Z",
    fill: "white"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M106.479 172.496C106.479 171.222 107.372 170.707 108.476 171.343C109.576 171.979 110.471 173.526 110.469 174.798C110.471 176.071 109.576 176.586 108.476 175.951C107.372 175.315 106.479 173.767 106.479 172.496Z",
    fill: "#F0F7FA"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M109.826 172.867C110.198 173.509 110.401 174.195 110.401 174.798C110.401 175.389 110.206 175.826 109.852 176.029C109.497 176.235 109.021 176.185 108.509 175.89C107.986 175.588 107.496 175.068 107.124 174.426C106.751 173.783 106.548 173.097 106.548 172.495C106.548 171.906 106.744 171.467 107.098 171.261C107.452 171.059 107.93 171.108 108.441 171.402C108.963 171.705 109.455 172.223 109.826 172.867Z",
    fill: "url(#paint263_linear_3744_1590)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M109.366 175.817C109.165 175.817 108.925 175.74 108.679 175.598C108.207 175.325 107.757 174.85 107.415 174.258C107.074 173.666 106.886 173.041 106.886 172.496C106.886 172.031 107.022 171.696 107.267 171.556C107.357 171.504 107.465 171.477 107.584 171.477C107.786 171.477 108.023 171.553 108.271 171.696C108.743 171.969 109.191 172.444 109.534 173.035C109.875 173.63 110.062 174.255 110.062 174.798C110.062 175.262 109.927 175.596 109.68 175.738C109.591 175.79 109.485 175.817 109.366 175.817Z",
    fill: "#9FA1A3"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M106.506 172.843L106.945 172.592C106.944 172.613 106.944 172.636 106.944 172.66C106.944 173.156 107.113 173.722 107.421 174.256C107.728 174.789 108.135 175.219 108.561 175.466C108.585 175.478 108.604 175.489 108.626 175.5L108.201 175.745L108.472 176.212L109.597 175.562L109.597 175.559C109.82 175.404 109.942 175.09 109.942 174.671C109.942 174.175 109.773 173.608 109.464 173.076C109.157 172.542 108.751 172.113 108.322 171.865C107.936 171.642 107.585 171.6 107.332 171.744L106.237 172.376L106.506 172.843Z",
    fill: "url(#paint264_linear_3744_1590)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M108.366 173.709C108.675 174.242 108.845 174.809 108.845 175.304C108.845 175.75 108.706 176.076 108.455 176.22C108.204 176.366 107.853 176.321 107.466 176.099C107.038 175.852 106.632 175.421 106.325 174.889C106.016 174.355 105.847 173.79 105.847 173.294C105.847 172.848 105.986 172.522 106.235 172.377C106.487 172.233 106.838 172.276 107.225 172.499C107.653 172.746 108.06 173.176 108.366 173.709Z",
    fill: "url(#paint265_linear_3744_1590)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M108.189 173.812C108.442 174.253 108.582 174.719 108.581 175.126C108.581 175.497 108.467 175.764 108.261 175.884C108.053 176.002 107.764 175.967 107.446 175.783C107.092 175.58 106.756 175.225 106.504 174.787C106.248 174.345 106.108 173.879 106.108 173.472C106.108 173.102 106.223 172.834 106.43 172.713C106.637 172.595 106.927 172.631 107.246 172.814C107.6 173.018 107.935 173.374 108.189 173.812Z",
    fill: "url(#paint266_linear_3744_1590)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M106.645 172.964L108.172 175.608C108.183 175.63 108.176 175.658 108.155 175.668C108.133 175.682 108.106 175.673 108.093 175.654L106.566 173.009C106.553 172.989 106.56 172.959 106.583 172.947C106.604 172.935 106.631 172.943 106.645 172.964Z",
    fill: "#A8BAC1"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.157 174.794C110.157 175.039 110.121 175.254 110.05 175.425C109.979 175.601 109.875 175.735 109.739 175.82C109.732 175.824 109.724 175.828 109.717 175.833L109.437 175.995C109.408 176.01 109.378 176.028 109.349 176.046L109.084 176.198L108.847 176.336C108.799 176.364 108.755 176.389 108.715 176.413C108.597 176.482 108.514 176.529 108.485 176.544C108.485 176.546 108.485 176.546 108.482 176.548C108.482 176.548 108.477 176.55 108.477 176.553C108.193 176.717 107.793 176.667 107.355 176.413C106.869 176.133 106.41 175.646 106.062 175.041C105.713 174.437 105.522 173.796 105.522 173.234C105.522 172.764 105.657 172.412 105.904 172.234C105.904 172.234 105.904 172.234 105.906 172.232C105.925 172.219 105.944 172.206 105.961 172.197C105.967 172.192 105.972 172.19 105.979 172.188L107.253 171.448L107.255 171.452C107.264 171.448 107.271 171.446 107.279 171.445C107.412 171.386 107.564 171.369 107.733 171.394C107.915 171.421 108.114 171.495 108.324 171.618C108.337 171.624 108.347 171.631 108.359 171.639C108.745 171.87 109.114 172.232 109.421 172.677C109.488 172.777 109.555 172.881 109.617 172.987C109.965 173.591 110.157 174.232 110.157 174.794Z",
    fill: "#F0F7FA"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.376 173.706C108.026 173.101 107.566 172.613 107.082 172.333C106.644 172.081 106.246 172.031 105.961 172.194C105.677 172.36 105.521 172.729 105.521 173.234C105.521 173.795 105.712 174.437 106.061 175.041C106.41 175.644 106.868 176.133 107.354 176.412C107.792 176.665 108.192 176.714 108.476 176.551C108.759 176.385 108.916 176.017 108.916 175.51C108.916 174.95 108.723 174.309 108.376 173.706Z",
    fill: "#F0F7FA"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.806 173.38C107.556 172.949 107.228 172.601 106.882 172.402C106.568 172.22 106.284 172.186 106.08 172.302C105.878 172.42 105.766 172.682 105.766 173.043C105.766 173.445 105.903 173.904 106.152 174.335C106.402 174.766 106.728 175.114 107.076 175.315C107.39 175.495 107.672 175.53 107.876 175.412C108.08 175.295 108.192 175.033 108.192 174.671C108.192 174.27 108.053 173.811 107.806 173.38Z",
    fill: "white"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.732 171.394C107.732 171.394 106.525 172.055 106.431 172.109C106.251 172.101 106.079 172.114 105.903 172.234C106.185 172.066 106.615 171.825 107.278 171.445C107.411 171.386 107.563 171.369 107.732 171.394Z",
    fill: "white"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.42 172.677C108.947 172.972 108.422 173.298 108.192 173.432C108.014 173.154 107.498 172.631 107.17 172.388L108.359 171.639C108.745 171.87 109.114 172.232 109.42 172.677Z",
    fill: "white"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.05 175.426C109.979 175.602 109.874 175.736 109.739 175.821C109.64 175.875 109.539 175.934 109.437 175.996C109.408 176.011 109.377 176.029 109.348 176.046C109.258 176.097 109.168 176.15 109.084 176.199C108.999 176.247 108.92 176.293 108.847 176.337C108.798 176.365 108.754 176.39 108.715 176.413C108.597 176.483 108.514 176.53 108.485 176.545C108.578 176.489 108.671 176.402 108.725 176.306C108.756 176.26 108.779 176.207 108.805 176.157L110.05 175.426Z",
    fill: "white"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M100.282 175.612C100.283 174.34 101.176 173.824 102.277 174.46C103.378 175.096 104.274 176.644 104.273 177.915C104.274 179.189 103.379 179.704 102.277 179.069C101.176 178.432 100.283 176.885 100.282 175.612Z",
    fill: "#F0F7FA"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M103.629 175.984C104.002 176.626 104.204 177.312 104.204 177.915C104.204 178.506 104.009 178.944 103.656 179.149C103.301 179.352 102.824 179.302 102.314 179.007C101.791 178.706 101.299 178.187 100.928 177.544C100.555 176.901 100.352 176.216 100.352 175.612C100.352 175.022 100.548 174.585 100.902 174.38C101.256 174.175 101.734 174.225 102.244 174.52C102.768 174.822 103.258 175.341 103.629 175.984Z",
    fill: "url(#paint267_linear_3744_1590)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M103.169 178.933C102.967 178.933 102.73 178.857 102.482 178.716C102.01 178.443 101.561 177.968 101.22 177.375C100.878 176.783 100.69 176.158 100.69 175.612C100.69 175.148 100.826 174.815 101.071 174.673C101.161 174.62 101.268 174.594 101.387 174.594C101.588 174.594 101.826 174.67 102.076 174.813C102.545 175.085 102.993 175.561 103.335 176.152C103.678 176.744 103.865 177.371 103.865 177.914C103.865 178.381 103.73 178.711 103.484 178.854C103.395 178.908 103.289 178.933 103.169 178.933Z",
    fill: "#9FA1A3"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M100.309 175.96L100.75 175.707C100.748 175.731 100.747 175.755 100.747 175.78C100.747 176.274 100.917 176.839 101.223 177.373C101.533 177.906 101.938 178.336 102.366 178.583C102.387 178.595 102.409 178.606 102.429 178.617L102.005 178.863L102.275 179.329L103.401 178.678V178.677C103.623 178.521 103.745 178.207 103.745 177.787C103.745 177.292 103.575 176.726 103.268 176.193C102.96 175.66 102.555 175.23 102.127 174.982C101.739 174.759 101.389 174.718 101.137 174.861L100.042 175.495L100.309 175.96Z",
    fill: "url(#paint268_linear_3744_1590)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M102.173 176.827C102.48 177.36 102.648 177.925 102.648 178.421C102.648 178.867 102.511 179.192 102.257 179.337C102.008 179.482 101.656 179.438 101.27 179.216C100.842 178.969 100.435 178.538 100.129 178.006C99.8194 177.472 99.6504 176.908 99.6504 176.412C99.6504 175.966 99.7889 175.64 100.04 175.495C100.291 175.35 100.642 175.392 101.029 175.615C101.457 175.863 101.864 176.292 102.173 176.827Z",
    fill: "url(#paint269_linear_3744_1590)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M101.992 176.931C102.246 177.37 102.385 177.836 102.385 178.246C102.385 178.615 102.273 178.884 102.065 179.003C101.857 179.122 101.569 179.086 101.25 178.903C100.895 178.697 100.561 178.343 100.307 177.905C100.054 177.464 99.9125 176.998 99.9125 176.588C99.9125 176.22 100.028 175.952 100.234 175.833C100.441 175.714 100.73 175.749 101.05 175.932C101.405 176.137 101.738 176.49 101.992 176.931Z",
    fill: "url(#paint270_linear_3744_1590)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M100.448 176.083L101.975 178.726C101.988 178.749 101.979 178.776 101.958 178.789C101.937 178.801 101.91 178.792 101.896 178.772L100.37 176.128C100.356 176.105 100.365 176.079 100.386 176.068C100.407 176.054 100.435 176.061 100.448 176.083Z",
    fill: "#A8BAC1"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M103.962 177.911C103.962 178.156 103.923 178.371 103.854 178.544C103.782 178.72 103.678 178.853 103.541 178.936C103.534 178.941 103.526 178.946 103.521 178.951L103.242 179.112C103.21 179.128 103.181 179.147 103.152 179.163L102.888 179.317L102.652 179.453C102.604 179.483 102.558 179.507 102.519 179.53C102.401 179.598 102.317 179.649 102.29 179.663C102.289 179.664 102.289 179.664 102.287 179.666C102.285 179.666 102.281 179.667 102.28 179.669C101.997 179.834 101.596 179.784 101.158 179.53C100.673 179.251 100.214 178.763 99.8663 178.159C99.5165 177.556 99.324 176.913 99.324 176.352C99.324 175.882 99.4594 175.53 99.7059 175.351C99.7059 175.351 99.7059 175.351 99.7075 175.351C99.727 175.336 99.745 175.325 99.7638 175.315C99.7685 175.311 99.7763 175.307 99.7834 175.304L101.058 174.568L101.06 174.571C101.068 174.568 101.075 174.563 101.083 174.562C101.214 174.502 101.367 174.486 101.536 174.511C101.718 174.537 101.917 174.611 102.128 174.734C102.14 174.74 102.152 174.748 102.163 174.756C102.548 174.987 102.918 175.347 103.225 175.795C103.292 175.895 103.358 175.997 103.419 176.103C103.767 176.707 103.962 177.349 103.962 177.911Z",
    fill: "#F0F7FA"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M102.179 176.822C101.83 176.218 101.371 175.732 100.885 175.449C100.446 175.198 100.049 175.148 99.7654 175.312C99.4805 175.475 99.324 175.845 99.324 176.351C99.324 176.912 99.5165 177.553 99.864 178.157C100.214 178.76 100.673 179.249 101.158 179.529C101.597 179.782 101.994 179.831 102.279 179.667C102.562 179.504 102.721 179.133 102.721 178.627C102.721 178.067 102.527 177.427 102.179 176.822Z",
    fill: "#F0F7FA"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.608 176.498C101.36 176.067 101.032 175.718 100.685 175.519C100.37 175.338 100.088 175.302 99.8835 175.419C99.6816 175.535 99.5681 175.8 99.5681 176.162C99.5681 176.562 99.7074 177.019 99.9563 177.451C100.204 177.883 100.532 178.231 100.881 178.43C101.192 178.613 101.477 178.648 101.681 178.53C101.883 178.413 101.995 178.148 101.997 177.788C101.994 177.386 101.857 176.929 101.608 176.498Z",
    fill: "white"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M101.535 174.512C101.535 174.512 100.33 175.174 100.235 175.227C100.056 175.218 99.8844 175.232 99.7059 175.351C99.9892 175.181 100.42 174.942 101.083 174.561C101.213 174.501 101.366 174.487 101.535 174.512Z",
    fill: "white"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.225 175.795C102.749 176.089 102.224 176.413 101.996 176.55C101.819 176.27 101.302 175.748 100.974 175.503L102.162 174.756C102.548 174.986 102.917 175.346 103.225 175.795Z",
    fill: "white"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M103.854 178.543C103.782 178.719 103.678 178.852 103.541 178.935C103.442 178.991 103.343 179.05 103.241 179.111C103.21 179.128 103.18 179.146 103.151 179.163C103.061 179.214 102.973 179.268 102.887 179.316C102.803 179.366 102.724 179.409 102.652 179.452C102.603 179.482 102.557 179.506 102.519 179.53C102.4 179.598 102.317 179.648 102.289 179.662C102.384 179.605 102.476 179.518 102.53 179.421C102.559 179.376 102.584 179.322 102.608 179.273L103.854 178.543Z",
    fill: "white"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M106.479 179.257C106.479 177.987 107.372 177.47 108.476 178.106C109.576 178.743 110.471 180.288 110.469 181.56C110.471 182.834 109.576 183.35 108.476 182.715C107.372 182.077 106.479 180.531 106.479 179.257Z",
    fill: "#F0F7FA"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M109.826 179.63C110.198 180.275 110.401 180.959 110.401 181.561C110.401 182.152 110.206 182.589 109.852 182.796C109.497 182.998 109.021 182.949 108.509 182.655C107.986 182.353 107.496 181.833 107.124 181.19C106.751 180.549 106.548 179.861 106.548 179.257C106.548 178.669 106.744 178.231 107.098 178.026C107.452 177.821 107.93 177.872 108.441 178.167C108.963 178.469 109.455 178.989 109.826 179.63Z",
    fill: "url(#paint271_linear_3744_1590)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M109.366 182.581C109.165 182.581 108.925 182.505 108.679 182.362C108.207 182.089 107.757 181.613 107.415 181.022C107.074 180.431 106.886 179.804 106.886 179.258C106.886 178.794 107.022 178.461 107.267 178.319C107.357 178.266 107.465 178.24 107.584 178.24C107.786 178.24 108.023 178.317 108.271 178.459C108.743 178.732 109.191 179.208 109.534 179.8C109.875 180.393 110.062 181.017 110.062 181.561C110.062 182.027 109.927 182.361 109.68 182.502C109.591 182.553 109.485 182.581 109.366 182.581Z",
    fill: "#9FA1A3"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M106.506 179.606L106.945 179.353C106.944 179.376 106.944 179.402 106.944 179.425C106.944 179.92 107.113 180.484 107.421 181.018C107.728 181.553 108.135 181.981 108.561 182.229C108.585 182.241 108.604 182.253 108.626 182.263L108.201 182.508L108.472 182.976L109.597 182.327L109.597 182.324C109.82 182.169 109.942 181.854 109.942 181.435C109.942 180.939 109.773 180.373 109.464 179.84C109.157 179.307 108.751 178.878 108.322 178.63C107.936 178.406 107.585 178.363 107.332 178.509L106.237 179.142L106.506 179.606Z",
    fill: "url(#paint272_linear_3744_1590)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M108.366 180.472C108.675 181.005 108.845 181.572 108.845 182.065C108.845 182.512 108.706 182.838 108.455 182.983C108.204 183.128 107.853 183.083 107.466 182.86C107.038 182.615 106.632 182.183 106.325 181.653C106.016 181.117 105.847 180.552 105.847 180.057C105.847 179.61 105.986 179.284 106.235 179.14C106.487 178.993 106.838 179.036 107.225 179.263C107.653 179.511 108.06 179.939 108.366 180.472Z",
    fill: "url(#paint273_linear_3744_1590)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M108.189 180.576C108.442 181.015 108.582 181.481 108.581 181.89C108.581 182.258 108.467 182.527 108.261 182.647C108.053 182.767 107.764 182.731 107.446 182.547C107.092 182.341 106.756 181.988 106.504 181.547C106.248 181.108 106.108 180.641 106.108 180.233C106.108 179.866 106.223 179.596 106.43 179.475C106.637 179.356 106.927 179.392 107.246 179.577C107.6 179.781 107.935 180.135 108.189 180.576Z",
    fill: "url(#paint274_linear_3744_1590)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M106.645 179.728L108.172 182.372C108.183 182.393 108.176 182.421 108.155 182.432C108.133 182.445 108.106 182.439 108.093 182.416L106.566 179.772C106.553 179.75 106.56 179.722 106.583 179.711C106.604 179.699 106.631 179.706 106.645 179.728Z",
    fill: "#A8BAC1"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110.157 181.56C110.157 181.803 110.121 182.018 110.05 182.191C109.979 182.364 109.875 182.5 109.739 182.584C109.732 182.588 109.724 182.591 109.717 182.597L109.437 182.756C109.408 182.773 109.378 182.792 109.349 182.808L109.084 182.961L108.847 183.099C108.799 183.126 108.755 183.152 108.715 183.177C108.597 183.243 108.514 183.292 108.485 183.307C108.485 183.309 108.485 183.309 108.482 183.313L108.477 183.315C108.193 183.48 107.793 183.43 107.355 183.177C106.869 182.894 106.41 182.408 106.062 181.805C105.713 181.199 105.522 180.557 105.522 179.997C105.522 179.529 105.657 179.175 105.904 178.998C105.904 178.998 105.904 178.998 105.906 178.995C105.925 178.983 105.944 178.971 105.961 178.959C105.967 178.957 105.972 178.953 105.979 178.951L107.253 178.212L107.255 178.216C107.264 178.212 107.271 178.209 107.279 178.208C107.412 178.148 107.564 178.133 107.733 178.158C107.915 178.182 108.114 178.258 108.324 178.379C108.337 178.387 108.347 178.392 108.359 178.402C108.745 178.633 109.114 178.993 109.421 179.439C109.488 179.539 109.555 179.641 109.617 179.75C109.965 180.355 110.157 180.998 110.157 181.56Z",
    fill: "#F0F7FA"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M108.376 180.47C108.026 179.866 107.566 179.377 107.082 179.098C106.644 178.844 106.246 178.794 105.961 178.959C105.677 179.123 105.521 179.493 105.521 179.998C105.521 180.558 105.712 181.2 106.061 181.804C106.41 182.409 106.868 182.895 107.354 183.176C107.792 183.429 108.192 183.48 108.476 183.315C108.759 183.151 108.916 182.784 108.916 182.276C108.916 181.715 108.723 181.074 108.376 180.47Z",
    fill: "#F0F7FA"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.806 180.143C107.556 179.711 107.228 179.364 106.882 179.163C106.568 178.981 106.284 178.947 106.08 179.064C105.878 179.182 105.766 179.445 105.766 179.805C105.766 180.208 105.903 180.666 106.152 181.097C106.402 181.528 106.728 181.875 107.076 182.075C107.39 182.257 107.672 182.29 107.876 182.175C108.08 182.059 108.192 181.794 108.192 181.432C108.192 181.031 108.053 180.575 107.806 180.143Z",
    fill: "white"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M107.732 178.158C107.732 178.158 106.525 178.818 106.431 178.871C106.251 178.862 106.079 178.879 105.903 178.997C106.185 178.828 106.615 178.589 107.278 178.207C107.411 178.148 107.563 178.133 107.732 178.158Z",
    fill: "white"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.42 179.439C108.947 179.735 108.422 180.06 108.192 180.195C108.014 179.917 107.498 179.393 107.17 179.152L108.359 178.402C108.745 178.633 109.114 178.993 109.42 179.439Z",
    fill: "white"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M110.05 182.191C109.979 182.364 109.874 182.501 109.739 182.584C109.64 182.639 109.539 182.699 109.437 182.757C109.408 182.774 109.377 182.793 109.348 182.809C109.258 182.86 109.168 182.912 109.084 182.962C108.999 183.01 108.92 183.056 108.847 183.1C108.798 183.127 108.754 183.152 108.715 183.178C108.597 183.244 108.514 183.293 108.485 183.308C108.578 183.251 108.671 183.166 108.725 183.069C108.756 183.023 108.779 182.968 108.805 182.919L110.05 182.191Z",
    fill: "white"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M110.863 159.93V195.377L102.372 190.473L99.9829 189.094L95.1095 186.279V150.836L99.9829 153.651L102.372 155.029L110.863 159.93Z",
    fill: "#CAD2DA"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4335 188.782L95.1088 186.279V150.836L99.4335 153.336V188.782Z",
    fill: "#E22B12"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M102.372 155.031V190.475L99.9829 189.096V153.652L102.372 155.031Z",
    fill: "#C42726"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M118.126 155.736L112.214 159.152L110.861 159.93L95.2167 150.906L95.2558 150.752L102.317 146.811L102.319 146.999L95.4405 150.842L110.861 159.735L117.824 155.718L118.126 155.736Z",
    fill: "#F4F7F9"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M110.845 195.387L118.128 191.182V155.738L110.845 159.943V195.387Z",
    fill: "#EEF0F3"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M118.128 155.738V166.139L110.845 178.621V159.942L110.861 159.931L112.214 159.153L118.128 155.738Z",
    fill: "url(#paint275_linear_3744_1590)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M117.974 155.98L110.845 159.941V160.049L116.299 165.69L122.997 161.828V161.678L117.974 155.98Z",
    fill: "#CAD4DB"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M118.126 155.736L110.845 159.923L116.308 165.543L122.997 161.68L118.126 155.736Z",
    fill: "#F8FCFF"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M102.317 146.811L95.2167 150.907L90.7738 149.228L97.4613 145.367L102.317 146.811Z",
    fill: "#EEF0F3"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7738 149.229V149.319L95.1087 150.952L95.2167 150.908L95.1087 150.867L90.7738 149.229Z",
    fill: "#BCC6CE"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M230.581 91.9121V140.871L210.107 129.05V80.0859L230.581 91.9121Z",
    fill: "#CAD2DA"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M249.473 81.0031L228.988 69.1699L210.107 80.0867L230.581 91.9128L249.473 81.0031Z",
    fill: "#F5F5F7"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M228.988 69.3304L249.192 81.0023L230.581 91.75L210.385 80.0859L228.988 69.3304ZM228.988 69.1699L210.107 80.0867L230.581 91.9128L249.473 81.0023L228.988 69.1699Z",
    fill: "white"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M249.483 129.955V129.959L230.581 140.872V91.9128L249.473 81L249.475 113.148L249.476 115.254V116.221L249.483 129.955Z",
    fill: "#EEF0F3"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M230.581 116.923V140.872L210.107 129.051V105.104L230.581 116.923Z",
    fill: "url(#paint276_linear_3744_1590)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M230.576 113.058V115.163L210.105 103.342V101.238L230.576 113.058Z",
    fill: "#ADBCC1"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M249.483 129.955L230.581 140.872V116.923L249.476 106.012L249.483 129.955Z",
    fill: "url(#paint277_linear_3744_1590)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M249.475 104.253L230.576 115.164V113.059L249.473 102.15L249.475 104.253Z",
    fill: "#C2D0D3"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M201.542 114.687V138.896L182.699 128.013V103.803L201.542 114.687Z",
    fill: "#CAD2DA"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M218.932 104.645L200.077 93.7539L182.699 103.803L201.542 114.687L218.932 104.645Z",
    fill: "#EAEAEF"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M200.077 93.9026L218.672 104.646L201.542 114.537L182.955 103.8L200.077 93.9026ZM200.077 93.7539L182.699 103.803L201.542 114.687L218.932 104.645L200.077 93.7539Z",
    fill: "white"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M218.944 128.848V128.852L201.542 138.896V114.687L218.932 104.645L218.937 113.377V115.316V116.209L218.944 128.848Z",
    fill: "#EEF0F3"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M201.542 126.25L202.492 132.153L201.542 138.897L182.699 128.014V115.369L201.542 126.25Z",
    fill: "url(#paint278_linear_3744_1590)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M201.542 123.417V125.358L182.699 114.48V112.539L201.542 123.417Z",
    fill: "#ADBCC1"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M218.944 128.848L201.542 138.896V126.249L218.937 116.209L218.944 128.848Z",
    fill: "url(#paint279_linear_3744_1590)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M218.937 115.316L201.542 125.358V123.417L218.937 113.377V115.316Z",
    fill: "#C2D0D3"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M216.63 129.513V148.903L201.537 140.187V120.795L216.63 129.513Z",
    fill: "#CAD2DA"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M230.558 121.471L215.457 112.748L201.537 120.796L216.63 129.514L230.558 121.471Z",
    fill: "#F5F5F7"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M215.457 112.865L230.351 121.471L216.63 129.396L201.743 120.796L215.457 112.865ZM215.457 112.748L201.537 120.797L216.63 129.515L230.558 121.472L215.457 112.748Z",
    fill: "white"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M230.567 140.855V140.86L216.63 148.903V129.514L230.558 121.471L230.561 128.464V130.018V130.732L230.567 140.855Z",
    fill: "#EEF0F3"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M216.63 138.775L217.39 143.503L216.63 148.904L201.537 140.188V130.061L216.63 138.775Z",
    fill: "#FF6600"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M216.63 136.505V138.06L201.537 129.346V127.793L216.63 136.505Z",
    fill: "#ADBCC1"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M230.567 140.856L216.63 148.903V138.774L230.561 130.732L230.567 140.856Z",
    fill: "#FF791F"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M230.561 130.019L216.63 138.061V136.506L230.561 128.465V130.019Z",
    fill: "#C2D0D3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3744_1590",
    x1: 21.8227,
    y1: 140.256,
    x2: 263.313,
    y2: 140.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43B7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FDFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3744_1590",
    x1: 23.3444,
    y1: 140.253,
    x2: 261.789,
    y2: 140.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43B7F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3744_1590",
    x1: 132.741,
    y1: 22.7522,
    x2: 132.741,
    y2: 159.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3116,
    stopColor: "#7CCBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4276,
    stopColor: "#80CDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5488,
    stopColor: "#8DD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    stopColor: "#A2DAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7977,
    stopColor: "#BFE6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    stopColor: "#E4F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3744_1590",
    x1: 178.26,
    y1: 158.53,
    x2: 178.26,
    y2: 178.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0426,
    stopColor: "#7CCBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.204,
    stopColor: "#80CDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3725,
    stopColor: "#8DD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5444,
    stopColor: "#A2DAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7186,
    stopColor: "#BFE6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8928,
    stopColor: "#E4F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3744_1590",
    x1: 139.602,
    y1: 165.686,
    x2: 139.525,
    y2: 174.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3116,
    stopColor: "#7CCBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4276,
    stopColor: "#80CDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5488,
    stopColor: "#8DD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    stopColor: "#A2DAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7977,
    stopColor: "#BFE6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    stopColor: "#E4F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3744_1590",
    x1: 151.47,
    y1: 172.497,
    x2: 151.547,
    y2: 181.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3116,
    stopColor: "#7CCBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4276,
    stopColor: "#80CDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5488,
    stopColor: "#8DD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6724,
    stopColor: "#A2DAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7977,
    stopColor: "#BFE6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9229,
    stopColor: "#E4F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3744_1590",
    x1: 119.565,
    y1: 184.883,
    x2: 119.565,
    y2: 208.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CCBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1686,
    stopColor: "#80CDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3446,
    stopColor: "#8DD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5241,
    stopColor: "#A2DAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7061,
    stopColor: "#BFE6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8881,
    stopColor: "#E4F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3744_1590",
    x1: 50.4269,
    y1: 147.078,
    x2: 50.4269,
    y2: 157.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CCBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1686,
    stopColor: "#80CDDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3446,
    stopColor: "#8DD2E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5241,
    stopColor: "#A2DAE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7061,
    stopColor: "#BFE6EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8881,
    stopColor: "#E4F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3744_1590",
    x1: 43.1836,
    y1: 155.41,
    x2: 43.1836,
    y2: 163.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7CCBDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    stopColor: "#83CEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2535,
    stopColor: "#AFDFEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4668,
    stopColor: "#D2EDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6676,
    stopColor: "#EBF7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8507,
    stopColor: "#FAFDFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3744_1590",
    x1: 160.019,
    y1: 151.249,
    x2: 227.935,
    y2: 121.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3744_1590",
    x1: 33.4969,
    y1: 154.555,
    x2: 47.4736,
    y2: 154.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3744_1590",
    x1: 41.4037,
    y1: 147.266,
    x2: 55.3811,
    y2: 147.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3744_1590",
    x1: 74.2053,
    y1: 178.092,
    x2: 91.045,
    y2: 178.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3744_1590",
    x1: 61.4804,
    y1: 160.197,
    x2: 90.0674,
    y2: 160.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3744_1590",
    x1: 53.2247,
    y1: 164.859,
    x2: 67.2022,
    y2: 164.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3744_1590",
    x1: 47.1515,
    y1: 154.409,
    x2: 39.2156,
    y2: 154.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3744_1590",
    x1: 43.1836,
    y1: 149.998,
    x2: 43.1836,
    y2: 154.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3744_1590",
    x1: 43.2797,
    y1: 150.561,
    x2: 43.0794,
    y2: 154.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3744_1590",
    x1: 40.4059,
    y1: 152.249,
    x2: 46.0307,
    y2: 152.249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3744_1590",
    x1: 54.3953,
    y1: 146.893,
    x2: 46.4587,
    y2: 146.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3744_1590",
    x1: 50.4272,
    y1: 142.481,
    x2: 50.4272,
    y2: 146.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3744_1590",
    x1: 50.5234,
    y1: 143.043,
    x2: 50.3232,
    y2: 146.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3744_1590",
    x1: 47.6498,
    y1: 144.732,
    x2: 53.2745,
    y2: 144.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3744_1590",
    x1: 45.4655,
    y1: 144.733,
    x2: 52.8931,
    y2: 144.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3744_1590",
    x1: 55.9257,
    y1: 144.021,
    x2: 47.9891,
    y2: 144.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3744_1590",
    x1: 51.9575,
    y1: 139.61,
    x2: 51.9575,
    y2: 143.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3744_1590",
    x1: 52.053,
    y1: 140.174,
    x2: 51.8529,
    y2: 143.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3744_1590",
    x1: 49.1801,
    y1: 141.86,
    x2: 54.8042,
    y2: 141.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3744_1590",
    x1: 131.975,
    y1: 167.039,
    x2: 177.711,
    y2: 147.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3744_1590",
    x1: 186.499,
    y1: 141.639,
    x2: 170.479,
    y2: 172.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3744_1590",
    x1: 165.587,
    y1: 162.526,
    x2: 158.029,
    y2: 162.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3744_1590",
    x1: 164.854,
    y1: 162.414,
    x2: 158.763,
    y2: 162.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3744_1590",
    x1: 161.809,
    y1: 159.027,
    x2: 161.809,
    y2: 162.364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3744_1590",
    x1: 161.882,
    y1: 159.46,
    x2: 161.729,
    y2: 162.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3744_1590",
    x1: 174.174,
    y1: 167.392,
    x2: 166.615,
    y2: 167.392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3744_1590",
    x1: 173.442,
    y1: 167.28,
    x2: 167.347,
    y2: 167.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3744_1590",
    x1: 170.395,
    y1: 163.895,
    x2: 170.395,
    y2: 167.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3744_1590",
    x1: 170.47,
    y1: 164.324,
    x2: 170.316,
    y2: 166.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3744_1590",
    x1: 173.629,
    y1: 157.884,
    x2: 166.069,
    y2: 157.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3744_1590",
    x1: 172.894,
    y1: 157.772,
    x2: 166.8,
    y2: 157.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3744_1590",
    x1: 169.847,
    y1: 154.386,
    x2: 169.847,
    y2: 157.723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3744_1590",
    x1: 169.922,
    y1: 154.817,
    x2: 169.768,
    y2: 157.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3744_1590",
    x1: 182.214,
    y1: 162.75,
    x2: 174.656,
    y2: 162.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3744_1590",
    x1: 181.484,
    y1: 162.637,
    x2: 175.39,
    y2: 162.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3744_1590",
    x1: 178.436,
    y1: 159.251,
    x2: 178.436,
    y2: 162.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3744_1590",
    x1: 178.511,
    y1: 159.682,
    x2: 178.357,
    y2: 162.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3744_1590",
    x1: 181.668,
    y1: 153.241,
    x2: 174.111,
    y2: 153.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3744_1590",
    x1: 180.937,
    y1: 153.128,
    x2: 174.842,
    y2: 153.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3744_1590",
    x1: 177.889,
    y1: 149.743,
    x2: 177.889,
    y2: 153.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3744_1590",
    x1: 177.964,
    y1: 150.174,
    x2: 177.81,
    y2: 152.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3744_1590",
    x1: 190.256,
    y1: 158.107,
    x2: 182.697,
    y2: 158.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_3744_1590",
    x1: 189.524,
    y1: 157.995,
    x2: 183.429,
    y2: 157.995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_3744_1590",
    x1: 186.476,
    y1: 154.609,
    x2: 186.476,
    y2: 157.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_3744_1590",
    x1: 186.552,
    y1: 155.041,
    x2: 186.398,
    y2: 157.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_3744_1590",
    x1: 189.71,
    y1: 148.599,
    x2: 182.149,
    y2: 148.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_3744_1590",
    x1: 188.977,
    y1: 148.487,
    x2: 182.881,
    y2: 148.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_3744_1590",
    x1: 185.93,
    y1: 145.102,
    x2: 185.93,
    y2: 148.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_3744_1590",
    x1: 186.004,
    y1: 145.532,
    x2: 185.85,
    y2: 148.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_3744_1590",
    x1: 198.298,
    y1: 153.465,
    x2: 190.737,
    y2: 153.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_3744_1590",
    x1: 197.564,
    y1: 153.352,
    x2: 191.47,
    y2: 153.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_3744_1590",
    x1: 194.518,
    y1: 149.966,
    x2: 194.518,
    y2: 153.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_3744_1590",
    x1: 194.593,
    y1: 150.396,
    x2: 194.439,
    y2: 153.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_3744_1590",
    x1: 161.013,
    y1: 168.103,
    x2: 186.803,
    y2: 151.189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_3744_1590",
    x1: 186.499,
    y1: 138.44,
    x2: 170.479,
    y2: 169.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_3744_1590",
    x1: 165.587,
    y1: 159.325,
    x2: 158.029,
    y2: 159.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_3744_1590",
    x1: 164.854,
    y1: 159.214,
    x2: 158.763,
    y2: 159.214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_3744_1590",
    x1: 161.809,
    y1: 155.827,
    x2: 161.809,
    y2: 159.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_3744_1590",
    x1: 161.883,
    y1: 156.259,
    x2: 161.729,
    y2: 158.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_3744_1590",
    x1: 174.174,
    y1: 164.191,
    x2: 166.615,
    y2: 164.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_3744_1590",
    x1: 173.442,
    y1: 164.079,
    x2: 167.347,
    y2: 164.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_3744_1590",
    x1: 170.395,
    y1: 160.694,
    x2: 170.395,
    y2: 164.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_3744_1590",
    x1: 170.469,
    y1: 161.125,
    x2: 170.316,
    y2: 163.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_3744_1590",
    x1: 173.629,
    y1: 154.685,
    x2: 166.069,
    y2: 154.685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_3744_1590",
    x1: 172.894,
    y1: 154.573,
    x2: 166.8,
    y2: 154.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_3744_1590",
    x1: 169.847,
    y1: 151.188,
    x2: 169.847,
    y2: 154.524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_3744_1590",
    x1: 169.922,
    y1: 151.618,
    x2: 169.768,
    y2: 154.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_3744_1590",
    x1: 182.214,
    y1: 159.549,
    x2: 174.656,
    y2: 159.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_3744_1590",
    x1: 181.484,
    y1: 159.437,
    x2: 175.39,
    y2: 159.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_3744_1590",
    x1: 178.436,
    y1: 156.05,
    x2: 178.436,
    y2: 159.388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_3744_1590",
    x1: 178.511,
    y1: 156.48,
    x2: 178.357,
    y2: 159.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_3744_1590",
    x1: 181.668,
    y1: 150.042,
    x2: 174.111,
    y2: 150.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_3744_1590",
    x1: 180.937,
    y1: 149.931,
    x2: 174.842,
    y2: 149.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_3744_1590",
    x1: 177.889,
    y1: 146.544,
    x2: 177.889,
    y2: 149.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_3744_1590",
    x1: 177.964,
    y1: 146.975,
    x2: 177.81,
    y2: 149.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_3744_1590",
    x1: 190.256,
    y1: 154.906,
    x2: 182.697,
    y2: 154.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_3744_1590",
    x1: 189.524,
    y1: 154.793,
    x2: 183.429,
    y2: 154.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_3744_1590",
    x1: 186.476,
    y1: 151.408,
    x2: 186.476,
    y2: 154.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_3744_1590",
    x1: 186.552,
    y1: 151.84,
    x2: 186.398,
    y2: 154.492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_3744_1590",
    x1: 189.71,
    y1: 145.4,
    x2: 182.149,
    y2: 145.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_3744_1590",
    x1: 188.977,
    y1: 145.287,
    x2: 182.881,
    y2: 145.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_3744_1590",
    x1: 185.93,
    y1: 141.903,
    x2: 185.93,
    y2: 145.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_3744_1590",
    x1: 186.004,
    y1: 142.333,
    x2: 185.85,
    y2: 144.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_3744_1590",
    x1: 198.298,
    y1: 150.264,
    x2: 190.737,
    y2: 150.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_3744_1590",
    x1: 197.564,
    y1: 150.151,
    x2: 191.47,
    y2: 150.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_3744_1590",
    x1: 194.518,
    y1: 146.764,
    x2: 194.518,
    y2: 150.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_3744_1590",
    x1: 194.593,
    y1: 147.195,
    x2: 194.439,
    y2: 149.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_3744_1590",
    x1: 161.013,
    y1: 164.902,
    x2: 186.803,
    y2: 147.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_3744_1590",
    x1: 168.277,
    y1: 166.718,
    x2: 188.052,
    y2: 135.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFC6C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_3744_1590",
    x1: 165.587,
    y1: 156.126,
    x2: 158.029,
    y2: 156.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_3744_1590",
    x1: 164.854,
    y1: 156.013,
    x2: 158.763,
    y2: 156.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_3744_1590",
    x1: 161.808,
    y1: 152.628,
    x2: 161.808,
    y2: 155.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_3744_1590",
    x1: 161.882,
    y1: 153.058,
    x2: 161.729,
    y2: 155.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_3744_1590",
    x1: 174.174,
    y1: 160.989,
    x2: 166.615,
    y2: 160.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_3744_1590",
    x1: 173.442,
    y1: 160.878,
    x2: 167.347,
    y2: 160.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_3744_1590",
    x1: 170.395,
    y1: 157.493,
    x2: 170.395,
    y2: 160.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_3744_1590",
    x1: 170.469,
    y1: 157.924,
    x2: 170.316,
    y2: 160.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_3744_1590",
    x1: 173.629,
    y1: 151.482,
    x2: 166.069,
    y2: 151.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_3744_1590",
    x1: 172.894,
    y1: 151.372,
    x2: 166.8,
    y2: 151.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_3744_1590",
    x1: 169.847,
    y1: 147.986,
    x2: 169.847,
    y2: 151.322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_3744_1590",
    x1: 169.922,
    y1: 148.416,
    x2: 169.768,
    y2: 151.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_3744_1590",
    x1: 182.214,
    y1: 156.35,
    x2: 174.655,
    y2: 156.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_3744_1590",
    x1: 181.484,
    y1: 156.236,
    x2: 175.39,
    y2: 156.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_3744_1590",
    x1: 178.436,
    y1: 152.851,
    x2: 178.436,
    y2: 156.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_3744_1590",
    x1: 178.511,
    y1: 153.281,
    x2: 178.357,
    y2: 155.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_3744_1590",
    x1: 181.668,
    y1: 146.84,
    x2: 174.111,
    y2: 146.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_3744_1590",
    x1: 180.937,
    y1: 146.73,
    x2: 174.842,
    y2: 146.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_3744_1590",
    x1: 177.889,
    y1: 143.342,
    x2: 177.889,
    y2: 146.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_3744_1590",
    x1: 177.964,
    y1: 143.774,
    x2: 177.81,
    y2: 146.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_3744_1590",
    x1: 190.256,
    y1: 151.705,
    x2: 182.697,
    y2: 151.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_3744_1590",
    x1: 189.523,
    y1: 151.593,
    x2: 183.428,
    y2: 151.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_3744_1590",
    x1: 186.476,
    y1: 148.206,
    x2: 186.476,
    y2: 151.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_3744_1590",
    x1: 186.552,
    y1: 148.639,
    x2: 186.398,
    y2: 151.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_3744_1590",
    x1: 189.709,
    y1: 142.197,
    x2: 182.149,
    y2: 142.197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_3744_1590",
    x1: 188.977,
    y1: 142.087,
    x2: 182.881,
    y2: 142.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_3744_1590",
    x1: 185.93,
    y1: 138.7,
    x2: 185.93,
    y2: 142.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_3744_1590",
    x1: 186.004,
    y1: 139.13,
    x2: 185.85,
    y2: 141.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_3744_1590",
    x1: 198.298,
    y1: 147.064,
    x2: 190.737,
    y2: 147.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_3744_1590",
    x1: 197.564,
    y1: 146.951,
    x2: 191.47,
    y2: 146.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_3744_1590",
    x1: 194.518,
    y1: 143.563,
    x2: 194.518,
    y2: 146.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_3744_1590",
    x1: 194.593,
    y1: 143.995,
    x2: 194.439,
    y2: 146.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_3744_1590",
    x1: 24.5793,
    y1: 136.722,
    x2: 191.639,
    y2: 136.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_3744_1590",
    x1: 132.473,
    y1: 56.1806,
    x2: 161.648,
    y2: 56.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.461,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6526,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8523,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_3744_1590",
    x1: 65.5466,
    y1: 158.671,
    x2: 90.6549,
    y2: 158.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0631,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744D30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_3744_1590",
    x1: 65.5488,
    y1: 143.005,
    x2: 90.6549,
    y2: 143.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#9C561E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_3744_1590",
    x1: 65.5466,
    y1: 128.101,
    x2: 90.6549,
    y2: 128.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_3744_1590",
    x1: 78.1018,
    y1: 126.152,
    x2: 78.1018,
    y2: 134.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1371,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3901,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7282,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969696"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_3744_1590",
    x1: 65.5466,
    y1: 158.052,
    x2: 90.6549,
    y2: 158.052,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#9C561E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_3744_1590",
    x1: 83.3111,
    y1: 122.532,
    x2: 71.7317,
    y2: 126.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_3744_1590",
    x1: 65.5488,
    y1: 151.141,
    x2: 65.5553,
    y2: 151.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5471,
    stopColor: "#007FC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_3744_1590",
    x1: 90.6476,
    y1: 151.141,
    x2: 90.6549,
    y2: 151.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#9C561E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_3744_1590",
    x1: 65.549,
    y1: 147.703,
    x2: 90.6562,
    y2: 147.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_3744_1590",
    x1: 73.3703,
    y1: 122.67,
    x2: 82.8328,
    y2: 122.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_3744_1590",
    x1: 73.3703,
    y1: 120.02,
    x2: 82.8328,
    y2: 120.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_3744_1590",
    x1: 73.5075,
    y1: 117.382,
    x2: 82.6903,
    y2: 117.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_3744_1590",
    x1: 56.408,
    y1: 163.832,
    x2: 67.178,
    y2: 163.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0631,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#744D30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_3744_1590",
    x1: 56.4099,
    y1: 157.112,
    x2: 67.1789,
    y2: 157.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#9C561E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_3744_1590",
    x1: 56.408,
    y1: 150.718,
    x2: 67.178,
    y2: 150.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_3744_1590",
    x1: 56.4098,
    y1: 163.567,
    x2: 67.1789,
    y2: 163.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#9C561E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_3744_1590",
    x1: 64.028,
    y1: 148.33,
    x2: 59.0607,
    y2: 149.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_3744_1590",
    x1: 56.408,
    y1: 160.601,
    x2: 56.4114,
    y2: 160.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5471,
    stopColor: "#007FC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_3744_1590",
    x1: 67.1742,
    y1: 160.601,
    x2: 67.1773,
    y2: 160.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.057,
    stopColor: "#63321A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5857,
    stopColor: "#9C561E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#612C06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_3744_1590",
    x1: 65.8003,
    y1: 158.712,
    x2: 59.9505,
    y2: 158.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2718,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8629,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_3744_1590",
    x1: 65.8005,
    y1: 158.727,
    x2: 59.9218,
    y2: 158.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2718,
    stopColor: "#656565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6099,
    stopColor: "#2F2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8629,
    stopColor: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_3744_1590",
    x1: 56.5413,
    y1: 150.533,
    x2: 67.0459,
    y2: 150.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_3744_1590",
    x1: 56.5412,
    y1: 147.59,
    x2: 67.0458,
    y2: 147.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_3744_1590",
    x1: 56.694,
    y1: 144.66,
    x2: 66.888,
    y2: 144.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_3744_1590",
    x1: 56.8326,
    y1: 144.66,
    x2: 66.7499,
    y2: 144.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8DCE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1787,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_3744_1590",
    x1: 58.9228,
    y1: 144.658,
    x2: 64.6625,
    y2: 144.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_3744_1590",
    x1: 59.0683,
    y1: 141.031,
    x2: 64.502,
    y2: 141.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint159_linear_3744_1590",
    x1: 76.2868,
    y1: 171.32,
    x2: 90.8493,
    y2: 171.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint160_linear_3744_1590",
    x1: 76.286,
    y1: 176.947,
    x2: 90.8494,
    y2: 176.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint161_linear_3744_1590",
    x1: 76.5845,
    y1: 165.243,
    x2: 90.5505,
    y2: 165.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint162_linear_3744_1590",
    x1: 76.583,
    y1: 161.325,
    x2: 90.5555,
    y2: 161.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint163_linear_3744_1590",
    x1: 76.7917,
    y1: 157.428,
    x2: 90.3457,
    y2: 157.428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint164_linear_3744_1590",
    x1: 76.2871,
    y1: 172.941,
    x2: 76.2901,
    y2: 172.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5471,
    stopColor: "#007FC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint165_linear_3744_1590",
    x1: 90.8471,
    y1: 172.941,
    x2: 90.8494,
    y2: 172.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5471,
    stopColor: "#007FC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint166_linear_3744_1590",
    x1: 76.2869,
    y1: 177.148,
    x2: 90.8494,
    y2: 177.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1957,
    stopColor: "#C42726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22B12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint167_linear_3744_1590",
    x1: 76.2869,
    y1: 174.085,
    x2: 90.8494,
    y2: 174.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1957,
    stopColor: "#C42726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22B12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint168_linear_3744_1590",
    x1: 144.097,
    y1: 177.47,
    x2: 156.472,
    y2: 177.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint169_linear_3744_1590",
    x1: 152.85,
    y1: 173.173,
    x2: 154.894,
    y2: 176.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFCA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAC18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint170_linear_3744_1590",
    x1: 150.425,
    y1: 174.483,
    x2: 152.592,
    y2: 178.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0564,
    stopColor: "#E20707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#BA0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint171_linear_3744_1590",
    x1: 148.111,
    y1: 175.869,
    x2: 150.275,
    y2: 179.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0564,
    stopColor: "#E20707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#BA0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint172_linear_3744_1590",
    x1: 144.403,
    y1: 169.719,
    x2: 132.028,
    y2: 169.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint173_linear_3744_1590",
    x1: 138.329,
    y1: 165.424,
    x2: 136.284,
    y2: 169.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2839,
    stopColor: "#CED4DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5482,
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint174_linear_3744_1590",
    x1: 140.753,
    y1: 166.735,
    x2: 138.586,
    y2: 170.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0564,
    stopColor: "#E20707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#BA0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint175_linear_3744_1590",
    x1: 143.067,
    y1: 168.119,
    x2: 140.903,
    y2: 171.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0564,
    stopColor: "#E20707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6544,
    stopColor: "#BA0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20707"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint176_linear_3744_1590",
    x1: 115.94,
    y1: 139.347,
    x2: 103.655,
    y2: 163.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC6C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint177_linear_3744_1590",
    x1: 108.279,
    y1: 141.508,
    x2: 105.526,
    y2: 136.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint178_linear_3744_1590",
    x1: 107.941,
    y1: 141.087,
    x2: 105.722,
    y2: 137.243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint179_linear_3744_1590",
    x1: 104.695,
    y1: 140.398,
    x2: 106.8,
    y2: 139.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint180_linear_3744_1590",
    x1: 104.994,
    y1: 140.287,
    x2: 106.612,
    y2: 139.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint181_linear_3744_1590",
    x1: 114.475,
    y1: 145.154,
    x2: 111.722,
    y2: 140.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint182_linear_3744_1590",
    x1: 114.137,
    y1: 144.733,
    x2: 111.918,
    y2: 140.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint183_linear_3744_1590",
    x1: 110.893,
    y1: 144.043,
    x2: 112.997,
    y2: 142.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint184_linear_3744_1590",
    x1: 111.191,
    y1: 143.934,
    x2: 112.808,
    y2: 142.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint185_linear_3744_1590",
    x1: 108.279,
    y1: 148.271,
    x2: 105.526,
    y2: 143.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint186_linear_3744_1590",
    x1: 107.942,
    y1: 147.851,
    x2: 105.721,
    y2: 144.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint187_linear_3744_1590",
    x1: 104.695,
    y1: 147.162,
    x2: 106.8,
    y2: 145.946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint188_linear_3744_1590",
    x1: 104.995,
    y1: 147.051,
    x2: 106.612,
    y2: 145.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint189_linear_3744_1590",
    x1: 114.474,
    y1: 151.917,
    x2: 111.722,
    y2: 147.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint190_linear_3744_1590",
    x1: 114.137,
    y1: 151.496,
    x2: 111.918,
    y2: 147.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint191_linear_3744_1590",
    x1: 110.892,
    y1: 150.807,
    x2: 112.997,
    y2: 149.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint192_linear_3744_1590",
    x1: 111.19,
    y1: 150.697,
    x2: 112.808,
    y2: 149.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint193_linear_3744_1590",
    x1: 108.278,
    y1: 155.035,
    x2: 105.526,
    y2: 150.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint194_linear_3744_1590",
    x1: 107.941,
    y1: 154.614,
    x2: 105.722,
    y2: 150.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint195_linear_3744_1590",
    x1: 104.696,
    y1: 153.925,
    x2: 106.801,
    y2: 152.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint196_linear_3744_1590",
    x1: 104.995,
    y1: 153.813,
    x2: 106.611,
    y2: 152.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint197_linear_3744_1590",
    x1: 114.475,
    y1: 158.678,
    x2: 111.722,
    y2: 153.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint198_linear_3744_1590",
    x1: 114.137,
    y1: 158.258,
    x2: 111.918,
    y2: 154.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint199_linear_3744_1590",
    x1: 110.892,
    y1: 157.568,
    x2: 112.997,
    y2: 156.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint200_linear_3744_1590",
    x1: 111.19,
    y1: 157.458,
    x2: 112.808,
    y2: 156.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint201_linear_3744_1590",
    x1: 108.278,
    y1: 161.796,
    x2: 105.526,
    y2: 157.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint202_linear_3744_1590",
    x1: 107.942,
    y1: 161.376,
    x2: 105.722,
    y2: 157.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint203_linear_3744_1590",
    x1: 104.695,
    y1: 160.687,
    x2: 106.8,
    y2: 159.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint204_linear_3744_1590",
    x1: 104.995,
    y1: 160.576,
    x2: 106.611,
    y2: 159.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint205_linear_3744_1590",
    x1: 114.475,
    y1: 165.443,
    x2: 111.722,
    y2: 160.674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint206_linear_3744_1590",
    x1: 114.137,
    y1: 165.02,
    x2: 111.918,
    y2: 161.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint207_linear_3744_1590",
    x1: 110.892,
    y1: 164.332,
    x2: 112.996,
    y2: 163.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint208_linear_3744_1590",
    x1: 111.19,
    y1: 164.221,
    x2: 112.808,
    y2: 163.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint209_linear_3744_1590",
    x1: 113.83,
    y1: 155.086,
    x2: 101.544,
    y2: 178.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC6C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint210_linear_3744_1590",
    x1: 106.168,
    y1: 157.248,
    x2: 103.415,
    y2: 152.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint211_linear_3744_1590",
    x1: 105.831,
    y1: 156.826,
    x2: 103.611,
    y2: 152.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint212_linear_3744_1590",
    x1: 102.583,
    y1: 156.139,
    x2: 104.69,
    y2: 154.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_3744_1590",
    x1: 102.884,
    y1: 156.027,
    x2: 104.501,
    y2: 154.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint214_linear_3744_1590",
    x1: 112.364,
    y1: 160.894,
    x2: 109.611,
    y2: 156.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint215_linear_3744_1590",
    x1: 112.027,
    y1: 160.474,
    x2: 109.807,
    y2: 156.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint216_linear_3744_1590",
    x1: 108.781,
    y1: 159.784,
    x2: 110.888,
    y2: 158.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint217_linear_3744_1590",
    x1: 109.08,
    y1: 159.673,
    x2: 110.698,
    y2: 158.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint218_linear_3744_1590",
    x1: 106.167,
    y1: 164.009,
    x2: 103.415,
    y2: 159.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint219_linear_3744_1590",
    x1: 105.831,
    y1: 163.589,
    x2: 103.611,
    y2: 159.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint220_linear_3744_1590",
    x1: 102.583,
    y1: 162.901,
    x2: 104.69,
    y2: 161.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint221_linear_3744_1590",
    x1: 102.884,
    y1: 162.789,
    x2: 104.501,
    y2: 161.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint222_linear_3744_1590",
    x1: 112.364,
    y1: 167.654,
    x2: 109.611,
    y2: 162.886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint223_linear_3744_1590",
    x1: 112.027,
    y1: 167.233,
    x2: 109.808,
    y2: 163.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint224_linear_3744_1590",
    x1: 108.781,
    y1: 166.546,
    x2: 110.887,
    y2: 165.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint225_linear_3744_1590",
    x1: 109.08,
    y1: 166.435,
    x2: 110.698,
    y2: 165.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint226_linear_3744_1590",
    x1: 106.168,
    y1: 170.773,
    x2: 103.415,
    y2: 166.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint227_linear_3744_1590",
    x1: 105.831,
    y1: 170.352,
    x2: 103.611,
    y2: 166.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint228_linear_3744_1590",
    x1: 102.583,
    y1: 169.664,
    x2: 104.689,
    y2: 168.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint229_linear_3744_1590",
    x1: 102.883,
    y1: 169.553,
    x2: 104.501,
    y2: 168.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint230_linear_3744_1590",
    x1: 112.364,
    y1: 174.417,
    x2: 109.611,
    y2: 169.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint231_linear_3744_1590",
    x1: 112.026,
    y1: 173.996,
    x2: 109.807,
    y2: 170.152,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint232_linear_3744_1590",
    x1: 108.781,
    y1: 173.308,
    x2: 110.887,
    y2: 172.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint233_linear_3744_1590",
    x1: 109.08,
    y1: 173.196,
    x2: 110.698,
    y2: 172.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint234_linear_3744_1590",
    x1: 106.168,
    y1: 177.537,
    x2: 103.415,
    y2: 172.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint235_linear_3744_1590",
    x1: 105.83,
    y1: 177.113,
    x2: 103.611,
    y2: 173.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint236_linear_3744_1590",
    x1: 102.583,
    y1: 176.428,
    x2: 104.69,
    y2: 175.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint237_linear_3744_1590",
    x1: 102.884,
    y1: 176.316,
    x2: 104.501,
    y2: 175.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint238_linear_3744_1590",
    x1: 112.364,
    y1: 181.18,
    x2: 109.611,
    y2: 176.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint239_linear_3744_1590",
    x1: 112.027,
    y1: 180.76,
    x2: 109.807,
    y2: 176.915,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint240_linear_3744_1590",
    x1: 108.781,
    y1: 180.071,
    x2: 110.887,
    y2: 178.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint241_linear_3744_1590",
    x1: 109.08,
    y1: 179.96,
    x2: 110.697,
    y2: 178.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint242_linear_3744_1590",
    x1: 111.317,
    y1: 156.699,
    x2: 99.0318,
    y2: 180.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFC6C9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_3744_1590",
    x1: 103.656,
    y1: 158.86,
    x2: 100.903,
    y2: 154.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint244_linear_3744_1590",
    x1: 103.318,
    y1: 158.441,
    x2: 101.099,
    y2: 154.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint245_linear_3744_1590",
    x1: 100.072,
    y1: 157.751,
    x2: 102.178,
    y2: 156.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_3744_1590",
    x1: 100.372,
    y1: 157.641,
    x2: 101.988,
    y2: 156.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_3744_1590",
    x1: 109.852,
    y1: 162.508,
    x2: 107.098,
    y2: 157.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint248_linear_3744_1590",
    x1: 109.514,
    y1: 162.087,
    x2: 107.295,
    y2: 158.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint249_linear_3744_1590",
    x1: 106.269,
    y1: 161.397,
    x2: 108.373,
    y2: 160.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint250_linear_3744_1590",
    x1: 106.568,
    y1: 161.287,
    x2: 108.185,
    y2: 160.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint251_linear_3744_1590",
    x1: 103.655,
    y1: 165.624,
    x2: 100.902,
    y2: 160.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint252_linear_3744_1590",
    x1: 103.318,
    y1: 165.203,
    x2: 101.098,
    y2: 161.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint253_linear_3744_1590",
    x1: 100.072,
    y1: 164.514,
    x2: 102.178,
    y2: 163.299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint254_linear_3744_1590",
    x1: 100.372,
    y1: 164.404,
    x2: 101.989,
    y2: 163.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint255_linear_3744_1590",
    x1: 109.851,
    y1: 169.27,
    x2: 107.098,
    y2: 164.502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint256_linear_3744_1590",
    x1: 109.514,
    y1: 168.849,
    x2: 107.295,
    y2: 165.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint257_linear_3744_1590",
    x1: 106.27,
    y1: 168.158,
    x2: 108.373,
    y2: 166.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint258_linear_3744_1590",
    x1: 106.567,
    y1: 168.048,
    x2: 108.185,
    y2: 166.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint259_linear_3744_1590",
    x1: 103.656,
    y1: 172.386,
    x2: 100.903,
    y2: 167.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint260_linear_3744_1590",
    x1: 103.318,
    y1: 171.965,
    x2: 101.098,
    y2: 168.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint261_linear_3744_1590",
    x1: 100.072,
    y1: 171.274,
    x2: 102.179,
    y2: 170.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint262_linear_3744_1590",
    x1: 100.371,
    y1: 171.166,
    x2: 101.989,
    y2: 170.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint263_linear_3744_1590",
    x1: 109.851,
    y1: 176.03,
    x2: 107.098,
    y2: 171.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint264_linear_3744_1590",
    x1: 109.514,
    y1: 175.61,
    x2: 107.295,
    y2: 171.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint265_linear_3744_1590",
    x1: 106.269,
    y1: 174.919,
    x2: 108.373,
    y2: 173.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint266_linear_3744_1590",
    x1: 106.567,
    y1: 174.811,
    x2: 108.185,
    y2: 173.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint267_linear_3744_1590",
    x1: 103.656,
    y1: 179.149,
    x2: 100.902,
    y2: 174.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint268_linear_3744_1590",
    x1: 103.318,
    y1: 178.726,
    x2: 101.098,
    y2: 174.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint269_linear_3744_1590",
    x1: 100.073,
    y1: 178.038,
    x2: 102.178,
    y2: 176.822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint270_linear_3744_1590",
    x1: 100.371,
    y1: 177.929,
    x2: 101.989,
    y2: 176.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint271_linear_3744_1590",
    x1: 109.852,
    y1: 182.795,
    x2: 107.098,
    y2: 178.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7446,
    stopColor: "#CED3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DFE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint272_linear_3744_1590",
    x1: 109.514,
    y1: 182.373,
    x2: 107.295,
    y2: 178.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0609,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3086,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint273_linear_3744_1590",
    x1: 106.269,
    y1: 181.684,
    x2: 108.373,
    y2: 180.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0963,
    stopColor: "#EAEBED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4876,
    stopColor: "#DBDCDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F5F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint274_linear_3744_1590",
    x1: 106.568,
    y1: 181.572,
    x2: 108.184,
    y2: 180.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint275_linear_3744_1590",
    x1: 111.047,
    y1: 177.601,
    x2: 115.74,
    y2: 157.733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBDADA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint276_linear_3744_1590",
    x1: 210.107,
    y1: 122.988,
    x2: 230.581,
    y2: 122.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00991F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215E4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint277_linear_3744_1590",
    x1: 230.581,
    y1: 123.442,
    x2: 249.483,
    y2: 123.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87D64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008653"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint278_linear_3744_1590",
    x1: 182.699,
    y1: 127.133,
    x2: 202.492,
    y2: 127.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00991F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#215E4F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint279_linear_3744_1590",
    x1: 201.542,
    y1: 127.553,
    x2: 218.944,
    y2: 127.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87D64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008653"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotionApp);
export default __webpack_public_path__ + "static/media/promotion-app.f0743b95d0d5e2f3fbf3e906f4016ddb.svg";
export { ForwardRef as ReactComponent };